<template>

  <!-- Chat-only mode: full-screen cover while connecting -->
  <transition name="fade">
    <div v-if="isChatOnlyMode && !mostrarModalPreguntas" class="chat-only-loading-cover">
      <div v-if="enteringSessionPreview && enteringSessionPreview.imageUrl" class="chat-only-preview-bg">
        <img :src="enteringSessionPreview.imageUrl" class="chat-only-preview-img" alt="">
        <div class="chat-only-preview-dim"></div>
      </div>
      <div class="chat-only-brand-center">
        <img
          v-if="enteringSessionPreview && enteringSessionPreview.logoUrl"
          :src="enteringSessionPreview.logoUrl"
          class="chat-only-brand-logo"
          alt=""
        >
        <p v-if="enteringSessionPreview && enteringSessionPreview.title" class="chat-only-brand-name">
          {{ enteringSessionPreview.title }}
        </p>
      </div>
      <div class="chat-only-spinner">
        <div class="chat-only-spinner-ring"></div>
      </div>
    </div>
  </transition>

   <transition name="fade-bg">
            <div 
              v-if="proyectorConfig.Branding"
              :key="proyectorConfig.Branding"
              class="tv-background-layer"
              :class="claseAnimacion"
              :style="estiloProyector"
            >
              <img 
                v-if="esImagenBack(proyectorConfig.Branding)" 
                :src="proyectorConfig.Branding" 
                class="tv-bg-image"
              >

              <div 
                :style="!esImagenBack(proyectorConfig.Branding)?'opacity:0':''" 
                class="tv-bg-overlay"
              ></div>
            </div>
          </transition>


  <transition name="comment-pop">
    <div v-if="puedeMostrarPerfil" class="bottom-sheet-overlay">
      <div class="bottom-sheet animate-up profile-setup">
        <div class="handle"></div>
        <div class="sheet-header">
          <h2 class="poppins-bold">{{ $t('user.profile_setup_title') }}</h2>
          <p>{{ $t('user.profile_setup_subtitle') }}</p>
        </div>

        <div class="profile-form">
          <div class="avatar-preview-wrapper">
            <div class="avatar-relative">
              <img 
                :src="fotoUrl || computedAvatar" 
                class="avatar-setup-img" 
                :style="{ borderColor: proyectorConfig.color, opacity: subiendoFoto ? 0.5 : 1 }"
              >
              
              <label for="upload-photo" class="btn-upload-avatar" :style="{ background: proyectorConfig.color }">
                <span v-if="!subiendoFoto" class="icon-camera">📷</span>
                <div v-else class="mini-spinner"></div> 
                <input 
                  type="file" 
                  id="upload-photo" 
                  @change="manejarSubidaFoto" 
                  accept="image/*" 
                  :disabled="subiendoFoto"
                  hidden
                >
              </label>
            </div>
          </div>

          <div class="input-group">
            <label>{{ $t('user.name') }}</label>
            <input v-model="nombreUsuario" type="text" placeholder="Ej. Juan Pérez" class="minimal-input">
          </div>

          <div class="input-group">
            <label>{{ $t('user.age') }}</label>
            <input v-model="edadUsuario" type="number" placeholder="25" class="minimal-input">
          </div>

                   <button
              @click="guardarPerfil"
              :disabled="!puedeGuardarPerfil"
              class="btn-save-profile"
              :style="{
              background: puedeGuardarPerfil ? proyectorConfig.color : '#444',
              opacity: puedeGuardarPerfil ? 1 : 0.6
              }"
              >
              {{ $t('user.start_participating') }}
              </button>
        </div>
      </div>
    </div>
  </transition>
  <!-- Name Setup Modal — clean welcome card -->
  <transition name="welcome-pop">
    <div v-if="mostrarModalNombreSetup" class="welcome-overlay">
      <div class="welcome-card">
        <p class="welcome-connected-label">Conectado a</p>
        <h1 class="welcome-session-name">{{ tituloVisibleSesionUsuario || proyectorConfig?.nombreSesion || 'la sesión' }}</h1>

        <div class="welcome-divider"></div>

        <p class="welcome-name-label">¿Cómo te llamas?</p>
        <input
          class="welcome-name-input"
          type="text"
          placeholder="Tu nombre"
          v-model="nombreUsuario"
          maxlength="40"
          autocomplete="off"
          @keyup.enter="guardarNombreYAvatar"
        />

        <button
          class="welcome-btn-continuar"
          :disabled="!puedeGuardarNombreSetup"
          :style="puedeGuardarNombreSetup ? { background: proyectorConfig.color || '#6c63ff' } : {}"
          @click="guardarNombreYAvatar"
        >
          Continuar
        </button>
      </div>
    </div>
  </transition>

  <!-- Personal Winner Announcement Screen -->
  <transition name="ganador-pop">
    <div v-if="mostrarPantallaGanador && miPuestoGanador" class="mi-ganador-overlay" :style="{ '--brand': proyectorConfig.color || '#6c63ff' }">
      <button class="mi-ganador-close" @click="mostrarPantallaGanador = false">✕</button>

      <div class="mi-ganador-medal animate__animated animate__backInUp">
        {{ miPuestoGanador.puesto === 1 ? '🥇' : miPuestoGanador.puesto === 2 ? '🥈' : miPuestoGanador.puesto === 3 ? '🥉' : '🏆' }}
      </div>

      <img
        class="mi-ganador-avatar"
        :src="fotoUrl || computedAvatar"
        alt="Avatar"
      />

      <p class="mi-ganador-puesto">#{{ miPuestoGanador.puesto }} del ranking</p>
      <h1 class="mi-ganador-felicidades">¡Felicitaciones!</h1>
      <p class="mi-ganador-nombre">{{ nombreUsuario }}</p>

      <div v-if="miPuestoGanador.puntos != null" class="mi-ganador-puntos">
        {{ miPuestoGanador.puntos }} pts
      </div>

      <div class="mi-ganador-confetti">
        <span>🎉</span><span>🎊</span><span>✨</span>
      </div>

      <p class="mi-ganador-mensaje">Gracias por participar</p>
    </div>
  </transition>

  <div v-if="pdfSource && pdfOverlayActive" class="pdf-phone-overlay" @mousemove="mostrarPdfUi" @touchstart="mostrarPdfUi">
    <div class="pdf-phone-controls" :class="{ hidden: !pdfUiVisible, landscape: !pdfIsPortrait, portrait: pdfIsPortrait }">
      <button class="pdf-save-btn" @click="guardarCapturaPdf">
        <span class="download-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 3v12"></path>
            <path d="M7 10l5 5 5-5"></path>
            <path d="M5 21h14"></path>
          </svg>
        </span>
        <span class="download-text">{{ $t('user.save_capture') }}</span>
      </button>
    </div>
    <div class="pdf-phone-canvas-wrap" :class="{ landscape: !pdfIsPortrait, portrait: pdfIsPortrait }">
      <canvas id="pdf-user-canvas" class="pdf-phone-canvas"></canvas>
    </div>
    <div v-if="pdfLoading" class="pdf-phone-loader">{{ $t('user.loading') }}</div>
  </div>
  <div
    class="user-app uvoto-dark-theme"
    :class="{ 'user-app--desktop-showcase': shouldUseDesktopShowcase || showDesktopEntryGate }"
    :style="!canalId || !proyectorConfig.Branding?'background-color: #1a1a1a;':''"
  >
    <transition name="ecosystem-panel-slide">
      <div v-if="showJoinHomePanel" class="ecosystem-join-panel brand-claim-redirect-panel">
        <div class="bcr-header">
          <button type="button" class="bcr-back-btn" @click="closeJoinHomePanel">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18">
              <path d="m15 18-6-6 6-6"></path>
            </svg>
            <span>{{ selectedLanguage === 'en' ? 'Back' : selectedLanguage === 'pt' ? 'Voltar' : 'Volver' }}</span>
          </button>
        </div>

        <div class="bcr-body">
          <div class="bcr-check-icon">
            <svg viewBox="0 0 24 24" fill="none" width="32" height="32">
              <circle cx="12" cy="12" r="12" fill="#46D68E" opacity="0.15"/>
              <path d="M7 12.5l3.5 3.5 6.5-7" stroke="#46D68E" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 class="bcr-title">
            {{ selectedLanguage === 'en' ? 'Link reserved!' : selectedLanguage === 'pt' ? 'Link reservado!' : '¡Link reservado!' }}
          </h2>
          <p class="bcr-slug">uvoto.com/<strong>{{ brandSlugDraft }}</strong></p>
          <p class="bcr-subtitle">
            {{ selectedLanguage === 'en'
              ? 'Open Uvoto Branding to complete your brand setup.'
              : selectedLanguage === 'pt'
              ? 'Abra o Uvoto Branding para completar sua marca.'
              : 'Abre Uvoto Branding para completar tu marca.' }}
          </p>

          <button class="bcr-open-btn" @click="tryOpenUvotoConnectApp">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" stroke="none" fill="currentColor"/>
            </svg>
            {{ selectedLanguage === 'en' ? 'Open Uvoto Branding' : selectedLanguage === 'pt' ? 'Abrir Uvoto Branding' : 'Abrir Uvoto Branding' }}
          </button>

          <div class="bcr-divider">
            <span>{{ selectedLanguage === 'en' ? "Don't have the app?" : selectedLanguage === 'pt' ? 'Não tem o app?' : '¿No tienes la app?' }}</span>
          </div>

          <div class="bcr-store-btns">
            <a class="bcr-store-btn" href="https://apps.apple.com/app/id6768442288" target="_blank" rel="noopener">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
              App Store
            </a>
            <a class="bcr-store-btn" href="https://play.google.com/store/apps/details?id=com.uvoto.connect" target="_blank" rel="noopener">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20"><path d="M3.18 23.76c.3.17.64.22.99.14l12.47-7.18-2.79-2.79-10.67 9.83zm-1.32-20.7C1.64 3.36 1.5 3.7 1.5 4.1v15.8c0 .4.14.74.36 1.01l.08.07 8.85-8.85v-.2L1.86 3.06zm14.34 12.32l-2.95-2.95 2.95-2.95 3.35 1.93c.95.55.95 1.44 0 1.99l-3.35 1.98zM3.18.24l10.67 9.83-2.79 2.79L1.19.69C1.49.17 1.96-.07 2.5 0c.24.03.47.1.68.24z"/></svg>
              Play Store
            </a>
          </div>

          <button class="bcr-cancel-btn" @click="cancelarReservaBrand">
            {{ selectedLanguage === 'en' ? 'Cancel reservation' : selectedLanguage === 'pt' ? 'Cancelar reserva' : 'Cancelar reserva' }}
          </button>
        </div>
      </div>
    </transition>

    <div
      v-if="canUseExploreSwipeZone"
      class="ecosystem-swipe-zone"
      @touchstart.passive="handleShellTouchStart"
      @touchmove.passive="handleShellTouchMove"
      @touchend.passive="handleShellTouchEnd"
    ></div>

    <div v-if="showDesktopEntryGate" class="desktop-entry-gate">
      <div class="desktop-entry-gate-card">
        <span class="desktop-entry-gate-kicker">{{ onboardingCopy.eyebrow }}</span>
        <h1 class="desktop-entry-gate-title poppins-bold">{{ desktopLandingCopy.title }}</h1>
        <p class="desktop-entry-gate-body">{{ desktopLandingCopy.body }}</p>
        <p class="desktop-entry-gate-purpose">{{ desktopLandingCopy.purpose }}</p>
        <button type="button" class="desktop-entry-gate-btn" @click="activateDesktopSessionExperience">
          {{ desktopLandingCopy.cta }}
        </button>
        <div class="desktop-entry-gate-legal">
          <router-link to="/privacy#privacy-policy" class="desktop-entry-gate-legal-link">Privacy Policy</router-link>
          <span class="desktop-entry-gate-legal-sep">·</span>
          <router-link to="/privacy#terms" class="desktop-entry-gate-legal-link">Terms of Service</router-link>
        </div>
      </div>
    </div>

    <div v-else :class="shouldUseDesktopShowcase ? 'desktop-user-layout' : ''">
      <aside v-if="shouldUseDesktopShowcase" class="desktop-user-info">

        <!-- Logo pegado al top -->
        <div class="dsi-logo-top">
          <img src="../assets/uvoto.png" alt="Uvoto" class="desktop-user-info-logo">
        </div>

        <!-- Contenido central con scroll -->
        <div class="desktop-user-info-scroll">

          <!-- HERO: título animado + subtitle -->
          <div class="dsi-hero dsi-anim-hero">
            <h1 class="dsi-title poppins-bold">
              <span class="dsi-title-line">{{ onboardingCopy.titleLineOne }}</span>
              <span class="dsi-title-line">{{ onboardingCopy.titleLineTwo }}</span>
              <span class="dsi-title-line">
                {{ onboardingCopy.titleLineThree }}&nbsp;<span
                  class="dsi-title-accent main-title-accent-animated"
                  :class="`is-motion-${rotatingAudienceMotion}`"
                  :key="`dl_${selectedLanguage}_${rotatingAudienceIndex}`"
                >{{ rotatingAudienceLabel }}</span>
              </span>
            </h1>
            <p class="dsi-subtitle">{{ onboardingCopy.subtitle }}</p>
          </div>

          <!-- JOIN: input + botón -->
          <div class="dsi-join dsi-anim-join">
            <label class="desktop-user-label">{{ desktopLandingCopy.inputTitle }}</label>
            <div class="capsule-input-container desktop-capsule-input-container">
              <input
                v-model="pinIngresado"
                type="text"
                inputmode="numeric"
                :placeholder="onboardingCopy.placeholder"
                maxlength="4"
                class="capsule-field"
                @input="pinIngresado = normalizarPinIngreso(pinIngresado)"
                @keyup.enter="conectarPorPin()"
              >
              <button @click="conectarPorPin()" class="btn-create-circle" :disabled="loading || !canJoinSession">
                {{ loading ? '...' : onboardingCopy.joinLabel }}
              </button>
            </div>
            <p class="join-helper desktop-join-helper">{{ onboardingCopy.helper }}</p>
          </div>

        </div>

        <!-- Lang switcher fijo en la esquina inferior izquierda -->
        <div class="dsi-lang-bottom" @click.stop>
          <div class="lang-switcher lang-switcher-bottom">
            <button class="lang-toggle-btn" @click="toggleLanguageMenu">
              <span>{{ currentLanguageLabel }}</span>
              <span class="lang-toggle-caret" :class="{ open: showLanguageMenu }">▾</span>
            </button>
            <transition name="lang-menu-up">
              <div v-if="showLanguageMenu" class="lang-dropdown lang-dropdown-up">
                <button
                  v-for="lang in availableLanguages"
                  :key="`desktop_${lang.code}`"
                  @click="cambiarIdioma(lang.code)"
                  :class="['lang-dropdown-item', { active: selectedLanguage === lang.code }]"
                >
                  {{ getLanguageLabel(lang.code) }}
                </button>
              </div>
            </transition>
          </div>
        </div>

      </aside>

      <div :class="shouldUseDesktopShowcase ? 'desktop-user-device-stage' : ''">

        <!-- PILL FLOTANTE: salir de sala + like + share -->
        <transition name="dsi-pill-pop">
          <div v-if="shouldShowRoomActionBar" class="room-action-bar">
            <button type="button" class="room-action-btn room-action-exit" @click="salirDeSala()">
              <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                <polyline points="16 17 21 12 16 7"/>
                <line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
              <span class="room-action-exit-label">{{ selectedLanguage === 'en' ? 'Exit' : selectedLanguage === 'pt' ? 'Sair' : 'Salir' }}</span>
            </button>
            <div class="room-action-sep"></div>
            <button
              type="button"
              class="room-action-btn room-action-like"
              :class="{ 'is-liked': roomLiked }"
              @click="toggleRoomLike"
              title="Me gusta"
            >
              <svg viewBox="0 0 24 24" width="19" height="19" :fill="roomLiked ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
              <span class="room-action-like-count" v-if="roomLikesCount > 0">{{ roomLikesCount }}</span>
            </button>
            <button
              type="button"
              class="room-action-btn room-action-share"
              @click="showShareSheet = true"
              title="Compartir"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
              </svg>
            </button>
          </div>
        </transition>

        <div :class="shouldUseDesktopShowcase ? 'desktop-user-device-shell dsi-anim-phone' : ''">
          <div :class="shouldUseDesktopShowcase ? 'desktop-user-device-screen' : ''">
    <header class="app-header" v-if="canalId && !proyectorConfig.waitingRoomEnabled">
       <button
         v-if="canalId && !proyectorConfig.preguntaActivaId"
         @click="salirDeSala"
         class="room-back-btn"
         :aria-label="selectedLanguage === 'en' ? 'Back to explore' : selectedLanguage === 'pt' ? 'Voltar para explorar' : 'Volver a explorar'"
       >
         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round">
           <path d="m15 18-6-6 6-6"></path>
         </svg>
       </button>

     <div style="width: 30%;">
       <img :src="proyectorConfig.logoEmpresa?proyectorConfig.logoEmpresa:require('../assets/uvoto.png')" alt="Uvoto" class="app-brand-logo">
     </div>
      <div
        v-if="canalId && runtimeConfig.gamificationEnabled"
        class="live-status"
        :style="{ background: 'rgba(255,255,255,0.14)', border: `1px solid ${(proyectorConfig.color || '#fff')}55` }"
      >
        <span style="font-size: 14px;">★</span> {{ puntosUsuario }} pts
      </div>
      <div v-if="canalId" class="live-status">
        <span class="dot"></span> {{ $t('user.live') }}
      </div>
    </header>

    <!-- PRÓXIMA CITA STICKY -->
    <div v-if="proximaCita && canalId && !proyectorConfig.waitingRoomEnabled" class="proxima-cita-bar">
      <div class="proxima-cita-info">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="4" width="18" height="18" rx="3"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
        <span class="proxima-cita-text">
          <strong>Cita: </strong>{{ proximaCita.fecha }} · {{ proximaCita.hora }}
          <span v-if="proximaCita.servicioNombre" class="proxima-cita-servicio"> · {{ proximaCita.servicioNombre }}</span>
        </span>
        <span class="proxima-cita-estado" :class="`is-${proximaCita.estado}`">{{ proximaCita.estado }}</span>
      </div>
      <button class="proxima-cita-btn" @click="abrirGestionar(proximaCita)">Gestionar</button>
    </div>

    <!-- MODAL GESTIONAR CITA -->
    <div v-if="gestionarModal.open" class="gestionar-overlay" @click.self="gestionarModal.open = false">
      <div class="gestionar-sheet">
        <div class="gestionar-header">
          <strong>Gestionar cita</strong>
          <button class="gestionar-close" @click="gestionarModal.open = false">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>

        <!-- Selección de acción -->
        <div v-if="!gestionarModal.accion" class="gestionar-actions">
          <button class="gestionar-action-btn" @click="gestionarModal.accion = 'reprogramar'">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg>
            Reprogramar cita
          </button>
          <button class="gestionar-action-btn is-danger" @click="gestionarModal.accion = 'cancelar'">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><path d="M15 9l-6 6M9 9l6 6"/></svg>
            Cancelar cita
          </button>
        </div>

        <!-- Reprogramar -->
        <div v-else-if="gestionarModal.accion === 'reprogramar'" class="gestionar-form">
          <p class="gestionar-label">Elige un nuevo horario:</p>
          <div v-if="!gestionarModal.slots.length" class="gestionar-empty">No hay horarios disponibles configurados.</div>
          <div v-else class="gestionar-slots">
            <button
              v-for="(slot, i) in gestionarModal.slots"
              :key="i"
              type="button"
              class="gestionar-slot"
              :class="{ selected: gestionarModal.selectedSlot?.fecha === slot.fecha && gestionarModal.selectedSlot?.hora === slot.hora }"
              @click="gestionarModal.selectedSlot = slot"
            >{{ slot.label }}</button>
          </div>
          <div class="gestionar-footer">
            <button class="gestionar-back" @click="gestionarModal.accion = null">← Volver</button>
            <button
              class="gestionar-confirm-btn"
              :style="getUserBubbleStyle()"
              :disabled="!gestionarModal.selectedSlot || gestionarModal.loading"
              @click="ejecutarGestionar"
            >
              <span v-if="gestionarModal.loading" class="ai-booking-spinner"></span>
              <span v-else>Confirmar cambio</span>
            </button>
          </div>
        </div>

        <!-- Cancelar -->
        <div v-else-if="gestionarModal.accion === 'cancelar'" class="gestionar-form">
          <p class="gestionar-label">¿Seguro que quieres cancelar tu cita?</p>
          <p class="gestionar-sub">{{ proximaCita?.fecha }} · {{ proximaCita?.hora }}</p>
          <textarea
            v-model="gestionarModal.motivo"
            class="gestionar-motivo"
            placeholder="Motivo (opcional)"
            rows="3"
          ></textarea>
          <div class="gestionar-footer">
            <button class="gestionar-back" @click="gestionarModal.accion = null">← Volver</button>
            <button
              class="gestionar-confirm-btn is-danger"
              :disabled="gestionarModal.loading"
              @click="ejecutarGestionar"
            >
              <span v-if="gestionarModal.loading" class="ai-booking-spinner"></span>
              <span v-else>Sí, cancelar</span>
            </button>
          </div>
        </div>
      </div>
    </div>

   <main class="content-container" :style="contentContainerInlineStyle">

  <!-- 1. Pantalla de Carga (SISTEMA DE GATES) -->
  <div v-if="loading && (enteringSessionPreview || isDirectSlug) && !isChatOnlyMode" class="direct-slug-gate">
    <!-- Fondo desenfocado con imagen del slug -->
    <div
      class="slug-gate-bg"
      :style="entryLoadingPreview.imageUrl ? { backgroundImage: `url(${entryLoadingPreview.imageUrl})` } : {}"
    ></div>
    <!-- Capa glass -->
    <div class="slug-gate-glass"></div>
    <!-- Contenido central -->
    <div class="slug-gate-content">
      <div class="slug-gate-avatar-wrap">
        <div class="explore-entry-loading-pulse"></div>
        <div
          class="slug-gate-avatar"
          :style="entryLoadingPreview.imageUrl ? { backgroundImage: `url(${entryLoadingPreview.imageUrl})` } : {}"
        ></div>
      </div>
      <div class="slug-gate-kicker">{{ entryLoadingPreview.kicker }}</div>
      <h2 class="slug-gate-title">{{ entryLoadingPreview.title }}</h2>
      <div class="spinner-mini slug-gate-spinner"></div>
    </div>
  </div>

  <template v-else-if="showExplorerSurface">
  <transition :name="showExploreOverlay ? 'ecosystem-explore-slide' : 'fade'">
  <div class="login-screen animate-in explore-entry-screen" :class="{ 'is-overlay-surface': showExploreOverlay }">
    <div class="login-shell">
      <div class="login-content-wrap">
        <div class="login-topbar explore-entry-topbar">
          <div class="login-topbar-brand">
            <img src="../assets/uvoto.png" alt="Uvoto" class="login-topbar-logo">
          </div>
          <div class="explore-topbar-right">
            <button class="explore-search-btn" @click="showSearchModal = true" aria-label="Buscar sala">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
            </button>
            <div class="lang-switcher" @click.stop>
              <button class="lang-toggle-btn" @click="toggleLanguageMenu">
                <span>{{ currentLanguageLabel }}</span>
                <span class="lang-toggle-caret" :class="{ open: showLanguageMenu }">▾</span>
              </button>
              <div v-if="showLanguageMenu" class="lang-dropdown">
                <button
                  v-for="lang in availableLanguages"
                  :key="lang.code"
                  @click="cambiarIdioma(lang.code)"
                  :class="['lang-dropdown-item', { active: selectedLanguage === lang.code }]"
                >
                  {{ getLanguageLabel(lang.code) }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="hero-section explore-hero-section">
          <span class="hero-eyebrow">{{ selectedLanguage === 'en' ? 'DISCOVER NOW' : selectedLanguage === 'pt' ? 'DESCUBRA AGORA' : 'DESCUBRE AHORA' }}</span>
          <h1 class="main-title poppins-bold explore-main-title">
            <span class="main-title-line">{{ selectedLanguage === 'en' ? 'Explore live' : selectedLanguage === 'pt' ? 'Explore salas' : 'Explora salas' }}</span>
            <span class="main-title-line">{{ selectedLanguage === 'en' ? 'rooms and brands' : selectedLanguage === 'pt' ? 'e marcas ativas' : 'y marcas activas' }}</span>
            <span class="main-title-line main-title-line-accent">
              {{ selectedLanguage === 'en' ? 'around' : selectedLanguage === 'pt' ? 'para' : 'para' }}
              <span class="main-title-line-space">&nbsp;</span>
              <span
                class="main-title-accent main-title-accent-animated"
                :class="`is-motion-${rotatingAudienceMotion}`"
                :key="`${selectedLanguage}_${rotatingAudienceIndex}`"
              >{{ rotatingAudienceLabel }}</span>
            </span>
          </h1>
          <!-- Reclamo de link: solo una línea y el input del último slide
               (con el botón Reservar dentro). Sin kicker ni titular: en la
               portada el protagonista son las salas, no este bloque. -->
          <div class="explore-claim-compact">
            <p class="explore-claim-line">
              {{
                selectedLanguage === 'en'
                  ? 'Secure your link now.'
                  : selectedLanguage === 'pt'
                  ? 'Garanta seu link agora.'
                  : 'Asegura tu enlace ahora.'
              }}
            </p>
            <!-- Con reserva activa el input desaparece: lo único que falta es
                 volver al panel de descarga, así que el campo cede su lugar. -->
            <button
              v-if="tieneReservaActiva"
              type="button"
              class="wr-continue-claim-btn"
              @click="openJoinHomePanel"
            >
              <span class="wr-continue-claim-copy">
                <span class="wr-continue-claim-label">{{
                  selectedLanguage === 'en' ? 'Continue your reservation'
                  : selectedLanguage === 'pt' ? 'Continue sua reserva'
                  : 'Continúa con tu reserva'
                }}</span>
                <span class="wr-continue-claim-slug">uvoto.com/{{ brandSlugDraft }}</span>
              </span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" width="18" height="18">
                <path d="M5 12h14M13 6l6 6-6 6"/>
              </svg>
            </button>
            <label v-else class="wr-startup-input-wrapper">
              <span class="wr-startup-input-prefix">uvoto.com/</span>
              <input
                :value="brandSlugDraft"
                type="text"
                maxlength="24"
                class="wr-startup-input-field"
                autocapitalize="none"
                autocorrect="off"
                spellcheck="false"
                :placeholder="selectedLanguage === 'en' ? 'your-brand' : selectedLanguage === 'pt' ? 'sua-marca' : 'tu-marca'"
                @input="onBrandSlugInput"
              >
              <button
                type="button"
                class="wr-startup-submit-btn"
                :disabled="brandSlugStatus === 'checking' || brandSlugStatus === 'saving' || !canReserveBrandSlug"
                @click="reserveBrandSlugAndContinue"
              >
                {{ brandSlugStatus === 'saving'
                  ? (selectedLanguage === 'en' ? 'Saving...' : selectedLanguage === 'pt' ? 'Salvando...' : 'Guardando...')
                  : (selectedLanguage === 'en' ? 'Reserve' : selectedLanguage === 'pt' ? 'Reservar' : 'Reservar') }}
              </button>
            </label>
            <small v-if="brandSlugMessage && !tieneReservaActiva" class="explore-claim-status" :class="`is-${brandSlugStatus}`">
              {{ brandSlugMessage }}
            </small>
          </div>
        </div>
      </div>

      <div v-if="filteredExploreProfiles.length || exploreProfilesLoading" class="explore-section">
        <div class="explore-head-bleed">
        <div class="explore-head">
          <div v-if="exploreProfilesLoading" class="explore-all-trigger shimmer" style="width: 100px; height: 32px; border-radius: 20px;"></div>
          <button v-else type="button" class="explore-all-trigger" @click="openExploreModal">
            <span>{{ selectedLanguage === 'en' ? 'Explore all' : selectedLanguage === 'pt' ? 'Explorar tudo' : 'Explorar todos' }}</span>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <rect x="3" y="3" width="7" height="7" rx="1.5"></rect>
              <rect x="14" y="3" width="7" height="7" rx="1.5"></rect>
              <rect x="3" y="14" width="7" height="7" rx="1.5"></rect>
              <rect x="14.5" y="14.5" width="6" height="6" rx="1.2" transform="rotate(45 17.5 17.5)"></rect>
            </svg>
          </button>
          <div v-if="exploreProfilesLoading" class="explore-categories explore-categories-head">
            <div v-for="i in 3" :key="`skel_cat_${i}`" class="explore-category-chip shimmer" style="width: 70px; height: 32px; border-radius: 20px;"></div>
          </div>
          <div v-else class="explore-categories explore-categories-head">
            <button
              v-for="category in availableExploreCategories"
              :key="category.id"
              type="button"
              class="explore-category-chip"
              :class="{ active: activeExploreCategory === category.id }"
              @click="selectExploreCategory(category.id)"
            >
              {{ category.label }}
            </button>
          </div>
        </div>
        </div>
        <div v-if="exploreProfilesLoading" class="explore-entry-hint shimmer" style="width: 80%; height: 16px; border-radius: 4px; margin-top: 5px; margin-bottom: 15px;"></div>
        <p v-else class="explore-entry-hint">
          {{
            selectedLanguage === 'en'
              ? 'Jump into a live interactive session.'
              : selectedLanguage === 'pt'
              ? 'Entre em uma sessão interativa ao vivo.'
              : 'Entra a una sesión interactiva en vivo.'
          }}
        </p>

        <div v-if="exploreProfilesLoading" class="explore-slider-bleed" style="display: flex; gap: 10px; overflow: hidden; padding-left: var(--app-side-pad);">
          <div v-for="i in 3" :key="`skel_card_${i}`" class="explore-slide" style="min-width: 120px; width: 120px;">
            <div class="explore-tile">
              <div class="explore-card shimmer" style="border-radius: 12px; height: 120px;"></div>
              <div class="explore-tile-label shimmer" style="width: 80%; height: 14px; margin-top: 8px; border-radius: 4px;"></div>
            </div>
          </div>
        </div>
        <div v-else class="explore-slider-bleed">
          <Swiper
            @swiper="setExploreSwiper"
            class="explore-slider"
            :slides-per-view="2.85"
            :space-between="10"
            :centered-slides="false"
            :watch-overflow="true"
            :loop="mainExploreLoopEnabled"
            :loop-additional-slides="2"
            :speed="300"
            :touch-ratio="0.7"
            :threshold="10"
            :long-swipes-ratio="0.6"
            @slideChange="onExploreSlideChange"
            @touchStart="pauseExploreAutoplay"
            @touchEnd="restartExploreAutoplay"
          >
            <SwiperSlide
              v-for="profile in mainExploreSlides"
              :key="profile.__loopKey || profile.canalId"
              class="explore-slide"
            >
              <div class="explore-tile">
                <button type="button" class="explore-card" @click="visitarPerfilExploracion(profile)">
                  <div
                    class="explore-card-bg"
                    :style="{ backgroundImage: `url(${profile.imageUrl || profile.logoUrl || fallbackExploreImage})` }"
                  ></div>
                <div class="explore-card-overlay"></div>

                <div class="explore-card-mini-meta">
                  <div class="explore-brand-logo">
                    <img v-if="profile.logoUrl" :src="profile.logoUrl" :alt="profile.brandName || profile.title">
                    <img v-else src="../assets/uvoto.png" alt="Uvoto">
                  </div>
                </div>
              </button>
              <span class="explore-tile-label">{{ profile.brandName || profile.title }}</span>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>

    <!-- Botón flotante sesiones recientes -->
    <transition name="tc-slide-up">
      <button
        v-if="sesionesRecientes.length > 0 && !loading && !showJoinHomePanel"
        type="button"
        class="recent-fab"
        @click="showRecentSessionsModal = true"
      >
        <span class="recent-fab-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9"/>
            <polyline points="12 7 12 12 15 15"/>
          </svg>
        </span>
        <span class="recent-fab-copy">
          <span class="recent-fab-label">{{ onboardingCopy.recentTitle }}</span>
          <small class="recent-fab-sub">{{ onboardingCopy.recentSubtitle }}</small>
        </span>
        <span class="recent-fab-arrow">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="18 15 12 9 6 15"/>
          </svg>
        </span>
      </button>
    </transition>

    <transition name="fade">
      <div
        v-if="!canalId && showRecentSessionsModal"
        class="recent-modal-overlay"
        @click="showRecentSessionsModal = false"
      >
        <div class="recent-modal" @click.stop>
          <div class="recent-modal-handle"></div>
          <div class="recent-modal-head">
            <div>
              <strong>{{ onboardingCopy.recentTitle }}</strong>
              <p>{{ onboardingCopy.recentSubtitle }}</p>
            </div>
            <button type="button" class="recent-modal-close" @click="showRecentSessionsModal = false">✕</button>
          </div>

          <div class="recent-modal-list">
            <button
              v-for="sesion in sesionesRecientes"
              :key="sesion.id"
              type="button"
              class="recent-modal-item"
              @click="reconectarSesion(sesion); showRecentSessionsModal = false"
            >
              <div
                class="recent-modal-thumb"
                :style="getRecentSessionThumb(sesion) ? { backgroundImage: `url(${getRecentSessionThumb(sesion)})` } : {}"
              >
                <span v-if="!getRecentSessionThumb(sesion)" class="recent-modal-thumb-fallback">{{ (sesion.nombre || '?')[0].toUpperCase() }}</span>
              </div>
              <div class="recent-modal-item-copy">
                <span class="recent-name">{{ limitarTituloSesion(sesion.nombre, 34) }}</span>
                <span class="recent-pin">PIN {{ sesion.pin }}</span>
              </div>
              <div class="recent-action-icon">→</div>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div
        v-if="!canalId && showExploreModal"
        class="explore-modal-overlay"
        @click="closeExploreModal"
      >
        <div class="explore-modal" @click.stop>
          <div class="explore-modal-head">
            <div class="explore-modal-copy">
              <strong>{{ selectedLanguage === 'en' ? 'Explore rooms' : selectedLanguage === 'pt' ? 'Explorar salas' : 'Explora salas' }}</strong>
              <p>{{ selectedLanguage === 'en' ? 'Discover brands, categories and active public rooms.' : selectedLanguage === 'pt' ? 'Descubra marcas, categorias e salas publicas ativas.' : 'Descubre marcas, categorias y salas publicas activas.' }}</p>
            </div>
            <button type="button" class="explore-modal-close" @click="closeExploreModal">✕</button>
          </div>

          <div class="explore-categories explore-modal-categories">
            <button
              v-for="category in availableExploreCategories"
              :key="`modal_${category.id}`"
              type="button"
              class="explore-category-chip"
              :class="{ active: activeExploreModalCategory === category.id }"
              @click="selectExploreModalCategory(category.id)"
            >
              {{ category.label }}
            </button>
          </div>

          <div class="explore-modal-body">
            <div v-if="filteredExploreModalProfiles.length" class="explore-modal-rail">
              <button
                v-for="profile in filteredExploreModalProfiles.slice(0, 8)"
                :key="`rail_${profile.canalId}`"
                type="button"
                class="explore-modal-rail-item"
                @click="visitarPerfilExploracion(profile)"
              >
                <div
                  class="explore-modal-rail-thumb"
                  :style="{ backgroundImage: `url(${profile.imageUrl || profile.logoUrl || fallbackExploreImage})` }"
                ></div>
                <span>{{ profile.brandName || profile.title }}</span>
              </button>
            </div>

            <div v-if="filteredExploreModalProfiles.length" class="explore-modal-featured">
              <div class="explore-modal-featured-kicker">
                {{ selectedLanguage === 'en' ? 'Featured rooms' : selectedLanguage === 'pt' ? 'Salas em destaque' : 'Salas destacadas' }}
              </div>
              <div class="explore-modal-slider">
                <div
                  v-for="profile in filteredExploreModalProfiles"
                  :key="`featured_${profile.canalId}`"
                  class="explore-modal-slide"
                >
                  <button type="button" class="explore-modal-featured-card" @click="visitarPerfilExploracion(profile)">
                    <div
                      class="explore-modal-featured-bg"
                      :style="{ backgroundImage: `url(${profile.imageUrl || profile.logoUrl || fallbackExploreImage})` }"
                    ></div>
                    <div class="explore-modal-featured-overlay"></div>
                    <div class="explore-modal-featured-meta">
                      <div class="explore-modal-brand-badge">
                        <img v-if="profile.logoUrl" :src="profile.logoUrl" :alt="profile.brandName || profile.title">
                        <img v-else src="../assets/uvoto.png" alt="Uvoto">
                      </div>
                      <div class="explore-modal-featured-copy">
                        <strong>{{ profile.brandName || profile.title }}</strong>
                       <span>
                          {{
                            profile.description
                              ? profile.description.slice(0, 60) + (profile.description.length > 60 ? '...' : '')
                              : profile.subtitle
                          }}
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>

            <div v-if="!exploreModalQuery.trim() && exploreCategoryRows.length" class="explore-category-rows">
              <div v-for="row in exploreCategoryRows" :key="`row_${row.key}`" class="explore-category-row">
                <div class="explore-category-row-kicker">{{ row.label }}</div>
                <div class="explore-category-row-rail">
                  <button
                    v-for="profile in row.profiles"
                    :key="`row_${row.key}_${profile.canalId}`"
                    type="button"
                    class="explore-modal-rail-item"
                    @click="visitarPerfilExploracion(profile)"
                  >
                    <div
                      class="explore-modal-rail-thumb"
                      :style="{ backgroundImage: `url(${profile.imageUrl || profile.logoUrl || fallbackExploreImage})` }"
                    ></div>
                    <span>{{ profile.brandName || profile.title }}</span>
                  </button>
                </div>
              </div>
            </div>

            <div v-if="exploreModalQuery.trim()" class="explore-search-results">
              <button
                v-for="profile in searchExploreProfiles"
                :key="`search_${profile.canalId}`"
                type="button"
                class="explore-search-card"
                @click="visitarPerfilExploracion(profile)"
              >
                <div
                  class="explore-search-card-media"
                  :style="{ backgroundImage: `url(${profile.imageUrl || profile.logoUrl || fallbackExploreImage})` }"
                ></div>
                <div class="explore-search-card-copy">
                  <strong>{{ profile.brandName || profile.title }}</strong>
                  <span>{{ profile.categoryLabel || profile.subtitle }}</span>
                </div>
              </button>
            </div>
          </div>

          <div class="explore-modal-searchbar">
            <input
              v-model="exploreModalQuery"
              type="text"
              class="explore-modal-search-input"
              :placeholder="selectedLanguage === 'en' ? 'Search brands, categories or rooms' : selectedLanguage === 'pt' ? 'Buscar marcas, categorias ou salas' : 'Busca marcas, categorías o salas'"
            >
          </div>
        </div>
      </div>
    </transition>

  </div>
  </transition>
  </template>

  <div v-else-if="votoRealizado && preguntaActiva && preguntaActiva.estado !== 'finalizado' && preguntaActiva.tipoContenido !== 'cards' && proyectorConfig.modo !== 'cards'" class="success-screen animate-in" :style="{ '--brand': proyectorConfig.color }">
    <div v-if="proyectorConfig.modo === 'resultados' && preguntaTieneRespuestaCorrecta(preguntaActiva)" class="results-layout">
      <div v-if="ganadorLocal" class="winner-card animate__animated animate__backInUp">
        <div class="winner-header">
          <span class="confetti-icon">🎊</span>
          <h1 class="poppins-bold text-correct">RESPUESTA CORRECTA</h1>
        </div>
        <div class="correct-info-box">
          <p class="label">La respuesta ganadora es:</p>
          <h2 class="correct-val">{{ respuestaCorrectaTexto }}</h2>
        </div>
        <div v-if="runtimeConfig.gamificationEnabled" class="points-badge-premium animate__animated animate__pulse">
          <div class="pts-glow"></div>
          <span class="pts-number">+{{ puntosGanados }}</span>
          <span class="pts-sub">PUNTOS OBTENIDOS</span>
        </div>
      </div>

      <div v-else class="loser-card animate__animated animate__fadeIn">
        <div class="error-icon">✕</div>
        <h2 class="poppins-bold" style="color: white;">¡Casi lo logras!</h2>
        <p style="color: white;">
          La respuesta era: <br><br>
          <strong 
            :style="{ fontSize: (respuestaCorrectaTexto && respuestaCorrectaTexto.length <= 6) ? '50px' : '30px' }"
            style="transition: font-size 0.3s ease;"
          >
            {{ respuestaCorrectaTexto }}
          </strong>
        </p>
        <div class="encouragement">¡Suerte en la próxima! 🚀</div>
      </div>
    </div>

    <div v-else-if="preguntaTieneRespuestaCorrecta(preguntaActiva)" class="waiting-mode">
      <div class="loader-ring">
        <div class="spinner-dot" :style="{ background: '#ff9800' }"></div>
      </div>
      <h2 class="poppins-bold">¡Voto registrado!</h2>
      <p>Mira la pantalla principal para ver si ganaste.</p>
    </div>

    <div v-else class="standard-success">
      <div class="check-circle">✓</div>
      <h2 class="poppins-bold">¡Recibido!</h2>
      <p>Gracias por tu respuesta en {{ tituloVisibleSesionUsuario || 'el evento' }}</p>
      <div class="standard-success-confetti">
        <span>🎉</span><span>✨</span><span>🎊</span>
      </div>
    </div>
  </div>

  <div v-else-if="proyectorConfig?.modo === 'conteo'" class="user-countdown-screen animate-in" :style="proyectorConfig.BrandingActual ? 'background:' + proyectorConfig.BrandingActual : ''">
    <div class="brand-bg-overlay" :style="{ background: proyectorConfig.color }"></div>
    <div class="timer-user-container">
      <p class="timer-user-label">{{ proyectorConfig.ultimoConteo?.titulo || '¡Atención!' }}</p>
      <h1 class="timer-user-display poppins-bold" :class="{ 'blink-red': tiempoRestante <= 10 && tiempoRestante > 0, 'timer-paused': proyectorConfig.ultimoConteo?.estado === 'pause' }">
        {{ tiempoRestante > 0 ? formatTimer(tiempoRestante) : '0:00' }}
      </h1>
      <transition name="fade">
        <div v-if="proyectorConfig.ultimoConteo?.estado === 'pause'" class="pause-tag">TIEMPO PAUSADO</div>
      </transition>
    </div>
    <div class="user-reaction-bar animate-up">
      <p class="reaction-title">¿Cómo vas? ¡Reacciona!</p>
      <div class="emoji-reaction-grid">
        <button v-for="e in ['🔥', '🚀', '👏', '😮', '💡']" :key="e" @click="ejecutarReaccionCompleta(e)" class="reaction-btn">{{ e }}</button>
      </div>
    </div>
    <div class="timer-progress-bar">
      <div class="progress-fill" :style="{ width: (tiempoRestante / (proyectorConfig.ultimoConteo?.segundos || 1) * 100) + '%', backgroundColor: '#fff' }"></div>
    </div>
  </div>

  <div v-else-if="(preguntaActiva?.tipoContenido === 'cards' || proyectorConfig?.modo === 'cards')" class="cards-user-section animate__animated animate__fadeIn">
    
    <Cards
      :titulo="proyectorConfig.tituloCard || 'Elige una opcion'"
      :moments="proyectorConfig.cardsData || []"
      :brandColor="proyectorConfig.color"
      :votoBloqueado="votoRealizado"
      :preselectedCard="cardVotada"
      @vote="enviarVotoCard"
    />
  </div>

  <div v-else-if="preguntaActiva && preguntaActiva.tipoContenido === 'ordenar'" class="vote-screen-overlay animate-in" :style="{ '--brand': proyectorConfig.color }">
    <div class="vote-card">
      <div class="vote-header">
        <span class="live-tag" :style="{ background: proyectorConfig.color }">ORDENAR</span>
        <h2 class="question-title">{{ preguntaActiva.titulo }}</h2>
        <p class="instruction-text" v-if="preguntaActiva.descripcion">{{ preguntaActiva.descripcion }}</p>
      </div>
      <div class="order-container">
        <draggable v-model="listaOrdenable" item-key="id" animation="300" ghost-class="sortable-ghost" drag-class="sortable-drag">
          <template #item="{ element, index }">
            <div class="sortable-item">
              <div class="sort-badge" :style="{ background: proyectorConfig.color }">{{ index + 1 }}</div>
              <div class="sort-text">{{ element }}</div>
              <div class="sort-handle"><span></span><span></span><span></span></div>
            </div>
          </template>
        </draggable>
      </div>
      <button @click="enviarOrden" class="btn-submit-full" :disabled="loadingEnvio" :style="{ background: proyectorConfig.color }">
        {{ loadingEnvio ? 'Enviando...' : 'Confirmar orden' }}
      </button>
    </div>
  </div>

 <div v-else-if="preguntaActiva && preguntaActiva.tipoContenido === 'quiz' && preguntaActiva.estado !== 'finalizado'" class="vote-screen-overlay animate-in" :style="{ '--brand': proyectorConfig.color }">
    <div class="vote-card">
      <div v-if="tiempoQuiz > 0" class="quiz-active-layout">
        <div class="quiz-timer-container-circular">
          <div class="circular-timer">
            <svg viewBox="0 0 36 36" class="circular-chart">
              <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
              <path class="circle" :style="{ strokeDasharray: (tiempoQuiz / preguntaActiva.duracion * 100) + ', 100', stroke: tiempoQuiz <= 5 ? '#ff5252' : proyectorConfig.color }" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
            </svg>
            <div class="timer-percentage poppins-bold" :class="{ 'timer-low': tiempoQuiz <= 5 }">{{ tiempoQuiz }}</div>
          </div>
          <div class="timer-info">
            <span class="live-tag" style="background: #ff9800;">QUIZ EN CURSO</span>
            <p class="instruction-text-mini">¡Selecciona tu respuesta ahora!</p>
          </div>
        </div>
        <div class="vote-header"><h2 class="question-title">{{ preguntaActiva.titulo }}</h2></div>
        <div class="options-grid">
          <button v-for="(opt, i) in preguntaActiva.opciones" :key="i" @click="indiceSeleccionado = i" class="opt-btn quiz-btn" :class="{ 'is-selected': indiceSeleccionado === i }" :style="indiceSeleccionado === i ? { borderColor: proyectorConfig.color, background: proyectorConfig.color + '40' } : {}">
            <span class="opt-label" :style="indiceSeleccionado === i ? { background: proyectorConfig.color } : {}">{{ String.fromCharCode(65 + i) }}</span>
            <span class="opt-text">{{ opt }}</span>
            <span v-if="indiceSeleccionado === i" class="opt-selected-check">✓</span>
          </button>
        </div>
        <button @click="enviarVotoQuiz(indiceSeleccionado)" class="btn-submit-full" :disabled="indiceSeleccionado === null || loadingEnvio" :style="{ background: proyectorConfig.color }">
          {{ loadingEnvio ? 'Enviando...' : 'Confirmar Respuesta' }}
        </button>
      </div>
      <div v-else class="time-expired-overlay animate__animated animate__fadeIn">
        <div class="expired-content">
          <div class="big-timer-zero"><svg viewBox="0 0 36 36" class="circular-chart"><path class="circle-bg-expired" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/></svg><span class="zero-num poppins-bold">0</span></div>
          <h2 class="poppins-bold">¡TIEMPO AGOTADO!</h2>
          <p class="expired-subtitle">No logramos recibir tu respuesta a tiempo.</p>
          <div class="attention-box"><p>Mira la pantalla principal para conocer la respuesta correcta</p></div>
        </div>
      </div>
    </div>
  </div>

  <div v-else-if="preguntaActiva && preguntaActiva.tipoContenido === 'multichoice'" class="vote-screen-overlay animate-in" :style="{ '--brand': proyectorConfig.color }">
    <div class="vote-card">
      <div class="vote-header">
        <span class="live-tag" :style="{ background: proyectorConfig.color || '#4cafef' }">MULTIPLE</span>
        <h2 class="question-title">{{ preguntaActiva.titulo }}</h2>
        <p class="instruction-text">{{ preguntaActiva.config?.maxSeleccion > 0 ? `Selecciona hasta ${preguntaActiva.config.maxSeleccion} opciones` : 'Selecciona todas las que quieras' }}</p>
      </div>
      <div class="options-grid">
        <button v-for="(opt, i) in preguntaActiva.opciones" :key="i" @click="toggleSeleccionMultiple(i)" class="opt-btn multi-btn" :class="{ 'is-selected-multi': indicesSeleccionados.includes(i) }" :style="indicesSeleccionados.includes(i) ? { borderColor: proyectorConfig.color, backgroundColor: proyectorConfig.color + '40' } : {}">
          <div class="multi-check" :style="indicesSeleccionados.includes(i) ? { background: proyectorConfig.color, borderColor: proyectorConfig.color } : {}">
            <span v-if="indicesSeleccionados.includes(i)" class="check-icon">✓</span>
          </div>
          <span class="opt-text">{{ opt }}</span>
        </button>
      </div>
      <button @click="enviarVotoMultiple" class="btn-submit-full" :disabled="indicesSeleccionados.length === 0 || loadingEnvio" :style="{ background: proyectorConfig.color }">
        {{ loadingEnvio ? 'Enviando...' : 'Enviar selección (' + indicesSeleccionados.length + ')' }}
      </button>
    </div>
  </div>

  <div v-else-if="preguntaActiva && preguntaActiva.tipoContenido === 'pregunta'" class="vote-screen-overlay animate-in" :style="{ '--brand': proyectorConfig.color }">
    <div class="vote-card">
      <div class="vote-header">
        <span class="live-tag" :style="{ background: proyectorConfig.color }">LIVE</span>
        <h2 class="question-title">{{ preguntaActiva.titulo }}</h2>
      </div>
      <div v-if="preguntaActiva.opciones?.length > 0" class="options-grid">
        <button v-for="(opt, i) in preguntaActiva.opciones" :key="i" @click="indiceSeleccionado = i" class="opt-btn" :class="{ 'is-selected': indiceSeleccionado === i }" :style="indiceSeleccionado === i ? { borderColor: proyectorConfig.color, background: proyectorConfig.color + '40' } : {}">
          <span class="opt-label" :style="indiceSeleccionado === i ? { background: proyectorConfig.color } : {}">{{ getLabel(i) }}</span>
          <span class="opt-text">{{ opt }}</span>
          <span v-if="indiceSeleccionado === i" class="opt-selected-check">✓</span>
        </button>
      </div>
      <div v-if="!preguntaActiva.opciones?.length || preguntaActiva.permiteComentarios" class="input-group-section">
        <textarea v-model="comentario" placeholder="Escribe aquí..." class="minimal-textarea" @input="adjustTextarea"></textarea>
      </div>
      <button @click="enviarParticipacionCompleta" class="btn-submit-full" :disabled="botonDeshabilitado" :style="{ background: proyectorConfig.color }">
        {{ loadingEnvio ? 'Enviando...' : 'Enviar participación' }}
      </button>
    </div>
  </div>

<div v-else-if="puedeMostrarSalaEspera" class="wr-screen animate-in" :class="{ 'is-join-page': esRutaJoin }" :style="waitingRoomUserScreenStyle">

  <!-- Blobs de color reactivos al slide activo -->
  <div class="wr-bg-blob wr-bg-blob--top"    :style="{ background: activeWaitingRoomSlide?.dominantColor || '#3d2f2f' }"></div>
  <div class="wr-bg-blob wr-bg-blob--bottom" :style="{ background: activeWaitingRoomSlide?.accentColor  || '#1a1a2e' }"></div>

  <!-- Header: logo + título de sesión (igual al Admin) -->
  <!-- En /join no hay sesión que encabezar -->
  <div v-if="!esRutaJoin" class="wr-header">
    <img
      v-if="proyectorConfig.logoEmpresa"
      :src="proyectorConfig.logoEmpresa"
      class="wr-header-logo"
      alt=""
    >
    <div v-else class="wr-header-logo-placeholder">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M4 21V6.5L12 3l8 3.5V21"/>
        <path d="M9 21v-6h6v6"/>
        <path d="M9 10h.01M15 10h.01M9 14h.01M15 14h.01"/>
      </svg>
    </div>
    <div class="wr-header-meta">
      <span class="wr-header-title">{{ proyectorConfig?.brandName || tituloVisibleSesionUsuario || proyectorConfig?.nombreSesion || 'Sesión activa' }}</span>
      <span class="wr-header-live">
        
        Waiting Room
      </span>
    </div>
    <button
      v-if="puedeMostrarQnaEnWaitingRoom"
      class="wr-chat-chip"
      @click="abrirPanelConsultas"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
      </svg>
      <span>Pregúntame</span>
    </button>
  </div>

  <!-- Swiper de lienzos -->
  <Swiper
    @swiper="setWaitingRoomSwiper"
    class="wr-slider"
    :slides-per-view="1"
    :space-between="0"
    :centered-slides="false"
    :watch-overflow="true"
    :loop="false"
    :resistance-ratio="0"
    :grab-cursor="displayWaitingRoomSlides.length > 1"
    :speed="260"
    @slideChange="onWaitingRoomUserSlideChange"
    @touchStart="onWrSlideMovementStart"
    @sliderMove="onWrSlideMovementStart"
    @transitionStart="onWrSlideMovementStart"
    @transitionEnd="onWrSlideMovementEnd"
    @touchEnd="onWrSlideMovementEnd"
  >
    <SwiperSlide
      v-for="(slide, index) in displayWaitingRoomSlides"
      :key="slide.id || index"
      class="wr-slide"
      :class="{ 'wr-slide-brand-claim': slide.layoutType === 'brand-claim' }"
    >
      <!-- ── Lienzo tipo BRAND CLAIM ── -->
      <template v-if="slide.layoutType === 'brand-claim'">
        <div class="wr-brand-claim-stage" @pointerdown="pausarCarruselMarca">
          <div class="wr-brand-claim-bg"></div>

          <div class="wr-premium-scene">
            <!-- Foto del canal a sangre completa, con el nombre y la descripción
                 encima sobre un degradado negro de abajo hacia arriba. -->
            <div
              class="wr-claim-track"
              :style="{
                transform: `translateX(-${brandSlideIndex * 100}%)`,
                transition: brandSlideIndex === 0 ? 'none' : 'transform 0.6s cubic-bezier(0.65, 0, 0.35, 1)'
              }"
            >
              <div
                v-for="(r, i) in brandClaimSlides"
                :key="r.canalId || i"
                class="wr-claim-shot"
              >
                <div
                  class="wr-claim-photo"
                  :style="r.imageUrl ? { backgroundImage: `url(${r.imageUrl})` } : {}"
                ></div>
                <div class="wr-claim-fade"></div>
                <div class="wr-claim-meta">
                  <span class="wr-claim-name">{{ r.brandName || r.title || 'Brand' }}</span>
                  <span class="wr-claim-desc">{{ r.descripcion || r.description || 'Interactive room' }}</span>
                </div>
              </div>
              <!-- Clon del primero para que el bucle no dé el salto -->
              <div class="wr-claim-shot" v-if="brandClaimSlides.length">
                <div
                  class="wr-claim-photo"
                  :style="brandClaimSlides[0]?.imageUrl ? { backgroundImage: `url(${brandClaimSlides[0].imageUrl})` } : {}"
                ></div>
                <div class="wr-claim-fade"></div>
                <div class="wr-claim-meta">
                  <span class="wr-claim-name">{{ brandClaimSlides[0]?.brandName || brandClaimSlides[0]?.title || 'Brand' }}</span>
                  <span class="wr-claim-desc">{{ brandClaimSlides[0]?.descripcion || brandClaimSlides[0]?.description || 'Interactive room' }}</span>
                </div>
              </div>
            </div>

            <div v-show="false" class="wr-floating-notif notif-1">
              <div class="notif-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M12 5v6 M9 8h6"/></svg>
              </div>
              <div class="notif-content">
                <strong>Asistente IA</strong>
                <span>Listo para interactuar.</span>
              </div>
            </div>

            <div class="wr-floating-notif notif-2">
              <div class="notif-icon is-brand">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
              </div>
              <div class="notif-content">
                <strong>uvoto.com/{{ brandSlugDraft || 'tu-marca' }}</strong>
                <span>Tu espacio conectado.</span>
              </div>
            </div>

            <!-- Floating Profession Icons – upper half only -->
            <!-- Tech / Dev -->
            <div class="wr-float-icon icon-1">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/><path d="m9 8 2 2-2 2M13 12h2"/></svg>
            </div>
            <!-- Camera -->
            <div class="wr-float-icon icon-2">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
            </div>
            <!-- Palette -->
            <div class="wr-float-icon icon-3">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 2a10 10 0 0 1 0 20c-1.7 0-3-1.3-3-3 0-.7.3-1.3.7-1.8.3-.4.3-1-.3-1.2-2.4-.8-4.4-3-4.4-5.5A7 7 0 0 1 12 5"/><circle cx="8" cy="8" r="1" fill="currentColor"/><circle cx="16" cy="8" r="1" fill="currentColor"/><circle cx="17" cy="14" r="1" fill="currentColor"/></svg>
            </div>
            <!-- Shopping -->
            <div class="wr-float-icon icon-4">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
            </div>
            <!-- Mic -->
            <div class="wr-float-icon icon-5">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
            </div>
            <!-- Chart -->
            <div class="wr-float-icon icon-6">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>
            </div>
            <!-- Music -->
            <div class="wr-float-icon icon-7">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>
            </div>
            <!-- Globe -->
            <div class="wr-float-icon icon-8">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
            </div>
          </div>
        </div>

        <div class="wr-copy wr-copy-brand-claim">
          <h2 class="wr-brand-claim-hero-title">
            <!-- En /join no hay sesión de la que "unirse": el gancho es el link -->
            <template v-if="selectedLanguage === 'en'">
              <template v-if="esRutaJoin">Claim your link and<br></template>
              <template v-else>Join, claim your link and<br></template>
              build your <span class="text-lime">interactive brand.</span>
            </template>
            <template v-else-if="selectedLanguage === 'pt'">
              <template v-if="esRutaJoin">Garanta seu link e<br></template>
              <template v-else>Junte-se, garanta seu link e<br></template>
              crie sua marca <span class="text-lime">interativa.</span>
            </template>
            <template v-else>
              <template v-if="esRutaJoin">Reclama tu link y<br></template>
              <template v-else>Únete, reclama tu link y<br></template>
              crea tu branding <span class="text-lime">interactivo.</span>
            </template>
          </h2>
          <p class="wr-block wr-block--small" style="color: rgba(255,255,255,0.65); margin-bottom: 24px; font-size: 15px; line-height: 1.5; font-weight: 400;">
            <template v-if="selectedLanguage === 'en'">Secure your Uvoto link and turn your profile into your audience's command center.</template>
            <template v-else-if="selectedLanguage === 'pt'">Garanta seu link no Uvoto e transforme seu perfil no centro de operações da sua audiência.</template>
            <template v-else>Asegura tu enlace en Uvoto y convierte tu perfil en el centro de operaciones de tu audiencia.</template>
          </p>

          <!-- Con reserva activa el input desaparece: lo único que falta es
               volver al panel de descarga, así que el campo cede su lugar. -->
          <button
            v-if="tieneReservaActiva"
            type="button"
            class="wr-continue-claim-btn"
            @click="openJoinHomePanel"
          >
            <span class="wr-continue-claim-copy">
              <span class="wr-continue-claim-label">{{
                selectedLanguage === 'en' ? 'Continue your reservation'
                : selectedLanguage === 'pt' ? 'Continue sua reserva'
                : 'Continúa con tu reserva'
              }}</span>
              <span class="wr-continue-claim-slug">uvoto.com/{{ brandSlugDraft }}</span>
            </span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" width="18" height="18">
              <path d="M5 12h14M13 6l6 6-6 6"/>
            </svg>
          </button>
          <label v-else class="wr-startup-input-wrapper">
            <span class="wr-startup-input-prefix">uvoto.com/</span>
            <input
              :value="brandSlugDraft"
              type="text"
              maxlength="24"
              class="wr-startup-input-field"
              :placeholder="slide.placeholder"
              @input="onBrandSlugInput"
              @focus="wrMarcaInputEnfocado = true"
              @blur="wrMarcaInputEnfocado = false; scrollJoinArriba()"
            >
            <button
              type="button"
              class="wr-startup-submit-btn"
              :disabled="brandSlugStatus === 'checking' || brandSlugStatus === 'saving' || !canReserveBrandSlug"
              @click="reserveBrandSlugAndContinue"
            >
              {{ brandSlugStatus === 'saving' ? (selectedLanguage === 'en' ? 'Saving...' : selectedLanguage === 'pt' ? 'Salvando...' : 'Guardando...') : (selectedLanguage === 'en' ? 'Reserve' : selectedLanguage === 'pt' ? 'Reservar' : 'Reservar') }}
            </button>
          </label>
          <small v-if="brandSlugMessage && !tieneReservaActiva" class="wr-brand-claim-status" :class="`is-${brandSlugStatus}`">
            {{ brandSlugMessage }}
          </small>
        </div>
      </template>

      <!-- ── Lienzo tipo TEXTO (primaryText grande centrado) ── -->
      <div
        v-else-if="slide.layoutType === 'text'"
        class="wr-media-wrap wr-media-wrap-text"
        :style="{ background: `linear-gradient(135deg, ${slide.accentColor || '#5a4635'} 0%, ${slide.dominantColor || '#2f2a27'} 100%)` }"
      >
        <div
          class="wr-primary-text-card"
          :style="wrPrimaryTextStyle(slide)"
        >{{ slide.primaryText || '' }}</div>
      </div>

      <!-- ── Lienzo tipo VIDEO ── -->
      <div v-else-if="slide.layoutType === 'video' && slide.videoUrl" class="wr-media-wrap wr-media-wrap--video" :class="{ 'is-9x16': slide.videoAspectRatio === '9:16' }">
          <video
            class="wr-video-embed"
            :class="{ 'is-loaded': videoLoadedMap[slide.id] }"
            :src="slide.videoUrl"
            :muted="slide.videoMuted !== false || videoMutedMap[slide.id] !== false"
            loop
            playsinline
            preload="auto"
            :style="{ objectPosition: (slide.videoPanX ?? 50) + '% ' + (slide.videoPanY ?? 50) + '%' }"
            @loadeddata="onVideoLoaded(slide.id)"
          ></video>
          <div v-if="!videoLoadedMap[slide.id]" class="wr-video-loader">
            <svg class="wr-video-spinner" viewBox="0 0 44 44" fill="none">
              <circle cx="22" cy="22" r="18" stroke="rgba(255,255,255,0.12)" stroke-width="2.5"/>
              <circle cx="22" cy="22" r="18" stroke="rgba(255,255,255,0.85)" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="30 83"/>
            </svg>
          </div>
          <!-- Botón de audio — sólo visible si el admin permitió sonido -->
          <button
            v-if="slide.videoMuted === false"
            class="wr-video-mute-fab"
            @click.stop="toggleVideoMute(slide.id, $event)"
            :title="videoMutedMap[slide.id] !== false ? 'Activar sonido' : 'Silenciar'"
          >
            <svg v-if="videoMutedMap[slide.id] !== false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/>
            </svg>
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/>
            </svg>
          </button>
      </div>

      <!-- ── Lienzo tipo IMAGEN ── -->
      <div v-else-if="slide.imageUrl || slide.imagePreview" class="wr-media-wrap">
        <div
          class="wr-media-blur-bg"
          :style="{ backgroundImage: `url(${slide.imageUrl || slide.imagePreview})` }"
        ></div>
        <img
          :src="slide.imageUrl || slide.imagePreview"
          v-img-watchdog="slide.imageUrl || slide.imagePreview"
          class="wr-media-img"
          :style="{
            objectPosition: (slide.imagePanX ?? 50) + '% ' + (slide.imagePanY ?? 50) + '%',
            transform: 'translateZ(0) scale(' + (slide.imageZoom ?? 1) + ')'
          }"
          alt=""
          loading="eager"
          decoding="async"
        >
      </div>

      <!-- ── Copy: bloques en el orden definido por el admin ── -->
      <div class="wr-copy" v-if="slide.layoutType !== 'brand-claim' && wrSlideHasContent(slide)">

        <!-- Sistema unificado (nuevo): blocks[] preserva el orden exacto -->
        <template v-if="slide.blocks && slide.blocks.length">
          <template v-for="block in slide.blocks" :key="block.id">

            <!-- Texto -->
            <div
              v-if="block.type === 'text' && (block.text || '').trim()"
              class="wr-block"
              :class="`wr-block--${block.kind || 'small'}`"
              :style="{ color: wrSlideTextColor(slide, block.kind === 'small' ? 0.65 : block.kind === 'text' ? 0.82 : 1) }"
            >{{ block.text }}</div>

            <!-- Link -->
            <div
              v-else-if="block.type === 'link' && (block.value || '').trim()"
              class="wr-links wr-links--block"
            >
              <a
                :href="wrBuildLink(block)"
                class="wr-link-chip"
                @click.prevent="abrirLinkInApp(wrBuildLink(block))"
              >
                <span class="wr-link-chip-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" v-html="wrPlatformIcon(block.platform || 'url')"></svg>
                </span>
                <span class="wr-link-chip-body">
                  <span class="wr-link-chip-platform">{{ wrPlatformLabel(block.platform) }}</span>
                  <span class="wr-link-chip-text">{{ block.label || wrBuildLink(block) }}</span>
                </span>
                <svg class="wr-link-chip-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </a>
            </div>

            <!-- Galería -->
            <div
              v-else-if="block.type === 'gallery' && (block.images || []).some(img => img.imageUrl)"
              class="wr-gallery-grid"
            >
              <button
                v-for="image in (block.images || []).filter(img => img.imageUrl)"
                :key="image.id || image.imageUrl"
                type="button"
                class="wr-gallery-thumb"
                @click="openAiContextGallery(block.images, image)"
              >
                <img :src="image.imageUrl" v-img-watchdog="image.imageUrl" :alt="image.caption || 'Imagen del waiting room'" loading="eager" decoding="async">
              </button>
            </div>

          </template>
        </template>

        <!-- Fallback legado: textBlocks + links + galleryImages (datos sin blocks[]) -->
        <template v-else>
          <template v-if="slide.textBlocks && slide.textBlocks.length">
            <div
              v-for="block in slide.textBlocks.filter(b => (b.text || '').trim())"
              :key="block.id"
              class="wr-block"
              :class="`wr-block--${block.kind || 'small'}`"
              :style="{ color: wrSlideTextColor(slide, block.kind === 'small' ? 0.65 : block.kind === 'text' ? 0.82 : 1) }"
            >{{ block.text }}</div>
          </template>
          <template v-else>
            <div v-if="slide.title"       class="wr-block wr-block--title"   :style="{ color: wrSlideTextColor(slide) }">{{ slide.title }}</div>
            <div v-if="slide.subtitle"    class="wr-block wr-block--subtitle" :style="{ color: wrSlideTextColor(slide) }">{{ slide.subtitle }}</div>
            <div v-if="slide.description" class="wr-block wr-block--small"   :style="{ color: wrSlideTextColor(slide, 0.65) }">{{ slide.description }}</div>
          </template>
          <div v-if="slide.links && slide.links.filter(l => l.value && l.value.trim()).length" class="wr-links">
            <a
              v-for="link in slide.links.filter(l => l.value && l.value.trim())"
              :key="link.id"
              :href="wrBuildLink(link)"
              class="wr-link-chip"
              :class="getWrLinkClass(link)"
              @click.prevent="abrirLinkInApp(wrBuildLink(link))"
            >
              <span class="wr-link-chip-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" v-html="wrPlatformIcon(link.platform || 'url')"></svg>
              </span>
              <span class="wr-link-chip-body">
                <span class="wr-link-chip-platform">{{ wrPlatformLabel(link.platform) }}</span>
                <span class="wr-link-chip-text">{{ link.label || wrBuildLink(link) }}</span>
              </span>
              <svg class="wr-link-chip-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                <path d="M5 12h14M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </div>
          <div v-if="slide.galleryImages && slide.galleryImages.length" class="wr-gallery-grid">
            <button
              v-for="image in slide.galleryImages"
              :key="image.id || image.imageUrl"
              type="button"
              class="wr-gallery-thumb"
              @click="openAiContextImage(image)"
            >
              <img :src="image.imageUrl" v-img-watchdog="image.imageUrl" :alt="image.caption || 'Imagen del waiting room'" loading="eager" decoding="async">
            </button>
          </div>
        </template>

      </div>

    </SwiperSlide>
  </Swiper>


  <div v-if="displayWaitingRoomSlides.length > 1" class="wr-dots">
    <span
      v-for="(s, i) in displayWaitingRoomSlides"
      :key="i"
      class="wr-dot"
      :class="{ active: activeWaitingRoomIndex === i }"
    ></span>
  </div>

  <div
    v-if="mostrarGuiaSlidesWaitingRoom"
    class="wr-guide-overlay"
  >
    <div class="wr-guide-hand-wrap">
      <svg class="wr-guide-trail" viewBox="0 0 220 72" fill="none" aria-hidden="true">
        <path d="M26 36C60 14 96 14 126 36C154 56 178 56 198 40" />
      </svg>
      <div class="wr-guide-hand-float" :style="waitingRoomGuideHandStyle">
        <img class="wr-guide-hand" src="../assets/hand.png" alt="" aria-hidden="true">
      </div>
    </div>
    <div class="wr-guide-card">
      <strong>Desliza para ver más</strong>
      <p>Puedes moverte entre las slides del waiting room hacia la izquierda o la derecha.</p>
      <button type="button" class="wr-guide-btn" @click="entendidoGuiaSlidesWaitingRoom">Entendido</button>
    </div>
  </div>

</div>

<div v-else-if="puedeMostrarMoments" class="moments-mobile-card animate-in">
    <div class="moments-mobile-header">
      <span class="moments-chip">{{ $t('user.moments_cta') }}</span>
      <p class="moments-instruction">{{ $t('user.moments_instruction') }}</p>
    </div>

    <div v-if="momentoPublicado" class="moments-waiting-state">
      <div class="moments-waiting-icon">✓</div>
      <p class="moments-success-text">{{ $t('user.moment_ready') }}</p>
      <p class="moments-waiting-copy">{{ $t('user.moment_waiting') }}</p>
    </div>

    <template v-else>
    <div class="moments-upload-stage">
      <div class="moments-photo-frame" :class="momentPreviewClass">
        <button class="moments-photo-picker" @click="$refs.momentInput.click()" :disabled="subiendoMomento">
          <img v-if="momentPhotoPreview" :src="momentPhotoPreview" class="moments-photo-preview">
          <div v-else class="moments-photo-empty">
            <div class="moments-upload-circle">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <rect x="3" y="5" width="18" height="14" rx="3"></rect>
                <circle cx="9" cy="10" r="1.5"></circle>
                <path d="M21 15l-4.5-4.5a1.8 1.8 0 0 0-2.6 0L8 16"></path>
              </svg>
            </div>
            <span>{{ subiendoMomento ? $t('user.processing_photo') : $t('user.select_image') }}</span>
          </div>
          <div v-if="subiendoMomento" class="moments-upload-overlay">
            <div class="spinner-inline-dark"></div>
          </div>
        </button>
      </div>
      <input
        ref="momentInput"
        type="file"
        accept="image/*"
        hidden
        @change="manejarSubidaMomento"
      >
    </div>

    <div class="input-group-section">
      <textarea
        v-model="momentCaption"
        maxlength="70"
        :placeholder="$t('user.moments_placeholder')"
        class="minimal-textarea moments-textarea"
        @input="adjustTextarea"
      ></textarea>
      <div class="moments-counter">{{ momentCaption.length }}/70</div>
    </div>

    <button
      @click="guardarMomento"
      class="btn-submit-full moments-submit-btn"
      :disabled="!puedeGuardarMomento || subiendoMomento"
      :style="{ background: '#111', color: '#fff' }"
    >
      {{ subiendoMomento ? $t('user.publishing_moment') : $t('user.publish_moment') }}
    </button>

    <p v-if="momentoGuardado" class="moments-success-text">{{ $t('user.moment_ready') }}</p>
    </template>
  </div>

  <div v-else class="empty-state animate-in">
    <div class="glass-info-card">
      <div class="connected-badge">{{ $t('user.connected_to') }}</div>
      <h2 class="room-name">{{ tituloVisibleSesionUsuario || 'la sesión' }}</h2>
      <div class="spinner-simple" :style="{ borderTopColor: proyectorConfig.color }"></div>
    </div>
    <p style="color: white; margin-top: 30%; padding: 20px; border: 1px dashed white; border-radius: 10px; font-size: 13px;">
      {{ $t('user.listening_changes') }}
    </p>
  </div>

  <!-- ── Modal buscador de salas ── -->
  <transition name="fade-overlay">
    <div v-if="showSearchModal" class="search-modal-overlay" @click.self="cerrarBuscador">
      <div class="search-bottom-sheet animate-up" @click.stop>
        <div class="handle"></div>
        <div class="search-sheet-header">
          <p class="search-sheet-title">Buscar sala</p>
          <button class="search-sheet-close" @click="cerrarBuscador">✕</button>
        </div>

        <div class="search-input-wrap">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <input
            ref="searchInput"
            v-model="searchQuery"
            type="text"
            placeholder="Nombre, slug o código..."
            class="search-input"
            @input="onSearchInput"
            autocomplete="off"
          />
          <button v-if="searchQuery" class="search-clear" @click="searchQuery = ''; searchResults = []">✕</button>
        </div>

        <!-- Loading -->
        <div v-if="searchLoading" class="search-loading">
          <div class="spinner-mini"></div>
          <span>Buscando...</span>
        </div>

        <!-- Sin resultados -->
        <div v-else-if="searchQuery.length >= 2 && !searchResults.length && !searchLoading" class="search-empty">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="1.8"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <p>Sin resultados para "{{ searchQuery }}"</p>
        </div>

        <!-- Resultados -->
        <div v-else-if="searchResults.length" class="search-results">
          <div
            v-for="sala in searchResults"
            :key="sala.canalId"
            class="search-result-item"
            @click="entrarDesdeBuscador(sala)"
          >
            <div class="sri-logo">
              <img v-if="sala.logo" :src="sala.logo" :alt="sala.nombre" />
              <div v-else class="sri-logo-fallback">{{ (sala.nombre || 'S')[0].toUpperCase() }}</div>
            </div>
            <div class="sri-info">
              <span class="sri-name">{{ sala.nombre }}</span>
              <span v-if="sala.shareSlug" class="sri-slug">{{ sala.shareSlug }}</span>
            </div>
            <div v-if="sala.activa" class="sri-active-dot" title="Activa ahora">
              <span class="sri-live-dot"></span>
              <span class="sri-live-label">EN VIVO</span>
            </div>
            <svg class="sri-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </div>
        </div>

        <!-- Hint inicial -->
        <div v-else-if="!searchQuery" class="search-hint">
          <p>Escribe el nombre, slug o código de la sala</p>
        </div>
      </div>
    </div>
  </transition>

</main>

  



      <div class="emoji-dock-container-right">
  
  <button 
    v-if="mostrarDisparadorGREETING" 
    class="btn-dock-trigger-right animate__animated animate__fadeInRight"
    @click="dockExpandido = true"
  >
    <span>🔥</span>
  </button>

  <transition name="dock-slide-rtl">
    <div v-if="dockExpandido && canalId" class="emoji-dock-expanded-rtl">
      
      <div class="dock-emojis-row">
        <button 
          v-for="(e, index) in ['👏', '😍', '🔥']" 
          :key="e"
          @click="ejecutarReaccionCompleta(e, $event)"
          class="emoji-item"
          :style="{ animationDelay: (0.3 - (index * 0.1)) + 's' }"
        >
          {{ e }}
        </button>
      </div>

      <button class="btn-dock-close-glass" @click="dockExpandido = false">
        ✕
      </button>

    </div>
  </transition>
</div>

<div v-if="presentarce" class="uvoto-overlay" @click.self="mostrarCajaLocal = false">
  
  <transition name="animate__animated animate__slideInUp" appear>
    <div class="uvoto-premium-panel">
      
      <div class="drag-handle" @click="mostrarCajaLocal = false"></div>
      
      <div class="panel-banner">
        <img src="https://images.squarespace-cdn.com/content/v1/57fb8aa26a496306c841e834/1493391452059-OV1IBQROOPZC5EUI4ZE4/representante+speakers+agent" class="banner-img">
        <div class="banner-overlay">
          <h3 class="event-name-overlay">{{ tituloVisibleSesionUsuario }}</h3>
        </div>
        <button class="btn-close-modern" @click="mostrarCajaLocal = false">✕</button>
      </div>

      <div class="panel-body">
        
        <div class="prompt-composer-box">
          
          <div class="prompt-top-row">
            <textarea 
              v-model="textoPresentacion" 
              placeholder="Presentate brevemente con los demas" 
              maxlength="80"
              class="prompt-textarea"
            ></textarea>
            
            <button 
              @click="enviarPresentacionFlash" 
              class="btn-send-up" 
              :style="{ background: textoPresentacion.trim() ? (proyectorConfig.color || '#000') : '#e0e0e0' }"
              :disabled="!textoPresentacion.trim() || loadingEnvio"
            >
              <span v-if="!loadingEnvio">↑</span>
              <span v-else class="spinner-mini"></span>
            </button>
          </div>

          <div class="prompt-bottom-row">
            
            <div class="prompt-helper-text">
              ✨ Manda tu energia al evento
            </div>

            <div class="prompt-emoji-row">
              <button 
                v-for="e in ['👏', '😍', '🔥']" 
                :key="e"
                @click="ejecutarReaccionCompleta(e, $event)" 
                class="emoji-inline-btn"
              >
                {{ e }}
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>
  </transition>
</div>
   
    <footer v-if="!proyectorConfig.waitingRoomEnabled && !wrMarcaInputEnfocado && !esRutaJoin" class="footer-text">
      <router-link to="/privacy#privacy-policy" class="footer-legal-link">{{
        selectedLanguage === 'en' ? 'Privacy Policy' : selectedLanguage === 'pt' ? 'Política de Privacidade' : 'Política de Privacidad'
      }}</router-link>
      <span class="footer-legal-sep"> · </span>
      <router-link to="/privacy#terms" class="footer-legal-link">{{
        selectedLanguage === 'en' ? 'Terms of Service' : selectedLanguage === 'pt' ? 'Termos de Serviço' : 'Términos y Condiciones'
      }}</router-link>
    </footer>
          </div>
        </div>
      </div>
    </div>
  </div>

  <button v-if="puedeMostrarQNA && !runtimeConfig.waitingRoomEnabled" @click="abrirPanelConsultas" class="btn-flotante-pregunta pulse-mini">
  <i class="fas fa-comment-dots"></i>
  <span>¿Tienes alguna duda?</span>
  <div class="apple-icon-circle" style="width: 40px; height: 40px; position: relative; margin: 0;">
      <img src="../assets/icon-white.png" alt="" style="width: 70%;">
    </div>
</button> 

<div
  v-show="mostrarModalPreguntas"
  class="modal-consultas-overlay animate__animated animate__fadeIn"
  :class="{ 'is-chat-only': isChatOnlyMode }"
  @click.self="!isChatOnlyMode && cerrarPanelConsultas()"
>
  <div class="modal-consultas-modern" :style="chatModalViewportStyle">

    <div class="chat-header-modern" :class="{ 'is-context-chat': !esContextoEventoActivo }">
      <div class="chat-header-identity">
        <div class="chat-header-avatar">
          <img v-if="chatHeaderAvatar" :src="chatHeaderAvatar" :alt="chatHeaderTitle">
          <div v-else class="chat-header-avatar-fallback">
            {{ (chatHeaderTitle || 'U').charAt(0).toUpperCase() }}
          </div>
        </div>
        <div class="chat-header-copy">
          <span class="chat-header-kicker">{{ chatHeaderKicker }}</span>
          <h3>{{ tituloVisibleSesionUsuario || proyectorConfig?.nombreSesion || 'Preguntame' }}</h3>
          <p v-if="chatHeaderSubtitle">{{ chatHeaderSubtitle }}</p>
        </div>
        <button v-if="!isChatOnlyMode" class="btn-x-cerrar" @click="cerrarPanelConsultas">✕</button>
      </div>
    </div>



   <div ref="chatBody" class="chat-body-modern" :style="chatBodyViewportStyle">
  
  <div v-if="showStarterPills" class="chat-empty-state">
    <div class="chat-welcome-bubble">
      <p class="chat-welcome-text">{{ chatWelcomeText }}</p>
    </div>
    <div class="chat-starters">
      <button
        v-for="hint in chatSuggestionChips"
        :key="hint.key"
        class="chat-starter-chip"
        @click="enviarStarter(hint.prompt)"
      >{{ hint.label }}</button>
    </div>
  </div>

  <template v-else>
    <div
      v-for="(item, index) in misConsultas"
      :key="item.id"
      class="chat-message"
      :data-msg-id="item.id"
    >
      <!-- User message -->
      <div v-if="item.audioUrl" class="msg-user-voice" :style="getUserBubbleStyle()">
        <button
          type="button"
          class="voice-note-play"
          @click="toggleVoicePlayback(item.id)"
          :aria-label="isVoicePlaying(item.id) ? 'Pausar nota de voz' : 'Reproducir nota de voz'"
        >
          <svg v-if="isVoicePlaying(item.id)" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <rect x="6" y="5" width="4" height="14" rx="1.5"></rect>
            <rect x="14" y="5" width="4" height="14" rx="1.5"></rect>
          </svg>
          <svg v-else viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M8 5.5v13l10-6.5-10-6.5Z"></path>
          </svg>
        </button>
        <div class="voice-note-wave" aria-hidden="true">
          <span v-for="bar in 12" :key="`sent_${item.id}_${bar}`"></span>
        </div>
        <span class="voice-note-duration">{{ formatVoiceDuration(item.audioDurationMs) }}</span>
        <audio
          :id="`voice-note-${item.id}`"
          :src="item.audioUrl"
          preload="metadata"
          @ended="handleVoicePlaybackEnded(item.id)"
        ></audio>
      </div>
      <div v-else-if="item.texto" class="msg-user" :style="getUserBubbleStyle()">{{ item.texto }}</div>

      <!-- Read receipt: only for user messages, not AI-initiated re-engagement -->
      <div v-if="item.texto || item.audioUrl" class="msg-sent-receipt">
        <svg viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 5l3.5 3.5L11 1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 5l3.5 3.5L16 1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <!-- AI response -->
      <template v-if="consultaTieneRespuesta(item)">
        <!-- Typing indicator phase -->
        <!-- Typing indicator phase -->
        <div v-if="revealState[item.id] && revealState[item.id].phase === 'typing'" class="msg-ai-writing" :class="{ 'is-delayed': revealState[item.id].phase === 'typing' }">
          <span class="msg-ai-writing-name">{{ tituloVisibleSesionUsuario || proyectorConfig?.nombreSesion || 'Asistente' }}</span> está escribiendo<span class="msg-ai-writing-dots"><span>.</span><span>.</span><span>.</span></span>
        </div>

        <!-- Reveal phase + fully-revealed (no revealState entry = complete) -->
        <div v-else-if="!revealState[item.id] || revealState[item.id].phase === 'revealing' || revealState[item.id].phase === 'typing-between'" class="msg-ai">
          <!-- Answer text — slot 0 -->
          <div
            v-if="getAiAnswer(item) && (!revealState[item.id] || revealState[item.id].visibleCount >= 1)"
            class="msg-ai-text"
            :class="{ 'msg-reveal-in': revealState[item.id] && revealState[item.id].visibleCount >= 1 }"
          >{{ getAiAnswer(item) }}</div>

          <!-- Blocks — slots 1..N -->
          <template v-for="(block, blockIndex) in getAiBlocks(item)" :key="`${item.id}_${block.type}_${blockIndex}`">
            <!-- slot index = (answer ? 1 : 0) + blockIndex + 1 -->
            <div
              v-if="!revealState[item.id] || revealState[item.id].visibleCount > (getAiAnswer(item) ? blockIndex + 1 : blockIndex)"
              class="msg-ai-block"
              :class="{ 'msg-reveal-in': revealState[item.id] && revealState[item.id].visibleCount === (getAiAnswer(item) ? blockIndex + 2 : blockIndex + 1) }"
            >
              <p v-if="block.title" class="msg-ai-block-title">{{ block.title }}</p>

              <div v-if="block.type === 'people'" class="ai-people-list">
                <button
                  v-for="(person, idx) in block.items || []"
                  :key="`${item.id}_person_${idx}`"
                  type="button"
                  class="ai-person-card"
                  @click="openAiPersonProfile(person)"
                >
                  <div class="ai-person-main">
                    <img v-if="person.imageUrl" :src="person.imageUrl" class="ai-person-avatar" alt="">
                    <div v-else class="ai-person-avatar ai-person-avatar-fallback">
                      {{ (person.title || 'P').charAt(0).toUpperCase() }}
                    </div>
                    <div class="ai-person-copy">
                      <strong>{{ person.title }}</strong>
                      <span v-if="person.subtitle">{{ person.subtitle }}</span>
                      <small v-if="person.meta">{{ person.meta }}</small>
                    </div>
                  </div>
                  <button
                    v-if="getPersonPrimaryLink(person)"
                    type="button"
                    class="ai-link-chip"
                    @click.stop="openAiExternalLink(getPersonPrimaryLink(person))"
                  >
                    <svg v-if="getPersonPrimaryLinkLabel(person) === 'LinkedIn'" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M6.94 8.5H3.56V20h3.38V8.5ZM5.25 3C4.14 3 3.25 3.9 3.25 5s.89 2 2 2 2-.9 2-2-.89-2-2-2ZM20.75 13.06c0-3.06-1.63-4.56-3.8-4.56-1.75 0-2.54.96-2.98 1.64V8.5h-3.38c.04 1.09 0 11.5 0 11.5h3.38v-6.42c0-.34.02-.68.12-.92.27-.68.9-1.39 1.95-1.39 1.38 0 1.94 1.05 1.94 2.59V20h3.38v-6.94Z"/>
                    </svg>
                    <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                      <path d="M10 14 21 3"/>
                      <path d="M15 3h6v6"/>
                      <path d="M11 5H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-3"/>
                    </svg>
                    {{ getPersonPrimaryLinkLabel(person) }}
                  </button>
                </button>
              </div>

              <div v-else-if="block.type === 'timeline'" class="ai-timeline">
                <div v-for="(step, idx) in block.items || []" :key="`${item.id}_step_${idx}`" class="ai-timeline-step">
                  <div class="ai-timeline-dot" :class="`is-${step.status || 'none'}`"></div>
                  <div class="ai-timeline-copy">
                    <strong>{{ step.title }}</strong>
                    <span v-if="step.subtitle">{{ step.subtitle }}</span>
                    <small v-if="step.meta">{{ step.meta }}</small>
                  </div>
                </div>
              </div>

              <div v-else-if="block.type === 'facts'" class="ai-facts-list">
                <div v-for="(fact, idx) in block.items || []" :key="`${item.id}_fact_${idx}`" class="ai-fact-pill">
                  <strong>{{ fact.title }}</strong>
                  <span v-if="fact.subtitle">{{ fact.subtitle }}</span>
                  <small v-if="fact.meta">{{ fact.meta }}</small>
                </div>
              </div>

              <div v-else-if="block.type === 'gallery'" :class="['ai-gallery-list', (block.items || []).length > 1 ? 'ai-gallery-grid' : '']">
                <button
                  v-for="(image, idx) in block.items || []"
                  :key="`${item.id}_gallery_${idx}`"
                  type="button"
                  class="ai-gallery-card"
                  @click="openAiContextImage(image)"
                >
                  <img
                    v-if="image.imageUrl"
                    :src="image.imageUrl"
                    class="ai-gallery-image"
                    :alt="image.title || image.subtitle || 'Imagen de contexto'"
                  >
                  <div class="ai-gallery-copy">
                    <strong v-if="image.title">{{ image.title }}</strong>
                    <span v-if="image.subtitle">{{ image.subtitle }}</span>
                    <small v-if="image.meta">{{ image.meta }}</small>
                  </div>
                </button>
              </div>

              <div v-else-if="block.type === 'products'" class="ai-products-list">
                <article
                  v-for="(product, idx) in block.items || []"
                  :key="`${item.id}_product_${idx}`"
                  class="ai-product-card"
                  :class="{ 'ai-product-card--no-media': !aiProductImages(product).length }"
                >
                  <!-- 1 imagen: banner completo -->
                  <button
                    v-if="aiProductImages(product).length === 1"
                    type="button"
                    class="ai-product-media"
                    @click="openAiContextGallery(aiProductImages(product).map(u => ({ imageUrl: u, title: product.title })), { imageUrl: aiProductImages(product)[0] })"
                  >
                    <img :src="aiProductImages(product)[0]" class="ai-product-image" :alt="product.title || 'Producto'">
                  </button>

                  <!-- 2 imágenes: dos columnas -->
                  <div v-else-if="aiProductImages(product).length === 2" class="ai-product-grid ai-product-grid--2">
                    <button
                      v-for="(imgUrl, gi) in aiProductImages(product)"
                      :key="gi"
                      type="button"
                      class="ai-product-grid-cell"
                      @click="openAiContextGallery(aiProductImages(product).map(u => ({ imageUrl: u, title: product.title })), { imageUrl: imgUrl })"
                    >
                      <img :src="imgUrl" :alt="product.title || 'Producto'">
                    </button>
                  </div>

                  <!-- 3 imágenes: tres columnas -->
                  <div v-else-if="aiProductImages(product).length === 3" class="ai-product-grid ai-product-grid--3">
                    <button
                      v-for="(imgUrl, gi) in aiProductImages(product)"
                      :key="gi"
                      type="button"
                      class="ai-product-grid-cell"
                      @click="openAiContextGallery(aiProductImages(product).map(u => ({ imageUrl: u, title: product.title })), { imageUrl: imgUrl })"
                    >
                      <img :src="imgUrl" :alt="product.title || 'Producto'">
                    </button>
                  </div>

                  <!-- 4+ imágenes: grid 2x2 + desborde abajo -->
                  <div v-else-if="aiProductImages(product).length >= 4" class="ai-product-grid ai-product-grid--4plus">
                    <button
                      v-for="(imgUrl, gi) in aiProductImages(product).slice(0, 4)"
                      :key="gi"
                      type="button"
                      class="ai-product-grid-cell"
                      :class="{ 'ai-product-grid-cell--more': gi === 3 && aiProductImages(product).length > 4 }"
                      @click="openAiContextGallery(aiProductImages(product).map(u => ({ imageUrl: u, title: product.title })), { imageUrl: imgUrl })"
                    >
                      <img :src="imgUrl" :alt="product.title || 'Producto'">
                      <span v-if="gi === 3 && aiProductImages(product).length > 4" class="ai-product-grid-more-label">
                        +{{ aiProductImages(product).length - 4 }}
                      </span>
                    </button>
                  </div>

                  <!-- Sin imagen -->
                  <div v-else class="ai-product-media ai-product-media--placeholder">
                    <span>{{ activeContextKind === 'product' ? 'Vista previa' : 'Producto' }}</span>
                  </div>
                  <div class="ai-product-copy">
                    <strong v-if="product.title">{{ product.title }}</strong>
                    <div v-if="product.subtitle" class="ai-product-desc-wrap">
                      <span
                        class="ai-product-desc"
                        :class="{ 'ai-product-desc--collapsed': !expandedDescriptions[`${item.id}_p_${idx}`] && product.subtitle.length > 110 }"
                      >{{ product.subtitle }}</span>
                      <button
                        v-if="product.subtitle.length > 110"
                        class="ai-product-desc-toggle"
                        @click.stop="toggleDesc(`${item.id}_p_${idx}`)"
                      >{{ expandedDescriptions[`${item.id}_p_${idx}`] ? 'Ver menos ↑' : 'Ver más ↓' }}</button>
                    </div>
                  </div>
                  <div class="ai-product-footer">
                    <div v-if="product.meta" class="ai-product-price">{{ formatAiPrice(product.meta) }}</div>
                    <div v-else class="ai-product-footer-spacer"></div>
                    <button
                      v-if="resolveAiExternalLink(product)"
                      type="button"
                      class="ai-product-cta"
                      @click="openProductLink(product)"
                    >{{ product.linkLabel || 'Ver' }}</button>
                  </div>
                </article>
              </div>

              <!-- Services block — 3 card variants based on image count -->
              <div v-else-if="block.type === 'services'" class="ai-services-list">
                <article
                  v-for="(service, idx) in block.items || []"
                  :key="`${item.id}_service_${idx}`"
                  class="ai-service-card"
                  :class="aiServiceCardClass(service)"
                  @click="resolveAiExternalLink(service) && openAiExternalLink(resolveAiExternalLink(service))"
                >
                  <!-- Single image (top banner) -->
                  <button
                    v-if="aiServiceImages(service).length === 1"
                    type="button"
                    class="ai-service-media"
                    @click.stop="openAiContextImage({ imageUrl: aiServiceImages(service)[0], title: service.title })"
                  >
                    <img :src="aiServiceImages(service)[0]" class="ai-service-img" :alt="service.title || 'Servicio'">
                  </button>
                  <!-- Gallery (2+ images) — panel on left -->
                  <div v-else-if="aiServiceImages(service).length >= 2" class="ai-service-gallery">
                    <button
                      type="button"
                      class="ai-service-gallery-cell"
                      @click.stop="openAiContextImage({ imageUrl: aiServiceImages(service)[0], title: service.title })"
                    >
                      <img :src="aiServiceImages(service)[0]" class="ai-service-gallery-img" :alt="service.title">
                    </button>
                    <button
                      type="button"
                      class="ai-service-gallery-cell"
                      @click.stop="openAiContextImage({ imageUrl: aiServiceImages(service)[1], title: service.title })"
                    >
                      <img :src="aiServiceImages(service)[1]" class="ai-service-gallery-img" :alt="service.title">
                      <div v-if="aiServiceImages(service).length > 2" class="ai-service-gallery-more">
                        +{{ aiServiceImages(service).length - 2 }}
                      </div>
                    </button>
                  </div>
                  <!-- Info -->
                  <div class="ai-service-copy">
                    <strong v-if="service.title">{{ service.title }}</strong>
                    <span v-if="service.subtitle">{{ service.subtitle }}</span>
                    <small v-if="service.meta">{{ service.meta }}</small>
                    <span v-if="resolveAiExternalLink(service)" class="ai-service-cta-pill">
                      {{ service.linkLabel || 'Ver más' }}
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                    </span>
                  </div>
                </article>
              </div>

              <div v-else-if="block.type === 'actions'" class="ai-actions-list">
                <button
                  v-for="(action, idx) in block.items || []"
                  :key="`${item.id}_action_${idx}`"
                  type="button"
                  class="ai-action-card"
                  :class="getAiActionClass(action)"
                  :disabled="!resolveAiExternalLink(action)"
                  @click="openAiExternalLink(resolveAiExternalLink(action))"
                >
                  <!-- Brand icon -->
                  <div class="ai-action-brand" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="currentColor" class="ai-action-brand-svg" v-html="getAiActionBrandSvg(action)"></svg>
                  </div>
                  <!-- Copy -->
                  <div class="ai-action-card-info">
                    <span class="ai-action-card-label">{{ action.title || action.linkLabel }}</span>
                    <span v-if="action.meta" class="ai-action-card-meta">{{ action.meta }}</span>
                  </div>
                  <!-- Chevron -->
                  <svg class="ai-action-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>
                </button>
              </div>

              <!-- NUEVO: Renderizado de Archivos/PDFs -->
              <div v-else-if="block.type === 'files' || block.type === 'file'" class="ai-files-list">
                <button
                  v-for="(file, idx) in block.items || (block.type === 'file' ? [block] : [])"
                  :key="`${item.id}_file_${idx}`"
                  type="button"
                  class="ai-file-card"
                  @click="openAiExternalLink(resolveAiExternalLink(file))"
                >
                  <div class="ai-file-card-icon" :class="`is-${detectFileKind(file.title || file.fileName)}`">
                    <span class="ai-file-card-extension">{{ fileVisualLabel(file.title || file.fileName) }}</span>
                  </div>
                  <div class="ai-file-card-info">
                    <strong class="ai-file-card-name">{{ file.title || file.fileName || 'Archivo' }}</strong>
                    <span v-if="file.subtitle || file.meta" class="ai-file-card-desc">{{ file.subtitle || file.meta }}</span>
                  </div>
                  <svg class="ai-file-card-download" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/>
                  </svg>
                </button>
              </div>

              <!-- BOOKING block -->
              <div v-else-if="block.type === 'booking'" class="ai-booking-block">
                <div v-if="!bookingState[`${item.id}_${blockIndex}`]?.confirmed">
                  <!-- Error message -->
                  <div v-if="bookingState[`${item.id}_${blockIndex}`]?.error && !bookingState[`${item.id}_${blockIndex}`]?.selectedSlot" class="ai-booking-error">
                    {{ bookingState[`${item.id}_${blockIndex}`].error }}
                  </div>
                  <!-- Slot picker -->
                  <div v-if="!bookingState[`${item.id}_${blockIndex}`]?.selectedSlot" class="ai-booking-slots">
                    <button
                      v-for="(slot, sIdx) in (block.slots || [])"
                      :key="`${item.id}_slot_${sIdx}`"
                      type="button"
                      class="ai-booking-slot"
                      :class="{ 'is-taken': slotsTomados.has(`${slot.fecha}|${slot.hora}`) }"
                      :disabled="slotsTomados.has(`${slot.fecha}|${slot.hora}`)"
                      @click="selectBookingSlot(`${item.id}_${blockIndex}`, slot)"
                    >
                      {{ slot.label }}
                      <span v-if="slotsTomados.has(`${slot.fecha}|${slot.hora}`)" class="ai-slot-taken-label">No disponible</span>
                    </button>
                  </div>
                  <!-- Contact form after slot selected -->
                  <div v-else class="ai-booking-form">
                    <div class="ai-booking-selected-slot">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="4" width="18" height="18" rx="3"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                      <span>{{ bookingState[`${item.id}_${blockIndex}`].selectedSlot.label }}</span>
                      <button type="button" class="ai-booking-change" @click="changeBookingSlot(`${item.id}_${blockIndex}`)">Cambiar</button>
                    </div>
                    <input
                      v-model="bookingState[`${item.id}_${blockIndex}`].nombre"
                      type="text"
                      class="ai-booking-input"
                      placeholder="Tu nombre"
                    >
                    <input
                      v-model="bookingState[`${item.id}_${blockIndex}`].telefono"
                      type="tel"
                      class="ai-booking-input"
                      placeholder="Tu teléfono (opcional)"
                    >
                    <button
                      type="button"
                      class="ai-booking-confirm-btn"
                      :style="getUserBubbleStyle()"
                      :disabled="!bookingState[`${item.id}_${blockIndex}`].nombre?.trim() || bookingState[`${item.id}_${blockIndex}`].loading"
                      @click="confirmarAgendamiento(`${item.id}_${blockIndex}`, item.id, block.title)"
                    >
                      <span v-if="bookingState[`${item.id}_${blockIndex}`].loading" class="ai-booking-spinner" style="border-color:#fff;border-top-color:transparent"></span>
                      <span v-else>Confirmar cita</span>
                    </button>
                    <a
                      v-if="getBookingWhatsAppLink(`${item.id}_${blockIndex}`)"
                      :href="getBookingWhatsAppLink(`${item.id}_${blockIndex}`)"
                      target="_blank"
                      rel="noopener"
                      class="ai-booking-whatsapp-btn"
                      @click="_trackOutboundLink(getBookingWhatsAppLink(`${item.id}_${blockIndex}`))"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-1-.3-.1-.5-.1-.7.2s-.8 1-1 1.2c-.2.2-.4.2-.7.1-1.9-.9-3.2-2.6-3.4-3-.2-.4 0-.6.2-.7l.5-.6c.1-.2.2-.4.3-.6 0-.2 0-.4-.1-.6L9.5 8c-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.1 1.1-1.1 2.7s1.2 3.1 1.3 3.3c.2.2 2.3 3.6 5.7 4.9.8.3 1.4.5 1.9.6.8.2 1.5.2 2.1.1.6-.1 1.8-.7 2.1-1.4.3-.6.3-1.2.2-1.3-.1-.2-.3-.3-.6-.4z"/><path d="M12 2a10 10 0 0 1 8.7 14.9L22 22l-5.2-1.3A10 10 0 1 1 12 2z"/></svg>
                      <span>Confirmar por WhatsApp</span>
                    </a>
                  </div>
                </div>
                <!-- Confirmed state -->
                <div v-else class="ai-booking-confirmed">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M20 6L9 17l-5-5"/></svg>
                  <div>
                    <strong>¡Cita confirmada!</strong>
                    <span>{{ bookingState[`${item.id}_${blockIndex}`].selectedSlot?.label }}</span>
                  </div>
                </div>
              </div>

              <div v-else class="ai-note-card">
                <p v-for="(note, idx) in normalizeBlockItems(block)" :key="`${item.id}_note_${idx}`">
                  {{ note.title || note.subtitle || note.meta }}
                </p>
              </div>
            </div>
          </template>

          <!-- followUp chip — last slot after all blocks -->
          <button
            v-if="getAiFollowUp(item) && (!revealState[item.id] || revealState[item.id].visibleCount >= getFollowUpSlot(item))"
            class="msg-ai-followup-chip"
            :class="{ 'msg-reveal-in': revealState[item.id] && revealState[item.id].visibleCount === getFollowUpSlot(item) }"
            @click="enviarStarter(getAiFollowUp(item))"
          >{{ getAiFollowUp(item) }}</button>

          <!-- Typing indicator between blocks -->
          <div v-if="revealState[item.id] && revealState[item.id].phase === 'typing-between'" class="msg-ai-writing" style="margin-top: 8px;">
            <span class="msg-ai-writing-name">{{ tituloVisibleSesionUsuario || proyectorConfig?.nombreSesion || 'Asistente' }}</span> está escribiendo<span class="msg-ai-writing-dots"><span>.</span><span>.</span><span>.</span></span>
          </div>
        </div>
      </template>

      <!-- Still waiting for response -->
      <div v-else-if="!consultaPendienteLocal && index === misConsultas.length - 1" class="msg-ai-writing is-delayed">
        <span class="msg-ai-writing-name">{{ tituloVisibleSesionUsuario || proyectorConfig?.nombreSesion || 'Asistente' }}</span> está escribiendo<span class="msg-ai-writing-dots"><span>.</span><span>.</span><span>.</span></span>
      </div>
    </div>

    <div v-if="consultaPendienteLocal" class="chat-message is-pending-local">
      <div v-if="consultaPendienteLocal.audioUrl" class="msg-user-voice" :style="getUserBubbleStyle()">
        <button
          type="button"
          class="voice-note-play"
          @click="toggleVoicePlayback(consultaPendienteLocal.id)"
          :aria-label="isVoicePlaying(consultaPendienteLocal.id) ? 'Pausar nota de voz' : 'Reproducir nota de voz'"
        >
          <svg v-if="isVoicePlaying(consultaPendienteLocal.id)" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <rect x="6" y="5" width="4" height="14" rx="1.5"></rect>
            <rect x="14" y="5" width="4" height="14" rx="1.5"></rect>
          </svg>
          <svg v-else viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M8 5.5v13l10-6.5-10-6.5Z"></path>
          </svg>
        </button>
        <div class="voice-note-wave" aria-hidden="true">
          <span v-for="bar in 12" :key="`pending_${consultaPendienteLocal.id}_${bar}`"></span>
        </div>
        <span class="voice-note-duration">{{ formatVoiceDuration(consultaPendienteLocal.audioDurationMs) }}</span>
        <audio
          :id="`voice-note-${consultaPendienteLocal.id}`"
          :src="consultaPendienteLocal.audioUrl"
          preload="metadata"
          @ended="handleVoicePlaybackEnded(consultaPendienteLocal.id)"
        ></audio>
      </div>
      <div v-else class="msg-user" :style="getUserBubbleStyle()">{{ consultaPendienteLocal.texto }}</div>
      <!-- Single check — pending, not yet confirmed in Firestore -->
      <div class="msg-sent-receipt msg-sent-receipt--pending">
        <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 5l3 3.5L9 1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <!-- Typing text indicator -->
      <div class="msg-ai-writing is-delayed">
        <span class="msg-ai-writing-name">{{ tituloVisibleSesionUsuario || proyectorConfig?.nombreSesion || 'Asistente' }}</span> está escribiendo<span class="msg-ai-writing-dots"><span>.</span><span>.</span><span>.</span></span>
      </div>
    </div>
  </template>
</div>


    <transition name="fade">
      <div v-if="selectedAiProfile" class="ai-profile-overlay" @click.self="closeAiPersonProfile">
        <div class="ai-profile-sheet">
          <button class="ai-profile-close" @click="closeAiPersonProfile">✕</button>
          <img
            v-if="selectedAiProfile.imageUrl"
            :src="selectedAiProfile.imageUrl"
            class="ai-profile-photo"
            alt=""
          >
          <div v-else class="ai-profile-photo ai-profile-photo-fallback">
            {{ (selectedAiProfile.title || 'P').charAt(0).toUpperCase() }}
          </div>
          <div class="ai-profile-content">
            <p class="ai-profile-kicker">Perfil relacionado</p>
            <h4>{{ selectedAiProfile.title }}</h4>
            <p v-if="selectedAiProfile.subtitle" class="ai-profile-subtitle">{{ selectedAiProfile.subtitle }}</p>
            <p v-if="selectedAiProfile.meta" class="ai-profile-meta">{{ selectedAiProfile.meta }}</p>
            <button
              v-if="getPersonPrimaryLink(selectedAiProfile)"
              type="button"
              class="ai-profile-link"
              @click="openAiExternalLink(getPersonPrimaryLink(selectedAiProfile))"
            >
              {{ getPersonPrimaryLinkLabel(selectedAiProfile) }}
            </button>
          </div>
        </div>
      </div>
    </transition>


    <div v-if="!runtimeConfig.qnaEnabled" class="chat-status-disabled">
      Las preguntas y respuestas fueron desactivadas por el evento.
    </div>

    <!-- Ya no mostramos el bubble de draft aquí arriba, ahora sucede todo en el input -->

    <div v-if="isRecordingVoice" class="chat-voice-recording">
     
      <span>Grabando nota de voz...</span>
    </div>


    <!-- Quick App Bottom Bar (Persistent CTA) -->
    <div v-if="quickAppConfig" class="chat-quick-app-bar" @click="abrirQuickApp" :style="{ background: quickAppConfig.color || '#C4A484' }">
      <div class="quick-app-bar-left">
        <div class="quick-app-bar-icon-box">
          <img v-if="proyectorConfig?.logo" :src="proyectorConfig.logo" class="quick-app-bar-logo">
          <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
        </div>
        <div class="quick-app-bar-copy">
          <span class="quick-app-bar-title">{{ quickAppConfig.name }}</span>
          <span class="quick-app-bar-subtitle">Toca para abrir sitio web</span>
        </div>
      </div>
    </div>

   

    <!-- CHAT INPUT WHATSAPP LOGIC (B&W) -->
    <div class="chat-footer-final">
      
      <!-- Centro: Área Dinámica (Texto o Ondas o Player) -->
      <div class="footer-input-main">
        
        <!-- MODO GRABANDO: Ondas y Tiempo -->
        <div v-if="isRecordingVoice" class="recording-ui-bw">
          <div class="record-dot-pulse"></div>
          <div class="record-timer-bw">{{ recordingDurationFormatted }}</div>
          <div class="record-waves-bw">
            <span v-for="i in 12" :key="i" :style="{ height: Math.random() * 60 + 20 + '%', animationDelay: i*0.05 + 's' }"></span>
          </div>
        </div>

        <!-- MODO NORMAL: Textarea -->
        <textarea
          v-show="!isRecordingVoice"
          ref="chatTextarea"
          v-model="nuevaPregunta"
          :placeholder="chatInputPlaceholder"
          rows="1"
          @input="autoResizeChatTextarea($event)"
          @keydown.enter.exact.prevent="onChatEnterKey"
        ></textarea>
      </div>

      <!-- Lado Derecho: Botón de Acción Principal -->
      <div class="footer-right-action">
        <button 
          class="btn-main-bw" 
          :class="{ 'is-stop': isRecordingVoice }"
          @click="isRecordingVoice ? toggleVoiceRecording() : (nuevaPregunta.trim() ? enviarPreguntaIA() : toggleVoiceRecording())"
        >
          <div v-if="loadingEnvio || voiceUploading || isTranscribingVoice" class="spinner-bw"></div>
          <template v-else>
            <!-- Icono Enviar (si hay texto listo) -->
            <svg v-if="nuevaPregunta.trim() && !isRecordingVoice" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z"/>
            </svg>
            <!-- Icono Stop (si está grabando) -->
            <svg v-else-if="isRecordingVoice" viewBox="0 0 24 24" fill="currentColor">
              <rect x="7" y="7" width="10" height="10" rx="2"></rect>
            </svg>
            <!-- Icono Mic (si está vacío) -->
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 14a3 3 0 0 0 3-3V7a3 3 0 1 0-6 0v4a3 3 0 0 0 3 3Z"></path>
              <path d="M19 11a7 7 0 0 1-14 0"></path>
              <path d="M12 18v3"></path>
            </svg>
          </template>
        </button>
      </div>

    </div>

  </div>
</div>

<!-- ═══════════════════════════════════════════════
     MODAL: RECLAMAR LINK (estilo brand-claim)
═══════════════════════════════════════════════ -->
<transition name="fade">
  <div v-if="mostrarModalLogin" class="login-invite-overlay" @click.self="mostrarModalLogin = false">
    <div class="login-invite-sheet">

      <!-- Fondo animado igual al slide brand-claim -->
      <div class="lib-bg">
        <div class="lib-blob lib-blob-1"></div>
        <div class="lib-blob lib-blob-2"></div>
      </div>

      <!-- Iconos flotantes -->
      <div class="lib-float-icon lib-fi-1"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg></div>
      <div class="lib-float-icon lib-fi-2"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></div>
      <div class="lib-float-icon lib-fi-3"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 1 0-16 0"/></svg></div>

      <!-- Close -->
      <button class="lib-close" @click="mostrarModalLogin = false" aria-label="Cerrar">✕</button>

      <!-- Copy -->
      <div class="lib-body">
        <span class="lib-kicker">uvoto.com/{{ brandSlugDraft || '...' }}</span>
        <h2 class="lib-title">
          Inicia sesión para<br>
          reclamar <span class="lib-lime">tu link.</span>
        </h2>
        <p class="lib-desc">Este link está reservado para ti. Tienes <strong>24 horas</strong> para iniciar sesión y hacerlo tuyo antes de que quede disponible para otros.</p>

        <p v-if="loginError" class="lib-error">{{ loginError }}</p>

        <!-- Botones de login -->
        <div class="lib-actions">
          <!-- Google -->
          <button
            class="lib-btn lib-btn-google"
            :class="{ 'is-loading': loginLoading === 'google' }"
            @click="loginConGoogle"
            :disabled="!!loginLoading"
          >
            <span v-if="loginLoading === 'google'" class="lib-spinner"></span>
            <template v-else>
              <svg viewBox="0 0 24 24" width="20" height="20"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
              Continuar con Google
            </template>
          </button>

          <!-- Apple -->
          <button
            class="lib-btn lib-btn-apple"
            :class="{ 'is-loading': loginLoading === 'apple' }"
            @click="loginConApple"
            :disabled="!!loginLoading"
          >
            <span v-if="loginLoading === 'apple'" class="lib-spinner"></span>
            <template v-else>
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
              Continuar con Apple
            </template>
          </button>
        </div>

        <button class="lib-skip" @click="mostrarModalLogin = false">Ahora no</button>
      </div>
    </div>
  </div>
</transition>

<transition name="fade">
  <div
    v-if="(selectedAiImage || (selectedAiGallery && selectedAiGallery.length)) && !mostrarModalPreguntas"
    class="ai-image-overlay ai-image-overlay-global"
    @click="closeAiContextImage"
  >
    <!-- Background for closing -->
    <div class="ai-image-overlay-bg"></div>
    
    <button class="ai-image-close" @click.stop="closeAiContextImage">✕</button>
    
    <!-- Gallery Version -->
    <div
      v-if="selectedAiGallery && selectedAiGallery.length"
      class="ai-gallery-swiper-wrap"
      @click.stop
    >
      <Swiper
        :key="`ai-gallery-final-${selectedAiGallery.length}-${selectedAiGallery[0]?.imageUrl}`"
        class="ai-gallery-swiper"
        :modules="[swiperPaginationModule]"
        :initial-slide="selectedAiGalleryIndex"
        :pagination="{ clickable: true }"
        :slides-per-view="1"
        :space-between="0"
        :grab-cursor="true"
      >
        <SwiperSlide v-for="(img, idx) in selectedAiGallery" :key="`slide-${idx}`">
          <div class="ai-gallery-slide-inner">
            <transition name="fade">
              <div v-if="!galleryLoadedMap[idx]" class="gallery-img-loading">
                <div class="gallery-img-spinner"></div>
              </div>
            </transition>
            <img
              :src="img.imageUrl"
              v-img-watchdog="img.imageUrl"
              class="ai-image-viewer"
              :class="{ 'is-visible': galleryLoadedMap[idx] }"
              :alt="img.title || img.subtitle || 'Imagen'"
              @load="onGalleryImgLoad(idx)"
            >
            <div v-if="img.caption" class="ai-gallery-caption">
              <p class="ai-gallery-caption-text">{{ img.caption }}</p>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>

    <!-- Single Image Fallback (only if no gallery) -->
    <img
      v-else-if="selectedAiImage"
      :src="selectedAiImage.imageUrl"
      v-img-watchdog="selectedAiImage.imageUrl"
      class="ai-image-viewer"
      :alt="selectedAiImage.title || selectedAiImage.subtitle || 'Imagen'"
      @click.stop
    >
  </div>
</transition>

<!-- Share bottom sheet — Instagram style -->
<transition name="sheet-up">
  <div v-if="showShareSheet" class="share-sheet-overlay" @click.self="showShareSheet = false">
    <div class="share-sheet">

      <!-- ── HERO: blurred bg + sharp image ── -->
      <div class="share-hero">
        <!-- Blurred background reproduces dominant color of the image -->
        <div class="share-hero-bg" :class="{ 'share-hero-bg--gradient': !shareRoomImage }" :style="shareHeroBgStyle"></div>
        <!-- Sharp hero image -->
        <img v-if="imagenCompartirActual" class="share-hero-img" :src="imagenCompartirActual" :alt="tituloCompartirActual" />
        <div v-else class="share-hero-initial">{{ (tituloCompartirActual || '?').charAt(0).toUpperCase() }}</div>
        <!-- Gradient fade into content card -->
        <div class="share-hero-gradient"></div>
        <!-- Back / close button -->
        <button class="share-back-btn" @click="showShareSheet = false">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="m15 18-6-6 6-6"/>
          </svg>
        </button>
      </div>

      <!-- ── CONTENT CARD ── -->
      <div class="share-content-card">

        <!-- Room identity -->
        <div class="share-room-header">
          <div class="share-room-header-text">
            <h2 class="share-room-title">{{ tituloCompartirActual }}</h2>
            <p v-if="descripcionCompartirActual" class="share-room-desc">{{ descripcionCompartirActual }}</p>
            <p class="share-room-url">{{ urlCompartirActual }}</p>
          </div>
          <div v-if="roomLikesCount > 0" class="share-like-badge">
            <svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
            {{ roomLikesCount }}
          </div>
        </div>

        <!-- Qué se comparte: este lienzo o todo el branding. Lo eligen aquí
             y las cuatro acciones de abajo lo respetan. -->
        <div v-if="puedeCompartirSlide" class="share-scope share-scope--sutil">
          <button
            type="button"
            class="share-scope-btn"
            :class="{ active: compartiendoSlide }"
            @click="modoCompartir = 'slide'"
          >{{ selectedLanguage === 'en' ? 'This canvas' : selectedLanguage === 'pt' ? 'Este lienzo' : 'Este lienzo' }}</button>
          <button
            type="button"
            class="share-scope-btn"
            :class="{ active: !compartiendoSlide }"
            @click="modoCompartir = 'canal'"
          >{{ selectedLanguage === 'en' ? 'Whole brand' : selectedLanguage === 'pt' ? 'Toda a marca' : 'Todo el branding' }}</button>
        </div>

        <!-- Divider -->
        <div class="share-divider"></div>

        <!-- Acciones: círculos en fila, como el sheet de Instagram. Antes
             eran cuatro filas a lo ancho y el panel quedaba larguísimo. -->
        <div class="share-circles">
          <button type="button" class="share-circle-item" @click="copyRoomLink">
            <span class="share-circle" :class="{ 'is-copied': linkCopied }">
              <svg v-if="!linkCopied" viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </span>
            <span class="share-circle-label">{{ linkCopied ? (selectedLanguage === 'en' ? 'Copied' : selectedLanguage === 'pt' ? 'Copiado' : 'Copiado') : (selectedLanguage === 'en' ? 'Copy link' : selectedLanguage === 'pt' ? 'Copiar link' : 'Copiar link') }}</span>
          </button>

          <button type="button" class="share-circle-item" @click="shareOnWhatsApp">
            <span class="share-circle share-circle--wa">
              <svg viewBox="0 0 24 24" width="19" height="19" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>
            </span>
            <span class="share-circle-label">WhatsApp</span>
          </button>

          <button type="button" class="share-circle-item" @click="shareOnInstagram">
            <span class="share-circle share-circle--ig">
              <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
              </svg>
            </span>
            <span class="share-circle-label">Instagram</span>
          </button>

          <button type="button" class="share-circle-item" @click="shareOnFacebook">
            <span class="share-circle share-circle--fb">
              <svg viewBox="0 0 24 24" width="19" height="19" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </span>
            <span class="share-circle-label">Facebook</span>
          </button>
        </div>

      </div><!-- end content card -->
    </div>
  </div>
</transition>

</template>

<script>
import draggable from 'vuedraggable';
import { Capacitor } from '@capacitor/core';
import { getStorage, ref, uploadString, getDownloadURL } from "firebase/storage";
import { getFunctions, httpsCallable } from 'firebase/functions';
import { db, auth } from '../firebase';
import { parsearEnlaceWhatsapp, abrirWhatsapp } from '../utils/whatsapp';
import { signInAnonymously, GoogleAuthProvider, OAuthProvider, signInWithPopup, linkWithPopup, onAuthStateChanged, setPersistence, inMemoryPersistence } from 'firebase/auth';
import JSConfetti from 'js-confetti';
import { markRaw } from 'vue';
import * as pdfjsLib from 'pdfjs-dist';
import i18n from '../i18n';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Home from './Home.vue';
import {
  doc, onSnapshot, updateDoc, increment, deleteDoc,
  collection, query, where, getDocs, addDoc, getDoc, setDoc, orderBy, serverTimestamp, limit
} from 'firebase/firestore';
import Cards from '../components/Cards.vue'; // Importamos el componente de cartas
import 'animate.css'

const EXPLORE_PROFILES_CACHE_KEY = 'uvoto_connect_public_explore_profiles_v1';
const EXPLORE_PROFILES_CACHE_TTL_MS = 4 * 60 * 1000;
// Marca que la animación de carga de canales ya se mostró en esta sesión.
const EXPLORE_BRAND_INTRO_KEY = 'uvoto_explore_brand_intro_v1';
const PENDING_BRAND_CLAIM_KEY = 'uvoto_connect_pending_brand_claim_v1';
const PENDING_BRAND_CLAIM_OWNER_KEY = 'uvoto_connect_pending_brand_claim_owner_v1';
const BRAND_CLAIM_TTL_MS = 12 * 60 * 1000;

// ── Publicación con período de gracia ──────────────────────────────────
// Un canal publicado sin membresía activa queda marcado con
// publishPlan: 'grace' + publishGraceStartedAt en su doc waiting_room/estado.
// Publicar NUNCA se apaga por tiempo: pasados los PUBLISH_GRACE_DAYS de
// gracia, la cuenta pasa a un plan free permanente (1 canal, sin link
// personalizado, sin IA) — nunca sale de circulación. Espejo de
// src/utils/planAccess.js en Uvoto Connect.

// Espejo de limitSlidesForPublishPlan en src/utils/planAccess.js de Uvoto
// Connect: este proyecto no tiene ese archivo. Plan free permanente = solo
// el primer lienzo; con membresía o gracia vigente, todos.
const FREE_ACTIVE_SLIDES = 1;

function publishGraceExpiroMs(canal = {}) {
  const bruto = canal?.publishGraceStartedAt;
  if (!bruto) return 0;
  const ms = typeof bruto?.toMillis === 'function'
    ? bruto.toMillis()
    : new Date(bruto instanceof Date ? bruto : String(bruto)).getTime();
  return Number.isFinite(ms) ? ms + 7 * 24 * 60 * 60 * 1000 : 0;
}

function limitSlidesForPublishPlan(slides = [], canal = {}) {
  const lista = Array.isArray(slides) ? slides : [];
  if (canal?.publishPlan === 'paid') return lista;
  if (canal?.publishPlan === 'grace') {
    const expira = publishGraceExpiroMs(canal);
    if (!expira || expira > Date.now()) return lista;
  }
  return lista.slice(0, FREE_ACTIVE_SLIDES);
}

function isPublicationActive(canal = {}) {
  return true;
}
const PUBLIC_SHARE_BASE_URL = 'https://uvoto.com';

function generarSlugCortoTemporal(longitud = 12) {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
  let token = '';
  for (let i = 0; i < longitud; i += 1) {
    token += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return token;
}
 
function elegirProyectorMasReciente(docs, pinBuscado = '') {
  const pin = String(pinBuscado || '').trim();
  const candidatos = [...docs].filter((docSnap) => {
    const data = docSnap.data() || {};
    const pinCanal = String(data.pinCanal || '').trim();
    const pinVirtual = String(data.proyectorVirtualPin || '').trim();
    return pinCanal === pin || pinVirtual === pin;
  });
  const preferidos = candidatos.filter((docSnap) => {
    const data = docSnap.data() || {};
    return String(data.proyectorVirtualPin || '').trim() === pin;
  });
  const pool = preferidos.length > 0 ? preferidos : candidatos;
  return pool.sort((a, b) => {
    const dataA = a.data() || {};
    const dataB = b.data() || {};
    const tsA =
      dataA.updatedAt?.toMillis?.() ??
      dataA.fechaVinculacion?.toMillis?.() ??
      new Date(dataA.updatedAt || dataA.fechaVinculacion || 0).getTime();
    const tsB =
      dataB.updatedAt?.toMillis?.() ??
      dataB.fechaVinculacion?.toMillis?.() ??
      new Date(dataB.updatedAt || dataB.fechaVinculacion || 0).getTime();
    return tsB - tsA;
  })[0] || null;
}

async function resolverShortLinkCompartido(slug = '') {
  const limpio = String(slug || '').trim();
  if (!limpio) return null;

  const shortSnap = await getDoc(doc(db, 'short_links', limpio));
  if (shortSnap.exists()) {
    const data = shortSnap.data() || {};
    if (data.active === false) return null;
    return {
      slug: limpio,
      pin: String(data.pin || '').trim(),
      canalId: String(data.canalId || '').trim(),
      proyectorId: String(data.proyectorId || '').trim()
    };
  }

  const fallbackQuery = query(
    collection(db, 'proyectores'),
    where('shareSlug', '==', limpio),
    where('estado', '==', 'vinculado')
  );
  const fallbackSnap = await getDocs(fallbackQuery);
  if (fallbackSnap.empty) return null;
  const docSnap = fallbackSnap.docs[0];
  const data = docSnap.data() || {};
  return {
    slug: limpio,
    pin: String(data.proyectorVirtualPin || data.pinCanal || '').trim(),
    canalId: String(data.canalId || '').trim(),
    proyectorId: docSnap.id
  };
}

async function obtenerPreviewPublicRoom(slug = '', canalId = '') {
  const limpio = String(slug || '').trim();
  let canalDocId = String(canalId || '').trim();

  // Lectura directa en short_links (mucho más rápida que query por shareSlug)
  if (!canalDocId && limpio) {
    const shortSnap = await getDoc(doc(db, 'short_links', limpio));
    if (shortSnap.exists()) {
      const shortData = shortSnap.data() || {};
      if (shortData.active !== false) {
        canalDocId = String(shortData.canalId || '').trim();
      }
    }
  }

  // Fallback: query por shareSlug en canales (para slugs sin short_link)
  if (!canalDocId && limpio) {
    const canalSnap = await getDocs(query(
      collection(db, 'canales'),
      where('shareSlug', '==', limpio)
    ));
    if (!canalSnap.empty) {
      canalDocId = canalSnap.docs[0].id;
    }
  }

  if (!canalDocId) return null;

  // Leer canal y waiting_room en paralelo
  const [canalSnap, waitingSnap] = await Promise.all([
    getDoc(doc(db, 'canales', canalDocId)),
    getDoc(doc(db, 'canales', canalDocId, 'waiting_room', 'estado'))
  ]);

  if (!canalSnap.exists()) return null;

  const canalData = canalSnap.data() || {};
  const waitingData = waitingSnap.exists() ? (waitingSnap.data() || {}) : {};
  const slides = Array.isArray(waitingData.slides) ? waitingData.slides : [];
  const firstSlide = slides[0] || {};
  const gallery = Array.isArray(firstSlide.galleryImages) ? firstSlide.galleryImages : [];
  const firstGalleryImage = gallery.find((image) => String(image?.imageUrl || image?.previewUrl || '').trim());

  return {
    title: String(canalData.brandName || canalData.tituloVisible || canalData.nombreSesion || canalData.nombreEvento || 'Sala publica').trim(),
    brandName: String(canalData.brandName || canalData.nombreSesion || canalData.tituloVisible || 'Uvoto').trim(),
    imageUrl: String(
      firstSlide.imageUrl ||
      firstSlide.imagePreview ||
      firstGalleryImage?.imageUrl ||
      firstGalleryImage?.previewUrl ||
      canalData.shareImageUrl ||
      canalData.logoEmpresa ||
      ''
    ).trim(),
    logoUrl: String(canalData.logoEmpresa || '').trim()
  };
}

function normalizarPinIngreso(value = '') {
  return String(value || '')
    .trim()
    .replace(/\s+/g, '')
    .replace(/[^\dA-Za-z]/g, '')
    .toUpperCase();
}

function getInitialEntryState() {
  const search = new URLSearchParams(window.location.search);
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const slugFromPath = String(pathParts[pathParts.length - 1] || '').trim();
  const slugFromQuery = String(search.get('slug') || '').trim();
  // Los usuarios siempre llegan a /user?slug=xxx tras el redirect del preview-share.php
  const slug = (slugFromPath && slugFromPath.toLowerCase() !== 'user') ? slugFromPath : slugFromQuery;
  const pin = String(search.get('pin') || '').trim();
  const canal = String(search.get('canal') || '').trim();
  const hasSlug = !!slug && slug.toLowerCase() !== 'user';
  const hasPendingEntry = hasSlug || !!pin || !!canal;

  if (!hasPendingEntry) {
    return {
      shouldShowLoading: false,
      preview: null
    };
  }

  try {
    const raw = sessionStorage.getItem('uvoto_entry_loading_preview');
    if (raw) {
      return {
        shouldShowLoading: true,
        preview: JSON.parse(raw)
      };
    }
  } catch (error) {
    // no-op
  }

  return {
    shouldShowLoading: true,
    preview: hasSlug
      ? { title: slug, imageUrl: '' }
      : { title: '', imageUrl: '' }
  };
}
 
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const AVATARES_FIJOS = [
  { id: 'av1', url: 'https://api.dicebear.com/9.x/open-peeps/svg?seed=Mia&backgroundColor=ffd5dc&backgroundType=solid', label: 'Mia' },
  { id: 'av2', url: 'https://api.dicebear.com/9.x/open-peeps/svg?seed=Zoe&backgroundColor=b6e3f4&backgroundType=solid', label: 'Zoe' },
  { id: 'av3', url: 'https://api.dicebear.com/9.x/open-peeps/svg?seed=Max&backgroundColor=d1f4d1&backgroundType=solid', label: 'Max' },
  { id: 'av4', url: 'https://api.dicebear.com/9.x/open-peeps/svg?seed=Leo&backgroundColor=c0aede&backgroundType=solid', label: 'Leo' },
];

// Vigía de carga de imágenes: en iOS (WKWebView) una descarga puede
// quedarse "colgada" sin disparar load NI error — típico con conexión
// intermitente o presión de memoria — dejando la imagen a medias para
// siempre. Este directive reintenta (con backoff) si la imagen no termina
// de cargar dentro de IMG_WATCHDOG_TIMEOUT_MS, hasta IMG_WATCHDOG_MAX_RETRIES
// veces.
const IMG_WATCHDOG_TIMEOUT_MS = 8000;
const IMG_WATCHDOG_MAX_RETRIES = 5;

function limpiarVigiaImagen(el) {
  if (el._imgWatchdogTimer) {
    clearTimeout(el._imgWatchdogTimer);
    el._imgWatchdogTimer = null;
  }
}

// Cuando se agotan los reintentos, la imagen queda realmente rota (URL caída,
// no solo una descarga colgada). En vez de dejar el hueco a medias tal cual
// quedó — el bug reportado — se oculta y, si hay un fondo desenfocado
// hermano (el blur-bg del slide principal), se reemplaza por un degradado
// neutro para que se vea como un estado vacío intencional, no un glitch.
function marcarFalloDefinitivoImagen(el) {
  el.classList.add('img-load-failed');
  el.classList.remove('img-cargando');
  // Quitar el src evita el ícono de "imagen rota" del navegador — el relleno
  // neutro lo pone la clase .img-load-failed vía CSS.
  el.removeAttribute('src');
  const hermanoBlur = el.previousElementSibling;
  if (hermanoBlur && hermanoBlur.classList.contains('wr-media-blur-bg')) {
    hermanoBlur.style.backgroundImage = 'none';
    hermanoBlur.classList.add('wr-media-blur-bg--fallback');
  }
}

// Simplemente reasignar el.src a veces no alcanza: el problema real en
// WKWebView es que la conexión de red queda colgada, y a veces reusa esa
// misma conexión wedged para el "nuevo" request. fetch() con cache:'reload'
// y su propio AbortController fuerza una conexión nueva de verdad — lo más
// parecido a lo que pasa cuando el usuario sale del canal y vuelve a entrar
// (que sí lo arregla siempre, según se reportó). Si el origen no permite CORS
// (fetch falla por eso, no por red), se cae de vuelta al método simple.
function recargarImagenViaFetch(el, url) {
  const controller = new AbortController();
  const abortTimer = setTimeout(() => controller.abort(), 6000);
  fetch(url, { cache: 'reload', signal: controller.signal })
    .then((res) => {
      if (!res.ok) throw new Error(`http ${res.status}`);
      return res.blob();
    })
    .then((blob) => {
      clearTimeout(abortTimer);
      if (!el.isConnected) return;
      const blobUrlAnterior = el.dataset.imgWatchdogBlobUrl;
      const blobUrlNueva = URL.createObjectURL(blob);
      el.dataset.imgWatchdogBlobUrl = blobUrlNueva;
      el.src = blobUrlNueva;
      if (blobUrlAnterior) URL.revokeObjectURL(blobUrlAnterior);
      armarVigiaImagen(el);
    })
    .catch(() => {
      clearTimeout(abortTimer);
      if (!el.isConnected) return;
      el.src = `${url}${url.includes('?') ? '&' : '?'}_r=${Date.now()}`;
      armarVigiaImagen(el);
    });
}

function reintentarImagenVigiada(el) {
  const intentos = Number(el.dataset.imgWatchdogAttempts || 0);
  if (intentos >= IMG_WATCHDOG_MAX_RETRIES) {
    limpiarVigiaImagen(el);
    marcarFalloDefinitivoImagen(el);
    return;
  }
  el.dataset.imgWatchdogAttempts = String(intentos + 1);
  const base = (el.dataset.imgWatchdogBase || el.src).split(/[?&]_r=/)[0];
  el.dataset.imgWatchdogBase = base;
  setTimeout(() => {
    if (!el.isConnected) return;
    recargarImagenViaFetch(el, base);
  }, Math.min(700 * (intentos + 1), 4000));
}

// Mientras la descarga va por la mitad, el navegador va pintando lo que lleva
// y la foto se ve CORTADA. El vigía de abajo solo reacciona a los 8s, así que
// ese recorte quedaba en pantalla todo ese rato. Se oculta la imagen hasta
// que termine de cargar: debajo ya está el fondo desenfocado del slide.
function marcarImagenCargando(el) {
  // Si viene de caché ya está completa: no tiene sentido esconderla.
  if (el.complete && el.naturalWidth > 0) {
    el.classList.remove('img-cargando');
    return;
  }
  el.classList.add('img-cargando');
}

function marcarImagenLista(el) {
  el.classList.remove('img-cargando');
}

function armarVigiaImagen(el) {
  limpiarVigiaImagen(el);
  marcarImagenCargando(el);
  el.addEventListener('load', () => {
    limpiarVigiaImagen(el);
    marcarImagenLista(el);
  }, { once: true });
  el.addEventListener('error', () => reintentarImagenVigiada(el), { once: true });
  el._imgWatchdogTimer = setTimeout(() => {
    if (!el.complete || el.naturalWidth === 0) reintentarImagenVigiada(el);
  }, IMG_WATCHDOG_TIMEOUT_MS);
}

export default {
  _AVATARES_FIJOS: AVATARES_FIJOS,
  components: {
    Home,
    Cards,
    draggable,
    Swiper,
    SwiperSlide
  },
  directives: {
    // Uso: v-img-watchdog="urlDeLaImagen" — reinicia el vigía si la url
    // (src) cambia, por ejemplo cuando Swiper recicla el <img> con otra foto.
    imgWatchdog: {
      mounted(el) {
        el.dataset.imgWatchdogAttempts = '0';
        armarVigiaImagen(el);
      },
      updated(el, binding) {
        if (binding.oldValue !== binding.value) {
          el.dataset.imgWatchdogAttempts = '0';
          delete el.dataset.imgWatchdogBase;
          if (el.dataset.imgWatchdogBlobUrl) {
            URL.revokeObjectURL(el.dataset.imgWatchdogBlobUrl);
            delete el.dataset.imgWatchdogBlobUrl;
          }
          // Nueva imagen para este elemento (Swiper recicla el <img>) — limpia
          // cualquier estado de fallo definitivo que haya quedado de la anterior.
          el.classList.remove('img-load-failed');
          const hermanoBlur = el.previousElementSibling;
          if (hermanoBlur && hermanoBlur.classList.contains('wr-media-blur-bg--fallback')) {
            hermanoBlur.classList.remove('wr-media-blur-bg--fallback');
            hermanoBlur.style.backgroundImage = '';
          }
          armarVigiaImagen(el);
        }
      },
      unmounted(el) {
        limpiarVigiaImagen(el);
        if (el.dataset.imgWatchdogBlobUrl) {
          URL.revokeObjectURL(el.dataset.imgWatchdogBlobUrl);
        }
      }
    }
  },
  data() {
    const initialEntryState = getInitialEntryState();
    return {
      expandedDescriptions: {},
      subModo: 'texto',
      textoPresentacion: '',
      yaSePresento: false,
      mostrarCajaLocal: true, // Controla si el usuario cerró la X
      loadingEnvio: false,
      canalId: null,
      preguntaCanalId: null,
      pinIngresado: '',
 
      proyectorConfig: { 
        color: '#ffffff', 
        logo: '', 
        nombreSesion: '', 
        modo: 'standard', 
        cardsData: []
      },
      preguntaActiva: null,
      votoRealizado: false,
      cardVotada: null,
      loading: initialEntryState.shouldShowLoading,
      loadingEnvio: false,
      showQuickAppModal: false,
      quickAppLoading: false,

      indiceSeleccionado: null,
      comentario: '',
      sesionesRecientes: [],
      nombreUsuario: localStorage.getItem('user_name') || '',
      edadUsuario: localStorage.getItem('user_age') || '',
      mostrarModalPerfil: false,
      emailUsuario: localStorage.getItem('user_email') || '',
      fotoUsuario: localStorage.getItem('user_photo') || '',
      userId: null,
      proximaCita: null,
      gestionarModal: { open: false, agendamientoId: null, accion: null, motivo: '', slots: [], selectedSlot: null, loading: false },
      unsubProximaCita: null,
      mostrarModalLogin: false,
      loginLoading: false,
      loginError: null,
      embedPageContext: null,    // contexto de la página host (solo en modo embed)
      embedApiKey: null,         // clave de autenticación del embed (validada en Firestore rules)
      fotoUrl: localStorage.getItem('user_photo') || null,
      subiendoFoto: false,
      listaOrdenable: [], // Nueva variable para manejar el orden local del usuario
     
      mostrarModalPreguntas: false,
      chatAbiertoAntesDeGaleria: false,
      nuevaPregunta: '',
      misConsultas: [],
      consultaPendienteLocal: null,
      unsubConsultasIA: null,
      revealState: {},   // { [itemId]: { phase: 'typing'|'revealing', visibleCount: number } }
      bookingState: {},  // { [blockKey]: { selectedSlot, nombre, telefono, loading, confirmed, agendamientoId } }
      slotsTomados: new Set(),  // Set de "fecha|hora" ya reservados — para marcar en el picker
      selectedAiProfile: null,
      selectedAiImage: null,
      selectedAiGallery: [],
      selectedAiGalleryIndex: 0,
      swiperPaginationModule: markRaw(Pagination),
      voiceRecorder: null,
      voiceRecorderStream: null,
      voiceRecorderChunks: [],
      voiceRecognition: null,
      voiceRecognitionShouldRestart: false,
      voiceTranscriptDraft: '',
      voiceRecordingStartedAt: 0,
      isRecordingVoice: false,
      voiceUploading: false,
      isTranscribingVoice: false,
      _isFinalizingVoice: false,
      recordingDurationFormatted: '0:00',
      activeVoicePlaybackId: null,
      selectedLanguage: 'en',
      availableLanguages: [
        { code: 'es' },
        { code: 'en' },
        { code: 'pt' }
      ],
      showLanguageMenu: false,
      translatedSlidesMap: {},   // { [slideId_lang]: translatedSlide }
      translatingSlides: false,
      publicExploreProfiles: [],
      activeExploreCategory: 'all',
      activeExploreIndex: 0,
      exploreSwiperInstance: null,
      exploreModalSwiperInstance: null,
      exploreProfilesLoading: false,
      exploreProfilesError: '',
      exploreAutoSlideInterval: null,
      rotatingAudienceIndex: 0,
      rotatingAudienceInterval: null,
      rotatingAudienceMotion: 'slide',
      enteringSessionPreview: initialEntryState.preview,
      desktopEntryStarted: false,
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
      showExploreModal: false,
      activeExploreModalCategory: 'all',
      exploreModalQuery: '',
      showRecentSessionsModal: false,
      showJoinHomePanel: false,
      wrMarcaInputEnfocado: false, // con el teclado abierto se oculta el pie legal
      showExploreOverlay: false,
      shellSwipeStartX: 0,
      shellSwipeStartY: 0,
      shellSwipeTracking: false,
      brandSlugDraft: '',
      brandSlugStatus: 'idle',
      brandSlugMessage: '',
      fallbackExploreImage: require('../assets/logo.png'),
      waitingRoomPublicData: { enabled: false, slides: [] },
      unsubWaitingRoomConfig: null,
      brandSlideIndex: 0,
      brandSlideInterval: null,
      activeWaitingRoomIndex: 0,
      // Slide al que apunta un enlace compartido (?s=<id>). Se consume una
      // sola vez: después el usuario navega libre.
      slideCompartidoPendiente: '',
      // 'slide' = este lienzo · 'canal' = todo el branding
      modoCompartir: 'slide',
      isWrSlideMoving: false,
      videoMutedMap: {},
      videoLoadedMap: {},
      tiempoRestante: 0,
      userTimerInterval: null,
    proyectorListener: null,
    currentProyectorEscuchado: null,
    dockExpandido: false,
    preguntaListener: null,
 
    // PDF en el teléfono
    pdfDoc: null,
    pdfLoading: false,
    pdfIsPortrait: true,
    pdfPaginaActual: 1,
    pdfUiVisible: true,
    pdfUiTimer: null,
    momentPhotoPreview: '',
    momentPhotoOrientation: 'square',
    momentCaption: '',
    subiendoMomento: false,
    momentoGuardado: false,
    momentoPublicado: false,
 
    //variables para la interfaz de usuario ganador
    ganadorLocal: false,
    puntosGanados: 0,
    respuestaCorrectaTexto: '',
    confetiLanzado: false,
    puntosUsuario: 0,
    chatViewportHeight: 0,
    chatKeyboardInset: 0,
    waitingRoomSwiperInstance: null,
    mostrarGuiaSlidesWaitingRoom: false,
    waitingRoomGuideSeen: localStorage.getItem('uvoto_waiting_room_swipe_guide_seen') === 'true',
    waitingRoomGuideInterval: null,
    waitingRoomGuideReturnTimeout: null,
    waitingRoomGuideDelayTimeout: null,
    waitingRoomGuideHandOffset: 0,
    waitingRoomGuideHandDuration: 520,
 
    indicesSeleccionados: [], // Para MultiChoice (Array)
    indiceSeleccionado: null,   // Para Pregunta estándar (Single)
    intervaloReloj: null,
    tiempoQuiz: 0,

    roomLiked: false,
    roomLikesCount: 0,
    _likesInitializedForCanal: '',
    showShareSheet: false,
    linkCopied: false,
    galleryLoadedMap: {},

    visitTracked: false,
    conversationTracked: false,

    // Name/Avatar Setup Modal
    mostrarModalNombreSetup: false,
    avatarSeleccionado: localStorage.getItem('user_avatar_id') || null,
    avataresTomados: [],

    // Personal Winner Screen
    miPuestoGanador: null,
    mostrarPantallaGanador: false,

    // Room search modal
    showSearchModal: false,
    searchQuery: '',
    searchResults: [],
    searchLoading: false,
    searchDebounceTimer: null,

    }

  },
watch: {
  showSearchModal(val) {
    if (val) {
      this.$nextTick(() => this.$refs.searchInput?.focus());
    } else {
      clearTimeout(this.searchDebounceTimer);
    }
  },
shouldUseDesktopShowcase: {
  immediate: false,
  handler(val) {
    if (val && !this.canalId) {
      this.$nextTick(() => {
        if (this.filteredExploreProfiles && this.filteredExploreProfiles.length) {
          this.showExploreModal = true;
        }
      });
    }
  }
},

filteredExploreProfiles(newVal) {
  if (this.shouldUseDesktopShowcase && !this.canalId && newVal && newVal.length && !this.showExploreModal) {
    this.showExploreModal = true;
  }
  this.$nextTick(() => {
    if (this.exploreSwiperInstance) {
      try {
        this.exploreSwiperInstance.update();
      } catch (error) {
        // noop
      }
    }
    this.restartExploreAutoplay();
  });
},

canalId: {
  immediate: true,
  handler(newVal) {
    if (this.unsubWaitingRoomConfig) {
      this.unsubWaitingRoomConfig();
      this.unsubWaitingRoomConfig = null;
    }
 
    if (!newVal) {
      this.puntosUsuario = 0;
      this.waitingRoomPublicData = { enabled: false, slides: [] };
      return;
    }
 
    this.puntosUsuario = parseInt(localStorage.getItem(`uvoto_pts_${newVal}`) || '0', 10);
    this.escucharWaitingRoomConfig();
    this.loadPersistedBookings();
  }
},
 
'proyectorConfig.activeContextId'(newVal, oldVal) {
  if (newVal === oldVal) return;
  this.reiniciarChatIAPorContexto();
  if (this.mostrarModalPreguntas && this.canalId) {
    this.escucharMisConsultas();
  }
},

  'runtimeConfig.qnaEnabled'(enabled) {
  if (enabled) return;
  this.nuevaPregunta = '';
  this.loadingEnvio = false;
  this.stopVoiceRecording(true);
},
 
nuevaPregunta() {
  this.$nextTick(() => this.autoResizeChatTextarea());
},
 
waitingRoomSlides(newSlides) {
  this.activeWaitingRoomIndex = 0;
  this.syncWaitingRoomGuideState();
  // Translate whenever the Firestore data changes
  if (newSlides && newSlides.length) {
    this.translateAllWaitingRoomSlides();
  }
},

puedeMostrarSalaEspera(val) {
  if (!val) {
    this.detenerGuiaSlidesWaitingRoom();
    this.mostrarGuiaSlidesWaitingRoom = false;
    return;
  }
  this.syncWaitingRoomGuideState();
},
 
  proyectorId: {
    immediate: true,
    handler(newId) {
      if (newId) {
        console.log("🔗 Conectando vía Link/Prop:", newId);
        this.conectarProyector(newId);
      }
    }
  },
 
 
  // 1. Unificación de Pregunta Activa (Gestiona Quiz, Cards y Estados)
  preguntaActiva: {
    immediate: true,
    deep: true,
    handler(newVal, oldVal) {
      // 1. SALIDA INMEDIATA: Si se cierra o finaliza
      if (!newVal || newVal.estado === 'finalizado') {
        this.resetInteraccion();
        return; 
      }
 
      // 2. CAMBIO DE PREGUNTA: Reset de interfaz
      const esNuevaPregunta = newVal.id !== oldVal?.id;
      
      if (esNuevaPregunta) {
        this.votoRealizado = false;
        this.indiceSeleccionado = null;
        this.votoConfirmado = false;
        this.tiempoQuiz = 0;
        this.ganadorLocal = false;     // Reset de estado de ganador
        this.confetiLanzado = false;   // Reset de confeti
        // Always dismiss winner overlay when a new question is launched
        this.mostrarPantallaGanador = false;
        this.miPuestoGanador = null;
 
        // PERSISTENCIA MEJORADA
        const storageKey = newVal.tipoContenido === 'cards'
          ? `voted_cards_${newVal.id || this.canalId}`
          : `voted_${newVal.id}`;
        
        const indexKey = `voted_index_${newVal.id}`;
        const relaunchKey = `relaunch_version_${newVal.id}`;
        const savedRelaunchVersion = localStorage.getItem(relaunchKey);
        const currentRelaunchVersion = newVal.relaunchVersion != null ? String(newVal.relaunchVersion) : null;
 
        if (currentRelaunchVersion && savedRelaunchVersion !== currentRelaunchVersion) {
          localStorage.removeItem(storageKey);
          localStorage.removeItem(indexKey);
          localStorage.setItem(relaunchKey, currentRelaunchVersion);
        }
 
        // Recuperar si ya votó
        if (localStorage.getItem(storageKey)) {
          this.votoRealizado = true;
          
          // Recuperar QUÉ votó (para que no se pierda al recargar)
          const indexGuardado = localStorage.getItem(indexKey);
          if (indexGuardado !== null) {
            this.indiceSeleccionado = parseInt(indexGuardado);
          }
        }
 
        // Inicialización por tipo
        if (newVal.tipoContenido === 'quiz') {
          this.iniciarCronometroQuiz();
          // Si al recargar ya estamos en modo resultados, verificar inmediatamente
          if (this.proyectorConfig.modo === 'resultados') {
            this.verificarResultadoQuiz();
          }
        } else if (this.preguntaTieneRespuestaCorrecta(newVal) && this.proyectorConfig.modo === 'resultados') {
          this.verificarResultadoQuiz();
        } else if (newVal.tipoContenido === 'ordenar') {
          this.listaOrdenable = [...newVal.opciones];
        }
      }
 
      // 3. ACTUALIZACIÓN POR LATENCIA: 
      // Si la pregunta es la misma pero llegó la fecha de lanzamiento que faltaba
      if (!esNuevaPregunta && newVal.tipoContenido === 'quiz' && !this.intervaloReloj) {
        if (newVal.fechaLanzamiento) {
          this.iniciarCronometroQuiz();
        }
      }
    }
  },
 
  // 2. Unificación de proyectorConfig.modo (Cambios de pantalla global)
  'proyectorConfig.modo'(nuevoModo) {
    // Si pasamos a modo conteo (Cuenta regresiva del proyector)
    if (nuevoModo === 'conteo') {
      const conteo = this.proyectorConfig?.ultimoConteo;
      if (conteo) {
        this.tiempoRestante = conteo.segundosActuales ?? conteo.segundos;
        if (conteo.estado === 'play') this.iniciarRelojUsuario();
      }
    } else {
      // Detener reloj de conteo general si salimos del modo
      if (this.userTimerInterval) {
        clearInterval(this.userTimerInterval);
        this.userTimerInterval = null;
      }
    }
 
    // Manejo de Resultados y Ganadores
    if (nuevoModo === 'resultados') {
      this.verificarResultadoQuiz();
    }
    else if (['standard', 'cards', 'pregunta'].includes(nuevoModo)) {
      // Limpiar estados de victoria cuando volvemos a modo pregunta o normal
      this.ganadorLocal = false;
      this.confetiLanzado = false;
    }

    // Ocultar pantalla personal de ganador si salimos del modo ganadores
    if (nuevoModo !== 'ganadores') {
      this.mostrarPantallaGanador = false;
    }
  },

  'proyectorConfig.ganadoresDestacados': {
    deep: true,
    handler(newVal) {
      // Only show the winner overlay when the projector is actually in
      // 'ganadores' mode. Without this guard, launching a new question keeps
      // ganadoresDestacados in Firestore, the watcher fires, finds the user
      // still in the list, and incorrectly re-shows the overlay.
      if (this.proyectorConfig?.modo !== 'ganadores') {
        this.mostrarPantallaGanador = false;
        this.miPuestoGanador = null;
        return;
      }
      if (!newVal || !newVal.length) {
        this.mostrarPantallaGanador = false;
        this.miPuestoGanador = null;
        return;
      }
      const myId = this.userId;
      const myNombre = (this.nombreUsuario || '').toLowerCase().trim();
      const ganador = newVal.find((g) => {
        const matchId = myId && g.id === myId;
        const matchNombre = myNombre && g.nombre?.toLowerCase().trim() === myNombre;
        return matchId || matchNombre;
      });
      if (ganador) {
        const puesto = newVal.indexOf(ganador) + 1;
        this.miPuestoGanador = { ...ganador, puesto };
        this.mostrarPantallaGanador = true;
      } else {
        this.miPuestoGanador = null;
        this.mostrarPantallaGanador = false;
      }
    }
  },
 
  // 3. Saludos / Greetings
  'proyectorConfig.greetings'(newVal) {
    if (newVal) this.mostrarCajaLocal = true;
  },
 
  // 4. Sincronización del Reloj de Conteo (Deep Watch para el estado del Timer)
  'proyectorConfig.ultimoConteo': {
    deep: true,
    handler(newVal) {
      if (this.proyectorConfig.modo !== 'conteo' || !newVal) return;
 
      this.tiempoRestante = newVal.segundosActuales !== undefined 
        ? newVal.segundosActuales 
        : newVal.segundos;
 
      if (newVal.estado === 'play') {
        this.iniciarRelojUsuario();
      } else {
        if (this.userTimerInterval) {
          clearInterval(this.userTimerInterval);
          this.userTimerInterval = null;
        }
      }
    }
  },
 
  pdfSource: {
    immediate: true,
    handler(newVal) {
      if (!newVal) {
        this.resetPdfPhone();
        return;
      }
      this.pdfPaginaActual = this.proyectorConfig?.pdfPaginaActual || 1;
      this.cargarPdfPhone(newVal);
    }
  },
  canalId(val) {
    this.actualizarEstadoMomentoPublicado(val);
    if (val && this.isChatOnlyMode) {
      this.$nextTick(() => { this.mostrarModalPreguntas = true; });
    }
    if (val && !this.nombreUsuario) {
      this.asignarNombreYAvatarAutomatico();
    }
  },
  'proyectorConfig.nombreSesion': {
    handler(val) {
      if (val && this.isChatOnlyMode) {
        document.title = val;
      }
    }
  },
  'proyectorConfig.pdfPaginaActual'(val) {
    if (this.pdfDoc && val) {
      this.pdfPaginaActual = val;
      this.$nextTick(() => this.renderizarPdfPhone(val));
    }
  },
 
  'proyectorConfig.viewphone'(val) {
    if (val && this.pdfSource) {
      this.$nextTick(() => this.renderizarPdfPhone(this.pdfPaginaActual || 1));
      this.mostrarPdfUi();
    }
  },
  'proyectorConfig.waitingRoomDocId'(newVal, oldVal) {
    if (this.canalId && newVal !== oldVal) {
      this.escucharWaitingRoomConfig();
    }
  },
  
},
 
 
  computed: {
  // Ruta dedicada para compartir por link: muestra solo el reclamo de marca.
  esRutaJoin() {
    // /join es la URL que se comparte, pero el preview redirige a
    // /user?join=1 para no chocar con la reescritura del .htaccess.
    if (this.$route?.path === '/join') return true;
    const q = this.$route?.query?.join;
    return q === '1' || q === 1 || q === '' || q === true;
  },
  // Con reserva viva no se pide la marca de nuevo: se ofrece retomarla.
  tieneReservaActiva() {
    return this.brandSlugStatus === 'current' && !!this.brandSlugDraft;
  },
  puedeGuardarNombreSetup() {
    return (this.nombreUsuario || '').trim().length >= 2;
  },
  roomShareUrl() {
    const slug = String(this.$route?.params?.slug || this.$route?.query?.slug || this.proyectorConfig?.shareSlug || '').trim();
    return slug ? `https://uvoto.com/${slug}` : `https://uvoto.com/${this.canalId || ''}`;
  },
  shareHeroBgStyle() {
    const img = this.shareRoomImage;
    if (img) return { backgroundImage: `url(${img})` };
    // No real image: use gradient Branding as flat background (no blur)
    const branding = this.proyectorConfig?.Branding || '';
    const isGradient = /^(linear|radial|conic)-gradient|^radial-gradient/.test(branding.trim());
    if (isGradient) return { background: branding };
    return {};
  },
  // ¿Tiene sentido ofrecer "este lienzo"? Solo si estamos en la sala, hay
  // más de un lienzo y el activo tiene id.
  puedeCompartirSlide() {
    return this.puedeMostrarSalaEspera
      && (this.displayWaitingRoomSlides || []).length > 1
      && !!String(this.activeWaitingRoomSlide?.id || '').trim();
  },

  compartiendoSlide() {
    return this.puedeCompartirSlide && this.modoCompartir === 'slide';
  },

  // URL que usan TODAS las acciones del sheet, según lo elegido.
  urlCompartirActual() {
    return this.compartiendoSlide ? this.urlCompartirSlide() : this.roomShareUrl;
  },

  tituloCompartirActual() {
    if (this.compartiendoSlide) {
      const sl = this.activeWaitingRoomSlide || {};
      const propio = String(sl.title || sl.primaryText || '').trim();
      if (propio) return propio;
    }
    return this.tituloVisibleSesionUsuario || this.proyectorConfig?.nombreSesion || 'Sala pública';
  },

  // La descripción que va a salir en la vista previa, para que el panel
  // muestre lo que la gente verá de verdad.
  descripcionCompartirActual() {
    if (this.compartiendoSlide) {
      const sl = this.activeWaitingRoomSlide || {};
      const propia = String(sl.subtitle || sl.description || '').trim();
      if (propia) return propia;
    }
    return this.shareRoomDescription || '';
  },

  // La miniatura del sheet acompaña a lo que se va a compartir.
  imagenCompartirActual() {
    if (this.compartiendoSlide) {
      const sl = this.activeWaitingRoomSlide || {};
      const propia = String(sl.imageUrl || sl.imagePreview || sl.videoPosterUrl || '').trim();
      if (propia) return propia;
      const galeria = Array.isArray(sl.galleryImages) ? sl.galleryImages : [];
      const primera = galeria.find((g) => String(g?.imageUrl || g?.previewUrl || '').trim());
      if (primera) return String(primera.imageUrl || primera.previewUrl).trim();
    }
    return this.shareRoomImage;
  },

  shareRoomImage() {
    // Same priority as explore-modal-featured-bg:
    // first slide image → canal shareImageUrl → logo fallback
    const firstSlide = this.waitingRoomPublicData?.slides?.[0] || {};
    return (
      firstSlide.imageUrl ||
      firstSlide.imagePreview ||
      this.proyectorConfig?.shareImageUrl ||
      this.proyectorConfig?.logoEmpresa ||
      ''
    );
  },
  shareRoomDescription() {
    return this.proyectorConfig?.descripcion || this.proyectorConfig?.bio || this.proyectorConfig?.descripcionSesion || '';
  },
  onboardingCopy() {
    const lang = String(this.selectedLanguage || 'es').toLowerCase();
    const copy = {
      es: {
        eyebrow: 'UNETE EN SEGUNDOS',
        titleLineOne: 'Únete a una',
        titleLineTwo: 'sesión interactiva',
        titleLineThree: 'de',
        subtitle: 'Ingresa el código de 4 dígitos para interactuar en tiempo real.',
        inputLabel: 'Tu acceso rápido',
        inputCaption: 'Escribe el código y entra al instante.',
        placeholder: 'Ingresa tu código',
        joinLabel: 'Unirme',
        helper: 'Pídele al administrador tu código de acceso para continuar.',
        recentTitle: 'Explora tus sesiones recientes',
        recentSubtitle: 'Vuelve a los canales que ya visitaste.',
        exploreTitle: 'Explora salas públicas',
        exploreBody: 'Desliza entre experiencias activas, descubre marcas y entra directo a la sala que quieras visitar.',
        brandCta: 'Crear mi sala'
      },
      en: {
        eyebrow: 'JOIN IN SECONDS',
        titleLineOne: 'Join an',
        titleLineTwo: 'interactive session',
        titleLineThree: 'of',
        subtitle: 'Enter the 4-digit code to interact in real time.',
        inputLabel: 'Your quick access',
        inputCaption: 'Type the code and join instantly.',
        placeholder: 'Enter your code',
        joinLabel: 'Join',
        helper: 'Ask the admin for your access code to continue.',
        recentTitle: 'Explore recent sessions',
        recentSubtitle: 'Jump back into the channels you already visited.',
        exploreTitle: 'Explore public rooms',
        exploreBody: 'Swipe through active experiences, discover brands, and jump straight into the room you want to visit.',
        brandCta: 'Create my room'
      },
      pt: {
        eyebrow: 'ENTRE EM SEGUNDOS',
        titleLineOne: 'Entre em uma',
        titleLineTwo: 'sessão interativa',
        titleLineThree: 'de',
        subtitle: 'Digite o código de 4 dígitos para interagir em tempo real.',
        inputLabel: 'Seu acesso rápido',
        inputCaption: 'Digite o código e entre na hora.',
        placeholder: 'Digite seu código',
        joinLabel: 'Entrar',
        helper: 'Peça ao administrador o seu código de acesso para continuar.',
        recentTitle: 'Explore suas sessões recentes',
        recentSubtitle: 'Volte aos canais que você já visitou.',
        exploreTitle: 'Explore salas públicas',
        exploreBody: 'Deslize entre experiências ativas, descubra marcas e entre direto na sala que quiser visitar.',
        brandCta: 'Criar minha sala'
      }
    };
    return copy[lang] || copy.es;
  },



  canJoinSession() {
    return normalizarPinIngreso(this.pinIngresado).length === 4;
  },

  showExplorerSurface() {
    // /join no pasa por el explorador: su única pantalla es el lienzo de
    // reclamo, que se renderiza en la rama de sala de espera.
    if (this.esRutaJoin) return false;
    return !this.canalId || this.showExploreOverlay;
  },

  canUseExploreSwipeZone() {
    return !!(this.canalId || this.showJoinHomePanel || this.showExploreOverlay);
  },

  hasDirectSessionIntent() {
    const slug = String(this.$route?.params?.slug || this.$route?.query?.slug || '').trim();
    const params = new URLSearchParams(window.location.search);
    return !!(slug || params.get('pin') || params.get('canal') || this.$route?.query?.desktop === '1');
  },

  isDesktopViewport() {
    return this.viewportWidth >= 1100;
  },

  showDesktopEntryGate() {
    return this.isDesktopViewport && !this.desktopEntryStarted && !this.canalId && !this.loading && !this.hasDirectSessionIntent;
  },

  shouldUseDesktopShowcase() {
    return this.isDesktopViewport && !this.showDesktopEntryGate;
  },

  contentContainerInlineStyle() {
    if (this.proyectorConfig.waitingRoomEnabled) {
      if (this.shouldUseDesktopShowcase) {
        return 'flex: 1; display: flex; padding: 0; flex-direction: column; width: 100%; height: 100%; position: relative; box-sizing: border-box;';
      }
      return 'flex: 1; display: flex; padding: 0; flex-direction: column; width: 100%; height: 100vh; position: fixed; box-sizing: border-box;';
    }
    if (this.shouldUseDesktopShowcase) {
      return 'flex: 1; display: flex; flex-direction: column; width: 100%; height: 100%; padding: 0; box-sizing: border-box; overflow-x: hidden;';
    }
    return '';
  },

  desktopLandingCopy() {
    const lang = String(this.selectedLanguage || 'es').toLowerCase();
    const copy = {
      es: {
        title: 'Accede desde tu computador',
        body: 'Uvoto es la plataforma de participación en tiempo real para eventos, conferencias, clases y experiencias interactivas. Vota, responde encuestas, hace preguntas en vivo y sigue el contenido del evento desde cualquier dispositivo.',
        purpose: 'Ingresa el código de tu evento para unirte a una sesión activa, o explora salas públicas disponibles.',
        cta: 'Unirme a una sesión',
        mainTitle: 'Únete',
        description: 'Conoce cómo funciona Uvoto, descubre salas activas y entra a una experiencia interactiva desde tu computador mientras ves la app vivir dentro de un teléfono simulado.',
        inputTitle: 'Ingresa tu código de sala',
        sectionTitle: 'Qué puedes hacer aquí',
        sectionBody: 'Participar en votaciones, navegar salas públicas, revisar sesiones recientes, interactuar en vivo y seguir el contenido preparado por cada marca o evento.',
        footerTitle: 'Diseñado para sentirse familiar',
        footerBody: 'La vista desktop conserva el look mobile-first de Uvoto para que nuevos usuarios entiendan la plataforma rápido y puedan actuar al instante.'
      },
      en: {
        title: 'Open the desktop experience',
        body: 'Uvoto is the real-time audience engagement platform for events, conferences, classes, and interactive experiences. Vote, answer polls, ask live questions, and follow the event content from any device.',
        purpose: 'Enter your event code to join an active session, or explore available public rooms.',
        cta: 'Join a session',
        mainTitle: 'Join',
        description: 'Discover how Uvoto works, browse active rooms and enter an interactive experience from your computer while the app lives inside a simulated phone.',
        inputTitle: 'Enter your room code',
        sectionTitle: 'What you can do here',
        sectionBody: 'Take part in voting, browse public rooms, revisit recent sessions, interact live and follow the content prepared by each brand or event.',
        footerTitle: 'Built to feel familiar',
        footerBody: 'The desktop view keeps the same mobile-first visual identity so new users understand the platform quickly and can act right away.'
      },
      pt: {
        title: 'Abra a experiencia desktop',
        body: 'Uvoto é a plataforma de participação em tempo real para eventos, conferências, aulas e experiências interativas. Vote, responda enquetes, faça perguntas ao vivo e acompanhe o conteúdo do evento de qualquer dispositivo.',
        purpose: 'Digite o código do seu evento para entrar em uma sessão ativa, ou explore as salas públicas disponíveis.',
        cta: 'Entrar em uma sessão',
        mainTitle: 'Entre',
        description: 'Descubra como a Uvoto funciona, navegue por salas ativas e entre em uma experiencia interativa do seu computador enquanto o app vive dentro de um telefone simulado.',
        inputTitle: 'Digite o código da sala',
        sectionTitle: 'O que você pode fazer aqui',
        sectionBody: 'Participar de votações, navegar por salas publicas, revisar sessões recentes, interagir ao vivo e acompanhar o conteúdo preparado por cada marca ou evento.',
        footerTitle: 'Feito para parecer familiar',
        footerBody: 'A versão desktop mantém a mesma identidade visual mobile-first para que novos usuarios entendam a plataforma rapidamente e ajam na hora.'
      }
    };
    return copy[lang] || copy.es;
  },

  desktopBenefitItems() {
    const lang = String(this.selectedLanguage || 'es').toLowerCase();
    const items = {
      es: [
        {
          title: 'Interacción en tiempo real',
          body: 'Responde dinámicas, vota y participa mientras el evento está sucediendo.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 12h16"></path><path d="M12 4v16"></path></svg>'
        },
        {
          title: 'Salas públicas y destacadas',
          body: 'Explora experiencias activas, marcas y contenidos públicos desde el preview lateral.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="4" width="18" height="16" rx="3"></rect><path d="M8 9h8M8 13h5"></path></svg>'
        },
        {
          title: 'Continuidad entre dispositivos',
          body: 'La interfaz conserva el look mobile para que todo se sienta familiar también en desktop.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="7" y="2.5" width="10" height="19" rx="3"></rect><path d="M11 18h2"></path></svg>'
        }
      ],
      en: [
        {
          title: 'Real-time interaction',
          body: 'Answer prompts, vote and participate while the session is happening.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 12h16"></path><path d="M12 4v16"></path></svg>'
        },
        {
          title: 'Public and featured rooms',
          body: 'Browse active experiences, brands and public content from the phone preview.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="4" width="18" height="16" rx="3"></rect><path d="M8 9h8M8 13h5"></path></svg>'
        },
        {
          title: 'Cross-device continuity',
          body: 'The interface keeps the mobile look so the experience still feels familiar on desktop.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="7" y="2.5" width="10" height="19" rx="3"></rect><path d="M11 18h2"></path></svg>'
        }
      ],
      pt: [
        {
          title: 'Interação em tempo real',
          body: 'Responda dinamicas, vote e participe enquanto a sessão acontece.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 12h16"></path><path d="M12 4v16"></path></svg>'
        },
        {
          title: 'Salas publicas e destaque',
          body: 'Explore experiencias ativas, marcas e conteúdo publico no preview do telefone.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="4" width="18" height="16" rx="3"></rect><path d="M8 9h8M8 13h5"></path></svg>'
        },
        {
          title: 'Continuidade entre dispositivos',
          body: 'A interface mantém o visual mobile para continuar familiar também no desktop.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="7" y="2.5" width="10" height="19" rx="3"></rect><path d="M11 18h2"></path></svg>'
        }
      ]
    };
    return items[lang] || items.es;
  },

  rotatingAudienceLabel() {
    const lang = String(this.selectedLanguage || 'es').toLowerCase();
    const audiences = {
      es: ['creadores.', 'speakers.', 'marcas.', 'negocios.', 'realtors.', 'creativos.', 'actores.', 'eventos.', 'equipos.', 'comunidades.'],
      en: ['creators.', 'speakers.', 'brands.', 'businesses.', 'realtors.', 'creatives.', 'actors.', 'events.', 'teams.', 'communities.'],
      pt: ['criadores.', 'speakers.', 'marcas.', 'negocios.', 'realtors.', 'criativos.', 'atores.', 'eventos.', 'equipes.', 'comunidades.']
    };
    const list = audiences[lang] || audiences.es;
    return list[this.rotatingAudienceIndex % list.length];
  },

  entryLoadingPreview() {
    const preview = this.enteringSessionPreview || {};
    const lang = String(this.selectedLanguage || 'es').toLowerCase();
    const kickerByLang = {
      es: 'Ingresando a',
      en: 'Entering',
      pt: 'Entrando em'
    };
    const fallbackTitleByLang = {
      es: 'tu experiencia',
      en: 'your experience',
      pt: 'sua experiencia'
    };

    return {
      imageUrl: preview.imageUrl || preview.logoUrl || '',
      title: preview.title || preview.brandName || (this.isDirectSlug ? this.getActiveSlug() : (fallbackTitleByLang[lang] || fallbackTitleByLang.es)),
      kicker: kickerByLang[lang] || kickerByLang.es
    };
  },

  isDirectSlug() {
    const slug = String(this.$route?.params?.slug || '').trim();
    return !!slug && slug.toLowerCase() !== 'user';
  },

  isChatOnlyMode() {
    return String(this.$route?.path || '').startsWith('/chat/');
  },

  availableExploreCategories() {
    const allLabels = { es: 'Todos', en: 'All', pt: 'Todos' };
    const lang = String(this.selectedLanguage || 'es').toLowerCase();
    const list = Array.isArray(this.publicExploreProfiles) ? this.publicExploreProfiles : [];
    // Una pill por cada categoría real presente (Artistas, Marca personal...),
    // ordenadas por cuál acumula más visitas — las más visitadas van primero.
    // "general"/"all" no son categorías reales — nunca generan su propia pill
    // (evita el "All" duplicado que salía con canales viejos sin categoría).
    const totales = new Map();
    for (const profile of list) {
      const key = String(profile.category || '').trim();
      if (!key || key === 'general' || key === 'all') continue;
      const label = (key === 'brand' || key === 'event')
        ? this.genericCategoryLabel(key, profile.categoryLabel || key)
        : (profile.categoryLabel || key);
      const entry = totales.get(key) || { id: key, label, visits: 0 };
      entry.visits += Number(profile.visitsCount || 0);
      totales.set(key, entry);
    }
    const ordenadas = Array.from(totales.values()).sort((a, b) => b.visits - a.visits);
    return [{ id: 'all', label: allLabels[lang] || allLabels.es }, ...ordenadas];
  },

  filteredExploreProfiles() {
    const list = Array.isArray(this.publicExploreProfiles) ? this.publicExploreProfiles : [];
    if (this.activeExploreCategory === 'all') return list;
    return list.filter((profile) => (profile.category || 'general') === this.activeExploreCategory);
  },

  mainExploreLoopEnabled() {
    return this.filteredExploreProfiles.length > 1;
  },

  mainExploreSlides() {
    const list = this.filteredExploreProfiles;
    if (!Array.isArray(list) || !list.length) return [];
    const desiredLength = this.mainExploreLoopEnabled ? Math.max(list.length, 6) : list.length;
    const copies = Math.max(1, Math.ceil(desiredLength / list.length));
    return Array.from({ length: copies })
      .flatMap(() => list)
      .map((profile, index) => ({
        ...profile,
        __loopKey: `${profile.canalId || profile.slug || 'slide'}_${index}`
      }));
  },

  brandClaimSlides() {
    const list = Array.isArray(this.publicExploreProfiles) ? [...this.publicExploreProfiles] : [];
    if (!list.length) return [];
    const currentId = this.canalId;
    if (currentId) {
      const idx = list.findIndex(p => p.canalId === currentId);
      if (idx > -1) {
        const [current] = list.splice(idx, 1);
        list.unshift(current);
      }
    }
    return list;
  },

  canReserveBrandSlug() {
    return this.isValidBrandSlug(this.brandSlugDraft) && ['available', 'current', 'idle'].includes(this.brandSlugStatus);
  },

  filteredExploreModalProfiles() {
    const list = Array.isArray(this.publicExploreProfiles) ? this.publicExploreProfiles : [];
    if (this.activeExploreModalCategory === 'all') return list;
    return list.filter((profile) => (profile.category || 'general') === this.activeExploreModalCategory);
  },

  // Filas por categoría real (Artista, Marca personal, Producto...) que se
  // muestran debajo de "Salas destacadas" — solo categorías con al menos 1 sala.
  exploreCategoryRows() {
    const list = Array.isArray(this.publicExploreProfiles) ? this.publicExploreProfiles : [];
    const grupos = new Map();
    for (const profile of list) {
      // "general" es el catch-all (sin categoría real) — no forma su propia fila.
      const key = String(profile.category || '').trim();
      if (!key || key === 'general') continue;
      if (!grupos.has(key)) {
        const fallbackLabel = profile.categoryLabel || (key.charAt(0).toUpperCase() + key.slice(1));
        grupos.set(key, {
          key,
          label: (key === 'brand' || key === 'event') ? this.genericCategoryLabel(key, fallbackLabel) : fallbackLabel,
          profiles: [],
          visits: 0
        });
      }
      const grupo = grupos.get(key);
      grupo.profiles.push(profile);
      grupo.visits += Number(profile.visitsCount || 0);
    }
    return Array.from(grupos.values())
      .filter((grupo) => grupo.profiles.length > 0)
      // Dentro de cada categoría, las más visitadas primero.
      .map((grupo) => ({ ...grupo, profiles: [...grupo.profiles].sort((a, b) => (b.visitsCount || 0) - (a.visitsCount || 0)) }))
      // Las categorías más visitadas (en conjunto) se posicionan primero.
      .sort((a, b) => b.visits - a.visits);
  },

  searchExploreProfiles() {
    const query = String(this.exploreModalQuery || '').trim().toLowerCase();
    if (!query) return [];
    return this.publicExploreProfiles.filter((profile) => {
      const haystack = [
        profile.brandName,
        profile.title,
        profile.description,
        profile.subtitle,
        profile.categoryLabel
      ].join(' ').toLowerCase();
      return haystack.includes(query);
    }).slice(0, 12);
  },
 
  runtimeConfig() {
    const nested = this.proyectorConfig?.config || {};
    return {
      // En modo chat-only (embed/standalone) el Q&A siempre está habilitado
      qnaEnabled: this.isChatOnlyMode ? true : (nested.qnaEnabled ?? this.proyectorConfig?.qnaEnabled ?? this.proyectorConfig?.['config.qnaEnabled'] ?? false),
      greetingsMode: nested.greetingsMode ?? this.proyectorConfig?.greetingsMode ?? this.proyectorConfig?.['config.greetingsMode'] ?? 0,
      momentsEnabled: nested.momentsEnabled ?? this.proyectorConfig?.momentsEnabled ?? this.proyectorConfig?.['config.momentsEnabled'] ?? false,
      waitingRoomEnabled: nested.waitingRoomEnabled ?? this.proyectorConfig?.waitingRoomEnabled ?? this.proyectorConfig?.['config.waitingRoomEnabled'] ?? false,
      gamificationEnabled: nested.gamificationEnabled ?? this.proyectorConfig?.gamificationEnabled ?? this.proyectorConfig?.['config.gamificationEnabled'] ?? false
    };
},
 
waitingRoomSlides() {
  const slides = Array.isArray(this.waitingRoomPublicData?.slides)
    ? this.waitingRoomPublicData.slides
    : [];
  if (!isPublicationActive(this.waitingRoomPublicData)) return [];
  // En plan free permanente (sin membresía y sin gracia vigente) solo se
  // sirve el primer lienzo. Los demás siguen guardados en el doc: vuelven a
  // mostrarse en cuanto el dueño active su membresía.
  return limitSlidesForPublishPlan(slides, this.waitingRoomPublicData);
},

// Returns translated clones of waitingRoomSlides when the current language differs from the source language
displayWaitingRoomSlides() {
  const lang = String(this.selectedLanguage || 'es').toLowerCase().split('-')[0];
  const slides = this.waitingRoomSlides.map((slide) => {
    const key = `${slide.id || slide._id || JSON.stringify(slide).slice(0,40)}_${lang}`;
    const resolved = this.translatedSlidesMap[key] || slide;
    return this.wrNormalizarBlocks(resolved);
  });
  if (this.esRutaJoin) return [this.buildBrandClaimWaitingRoomSlide()];
  if (this.shouldAppendBrandClaimSlide) {
    slides.push(this.buildBrandClaimWaitingRoomSlide());
  }
  return slides;
},

shouldAppendBrandClaimSlide() {
  return !!this.canalId && this.runtimeConfig.waitingRoomEnabled;
},

activeWaitingRoomSlide() {
  return this.displayWaitingRoomSlides[this.activeWaitingRoomIndex] || this.displayWaitingRoomSlides[0] || {};
},

// Color con el que Safari tiñe la franja superior en iOS 15+. En la sala de
// espera sigue al color dominante del lienzo activo —el mismo que arranca el
// degradado de waitingRoomUserScreenStyle—, así la barra no corta la pantalla
// con una franja de otro color. Fuera de ahí, el negro base del sitio.
colorBarraEstado() {
  if (this.puedeMostrarSalaEspera) {
    return this.activeWaitingRoomSlide?.dominantColor || '#0f0f0f';
  }
  return '#0f0f0f';
},

shouldShowRoomActionBar() {
  if (!this.canalId) return false;
  if (this.isWrSlideMoving) return false;
  if (this.activeWaitingRoomSlide?.layoutType === 'brand-claim') return false;
  return true;
},
 
waitingRoomUserScreenStyle() {
  const dominant = this.activeWaitingRoomSlide?.dominantColor || '#211d1b';
  const accent = this.activeWaitingRoomSlide?.accentColor || '#5f4737';
  return {
    background: `
      radial-gradient(circle at 14% 12%, ${this.colorConAlpha(accent, 0.32)} 0%, transparent 30%),
      radial-gradient(circle at 88% 0%, ${this.colorConAlpha(dominant, 0.5)} 0%, transparent 35%),
      linear-gradient(180deg, ${this.colorConAlpha(dominant, 0.92)} 0%, #121212 72%)
    `
  };
},


activeContextKind() {
  const raw = this.proyectorConfig?.activeContextKind
    || this.proyectorConfig?.contexto_ia?.activeContextKind
    || 'event';
  const normalized = String(raw).trim().toLowerCase();
  // Ahora acepta los 4 tipos reales en vez de forzar brand/event
  if (['brand', 'personal', 'product', 'event'].includes(normalized)) return normalized;
  return 'event';
},

activeContextData() {
  const contextoIA = this.proyectorConfig?.contexto_ia || {};
  const contexts = Array.isArray(contextoIA?.contexts) ? contextoIA.contexts : [];
  const activeId = String(contextoIA?.activeContextId || this.proyectorConfig?.activeContextId || '').trim();
  if (activeId) {
    const match = contexts.find((ctx) => String(ctx?.id || '').trim() === activeId);
    if (match) return match;
  }
  return contexts[0] || contextoIA || {};
},

activeContextGoalPreset() {
  const raw = this.activeContextData?.goalPreset
    || this.proyectorConfig?.contexto_ia?.activeContextGoalPreset
    || this.proyectorConfig?.activeContextGoalPreset
    || '';
  return String(raw || '').trim().toLowerCase();
},

activeContextBusinessBasics() {
  return this.activeContextData?.businessBasics
    || this.proyectorConfig?.contexto_ia?.activeContextBusinessBasics
    || {};
},

quickAppConfig() {
  const ctxBasics = this.activeContextBusinessBasics || {};
  const ctxIaBasics = this.proyectorConfig?.contexto_ia?.activeContextBusinessBasics || {};

  // 1. Prioridad: Raíz de proyectorConfig (quickAppUrl/Name se guardan aquí)
  if (this.proyectorConfig?.quickAppUrl && this.proyectorConfig?.quickAppName) {
    const enabled = (this.proyectorConfig.quickAppEnabled ?? ctxBasics.quickAppEnabled ?? ctxIaBasics.quickAppEnabled ?? true) !== false;
    if (!enabled) return null;
    const color = this.proyectorConfig.quickAppColor
      || ctxBasics.quickAppColor
      || ctxIaBasics.quickAppColor
      || '#C4A484';
    return {
      url: this.proyectorConfig.quickAppUrl,
      name: this.proyectorConfig.quickAppName,
      color
    };
  }

  // 2. Fallbacks: Contexto activo o businessBasics anidados
  const globalBasics = this.proyectorConfig?.businessBasics || {};

  const url = ctxBasics.quickAppUrl || globalBasics.quickAppUrl || ctxIaBasics.quickAppUrl;
  const name = ctxBasics.quickAppName || globalBasics.quickAppName || ctxIaBasics.quickAppName;
  const enabled = (ctxBasics.quickAppEnabled ?? globalBasics.quickAppEnabled ?? ctxIaBasics.quickAppEnabled ?? true) !== false;
  const color = ctxBasics.quickAppColor || globalBasics.quickAppColor || ctxIaBasics.quickAppColor || '#C4A484';

  if (url && name && enabled) {
    return { url, name, color };
  }
  return null;
},

activeContextStructuredInventory() {
  return this.activeContextData?.structuredInventory
    || this.proyectorConfig?.contexto_ia?.activeContextStructuredInventory
    || {};
},

chatInventorySummary() {
  const inventory = this.activeContextStructuredInventory || {};
  const products = Array.isArray(inventory?.products) ? inventory.products : [];
  const services = Array.isArray(inventory?.services) ? inventory.services : [];
  const links = Array.isArray(inventory?.links) ? inventory.links : [];
  const businessBasics = this.activeContextBusinessBasics || {};
  const channels = typeof businessBasics?.channels === 'object' && businessBasics?.channels
    ? Object.values(businessBasics.channels).filter((value) => String(value || '').trim())
    : [];
  return {
    products: products.length,
    services: services.length,
    links: links.length,
    channels: channels.length,
    hasHours: !!String(businessBasics?.hoursNote || '').trim()
      || (Array.isArray(businessBasics?.scheduleRows) && businessBasics.scheduleRows.some((row) => row?.enabled))
  };
},

esContextoEventoActivo() {
  return this.activeContextKind === 'event';
},

nombreContextoVisible() {
  return this.tituloVisibleSesionUsuario || this.proyectorConfig?.nombreSesion || 'este espacio';
},

chatModalSubtitle() {
  return this.esContextoEventoActivo
      ? 'Te respondo dudas del evento y también te ayudo a entender mejor lo que se habló.'
      : this.activeContextKind === 'personal'
        ? `Aquí hablas con la esencia de ${this.nombreContextoVisible}. Puedes preguntarme por lo que hago, mis servicios y dónde encontrarme.`
        : this.activeContextKind === 'product'
          ? `Aquí te explico ${this.nombreContextoVisible}, qué ofrece, cuánto cuesta y cómo conseguirlo.`
          : `Aquí respondo como ${this.nombreContextoVisible}, con foco en lo que ofrece, cómo ayuda y cómo contactarlo.`;
},

chatWelcomeTitle() {
  return this.esContextoEventoActivo
    ? 'Haz tu pregunta'
    : this.activeContextKind === 'personal'
      ? `Habla con ${this.nombreContextoVisible}`
      : this.activeContextKind === 'product'
        ? `Descubre ${this.nombreContextoVisible}`
        : `Pregunta por ${this.nombreContextoVisible}`;
},

chatWelcomeSubtitle() {
  if (this.esContextoEventoActivo) return '';
  if (this.activeContextKind === 'personal') return 'Pregúntame por mis servicios, mi enfoque o dónde seguirme.';
  if (this.activeContextKind === 'product') return 'Aquí puedes preguntar por funciones, precio, beneficios o cómo conseguirlo.';
  return 'Haz preguntas concretas sobre lo que ofrece, cómo trabaja o cómo contactarlo.';
},

chatSuggestionChips() {
  const aiChips = this.proyectorConfig?.contexto_ia?.aiStarterChips;
  if (Array.isArray(aiChips) && aiChips.length) return aiChips;

  if (this.esContextoEventoActivo) {
    return [
      { key: 'main', label: 'Tema principal', prompt: '¿Cuál es el tema principal de hoy?' },
      { key: 'schedule', label: 'Horarios', prompt: '¿Cuándo termina la sesión?' },
      { key: 'summary', label: 'Resumen', prompt: 'Resumen de los puntos clave' }
    ];
  }

  const summary = this.chatInventorySummary;
  const name = this.nombreContextoVisible;

  if (this.activeContextKind === 'personal') {
    return [
      { key: 'offer', label: summary.services || summary.products ? 'Qué ofreces' : 'Quién eres', prompt: summary.services || summary.products ? `¿Qué ofreces exactamente ${name}?` : `¿Quién es ${name} y a qué se dedica?` },
      { key: 'contact', label: summary.channels ? 'Dónde seguirte' : 'Contacto', prompt: summary.channels ? `¿En qué redes o canales puedo seguirte?` : `¿Cómo puedo contactar a ${name}?` },
      { key: 'value', label: 'Cómo trabajas', prompt: `¿Cómo trabaja ${name} y en qué puede ayudarme?` }
    ];
  }

  if (this.activeContextKind === 'product' || ['sell', 'product', 'course'].includes(this.activeContextGoalPreset)) {
    return [
      { key: 'products', label: summary.products ? 'Productos' : 'Qué incluye', prompt: summary.products ? `¿Qué productos o versiones tienes disponibles?` : `¿Qué incluye ${name}?` },
      { key: 'pricing', label: 'Precios', prompt: `¿Qué precios manejas o desde cuánto empieza ${name}?` },
      { key: 'buy', label: summary.channels || summary.links ? 'Cómo comprar' : 'Saber más', prompt: summary.channels || summary.links ? `¿Cómo puedo comprar o pedir más información?` : `¿Cómo funciona ${name} y para quién es?` }
    ];
  }

  if (['support', 'leads', 'trust'].includes(this.activeContextGoalPreset)) {
    return [
      { key: 'help', label: 'Cómo ayuda', prompt: `¿Cómo puede ayudarme ${name}?` },
      { key: 'contact', label: summary.channels ? 'Contacto' : 'Canales', prompt: `¿Por dónde puedo contactar a ${name}?` },
      { key: 'hours', label: summary.hasHours ? 'Horarios' : 'Disponibilidad', prompt: summary.hasHours ? '¿Cuál es el horario de atención?' : `¿Cómo responde ${name} y en qué tiempos?` }
    ];
  }

  return [
    { key: 'main', label: 'Qué hace', prompt: `¿Qué hace ${name}?` },
    { key: 'offer', label: summary.services ? 'Servicios' : 'Qué ofrece', prompt: summary.services ? `¿Qué servicios ofrece ${name}?` : `¿Qué ofrece ${name}?` },
    { key: 'contact', label: summary.channels ? 'Contacto' : 'Cómo ayuda', prompt: summary.channels ? `¿Cómo puedo contactar a ${name}?` : `¿Cómo puede ayudarme ${name}?` }
  ];
},

chatWelcomeText() {
  const aiWelcome = String(this.proyectorConfig?.contexto_ia?.aiWelcomeMessage || '').trim();
  if (aiWelcome) return aiWelcome;

  const nombre = this.tituloVisibleSesionUsuario || this.nombreContextoVisible || 'esta marca';
  if (this.activeContextKind === 'personal') {
    return `¡Hola! Soy ${nombre}. ¿De qué te gustaría hablar hoy?`;
  }
  if (this.activeContextKind === 'brand' || this.activeContextKind === 'product') {
    return `¡Hola! Somos ${nombre}. ¿Cómo podemos ayudarte hoy?`;
  }
  return `¡Hola! Soy el asistente de ${nombre}. ¿De qué te gustaría hablar hoy?`;
},

chatTipText() {
  return this.esContextoEventoActivo
    ? 'Si preguntas por una persona o un momento concreto, la respuesta será mucho más exacta.'
    : this.activeContextKind === 'personal'
      ? 'Si preguntas por un servicio, una necesidad concreta o por dónde seguirle, la respuesta será mucho más útil.'
      : this.activeContextKind === 'product'
        ? 'Si preguntas por precio, beneficios, disponibilidad o compra, la respuesta conectará mejor con el catálogo.'
        : 'Si preguntas por una necesidad real, un servicio o un canal de contacto, la respuesta será mucho más útil.';
},

chatHeaderAvatar() {
  return String(this.proyectorConfig?.logoEmpresa || this.proyectorConfig?.logo || '').trim()
    || require('../assets/icon-white.png');
},

chatHeaderTitle() {
  return this.esContextoEventoActivo
    ? 'Haz tu pregunta'
    : this.nombreContextoVisible;
},

chatHeaderKicker() {
  return 'Activo ahora';
},

chatHeaderSubtitle() {
  return '';
},

chatInputPlaceholder() {
  if (!this.runtimeConfig.qnaEnabled) {
    return 'Las preguntas y respuestas fueron desactivadas';
  }
  if (this.isRecordingVoice) {
    return 'Grabando nota de voz...';
  }
  return this.esContextoEventoActivo
    ? 'Escribe tu duda o pregunta'
    : this.activeContextKind === 'personal'
      ? 'Pregúntame por mis servicios, redes o forma de trabajar'
      : this.activeContextKind === 'product'
        ? 'Pregúntame por precio, beneficios o cómo conseguirlo'
        : 'Pregúntame por productos, servicios, contacto o disponibilidad';
},

puedeEnviarConsulta() {
  return !!String(this.nuevaPregunta || '').trim();
},

showStarterPills() {
  return !this.misConsultas.length && !this.consultaPendienteLocal && !this.isRecordingVoice;
},
 
       puedeMostrarQNA() {
    // Validamos que:
    // 1. Exista un canalId activo.
    // 2. NO haya una pregunta activa en pantalla (!preguntaActiva).
    // 3. La configuración del canal tenga el Q&A habilitado.
    return (
      this.canalId && 
      !this.preguntaActiva && 
      this.runtimeConfig.qnaEnabled
    );
  },

  puedeMostrarQnaEnWaitingRoom() {
    return (
      this.canalId
      && !this.preguntaActiva
      && this.runtimeConfig.qnaEnabled
      && this.runtimeConfig.waitingRoomEnabled
      && this.waitingRoomSlides.length > 0
    );
  },
 
 
  presentarce(){
     const modo = this.runtimeConfig.greetingsMode;
 
     return (
     
      this.canalId && 
      (modo === 2 || modo === 3)
    );
  },
 
    mostrarDisparadorGREETING() {
    // Extraemos el modo de forma segura
    const modo = this.runtimeConfig.greetingsMode;
 
    // Retorna true solo si:
    // 1. El dock NO está expandido
    // 2. Existe un canalId activo
    // 3. El modo es exactamente 1 o 3
    return (
      !this.dockExpandido && 
      this.canalId && 
      (modo === 1 || modo === 3)
    );
  },
 
 
     puedeMostrarPerfil() {
    const modo = this.runtimeConfig.greetingsMode;
    return this.mostrarModalPerfil && modo > 1;
  },
 
 
     puedeGuardarPerfil(){
 
    if(!this.nombreUsuario) return false
      if(this.nombreUsuario.trim().length < 2) return false
      if(!this.edadUsuario) return false
 
      return true
 
    },
 
  
      claseAnimacion() {
      return {
        'anim-float-slow': this.proyectorConfig?.animation === 'floatSlow',
        'anim-move': this.proyectorConfig?.animation === 'move',
        'anim-pulse': this.proyectorConfig?.animation === 'pulse'
      };
    },
 
  estiloProyector() {
  const val = this.proyectorConfig?.Branding?.trim();
 
  if (!val || this.esImagenBack(val)) return {};
 
  // 🔥 Detecta gradients
  if (val.includes('gradient')) {
 
    // 🔥 NUEVO: detectar bokeh (radial gradients)
    const esBokeh = val.includes('radial-gradient');
 
    return {
      backgroundImage: val,
 
      // 🔥 CAMBIO CLAVE
      backgroundSize: esBokeh ? '150% 150%' : 'cover',
      backgroundPosition: esBokeh ? '0% 50%' : 'center',
 
      backgroundRepeat: 'no-repeat',
 
      // 🔥 opcional pero mejora visual
      ...(esBokeh && { backgroundBlendMode: 'screen' })
    };
  }
 
  // Color plano (igual que antes)
  return { backgroundColor: val };
},
 
 
    cssProps() { return { '--brand-color': this.proyectorConfig.color }; },
 
    pdfSource() {
      // Only read from media.url — never fall back to Branding which can be
      // a firebasestorage image URL and would incorrectly keep the PDF visible.
      const mediaUrl = this.proyectorConfig?.media?.url;
      if (!mediaUrl || typeof mediaUrl !== 'string') return '';
      const clean = mediaUrl.split('?')[0].toLowerCase();
      if (clean.endsWith('.pdf') || clean.includes('drive.google.com') || clean.includes('firebasestorage')) {
        return mediaUrl;
      }
      return '';
    },
 
  pdfOverlayActive() {
      // Hide PDF when a quiz/question is active — they are mutually exclusive in UserView.
      // This prevents stale media.tipo='presentacion' from showing on top of a live vote.
      return this.proyectorConfig?.media?.tipo === 'presentacion'
        && (this.proyectorConfig?.viewphone ?? true)
        && !this.preguntaActiva;
    },
 
puedeMostrarMoments() {
  return this.canalId && !this.preguntaActiva && this.runtimeConfig.momentsEnabled;
},
 
  puedeMostrarSalaEspera() {
  // En /join no hay canal: se muestra igual, con el lienzo de reclamo como
  // único contenido. Así la página comparte el render real del slide en vez
  // de tener una copia aparte que se desincroniza.
  if (this.esRutaJoin) return true;
  return this.canalId
    && !this.preguntaActiva
    && this.runtimeConfig.waitingRoomEnabled
    && this.waitingRoomSlides.length > 0;
},

chatModalViewportStyle() {
  // Chat-only standalone mode: full screen, no sheet styling
  if (this.isChatOnlyMode) {
    return { height: '100%', maxWidth: '100%', borderRadius: '0', animation: 'none' };
  }

  const baseHeight = Math.round((window.innerHeight || 0) * 0.85);
  const viewportHeight = this.chatViewportHeight || window.innerHeight || 0;
  const keyboardInset = this.chatKeyboardInset || 0;

  // Definimos el margen izquierdo opcional
  const extraStyles = this.shouldUseDesktopShowcase ? { marginLeft: '35%', width:'360px' } : {};

  if (!keyboardInset) {
    return {
      height: `${baseHeight}px`,
      ...extraStyles
    };
  }

  return {
    height: `${Math.max(320, Math.floor(viewportHeight - 8))}px`,
    transform: `translateY(-${keyboardInset}px)`,
    ...extraStyles
  };
},

chatBodyViewportStyle() {
  return this.chatKeyboardInset > 0
    ? { paddingBottom: '24px' }
    : {};
},
 
    puedeGuardarMomento() {
      return !!this.momentPhotoPreview && this.momentCaption.trim().length >= 4;
    },
 
    momentPreviewClass() {
      return {
        portrait: this.momentPhotoOrientation === 'portrait',
        landscape: this.momentPhotoOrientation === 'landscape',
        square: this.momentPhotoOrientation === 'square' || !this.momentPhotoPreview
      };
    },
 
 
    botonDeshabilitado() {
      if (this.loadingEnvio) return true;
      if (this.preguntaActiva?.opciones?.length > 0) return this.indiceSeleccionado === null;
      return !this.comentario.trim();
    },
 
 
 
    tituloVisibleSesionUsuario() {
      // El nombre de marca (elegido al crear/editar el canal) es lo que debe
      // verse aquí siempre que exista — tituloVisible suele quedar igual al
      // nombre del canal por defecto (se guarda junto al resto del sheet de
      // edición aunque el admin no lo haya tocado), así que nunca debería
      // tapar la marca.
      return this.proyectorConfig?.brandName
        || (this.proyectorConfig?.tituloVisible || '').trim()
        || this.proyectorConfig?.nombreEvento
        || this.proyectorConfig?.nombreSesion
        || 'Sesión Activa';
    },

    chatStarters() {
      const kind = this.proyectorConfig?.contexto_ia?.activeContextKind || '';
      const nombre = this.tituloVisibleSesionUsuario || '';
      const ref = nombre && nombre !== 'Sesión Activa' ? ` de ${nombre}` : '';
      if (kind === 'personal') {
        return [
          `¿En qué trabajas${ref ? ' ' + nombre : ''}?`,
          '¿Cómo puedo colaborar contigo?',
          '¿Qué proyectos tienes actualmente?'
        ];
      }
      if (['product', 'store', 'sell'].includes(kind)) {
        return [
          `¿Qué productos${ref} tienen disponibles?`,
          '¿Cuáles son los precios?',
          '¿Cómo puedo hacer un pedido?'
        ];
      }
      if (['service', 'business', 'leads', 'course'].includes(kind)) {
        return [
          `¿Qué servicios${ref} ofrecen?`,
          '¿Cuánto cuesta?',
          '¿Cómo puedo agendar?'
        ];
      }
      return [
        `¿De qué trata${ref}?`,
        '¿Qué ofrecen?',
        '¿Cómo me pueden ayudar?'
      ];
    },
 
 
    computedAvatar() {
      return `https://ui-avatars.com/api/?name=${this.nombreUsuario || 'U'}&background=random&color=fff`;
    },
  currentLanguageLabel() {
      return this.getLanguageLabel(this.selectedLanguage);
    },
    waitingRoomGuideHandStyle() {
      return {
        transform: `translate(-50%, -50%) translateX(${this.waitingRoomGuideHandOffset}px)`,
        transition: `transform ${this.waitingRoomGuideHandDuration}ms cubic-bezier(0.16, 0.84, 0.26, 1)`
      };
    }
  },
 
 
 
 
async created() {
    const slugUrl = String(this.$route?.params?.slug || this.$route?.query?.slug || '').trim();
    if (slugUrl && !this.enteringSessionPreview?.imageUrl) {
      try {
        const preview = await obtenerPreviewPublicRoom(slugUrl);
        if (preview?.imageUrl) {
          this.setEntryLoadingPreview(preview);
          sessionStorage.setItem('uvoto_entry_loading_preview', JSON.stringify(this.enteringSessionPreview));
        }
      } catch (_) { /* silencioso — mounted lo reintenta */ }
    }
  },

  async mounted() {
    // Chat-only mode: add class to body for CSS scoping
    if (this.isChatOnlyMode) {
      console.log('[Uvoto] Chat-only mode detectado. Escuchando mensajes del padre...');
      document.documentElement.classList.add('chat-only-page');

      // Escuchar contexto de página enviado por embed.js via postMessage
      this._onEmbedMessage = (e) => {
        // Solo procesar mensajes que tengan nuestra estructura
        if (!e.data || typeof e.data !== 'object' || e.data.type !== 'uvoto:page-context') return;

        console.log('[Uvoto] Mensaje de contexto recibido:', { 
          origin: e.origin, 
          hasKey: !!e.data.embedApiKey 
        });

        // Guardar la API key
        if (e.data.embedApiKey) {
          const trimmedKey = String(e.data.embedApiKey).trim();
          if (trimmedKey && this.embedApiKey !== trimmedKey) {
            console.log('[Uvoto] API Key establecida correctamente.');
            this.embedApiKey = trimmedKey;
          }
        }

        const ctx = e.data.context;
        if (ctx && typeof ctx === 'object') {
          this.embedPageContext = ctx;
        }
      };
      window.addEventListener('message', this._onEmbedMessage);

      // ── NUEVO: Capturar contexto inicial desde la URL (Fallback ultra-fiable con URLSearchParams nativo) ──
      const params = new URLSearchParams(window.location.search);
      const urlParam = params.get('url');
      const titleParam = params.get('title');

      if (urlParam && !this.embedPageContext) {
        console.log('[Uvoto] Contexto inicial detectado en URL nativa:', urlParam);
        this.embedPageContext = {
          url: urlParam,
          title: titleParam || '',
          capturedAt: Date.now(),
          isFallback: true
        };
      } else {
        console.log('[Uvoto] No se detectó contexto en la URL actual:', window.location.search);
      }

      // Pedir el contexto inicial al padre en cuanto el chat esté montado
      try {
        console.log('[Uvoto] Solicitando contexto al padre...');
        window.parent.postMessage('uvoto:request-context', '*');
      } catch (err) { console.error('[Uvoto] Error al solicitar contexto:', err); }
    } else {
      console.log('[Uvoto] No es modo chat-only (path:', this.$route?.path, ')');
    }
    this.startBrandSlideShow();
    this.rearmarCarruselAlVolver();
  this.selectedLanguage = i18n.global.locale.value;
  this.viewportWidth = window.innerWidth || 0;
  this.hydrateBrandClaimDraft();
  if (this.brandSlugStatus === 'current') {
    this.showJoinHomePanel = true;
  }
  // ?s=<idDelSlide> — enlace directo a un lienzo concreto de la sala.
  this.slideCompartidoPendiente = String(this.$route?.query?.s || '').trim();

  this.hydrateExploreProfilesCache();
  this.rotatingAudienceInterval = setInterval(() => {
    this.rotatingAudienceIndex += 1;
    this.rotatingAudienceMotion = 'slide';
  }, 1800);
  this.actualizarViewportChat();
  // 1. Cargar historial de sesiones para mostrar en la Pantalla Principal
  this.cargarSesionesRecientes();
 
  // 2. DETECTAR CANAL O PIN: Solo conectamos si hay un parámetro en la URL
  const params = new URLSearchParams(window.location.search);
  const canalUrl = params.get('canal');
  const pinUrl = params.get('pin');
  const proyectorUrl = params.get('proyector');
  const slugUrl = String(this.$route?.params?.slug || this.$route?.query?.slug || '').trim();
  const desktopUrl = String(this.$route?.query?.desktop || '').trim();
  if (this.isDesktopViewport && (slugUrl || pinUrl || canalUrl)) {
    this.desktopEntryStarted = true;
  }
  if (this.isDesktopViewport && desktopUrl === '1') {
    this.desktopEntryStarted = true;
  }

  if (slugUrl || pinUrl || canalUrl) {
    this.restoreEntryLoadingPreview();
    if (slugUrl && !this.enteringSessionPreview) {
      this.restoreRoomPreviewForSlug(slugUrl);
    }
  } else {
    this.clearEntryLoadingPreview();
  }
 
  if (slugUrl) {
    console.log("📍 Conexión por link corto detectada:", slugUrl);
    this.loading = true;
    if (!this.enteringSessionPreview?.imageUrl) {
      try {
        const preview = await obtenerPreviewPublicRoom(slugUrl);
        if (preview) {
          this.setEntryLoadingPreview(preview);
          this.persistEntryLoadingPreview();
        } else {
          this.setEntryLoadingPreview({ title: slugUrl, imageUrl: this.fallbackExploreImage });
        }
      } catch (previewError) {
        this.setEntryLoadingPreview({ title: slugUrl, imageUrl: this.fallbackExploreImage });
      }
    }
    this.verificarPerfil();
    try {
      const destino = await resolverShortLinkCompartido(slugUrl);
      if (destino?.pin) {
        this.pinIngresado = normalizarPinIngreso(destino.pin);
        this.conectarPorPin(normalizarPinIngreso(destino.pin), { autoFromUrl: true, proyectorEsperado: destino.proyectorId || null });
      } else {
        this.loading = false;
        alert("Este enlace ya no está disponible.");
      }
    } catch (error) {
      console.error("Error resolviendo link corto:", error);
      this.loading = false;
      alert("No pudimos abrir este enlace.");
    }
  } else if (pinUrl) {
    // Entrada por URL con PIN — usa el mismo flujo seguro que el ingreso manual
    console.log("📍 Conexión por URL con PIN detectada:", pinUrl);
    this.pinIngresado = normalizarPinIngreso(pinUrl);
    this.loading = true;
    if (!this.enteringSessionPreview) {
      this.setEntryLoadingPreview({ title: this.selectedLanguage === 'en' ? 'your experience' : this.selectedLanguage === 'pt' ? 'sua experiencia' : 'tu experiencia', imageUrl: this.fallbackExploreImage });
    }
    this.verificarPerfil();
    this.conectarPorPin(normalizarPinIngreso(pinUrl), { autoFromUrl: true, proyectorEsperado: proyectorUrl || null });
  } else if (canalUrl) {
    console.log("📍 Conexión por Link (canal) detectada:", canalUrl);
    this.canalId = canalUrl;
    this.loading = true;
    if (!this.enteringSessionPreview) {
      this.setEntryLoadingPreview({ title: this.selectedLanguage === 'en' ? 'your experience' : this.selectedLanguage === 'pt' ? 'sua experiencia' : 'tu experiencia', imageUrl: this.fallbackExploreImage });
    }
    // Esperamos a que el userId esté resuelto antes de registrar presencia
    console.log('[Uvoto] Resolviendo sesión de usuario para el canal:', canalUrl);
    await this.getOrCreateSessionUserId(canalUrl);
    
    if (this.userId) {
      console.log('[Uvoto] Sesión lista (UID:', this.userId, '). Iniciando escucha de mensajes...');
      this.escucharMisConsultas();
    } else {
      console.warn('[Uvoto] No se pudo obtener un UID de sesión.');
    }

    this.escucharWaitingRoomConfig();
    // Ahora que userId está listo, cargar bookings desde Firestore y suscribir próxima cita
    this.loadBookingsFirestore();
    this.subscribeProximaCita();
    
    this.verificarPerfil();
    this.conectarProyector(); 
    this.registrarPresencia();
    this.actualizarEstadoMomentoPublicado(this.canalId);
  } 

  // 3. ELIMINADO: Ya no forzamos la entrada mediante localStorage.
  // Si no hay canalUrl, el flujo natural de Vue mostrará tu Home/Dashboard de usuario.
  else {
    console.log("🏠 Usuario en pantalla principal (sin sesión activa forzada)");
    // Opcional: Limpiamos canalId para asegurarnos de que la UI sea la de Home
    this.canalId = null;
  }
 
  // 4. Estado de presentación (solo si hay un canal activo)
  if (this.canalId) {
    this.yaSePresento = localStorage.getItem(`presented_${this.canalId}`) === 'true';
  }
  this.syncWaitingRoomGuideState();
  if (!this.canalId) {
    this.cargarPerfilesPublicosExploracion({ allowCachedOnly: this.publicExploreProfiles.length > 0 });
  }
  
  window.addEventListener('keydown', this.handleKeydown);
  window.addEventListener('popstate', this.handleBrowserBack);
  window.addEventListener('resize', this.actualizarViewportChat);
  window.addEventListener('resize', this.handleViewportResize);
  document.addEventListener('focusin', this.handleEditableFocus, true);
  document.addEventListener('click', this.closeLanguageMenu);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', this.actualizarViewportChat);
    window.visualViewport.addEventListener('scroll', this.actualizarViewportChat);
  }
},
 
beforeUnmount() {
    document.documentElement.classList.remove('chat-only-page');
    if (this._onEmbedMessage) {
      window.removeEventListener('message', this._onEmbedMessage);
      this._onEmbedMessage = null;
    }
    if (this.brandSlideInterval) clearInterval(this.brandSlideInterval);
    if (this._pausaCarruselTimer) { clearTimeout(this._pausaCarruselTimer); this._pausaCarruselTimer = null; }
    if (this._onVisibilidadCarrusel) {
      document.removeEventListener('visibilitychange', this._onVisibilidadCarrusel);
      this._onVisibilidadCarrusel = null;
    }
  this.stopVoiceRecording(true);
  if (this.unsubProximaCita) { this.unsubProximaCita(); this.unsubProximaCita = null; }

  if (this.proyectorListener) {
    this.proyectorListener();
    this.proyectorListener = null;
  }
 
  if (this.preguntaListener) {
    this.preguntaListener();
    this.preguntaListener = null;
  }
 
  if (this.unsubWaitingRoomConfig) {
    this.unsubWaitingRoomConfig();
    this.unsubWaitingRoomConfig = null;
  }
 
  if (this.unsubConsultasIA) {
    this.unsubConsultasIA();
    this.unsubConsultasIA = null;
  }
 
  if (this.userTimerInterval) {
    clearInterval(this.userTimerInterval);
    this.userTimerInterval = null;
  }
 
  if (this.intervaloReloj) {
    clearInterval(this.intervaloReloj);
    this.intervaloReloj = null;
  }

  if (this.exploreAutoSlideInterval) {
    clearInterval(this.exploreAutoSlideInterval);
    this.exploreAutoSlideInterval = null;
  }
  if (this.rotatingAudienceInterval) {
    clearInterval(this.rotatingAudienceInterval);
    this.rotatingAudienceInterval = null;
  }
  this.detenerGuiaSlidesWaitingRoom();

  window.removeEventListener('resize', this.actualizarViewportChat);
  window.removeEventListener('resize', this.handleViewportResize);
  document.removeEventListener('focusin', this.handleEditableFocus, true);
  if (window.visualViewport) {
    window.visualViewport.removeEventListener('resize', this.actualizarViewportChat);
    window.visualViewport.removeEventListener('scroll', this.actualizarViewportChat);
  }
 
  this.currentProyectorEscuchado = null;
  window.removeEventListener('keydown', this.handleKeydown);
  window.removeEventListener('popstate', this.handleBrowserBack);
  document.removeEventListener('click', this.closeLanguageMenu);
},
 
 
 
  watch: {
    // Safari repinta la franja en cuanto cambia el meta, así que basta con
    // seguir el color calculado.
    colorBarraEstado: {
      immediate: true,
      handler(color) { this.aplicarColorBarraEstado(color); }
    },
    // Los slides llegan de Firestore bastante después de que se leyó el
    // parámetro de la URL: cuando aparecen, se intenta el salto.
    displayWaitingRoomSlides() {
      this.$nextTick(() => this.aplicarSlideCompartido());
    }
  },

  methods: {
  // Tiñe la barra de estado de Safari (iOS 15+) y la barra de título en
  // Android/escritorio. En la PWA instalada no aplica: ahí manda
  // apple-mobile-web-app-status-bar-style, que se lee al instalar.
  aplicarColorBarraEstado(color) {
    const valor = String(color || '').trim();
    if (!valor) return;
    try {
      // OJO: el HTML servido trae DOS metas theme-color — el de public/index.html
      // y el que inyecta el plugin PWA desde vue.config.js. Actualizar solo el
      // primero no sirve: Safari no repintaba porque quedaba el otro con el
      // color viejo. Se actualizan todos.
      const metas = document.querySelectorAll('meta[name="theme-color"]');
      if (!metas.length) {
        const meta = document.createElement('meta');
        meta.setAttribute('name', 'theme-color');
        meta.setAttribute('content', valor);
        document.head.appendChild(meta);
        return;
      }
      metas.forEach((m) => m.setAttribute('content', valor));
    } catch (error) {
      // Sin acceso al head no pasa nada: se queda el color del index.html
    }
  },

  // "Marcas"/"Eventos" (categorías genéricas de canales viejos sin brandType)
  // se recalculan aquí en vivo según el idioma actual — profile.categoryLabel
  // queda fijo en el idioma que estaba activo cuando se cargó/cacheó el
  // perfil, así que no basta con leerlo directo o "Marcas" no se traduce al
  // cambiar de idioma sin recargar.
  genericCategoryLabel(key, fallback) {
    const labels = {
      es: { brand: 'Marcas', event: 'Eventos', general: 'Destacados' },
      en: { brand: 'Brands', event: 'Events', general: 'Featured' },
      pt: { brand: 'Marcas', event: 'Eventos', general: 'Destaques' }
    };
    const lang = String(this.selectedLanguage || 'es').toLowerCase();
    return (labels[lang] || labels.es)[key] || fallback;
  },

  async toggleRoomLike() {
    if (!this.canalId) return;
    const wasLiked = this.roomLiked;
    this.roomLiked = !wasLiked;
    this.roomLikesCount = Math.max(0, this.roomLikesCount + (wasLiked ? -1 : 1));
    const key = `uvoto_liked_${this.canalId}`;
    if (this.roomLiked) {
      localStorage.setItem(key, '1');
    } else {
      localStorage.removeItem(key);
    }
    try {
      const ref = doc(this.$db || db, 'canales', this.canalId);
      await updateDoc(ref, { likesCount: increment(wasLiked ? -1 : 1) });
    } catch (e) {
      this.roomLiked = wasLiked;
      this.roomLikesCount = Math.max(0, this.roomLikesCount + (wasLiked ? 1 : -1));
    }
  },

    nativeShare() {
    if (!navigator.share) return;
    navigator.share({
      title: this.tituloVisibleSesionUsuario || 'Sala pública',
      text: `¡Únete a ${this.tituloVisibleSesionUsuario || 'esta sala'}!`,
      url: this.roomShareUrl,
    }).catch(() => {});
  },
copyRoomLink() {
    navigator.clipboard?.writeText(this.urlCompartirActual).then(() => {
      this.linkCopied = true;
      setTimeout(() => { this.linkCopied = false; }, 2200);
    }).catch(() => {
      const el = document.createElement('textarea');
      el.value = this.urlCompartirActual;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.linkCopied = true;
      setTimeout(() => { this.linkCopied = false; }, 2200);
    });
  },

  shareOnWhatsApp() {
    const text = encodeURIComponent(
      `¡Únete a ${this.tituloVisibleSesionUsuario || 'esta sala'}! ${this.urlCompartirActual}`
    );
    window.open(`https://wa.me/?text=${text}`, '_blank');
  },

  shareOnFacebook() {
    const url = encodeURIComponent(this.urlCompartirActual);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
  },

  async shareOnInstagram() {
    this.showShareSheet = false;
    const url = this.urlCompartirActual;
    const title = this.tituloCompartirActual || 'Uvoto';
    // Use native Web Share API on mobile (opens share sheet with Instagram, Stories, DMs, etc.)
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch (_) {}
    } else {
      // Desktop fallback: copy link to clipboard
      this.copyRoomLink();
    }
  },

  onGalleryImgLoad(idx) {
    this.galleryLoadedMap = { ...this.galleryLoadedMap, [idx]: true };
  },

  async cancelarReservaBrand() {
    const slug = this.sanitizeBrandSlug(this.brandSlugDraft);
    const ownerToken = this.getBrandClaimOwnerToken();
    try {
      localStorage.removeItem(PENDING_BRAND_CLAIM_KEY);
      localStorage.removeItem(PENDING_BRAND_CLAIM_OWNER_KEY);
    } catch (e) { /* ignore */ }
    // Cancelar también en Firestore — si no lo hacemos, cualquier otra app
    // (Uvoto Connect Android/iOS) que ya cacheó esta reserva localmente
    // nunca se entera de la cancelación y sigue insistiendo en continuarla.
    if (slug) {
      try {
        const shortRef = doc(db, 'short_links', slug);
        const shortSnap = await getDoc(shortRef);
        const data = shortSnap.exists() ? (shortSnap.data() || {}) : null;
        if (data && data.type === 'pending_brand_claim' && String(data.reservedBy || '') === ownerToken) {
          await deleteDoc(shortRef);
        }
      } catch (e) {
        console.warn('No se pudo cancelar la reserva en Firestore:', e);
      }
    }
    this.brandSlugDraft = '';
    this.brandSlugStatus = 'idle';
    this.brandSlugMessage = this.selectedLanguage === 'en'
      ? 'Write your brand name and secure your link'
      : this.selectedLanguage === 'pt'
      ? 'Escreva o nome da sua marca e garanta seu link'
      : 'Escribe el nombre de tu marca y asegura tu link';
    this.showJoinHomePanel = false;
    this.scrollJoinArriba();
  },
  tryOpenUvotoConnectApp() {
    const slug = this.brandSlugDraft || '';
    if (slug) {
      window.location.href = `uvoto://claim?slug=${encodeURIComponent(slug)}`;
    }
  },
  async handleBrandClaimAfterLogin(uid) {
    const slug = this.sanitizeBrandSlug(this.brandSlugDraft);
    if (slug && uid) {
      try {
        const shortRef = doc(db, 'short_links', slug);
        await updateDoc(shortRef, { ownerUid: uid });
      } catch (e) {
        console.warn('No se pudo actualizar ownerUid en el claim:', e);
      }
    }
    // Ya no abrimos la app automáticamente: mostramos el panel y el usuario
    // decide con el botón "Abrir Uvoto Branding" o los links de tienda.
    this.openJoinHomePanel();
  },
  openJoinHomePanel() {
    this.showJoinHomePanel = true;
    this.showExploreOverlay = false;
  },
  closeJoinHomePanel() {
    this.showJoinHomePanel = false;
    this.scrollJoinArriba();
  },
  // En Safari de iOS, enfocar el input desplaza la página para dejarlo visible
  // y al cerrar un overlay position:fixed ese desplazamiento no se restaura:
  // el lienzo quedaba subido y cortado por arriba. Se devuelve a cero a mano.
  scrollJoinArriba() {
    const alTope = () => {
      try {
        const pantalla = document.querySelector('.wr-screen.is-join-page');
        if (!pantalla) return;
        // Hacia arriba: los contenedores que envuelven la pantalla.
        let nodo = pantalla;
        while (nodo && nodo !== document.documentElement) {
          if (nodo.scrollHeight > nodo.clientHeight + 2) nodo.scrollTop = 0;
          nodo = nodo.parentElement;
        }
        // Y hacia adentro: el lienzo y el slide también desplazan por su cuenta
        // (el mockup mide más que su caja), y ahí es donde quedaba cortada.
        pantalla.querySelectorAll('*').forEach((el) => {
          if (el.scrollTop) el.scrollTop = 0;
          if (el.scrollLeft) el.scrollLeft = 0;
        });
        window.scrollTo(0, 0);
      } catch (e) { /* sin scroll que corregir */ }
    };
    // Dos pasadas: iOS reajusta el scroll después de cerrar el teclado.
    this.$nextTick(alTope);
    setTimeout(alTope, 260);
    setTimeout(alTope, 650);
  },
  openExploreOverlay() {
    if (!this.canalId) return;
    this.showJoinHomePanel = false;
    this.showExploreOverlay = true;
    this.showExploreModal = false;
  },
  closeExploreOverlay() {
    this.showExploreOverlay = false;
  },
  handleShellTouchStart(event) {
    const touch = event?.touches?.[0];
    if (!touch) return;
    this.shellSwipeStartX = touch.clientX || 0;
    this.shellSwipeStartY = touch.clientY || 0;
    this.shellSwipeTracking = true;
  },
  handleShellTouchMove() {
    if (!this.shellSwipeTracking) return;
  },
  handleShellTouchEnd(event) {
    if (!this.shellSwipeTracking) return;
    this.shellSwipeTracking = false;
    const touch = event?.changedTouches?.[0];
    if (!touch) return;
    const deltaX = (touch.clientX || 0) - this.shellSwipeStartX;
    const deltaY = (touch.clientY || 0) - this.shellSwipeStartY;
    if (Math.abs(deltaX) < 70 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
    if (deltaX > 0) {
      if (this.showJoinHomePanel) {
        this.closeJoinHomePanel();
        return;
      }
      if (this.canalId && !this.showExploreOverlay) {
        this.openExploreOverlay();
      }
      return;
    }
    if (deltaX < 0 && this.showExploreOverlay) {
      this.closeExploreOverlay();
    }
  },
  getBrandClaimOwnerToken() {
    try {
      let token = localStorage.getItem(PENDING_BRAND_CLAIM_OWNER_KEY);
      if (!token) {
        token = `claim_${generarSlugCortoTemporal(14)}`;
        localStorage.setItem(PENDING_BRAND_CLAIM_OWNER_KEY, token);
      }
      return token;
    } catch (error) {
      return `claim_${generarSlugCortoTemporal(14)}`;
    }
  },
  sanitizeBrandSlug(value = '') {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 24);
  },
  isReservedBrandSlug(slug = '') {
    return [
      'u',
      'user',
      'users',
      'admin',
      'login',
      'home',
      'api',
      'connect',
      'tv',
      'ios',
      'app',
      'www',
      'mail',
      'support'
    ].includes(String(slug || '').trim());
  },
  isValidBrandSlug(slug = '') {
    const normalized = this.sanitizeBrandSlug(slug);
    if (!normalized || normalized.length < 3) return false;
    if (this.isReservedBrandSlug(normalized)) return false;
    return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(normalized);
  },
  hydrateBrandClaimDraft() {
    try {
      const pending = JSON.parse(localStorage.getItem(PENDING_BRAND_CLAIM_KEY) || 'null');
      const expiresAt = new Date(pending?.reservedUntil || 0).getTime();
      if (pending?.slug && expiresAt > Date.now()) {
        this.brandSlugDraft = this.sanitizeBrandSlug(pending.slug);
        this.brandSlugStatus = 'current';
        this.brandSlugMessage = this.selectedLanguage === 'en'
          ? 'You already reserved this brand link. You can continue when ready.'
          : this.selectedLanguage === 'pt'
          ? 'Esse link já está reservado para você. Continue quando quiser.'
          : 'Ese link ya quedó reservado para ti. Puedes continuar cuando quieras.';
        // Verify in Firestore that the claim is still pending (not finalized by the app)
        this.verifyBrandClaimStillPending(pending.slug);
        return;
      }
    } catch (error) {
      // ignore
    }
    this.brandSlugDraft = '';
    this.brandSlugStatus = 'idle';
    this.brandSlugMessage = this.selectedLanguage === 'en'
      ? 'Write your brand name and secure your link'
      : this.selectedLanguage === 'pt'
      ? 'Escreva o nome da sua marca e garanta seu link'
      : 'Escribe el nombre de tu marca y asegura tu link';
    this.brandSlideIndex = 0;
  },
  async verifyBrandClaimStillPending(slug) {
    try {
      const shortRef = doc(db, 'short_links', slug);
      const snap = await getDoc(shortRef);
      if (!snap.exists()) return;
      const data = snap.data() || {};
      // If type changed from 'pending_brand_claim' or the link is now active → claim was finalized
      const isFinalized = data.type !== 'pending_brand_claim' || data.active === true;
      if (isFinalized) {
        localStorage.removeItem(PENDING_BRAND_CLAIM_KEY);
        localStorage.removeItem(PENDING_BRAND_CLAIM_OWNER_KEY);
        this.brandSlugDraft = '';
        this.brandSlugStatus = 'idle';
        this.brandSlugMessage = '';
        this.showJoinHomePanel = false;
      }
    } catch (e) {
      // Silently ignore — network error, user can still proceed
    }
  },
  // iOS suspende los setInterval cuando la pestaña pasa a segundo plano o se
  // bloquea el teléfono, y al volver no siempre se reanudan: por eso se rearma
  // al recuperar visibilidad.
  rearmarCarruselAlVolver() {
    if (this._onVisibilidadCarrusel) return;
    this._onVisibilidadCarrusel = () => {
      if (document.visibilityState === 'visible') this.startBrandSlideShow();
    };
    document.addEventListener('visibilitychange', this._onVisibilidadCarrusel);
  },

  // Al tocar el lienzo, el carrusel se detiene 4 segundos: si alguien está
  // mirando una marca concreta, que no se la cambien de golpe. Cada toque
  // reinicia la cuenta.
  pausarCarruselMarca() {
    if (this.brandSlideInterval) {
      clearInterval(this.brandSlideInterval);
      this.brandSlideInterval = null;
    }
    if (this._pausaCarruselTimer) clearTimeout(this._pausaCarruselTimer);
    this._pausaCarruselTimer = setTimeout(() => {
      this._pausaCarruselTimer = null;
      this.startBrandSlideShow();
    }, 4000);
  },

  startBrandSlideShow() {
    if (this.brandSlideInterval) clearInterval(this.brandSlideInterval);
    this.brandSlideInterval = setInterval(() => {
      const len = this.brandClaimSlides.length;
      if (!len) return;
      this.brandSlideIndex++;
      if (this.brandSlideIndex > len) {
        this.brandSlideIndex = 0;
      }
    }, 2000);
  },
  persistPendingBrandClaim(payload = null) {
    if (!payload) {
      localStorage.removeItem(PENDING_BRAND_CLAIM_KEY);
      return;
    }
    localStorage.setItem(PENDING_BRAND_CLAIM_KEY, JSON.stringify(payload));
  },
  onBrandSlugInput(event) {
    const nextValue = this.sanitizeBrandSlug(event?.target?.value ?? '');
    this.brandSlugDraft = nextValue;
    this.scheduleBrandSlugAvailabilityCheck();
  },
  scheduleBrandSlugAvailabilityCheck() {
    const slug = this.sanitizeBrandSlug(this.brandSlugDraft);
    this.brandSlugDraft = slug;
    if (!slug) {
      this.brandSlugStatus = 'idle';
      this.brandSlugMessage = this.selectedLanguage === 'en'
        ? 'Write the name you want to use at the end of your link.'
        : this.selectedLanguage === 'pt'
        ? 'Escreva o nome que deseja usar no final do seu link.'
        : 'Escribe el nombre que quieres usar al final de tu link.';
      return;
    }
    if (slug.length < 3) {
      this.brandSlugStatus = 'invalid';
      this.brandSlugMessage = this.selectedLanguage === 'en'
        ? 'Use at least 3 characters.'
        : this.selectedLanguage === 'pt'
        ? 'Use pelo menos 3 caracteres.'
        : 'Usa al menos 3 caracteres.';
      return;
    }
    if (!this.isValidBrandSlug(slug)) {
      this.brandSlugStatus = 'invalid';
      this.brandSlugMessage = this.selectedLanguage === 'en'
        ? 'Only letters, numbers and hyphens are allowed.'
        : this.selectedLanguage === 'pt'
        ? 'Usa apenas letras, números e hífens.'
        : 'Solo puedes usar letras, números y guiones.';
      return;
    }
    this.checkBrandSlugAvailability(slug);
  },
  async checkBrandSlugAvailability(candidate = '') {
    const slug = this.sanitizeBrandSlug(candidate);
    if (!this.isValidBrandSlug(slug)) return false;
    const ownerToken = this.getBrandClaimOwnerToken();
    this.brandSlugStatus = 'checking';
    this.brandSlugMessage = this.selectedLanguage === 'en'
      ? 'Checking availability...'
      : this.selectedLanguage === 'pt'
      ? 'Verificando disponibilidade...'
      : 'Revisando disponibilidad...';
    try {
      const shortRef = doc(db, 'short_links', slug);
      const shortSnap = await getDoc(shortRef);
      if (!shortSnap.exists()) {
        this.brandSlugStatus = 'available';
        this.brandSlugMessage = this.selectedLanguage === 'en'
          ? 'Available. You can reserve it now.'
          : this.selectedLanguage === 'pt'
          ? 'Disponível. Você já pode reservar.'
          : 'Disponible. Ya puedes reservarlo.';
        return true;
      }
      const data = shortSnap.data() || {};
      const reservedUntilMs = new Date(data?.reservedUntil || 0).getTime();
      const isExpiredReservation = data?.type === 'pending_brand_claim' && reservedUntilMs > 0 && reservedUntilMs <= Date.now();
      const isCurrentReservation = data?.type === 'pending_brand_claim' && String(data?.reservedBy || '') === ownerToken && reservedUntilMs > Date.now();
      if (isExpiredReservation) {
        this.brandSlugStatus = 'available';
        this.brandSlugMessage = this.selectedLanguage === 'en'
          ? 'Available again. You can reserve it now.'
          : this.selectedLanguage === 'pt'
          ? 'Disponível novamente. Você já pode reservar.'
          : 'Disponible de nuevo. Ya puedes reservarlo.';
        return true;
      }
      if (isCurrentReservation) {
        this.brandSlugStatus = 'current';
        this.brandSlugMessage = this.selectedLanguage === 'en'
          ? 'This link is already reserved for you.'
          : this.selectedLanguage === 'pt'
          ? 'Esse link já está reservado para você.'
          : 'Ese link ya está reservado para ti.';
        return true;
      }
      this.brandSlugStatus = 'taken';
      this.brandSlugMessage = this.selectedLanguage === 'en'
        ? 'That link is already taken. Try another one.'
        : this.selectedLanguage === 'pt'
        ? 'Esse link já está em uso. Tente outro.'
        : 'Ese link ya está tomado. Prueba con otro.';
      return false;
    } catch (error) {
      console.error('Error revisando slug de marca:', error);
      this.brandSlugStatus = 'error';
      this.brandSlugMessage = this.selectedLanguage === 'en'
        ? 'We could not verify this link right now.'
        : this.selectedLanguage === 'pt'
        ? 'Não pudemos verificar esse link agora.'
        : 'No pudimos verificar ese link ahora mismo.';
      return false;
    }
  },
  async reserveBrandSlugAndContinue() {
    // Sin esto iOS conserva el desplazamiento que hizo para el teclado.
    try { document.activeElement?.blur?.(); } catch (e) { /* noop */ }
    const slug = this.sanitizeBrandSlug(this.brandSlugDraft);
    if (!this.isValidBrandSlug(slug)) {
      this.scheduleBrandSlugAvailabilityCheck();
      return;
    }
    // Ya hay reserva activa: directo al panel de descarga, sin pasar por login.
    if (this.brandSlugStatus === 'current') {
      this.openJoinHomePanel();
      return;
    }
    // Las reglas de Firestore exigen request.auth != null para escribir en
    // short_links. Basta una sesión anónima silenciosa: así se reserva sin
    // interrumpir con el login de Google/Apple.
    if (!this.userId) {
      try { await this.getOrCreateSessionUserId('__brand_claim__'); } catch (e) { /* se reintenta abajo */ }
    }
    this.brandSlugStatus = 'saving';
    this.brandSlugMessage = this.selectedLanguage === 'en'
      ? 'Reserving your link...'
      : this.selectedLanguage === 'pt'
      ? 'Reservando seu link...'
      : 'Reservando tu link...';
    try {
      const shortRef = doc(db, 'short_links', slug);
      const shortSnap = await getDoc(shortRef);
      const ownerToken = this.getBrandClaimOwnerToken();
      const currentData = shortSnap.exists() ? (shortSnap.data() || {}) : {};
      const reservedUntil = new Date(Date.now() + BRAND_CLAIM_TTL_MS);
      if (shortSnap.exists()) {
        const reservedUntilMs = new Date(currentData?.reservedUntil || 0).getTime();
        const stillReservedByOther = currentData?.type === 'pending_brand_claim'
          && String(currentData?.reservedBy || '') !== ownerToken
          && reservedUntilMs > Date.now();
        const activeByOther = currentData?.active !== false;
        if (stillReservedByOther || activeByOther) {
          this.brandSlugStatus = 'taken';
          this.brandSlugMessage = this.selectedLanguage === 'en'
            ? 'That link is no longer available.'
            : this.selectedLanguage === 'pt'
            ? 'Esse link não está mais disponível.'
            : 'Ese link ya no está disponible.';
          return;
        }
      }
      const payload = {
        slug,
        type: 'pending_brand_claim',
        active: false,
        reservedBy: ownerToken,
        reservedUntil,
        ownerPinCanal: '',
        updatedAt: new Date(),
        createdAt: currentData?.createdAt || new Date()
      };
      await setDoc(shortRef, payload, { merge: true });
      this.persistPendingBrandClaim({
        slug,
        reservedBy: ownerToken,
        reservedUntil: reservedUntil.toISOString(),
        brandName: slug.replace(/-/g, ' ')
      });
      this.brandSlugStatus = 'current';
      this.brandSlugMessage = this.selectedLanguage === 'en'
        ? 'Link reserved! Secure it now.'
        : this.selectedLanguage === 'pt'
        ? 'Link reservado! Proteja-o agora.'
        : '¡Link reservado! Asegúralo ahora.';

      // Reservado: se abre el panel de descarga de la app. El login se pide
      // más adelante, dentro de la app — pedirlo acá cortaba el flujo.
      this.openJoinHomePanel();
    } catch (error) {
      console.error('Error reservando slug de marca:', error);
      this.brandSlugStatus = 'error';
      this.brandSlugMessage = this.selectedLanguage === 'en'
        ? 'We could not reserve your link right now.'
        : this.selectedLanguage === 'pt'
        ? 'Não pudemos reservar seu link agora.'
        : 'No pudimos reservar tu link ahora mismo.';
    }
  },
  hydrateExploreProfilesCache() {
    try {
      const cached = JSON.parse(localStorage.getItem(EXPLORE_PROFILES_CACHE_KEY) || 'null');
      const updatedAt = Number(cached?.updatedAt || 0);
      const profiles = Array.isArray(cached?.profiles) ? cached.profiles : [];
      if (!profiles.length) return false;
      this.publicExploreProfiles = profiles.slice(0, 16);
      this.activeExploreIndex = 0;
      this.exploreProfilesError = '';
      return (Date.now() - updatedAt) <= EXPLORE_PROFILES_CACHE_TTL_MS;
    } catch (error) {
      return false;
    }
  },
  persistExploreProfilesCache(profiles = []) {
    try {
      localStorage.setItem(EXPLORE_PROFILES_CACHE_KEY, JSON.stringify({
        updatedAt: Date.now(),
        profiles: Array.isArray(profiles) ? profiles.slice(0, 16) : []
      }));
    } catch (error) {
      // ignore cache write errors
    }
  },
  getRecentSessionThumb(sesion) {
    if (!sesion) return null;
    if (sesion.imageUrl && this.esImagenBack(sesion.imageUrl)) return sesion.imageUrl;
    if (sesion.logoUrl && this.esImagenBack(sesion.logoUrl)) return sesion.logoUrl;
    if (this.publicExploreProfiles && this.publicExploreProfiles.length) {
      const pub = this.publicExploreProfiles.find(p => p.canalId === sesion.canalId);
      if (pub && pub.imageUrl && this.esImagenBack(pub.imageUrl)) return pub.imageUrl;
      if (pub && pub.logoUrl && this.esImagenBack(pub.logoUrl)) return pub.logoUrl;
    }
    return null;
  },
  activateDesktopSessionExperience() {
    this.desktopEntryStarted = true;
    this.$nextTick(() => {
      if (this.filteredExploreProfiles && this.filteredExploreProfiles.length) {
        this.showExploreModal = true;
      }
    });
  },

  handleViewportResize() {
    this.viewportWidth = window.innerWidth || 0;
    this.actualizarViewportChat();
  },

  setEntryLoadingPreview(payload = {}) {
    this.enteringSessionPreview = {
      // brandName siempre gana sobre title — title suele venir del nombre del
      // canal (tituloVisible/nombreSesion), no de la marca elegida.
      title: String(payload.brandName || payload.title || '').trim(),
      brandName: String(payload.brandName || '').trim(),
      imageUrl: String(payload.imageUrl || '').trim(),
      logoUrl: String(payload.logoUrl || '').trim()
    };
  },

  setEntryLoadingPreviewFromProjector(proyectorData = {}, fallback = {}) {
    // El nombre de marca siempre gana sobre tituloVisible/nombreSesion — ver
    // tituloVisibleSesionUsuario más abajo, mismo criterio.
    const title = String(
      proyectorData.brandName
      || proyectorData.tituloVisible
      || proyectorData.nombreSesion
      || proyectorData.nombreEvento
      || fallback.brandName
      || fallback.title
      || ''
    ).trim();

    const imageUrl = String(
      proyectorData.shareImageUrl
      || proyectorData.logoEmpresa
      || fallback.imageUrl
      || fallback.logoUrl
      || ''
    ).trim();

    this.setEntryLoadingPreview({
      title,
      brandName: proyectorData.brandName || fallback.brandName || title,
      imageUrl,
      logoUrl: String(proyectorData.logoEmpresa || fallback.logoUrl || '').trim()
    });
  },

  getActiveSlug() {
    return String(this.$route?.params?.slug || this.$route?.query?.slug || '').trim();
  },

  getRoomPreviewStorageKey(slug = '') {
    const limpio = String(slug || '').trim();
    return limpio ? `uvoto_room_preview_${limpio}` : '';
  },

  persistEntryLoadingPreview() {
    if (!this.enteringSessionPreview) return;
    sessionStorage.setItem('uvoto_entry_loading_preview', JSON.stringify(this.enteringSessionPreview));
  },

  restoreEntryLoadingPreview() {
    try {
      const raw = sessionStorage.getItem('uvoto_entry_loading_preview');
      if (!raw) return false;
      const parsed = JSON.parse(raw);
      this.setEntryLoadingPreview(parsed || {});
      return true;
    } catch (error) {
      return false;
    }
  },

  clearEntryLoadingPreview() {
    this.enteringSessionPreview = null;
    sessionStorage.removeItem('uvoto_entry_loading_preview');
  },

  persistCurrentRoomPreview(proyectorData = {}) {
    const slug = this.getActiveSlug();
    const storageKey = this.getRoomPreviewStorageKey(slug);
    if (!storageKey) return;

    const preview = {
      title: String(
        proyectorData.brandName
        || proyectorData.tituloVisible
        || proyectorData.nombreSesion
        || proyectorData.nombreEvento
        || this.tituloVisibleSesionUsuario
        || ''
      ).trim(),
      brandName: String(
        proyectorData.brandName
        || proyectorData.nombreSesion
        || proyectorData.tituloVisible
        || ''
      ).trim(),
      imageUrl: String(
        proyectorData.shareImageUrl
        || proyectorData.logoEmpresa
        || ''
      ).trim(),
      logoUrl: String(proyectorData.logoEmpresa || '').trim()
    };

    sessionStorage.setItem(storageKey, JSON.stringify(preview));
  },

  restoreRoomPreviewForSlug(slug = '') {
    const storageKey = this.getRoomPreviewStorageKey(slug);
    if (!storageKey) return false;

    try {
      const raw = sessionStorage.getItem(storageKey);
      if (!raw) return false;
      const parsed = JSON.parse(raw);
      this.setEntryLoadingPreview(parsed || {});
      return true;
    } catch (error) {
      return false;
    }
  },

  handleBrowserBack() {
    const pathname = String(window.location.pathname || '').trim();
    if (pathname === '/user' && this.canalId) {
      this.salirDeSala(true);
    }
  },

  async cargarPerfilesPublicosExploracion(options = {}) {
    const { allowCachedOnly = false } = options;
    const hasCachedProfiles = Array.isArray(this.publicExploreProfiles) && this.publicExploreProfiles.length > 0;

    const startTime = Date.now();
    // La silueta solo reemplaza contenido que el usuario NO tiene. Antes se
    // pintaba siempre, con un piso de 1s, incluso sobre canales que ya
    // estaban en caché: se le robaba un segundo a algo que podía verse al
    // instante. Ahora aparece en dos casos:
    //   · no hay nada en caché (primera visita, no hay qué mostrar), o
    //   · es la primera carga de esta sesión (el momento de marca, una vez).
    // En cualquier otro caso los canales se pintan ya y la consulta corre
    // por detrás, reemplazando la lista en silencio cuando llega.
    const primeraDeLaSesion = !this.yaMostramosAnimacionMarca();
    const mostrarSilueta = !hasCachedProfiles || primeraDeLaSesion;
    this.exploreProfilesLoading = mostrarSilueta;
    this.exploreProfilesError = '';

    try {
      const canalesSnap = await getDocs(query(
        collection(db, 'canales'),
        where('waitingRoomEnabled', '==', true)
      ));

      const perfiles = [];
      for (const canalSnap of canalesSnap.docs) {
        const canalData = canalSnap.data() || {};
        const slug = String(canalData.shareSlug || '').trim();
        if (!slug) continue;
        // El UserView es la instancia pública: se muestra todo lo publicado
        // sin importar en qué app se creó (appOrigin solo separa el Home de
        // cada producto, no la exploración).

        const waitingSnap = await getDoc(doc(db, 'canales', canalSnap.id, 'waiting_room', 'estado'));
        const waitingData = waitingSnap.exists() ? (waitingSnap.data() || {}) : {};
        // visitsCount vive en el doc raíz del canal (único lugar que las reglas
        // de Firestore permiten leer/incrementar públicamente), ya lo tenemos en canalData.
        const visitsCount = Number(canalData.visitsCount || 0);
        const slides = Array.isArray(waitingData.slides) ? waitingData.slides : [];
        const firstSlide = slides[0] || {};
        const gallery = Array.isArray(firstSlide.galleryImages) ? firstSlide.galleryImages : [];
        const firstGalleryImage = gallery.find((image) => String(image?.imageUrl || image?.previewUrl || '').trim());
        const imageUrl = String(
          firstSlide.imageUrl ||
          firstSlide.imagePreview ||
          firstGalleryImage?.imageUrl ||
          firstGalleryImage?.previewUrl ||
          canalData.shareImageUrl ||
          canalData.logoEmpresa ||
          ''
        ).trim();

        const contextKind = String(
          canalData?.contexto_ia?.activeContextKind ||
          canalData?.activeContextKind ||
          'general'
        ).trim().toLowerCase();

        // Categoría real elegida al crear el canal (Artista, Marca personal,
        // Producto...) — si no existe (canales viejos), caemos al contextKind.
        // "category"/"categoryLabel" quedan unificados: todo el resto de la
        // pantalla (pills, filas, filtro) usa estos dos campos sin importar
        // si vienen del brandType nuevo o del contextKind viejo.
        const brandType = String(canalData.brandType || '').trim();
        const brandTypeLabel = String(canalData.brandTypeLabel || '').trim();
        const category = brandType || (contextKind === 'brand' || contextKind === 'event' ? contextKind : 'general');
        const legacyLabels = {
          es: { brand: 'Marcas', event: 'Eventos', general: 'Destacados' },
          en: { brand: 'Brands', event: 'Events', general: 'Featured' },
          pt: { brand: 'Marcas', event: 'Eventos', general: 'Destaques' }
        };
        const legacyLang = legacyLabels[String(this.selectedLanguage || 'es').toLowerCase()] || legacyLabels.es;
        const categoryLabel = brandTypeLabel || legacyLang[category] || legacyLang.general;

        perfiles.push({
          canalId: canalSnap.id,
          slug,
          imageUrl,
          logoUrl: String(canalData.logoEmpresa || '').trim(),
          title: String(canalData.tituloVisible || canalData.nombreSesion || 'Sala pública').trim(),
          brandName: String(canalData.brandName || canalData.nombreSesion || canalData.tituloVisible || 'Uvoto').trim(),
          subtitle: contextKind === 'brand' ? 'WAITING ROOM' : contextKind === 'event' ? 'EVENTO ACTIVO' : 'EXPERIENCIA UVOTO',
          description: String(
            firstSlide.subtitle ||
            firstSlide.description ||
            firstSlide.title ||
            canalData.descripcionExploracion ||
            'Explora esta experiencia y descubre lo que la marca preparó para su audiencia.'
          ).trim(),
          category,
          categoryLabel,
          brandType,
          brandTypeLabel,
          visitsCount
        });
      }

      // Global: "Salas destacadas" y el orden por defecto siempre son por
      // las más visitadas en TODA la plataforma, sin importar su categoría.
      perfiles.sort((a, b) => (b.visitsCount || 0) - (a.visitsCount || 0));
      this.publicExploreProfiles = perfiles.slice(0, 100);
      this.persistExploreProfilesCache(this.publicExploreProfiles);
      this.activeExploreIndex = 0;
    } catch (error) {
      console.error('Error cargando perfiles públicos:', error);
      if (!hasCachedProfiles) {
        this.exploreProfilesError = 'No pudimos cargar las salas públicas.';
      }
    } finally {
      if (!mostrarSilueta) {
        // Refresco en segundo plano: nunca hubo silueta que apagar.
        this.exploreProfilesLoading = false;
      } else {
        // Un piso corto evita el parpadeo si la red responde en 80ms. Antes
        // era de 1s, que ya se sentía como espera; 400ms sigue leyéndose
        // como instantáneo.
        const elapsed = Date.now() - startTime;
        const remainingTime = Math.max(0, 400 - elapsed);
        setTimeout(() => {
          this.exploreProfilesLoading = false;
        }, remainingTime);
        this.marcarAnimacionMarcaVista();
      }
    }
  },

  // La animación de marca se ve una vez por sesión: la primera entrada la
  // tiene completa y, al volver a la portada desde un canal, entra directo.
  yaMostramosAnimacionMarca() {
    try {
      return sessionStorage.getItem(EXPLORE_BRAND_INTRO_KEY) === '1';
    } catch (error) {
      return false;
    }
  },

  marcarAnimacionMarcaVista() {
    try {
      sessionStorage.setItem(EXPLORE_BRAND_INTRO_KEY, '1');
    } catch (error) {
      // sin sessionStorage: se verá en cada carga, que es el comportamiento viejo
    }
  },

  setExploreSwiper(swiper) {
    this.exploreSwiperInstance = swiper;
    this.$nextTick(() => {
      try {
        swiper.update();
        if (this.mainExploreLoopEnabled && typeof swiper.slideToLoop === 'function') {
          swiper.slideToLoop(0, 0, false);
        }
      } catch (error) {
        // noop
      }
    });
    this.restartExploreAutoplay();
  },

  setExploreModalSwiper(swiper) {
    this.exploreModalSwiperInstance = swiper;
  },

  onExploreSlideChange(swiper) {
    const baseLength = this.filteredExploreProfiles.length || 1;
    const rawIndex = typeof swiper.realIndex === 'number' ? swiper.realIndex : (swiper.activeIndex || 0);
    this.activeExploreIndex = ((rawIndex % baseLength) + baseLength) % baseLength;
  },

  pauseExploreAutoplay() {
    if (this.exploreAutoSlideInterval) {
      clearInterval(this.exploreAutoSlideInterval);
      this.exploreAutoSlideInterval = null;
    }
  },

  restartExploreAutoplay() {
    if (this.exploreAutoSlideInterval) {
      clearInterval(this.exploreAutoSlideInterval);
      this.exploreAutoSlideInterval = null;
    }
    if (!this.exploreSwiperInstance || this.filteredExploreProfiles.length <= 1) return;
    this.exploreAutoSlideInterval = setInterval(() => {
      if (!this.exploreSwiperInstance) return;
      try {
        this.exploreSwiperInstance.slideNext(640);
      } catch (error) {
        // noop
      }
    }, 2400);
  },

  selectExploreCategory(categoryId = 'all') {
    this.activeExploreCategory = categoryId;
    this.activeExploreIndex = 0;
    if (this.exploreSwiperInstance) {
      this.$nextTick(() => {
        try {
          this.exploreSwiperInstance.update();
          if (this.mainExploreLoopEnabled && typeof this.exploreSwiperInstance.slideToLoop === 'function') {
            this.exploreSwiperInstance.slideToLoop(0, 0, false);
          } else {
            this.exploreSwiperInstance.slideTo(0, 0, false);
          }
        } catch (error) {
          // noop
        }
      });
    }
    this.$nextTick(() => this.restartExploreAutoplay());
  },

  openExploreModal() {
    this.showExploreModal = true;
    // "Explorar todas" siempre parte en "Todos" — el filtro de la pantalla
    // principal no debe limitar lo que se ve al entrar a explorar salas.
    this.activeExploreModalCategory = 'all';
    this.exploreModalQuery = '';
  },

  closeExploreModal() {
    if (this.shouldUseDesktopShowcase) return;
    this.showExploreModal = false;
    this.exploreModalQuery = '';
  },

  selectExploreModalCategory(categoryId = 'all') {
    this.activeExploreModalCategory = categoryId;
    if (this.exploreModalSwiperInstance) {
      this.exploreModalSwiperInstance.slideTo(0, 0);
    }
  },

  async visitarPerfilExploracion(profile = {}) {
    const slug = String(profile.slug || '').trim();
    if (!slug) return;
    this.setEntryLoadingPreview(profile);
    this.persistEntryLoadingPreview();
    this.showJoinHomePanel = false;
    this.showExploreOverlay = false;
    this.showExploreModal = false;
    this.loading = true;
    try {
      if (this.$route?.path !== `/${slug}`) {
        await this.$router.push({ path: `/${slug}` });
      }
      const destino = await resolverShortLinkCompartido(slug);
      if (destino?.pin) {
        this.pinIngresado = normalizarPinIngreso(destino.pin);
        this.conectarPorPin(normalizarPinIngreso(destino.pin), {
          autoFromUrl: true,
          proyectorEsperado: destino.proyectorId || null
        });
      } else {
        this.loading = false;
        this.clearEntryLoadingPreview();
        alert("Este enlace ya no está disponible.");
      }
    } catch (error) {
      console.error("Error entrando a sala pública:", error);
      this.loading = false;
      this.clearEntryLoadingPreview();
      alert("No pudimos abrir esta sala.");
    }
  },

  irACrearSala() {
    this.$router.push('/login');
  },

  resolveShortLink(slug = '') {
    return resolverShortLinkCompartido(slug);
  },
 
 
  // Cambia slide activo — pausa video anterior, reproduce el nuevo
  onWaitingRoomUserSlideChange(swiper) {
    this.activeWaitingRoomIndex = swiper.activeIndex;
    this.$nextTick(() => {
      const slides = swiper.el?.querySelectorAll?.('.wr-slide');
      if (!slides) return;
      slides.forEach((slideEl, i) => {
        const video = slideEl.querySelector('.wr-video-embed');
        if (!video) return;
        if (i === swiper.activeIndex) {
          try { video.play().catch(() => {}); } catch {}
        } else {
          try { video.pause(); } catch {}
        }
      });
      // Auto-open app panel when landing on brand-claim slide with a pending claim
      const activeSlide = this.displayWaitingRoomSlides[swiper.activeIndex];
      if (activeSlide?.layoutType === 'brand-claim' && this.brandSlugStatus === 'current') {
        this.showJoinHomePanel = true;
      }
    });
  },

onWrSlideMovementStart() {
  clearTimeout(this._wrSlideMoveTimer);
  this.isWrSlideMoving = true;
},
onWrSlideMovementEnd() {
  clearTimeout(this._wrSlideMoveTimer);
  this._wrSlideMoveTimer = setTimeout(() => {
    this.isWrSlideMoving = false;
  }, 150);
},

setWaitingRoomSwiper(swiper) {
  this.waitingRoomSwiperInstance = swiper;
  this.syncWaitingRoomGuideState();
  this.aplicarSlideCompartido();
  // Ensure the first video plays if active
  this.onWaitingRoomUserSlideChange(swiper);
},

// ── Enlace directo a un slide ────────────────────────────────────────────
// uvoto.com/<slug>?s=<idDelSlide> abre la sala posicionada en ese lienzo.
// Se intenta cada vez que cambian los slides o se monta el swiper, porque el
// parámetro suele llegar ANTES que los datos de Firestore.
aplicarSlideCompartido() {
  const objetivo = String(this.slideCompartidoPendiente || '').trim();
  if (!objetivo) return;
  const swiper = this.waitingRoomSwiperInstance;
  const slides = this.displayWaitingRoomSlides || [];
  if (!swiper || swiper.destroyed || !slides.length) return;

  // `?s=3` es la posición (1-based); cualquier otra cosa se trata como id,
  // que es el formato de los enlaces compartidos antes de este cambio.
  let indice;
  if (/^\d+$/.test(objetivo)) {
    const pos = parseInt(objetivo, 10) - 1;
    indice = (pos >= 0 && pos < slides.length) ? pos : -1;
  } else {
    indice = slides.findIndex((sl) => String(sl?.id || '').trim() === objetivo);
  }
  // El slide pudo borrarse, o el canal estar en plan gratuito y no servirse
  // más que el primero: en cualquier caso se abre en el primero, nunca en
  // blanco. Se consume igual para no reintentar en cada cambio.
  this.slideCompartidoPendiente = '';
  if (indice <= 0) return;

  // Sin animación: el enlace debe abrir YA en ese lienzo, no recorrerlos.
  swiper.slideTo(indice, 0);
  this.activeWaitingRoomIndex = indice;
  this.onWaitingRoomUserSlideChange(swiper);
},

// URL para compartir ESTE lienzo, no el canal entero.
// Se usa la POSICIÓN (1, 2, 3…) en vez del id: `?s=3` se lee y se comparte
// mucho mejor que `?s=waiting_1777513713402_hxpvp`. El id se sigue aceptando
// al abrir, para que los enlaces ya compartidos no se rompan.
urlCompartirSlide(slide = null) {
  const base = this.roomShareUrl;
  const slides = this.displayWaitingRoomSlides || [];
  const objetivo = slide || this.activeWaitingRoomSlide;
  let indice = slides.indexOf(objetivo);
  if (indice < 0) {
    const id = String(objetivo?.id || '').trim();
    indice = id ? slides.findIndex((sl) => String(sl?.id || '').trim() === id) : -1;
  }
  if (indice < 0) return base;
  return `${base}${base.includes('?') ? '&' : '?'}s=${indice + 1}`;
},

async compartirSlideActual() {
  const url = this.urlCompartirSlide();
  const slide = this.activeWaitingRoomSlide || {};
  const titulo = String(slide.title || slide.primaryText || this.tituloVisibleSesionUsuario || 'Uvoto').trim();
  if (navigator.share) {
    try {
      await navigator.share({ title: titulo, text: titulo, url });
      return;
    } catch (e) { /* el usuario canceló: seguimos al portapapeles */ }
  }
  try {
    await navigator.clipboard?.writeText(url);
    this.linkCopied = true;
    setTimeout(() => { this.linkCopied = false; }, 2200);
  } catch (e) { /* sin portapapeles no hay nada más que hacer */ }
},

syncWaitingRoomGuideState() {
  const shouldShow = !this.waitingRoomGuideSeen
    && this.puedeMostrarSalaEspera
    && this.waitingRoomSlides.length > 1;

  if (!shouldShow) {
    this.mostrarGuiaSlidesWaitingRoom = false;
    this.detenerGuiaSlidesWaitingRoom();
    return;
  }

  if (this.mostrarGuiaSlidesWaitingRoom || this.waitingRoomGuideDelayTimeout) return;

  this.waitingRoomGuideDelayTimeout = setTimeout(() => {
    this.waitingRoomGuideDelayTimeout = null;
    if (this.waitingRoomGuideSeen || !this.puedeMostrarSalaEspera || this.waitingRoomSlides.length <= 1) return;
    this.mostrarGuiaSlidesWaitingRoom = true;
    this.$nextTick(() => {
      this.iniciarGuiaSlidesWaitingRoom();
    });
  }, 1000);
},

iniciarGuiaSlidesWaitingRoom() {
  this.detenerGuiaSlidesWaitingRoom();
  if (!this.waitingRoomSwiperInstance || this.waitingRoomSlides.length <= 1 || !this.mostrarGuiaSlidesWaitingRoom) return;

  const ejecutarDemo = () => {
    if (!this.waitingRoomSwiperInstance || !this.mostrarGuiaSlidesWaitingRoom) return;
    this.waitingRoomGuideHandDuration = 430;
    this.waitingRoomGuideHandOffset = -28;
    setTimeout(() => {
      if (!this.waitingRoomSwiperInstance || !this.mostrarGuiaSlidesWaitingRoom) return;
      this.waitingRoomSwiperInstance.slideTo(1, 520);
    }, 110);

    this.waitingRoomGuideReturnTimeout = setTimeout(() => {
      if (!this.waitingRoomSwiperInstance || !this.mostrarGuiaSlidesWaitingRoom) return;
      this.waitingRoomGuideHandDuration = 430;
      this.waitingRoomGuideHandOffset = 28;
      setTimeout(() => {
        if (!this.waitingRoomSwiperInstance || !this.mostrarGuiaSlidesWaitingRoom) return;
        this.waitingRoomSwiperInstance.slideTo(0, 520);
      }, 110);
    }, 1300);
  };

  ejecutarDemo();
  this.waitingRoomGuideInterval = setInterval(ejecutarDemo, 4200);
},

detenerGuiaSlidesWaitingRoom() {
  if (this.waitingRoomGuideInterval) {
    clearInterval(this.waitingRoomGuideInterval);
    this.waitingRoomGuideInterval = null;
  }
  if (this.waitingRoomGuideReturnTimeout) {
    clearTimeout(this.waitingRoomGuideReturnTimeout);
    this.waitingRoomGuideReturnTimeout = null;
  }
  if (this.waitingRoomGuideDelayTimeout) {
    clearTimeout(this.waitingRoomGuideDelayTimeout);
    this.waitingRoomGuideDelayTimeout = null;
  }
  this.waitingRoomGuideHandOffset = 0;
},

entendidoGuiaSlidesWaitingRoom() {
  this.waitingRoomGuideSeen = true;
  this.mostrarGuiaSlidesWaitingRoom = false;
  localStorage.setItem('uvoto_waiting_room_swipe_guide_seen', 'true');
  this.detenerGuiaSlidesWaitingRoom();
},

// ── Waiting Room helpers ──────────────────────────────────────────────

  // Ensures every slide has a blocks[] array preserving order.
  // For new slides saved with the unified system, blocks[] comes directly from Firestore.
  // For legacy slides (no blocks[]), we reconstruct from textBlocks + links + galleryImages
  // so they also render in the correct interleaved order they were last saved in.
  wrNormalizarBlocks(slide) {
    if (!slide) return slide;
    // Already has unified blocks — nothing to do
    if (Array.isArray(slide.blocks) && slide.blocks.length) return slide;

    // Build a synthetic blocks[] from legacy fields
    const syntheticBlocks = [];

    // text blocks
    if (Array.isArray(slide.textBlocks)) {
      slide.textBlocks.forEach((b) => {
        if ((b.text || '').trim()) {
          syntheticBlocks.push({ id: b.id || b.text, type: 'text', kind: b.kind || 'small', text: b.text });
        }
      });
    } else {
      // Very old format: title / subtitle / description
      if (slide.title)       syntheticBlocks.push({ id: 'title',       type: 'text', kind: 'title',    text: slide.title });
      if (slide.subtitle)    syntheticBlocks.push({ id: 'subtitle',    type: 'text', kind: 'subtitle', text: slide.subtitle });
      if (slide.description) syntheticBlocks.push({ id: 'description', type: 'text', kind: 'small',    text: slide.description });
    }

    // links — appended after text (legacy has no interleaved order info)
    if (Array.isArray(slide.links)) {
      slide.links.filter((l) => (l.value || '').trim()).forEach((l) => {
        syntheticBlocks.push({ id: l.id, type: 'link', platform: l.platform, value: l.value, label: l.label, url: l.url });
      });
    }

    // gallery — one block containing all legacy gallery images
    if (Array.isArray(slide.galleryImages) && slide.galleryImages.some((img) => img.imageUrl)) {
      syntheticBlocks.push({
        id: 'gallery_legacy',
        type: 'gallery',
        images: slide.galleryImages.filter((img) => img.imageUrl),
      });
    }

    return syntheticBlocks.length ? { ...slide, blocks: syntheticBlocks } : slide;
  },

wrSlideHasContent(slide = {}) {
  if (Array.isArray(slide.blocks) && slide.blocks.some((b) => {
    if (b.type === 'text')    return (b.text || '').trim();
    if (b.type === 'link')    return (b.value || '').trim();
    if (b.type === 'gallery') return (b.images || []).some((img) => img.imageUrl);
    return false;
  })) return true;
  if (Array.isArray(slide.textBlocks) && slide.textBlocks.some(b => (b.text || '').trim())) return true;
  if ((slide.title || slide.subtitle || slide.description || '').trim()) return true;
  if (Array.isArray(slide.links) && slide.links.some(l => (l.value || '').trim())) return true;
  if (Array.isArray(slide.galleryImages) && slide.galleryImages.some((image) => (image?.imageUrl || '').trim())) return true;
  return false;
},

onVideoLoaded(slideId) {
  this.videoLoadedMap = { ...this.videoLoadedMap, [slideId]: true };
},

toggleVideoMute(slideId, event) {
  const current = this.videoMutedMap[slideId];
  // Si nunca se tocó (undefined) empieza en muted (true), toggle → unmute (false)
  const newVal = current !== false ? false : true;
  this.videoMutedMap = { ...this.videoMutedMap, [slideId]: newVal };
  // Actualizar DOM directamente porque :muted no es reactivo en <video>
  const btn = event?.currentTarget;
  const wrap = btn?.closest('.wr-media-wrap--video');
  const videoEl = wrap?.querySelector('video');
  if (videoEl) videoEl.muted = newVal !== false;
},

isLightSlide(slide = {}) {
  const hex = (slide?.dominantColor || '#2f2a27').replace('#', '');
  if (hex.length < 6) return false;
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return (r * 0.299 + g * 0.587 + b * 0.114) > 160;
},

wrSlideTextColor(slide = {}, opacity = 1) {
  if (this.isLightSlide(slide)) {
    return opacity < 1 ? `rgba(17,17,17,${opacity})` : '#111111';
  }
  return opacity < 1 ? `rgba(255,255,255,${opacity})` : '#ffffff';
},

wrPrimaryTextStyle(slide = {}) {
  const length = String(slide.primaryText || '').trim().length;
  let fontSize = 40;
  if (length > 260) fontSize = 22;
  else if (length > 220) fontSize = 24;
  else if (length > 180) fontSize = 27;
  else if (length > 140) fontSize = 30;
  else if (length > 100) fontSize = 33;
  else if (length > 60)  fontSize = 36;
  const lineHeight = length > 180 ? 1.22 : length > 100 ? 1.18 : 1.12;
  return {
    textAlign:   slide.primaryTextAlign  || 'center',
    fontWeight:  slide.primaryTextWeight === 'light' ? 500 : 800,
    fontFamily:  `'${slide.primaryTextFont || 'Plus Jakarta Sans'}', sans-serif`,
    fontSize:    `${fontSize}px`,
    lineHeight:  String(lineHeight),
    color:       this.isLightSlide(slide) ? '#111111' : '#ffffff',
  };
},

buildBrandClaimWaitingRoomSlide() {
  const lang = String(this.selectedLanguage || 'es').toLowerCase().split('-')[0];
  const copy = {
    es: {
      kicker: 'TU SIGUIENTE PASO',
      title: 'También puedes crear tu Branding Interactivo',
      description: 'Reserva el nombre de tu marca y sigue al flujo de creación para lanzar tu propia experiencia en Uvoto.',
      placeholder: 'tu-marca',
      cta: 'Reservar y continuar',
      savingCta: 'Reservando...'
    },
    en: {
      kicker: 'YOUR NEXT STEP',
      title: 'You can create your own Interactive Branding too',
      description: 'Reserve your brand name and continue to the creation flow to launch your own experience in Uvoto.',
      placeholder: 'your-brand',
      cta: 'Reserve and continue',
      savingCta: 'Reserving...'
    },
    pt: {
      kicker: 'SEU PRÓXIMO PASSO',
      title: 'Você também pode criar seu Branding Interativo',
      description: 'Reserve o nome da sua marca e continue para o fluxo de criação para lançar sua própria experiência na Uvoto.',
      placeholder: 'sua-marca',
      cta: 'Reservar e continuar',
      savingCta: 'Reservando...'
    }
  };
  const selected = copy[lang] || copy.es;
  return {
    id: '__uvoto_brand_claim__',
    layoutType: 'brand-claim',
    dominantColor: '#0b0b0d',
    accentColor: '#1c1d22',
    ...selected
  };
},

wrBuildLink(link = {}) {
  const v = String(link.value || '').trim();
  if (!v) return '';
  if (link.platform === 'whatsapp') {
    const num = v.replace(/\D/g, '');
    return `https://wa.me/${num}`;
  }
  if (link.platform === 'instagram') {
    if (/^https?:\/\//i.test(v)) return v;
    return `https://instagram.com/${v.replace(/^@/, '')}`;
  }
  if (link.platform === 'linkedin') {
    if (/^https?:\/\//i.test(v)) return v;
    return `https://linkedin.com/in/${v.replace(/^@/, '')}`;
  }
  if (link.platform === 'facebook') {
    if (/^https?:\/\//i.test(v)) return v;
    return `https://facebook.com/${v}`;
  }
  if (link.platform === 'youtube') {
    if (/^https?:\/\//i.test(v)) return v;
    return `https://youtube.com/@${v.replace(/^@/, '')}`;
  }
  if (link.platform === 'telegram') {
    if (/^https?:\/\//i.test(v)) return v;
    return `https://t.me/${v.replace(/^@/, '')}`;
  }
  if (link.platform === 'x') {
    if (/^https?:\/\//i.test(v)) return v;
    return `https://x.com/${v.replace(/^@/, '')}`;
  }
  if (/^https?:\/\//i.test(v)) return v;
  return `https://${v}`;
},

wrPlatformLabel(platform = 'url') {
  const map = {
    url: 'Sitio web', whatsapp: 'WhatsApp', linkedin: 'LinkedIn',
    facebook: 'Facebook', instagram: 'Instagram', youtube: 'YouTube',
    telegram: 'Telegram', x: 'X / Twitter',
  };
  return map[platform] || 'Link';
},

wrPlatformIcon(platform = 'url') {
  const icons = {
    url:       '<circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>',
    whatsapp:  '<path d="M17.5 14.4c-.3-.1-1.7-.8-2-1-.3-.1-.5-.1-.7.2s-.8 1-1 1.2c-.2.2-.4.2-.7.1-1.9-.9-3.2-2.6-3.4-3-.2-.4 0-.6.2-.7l.5-.6c.1-.2.2-.4.3-.6 0-.2 0-.4-.1-.6L9.5 8c-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.1 1.1-1.1 2.7s1.2 3.1 1.3 3.3c.2.2 2.3 3.6 5.7 4.9.8.3 1.4.5 1.9.6.8.2 1.5.2 2.1.1.6-.1 1.8-.7 2.1-1.4.3-.6.3-1.2.2-1.3-.1-.2-.3-.3-.6-.4z"/><path d="M12 2a10 10 0 0 1 8.7 14.9L22 22l-5.2-1.3A10 10 0 1 1 12 2z"/>',
    linkedin:  '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/>',
    facebook:  '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>',
    instagram: '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.4a4 4 0 1 1-4.9-3.9 4 4 0 0 1 4.9 3.9z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>',
    youtube:   '<path d="M22.5 6.4a2.9 2.9 0 0 0-2-2C18.9 4 12 4 12 4s-6.9 0-8.5.4a2.9 2.9 0 0 0-2 2C1 8 1 12 1 12s0 4 .5 5.6a2.9 2.9 0 0 0 2 2C5.1 20 12 20 12 20s6.9 0 8.5-.4a2.9 2.9 0 0 0 2-2C23 16 23 12 23 12s0-4-.5-5.6z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/>',
    telegram:  '<path d="m22 2-7 20-4-9-9-4z"/><path d="M22 2 11 13"/>',
    x:         '<path d="M4 4l16 16M4 20 20 4"/>',
  };
  return icons[platform] || icons.url;
},
 
  sessionUserIdKey(canalId = this.canalId) {
    return `uvoto_user_id_${canalId}`;
  },

  // Espera a que Firebase Auth restaure la sesión cacheada antes de decidir.
  // Sin esto, auth.currentUser es null en los primeros ms aunque ya haya sesión guardada.
  waitForAuthReady() {
    return new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe();
        resolve(user);
      });
    });
  },

  // Wrapper de candado único: esta función se llama desde varios puntos de
  // inicialización (flujo de PIN, listener de consultas, envío de mensaje,
  // etc.). Sin esto, dos llamadas casi simultáneas ven this.userId vacío
  // ANTES de que la primera termine su await, y cada una crea su propia
  // sesión anónima — dos UIDs distintos en la misma carga de página. Eso
  // hacía que el chat se quedara pegado en "escribiendo" (el mensaje se
  // guardaba con un UID distinto al que el listener escuchaba) o que un
  // mensaje "desapareciera" al recargar.
  getOrCreateSessionUserId(canalId = this.canalId) {
    if (this.userId) return Promise.resolve(this.userId);
    if (this._sessionUserIdInFlight) return this._sessionUserIdInFlight;
    this._sessionUserIdInFlight = this._getOrCreateSessionUserIdInner(canalId).finally(() => {
      this._sessionUserIdInFlight = null;
    });
    return this._sessionUserIdInFlight;
  },

  async _getOrCreateSessionUserIdInner(canalId = this.canalId) {
    if (!canalId) return this.userId || null;

    // 1. Si ya tenemos un userId en memoria en esta sesión Vue, reutilizarlo
    if (this.userId) return this.userId;

    // 2. Detectar si estamos en un iframe cross-origin (embed en otro sitio).
    //    En ese contexto localStorage / indexedDB están bloqueados, así que
    //    Firebase Auth necesita persistencia en memoria para poder funcionar.
    const isIframe = (() => {
      try { return window.self !== window.top; } catch { return true; }
    })();

    if (isIframe) {
      // En iframe: Intentamos persistencia local primero para que el UID no cambie al recargar.
      // Solo si falla o está bloqueado, Firebase manejará el estado en memoria.
      try { 
        const { browserLocalPersistence } = await import('firebase/auth');
        await setPersistence(auth, browserLocalPersistence); 
      } catch (e) { 
        console.warn('[Uvoto] Falló persistencia local en iframe, usando fallback.', e);
      }
    }

    // 3. Esperar a que Firebase restaure su sesión cacheada (si no es iframe).
    //    Esto es CRÍTICO: evita crear un nuevo anónimo cuando ya hay uno guardado.
    const restoredUser = await this.waitForAuthReady();

    if (restoredUser) {
      const uid = restoredUser.uid;
      this.userId = uid;
      if (!isIframe) {
        try { localStorage.setItem(this.sessionUserIdKey(canalId), uid); } catch { /* storage bloqueado */ }
      }
      return uid;
    }

    // 4. Sin sesión Firebase — crear una nueva sesión anónima silenciosa
    try {
      const result = await signInAnonymously(auth);
      const uid = result.user.uid;
      this.userId = uid;
      if (!isIframe) {
        try { localStorage.setItem(this.sessionUserIdKey(canalId), uid); } catch { /* storage bloqueado */ }
      }
      return uid;
    } catch (e) {
      // signInAnonymously falló — no generamos un ID falso porque Firestore
      // necesita request.auth != null para permitir la escritura.
      console.warn('Anonymous Auth falló:', e);
      return null;
    }
  },
 
  clearSessionUserId(canalId = this.canalId) {
    if (!canalId) return;
    localStorage.removeItem(this.sessionUserIdKey(canalId));
    if (this.canalId === canalId) {
      this.userId = null;
    }
  },
 
  limitarTituloSesion(texto, max = 50) {
    const value = (texto || '').trim();
    if (!value) return 'Sesión Activa';
    return value.length > max ? `${value.slice(0, max).trim()}...` : value;
  },
 
  toggleLanguageMenu() {
    this.showLanguageMenu = !this.showLanguageMenu;
  },
 
  closeLanguageMenu() {
    this.showLanguageMenu = false;
  },
 
  getLanguageLabel(code) {
    const labelsByLocale = {
      es: {
        es: 'Espanol',
        en: 'Ingles',
        pt: 'Portugues'
      },
      en: {
        es: 'Spanish',
        en: 'English',
        pt: 'Portuguese'
      },
      pt: {
        es: 'Espanhol',
        en: 'Ingles',
        pt: 'Portugues'
      }
    };
 
    const locale = this.selectedLanguage || i18n.global.locale.value || 'en';
    return labelsByLocale[locale]?.[code] || labelsByLocale.en[code] || code.toUpperCase();
  },
 
  cambiarIdioma(locale) {
    this.selectedLanguage = locale;
    i18n.global.locale.value = locale;
    localStorage.setItem('user_lang', locale);
    this.showLanguageMenu = false;
    // Re-translate waiting room slides into the new language
    this.translateAllWaitingRoomSlides();
  },

  // ── Dynamic waiting-room slide translation ──────────────────────────

  async translateWithApi(text, targetLang) {
    if (!text || !text.trim()) return text;
    try {
      const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=${encodeURIComponent(targetLang)}&dt=t&q=${encodeURIComponent(text)}`;
      const res = await fetch(url);
      if (!res.ok) return text;
      const data = await res.json();
      // Response: [ [ [translatedChunk, original, ...], ... ], ... ]
      return (data[0] || []).map((chunk) => chunk[0] || '').join('').trim() || text;
    } catch {
      return text;
    }
  },

  async translateSlide(slide, lang) {
    // Deep-clone so we never mutate the original Firestore data
    const s = JSON.parse(JSON.stringify(slide));

    // Helpers
    const tr = (t) => this.translateWithApi(t, lang);

    // primaryText (type=text layout)
    if (s.primaryText) s.primaryText = await tr(s.primaryText);

    // ── Unified blocks[] (new canonical system) ──────────────────────
    // Translate text/label/caption inside each block in-order so the
    // translated clone keeps the same block structure and order.
    if (Array.isArray(s.blocks)) {
      for (const block of s.blocks) {
        if (block.type === 'text' && block.text) {
          block.text = await tr(block.text);
        } else if (block.type === 'link' && block.label) {
          block.label = await tr(block.label);
        } else if (block.type === 'gallery' && Array.isArray(block.images)) {
          for (const img of block.images) {
            if (img.caption) img.caption = await tr(img.caption);
          }
        }
      }
    }

    // ── Legacy fields (kept in sync for backward compat) ─────────────
    if (Array.isArray(s.textBlocks)) {
      for (const block of s.textBlocks) {
        if (block.text) block.text = await tr(block.text);
      }
    }

    // Legacy title/subtitle/description
    if (s.title)       s.title       = await tr(s.title);
    if (s.subtitle)    s.subtitle    = await tr(s.subtitle);
    if (s.description) s.description = await tr(s.description);

    // Link labels (NOT the URLs)
    if (Array.isArray(s.links)) {
      for (const link of s.links) {
        if (link.label) link.label = await tr(link.label);
      }
    }

    // Gallery captions
    if (Array.isArray(s.galleryImages)) {
      for (const img of s.galleryImages) {
        if (img.caption) img.caption = await tr(img.caption);
      }
    }

    return s;
  },

  async translateAllWaitingRoomSlides() {
    const lang = String(this.selectedLanguage || 'es').toLowerCase().split('-')[0];
    // No translation needed when language is Spanish (source language of slides)
    // — or adjust this check if slides may also be authored in other languages
    const slides = this.waitingRoomSlides;
    if (!slides.length) return;

    for (const slide of slides) {
      const key = `${slide.id || slide._id || JSON.stringify(slide).slice(0,40)}_${lang}`;
      // Skip if already translated
      if (this.translatedSlidesMap[key]) continue;

      try {
        const translated = await this.translateSlide(slide, lang);
        // Reactive assignment so Vue tracks the new key
        this.translatedSlidesMap = { ...this.translatedSlidesMap, [key]: translated };
      } catch (e) {
        console.warn('Error traduciendo slide:', e);
      }
    }
  },

  normalizarPinIngreso(value = '') {
    return normalizarPinIngreso(value);
  },
 
waitingRoomDocRef() {
  if (!this.canalId) return null;
  const waitingRoomDocId = this.proyectorConfig?.waitingRoomDocId || 'estado';
  return doc(db, "canales", this.canalId, "waiting_room", waitingRoomDocId);
},
 
escucharWaitingRoomConfig() {
  // Always unsubscribe the previous listener before creating a new one.
  // Without this, calling this function multiple times (e.g. on room switch,
  // on waitingRoomDocId change, on canalId change) stacks up duplicate Firestore
  // listeners that all keep firing — a confirmed source of multi-user inconsistency.
  if (this.unsubWaitingRoomConfig) {
    this.unsubWaitingRoomConfig();
    this.unsubWaitingRoomConfig = null;
  }

  const waitingRoomRef = this.waitingRoomDocRef();
  if (!waitingRoomRef) return;

  this.unsubWaitingRoomConfig = onSnapshot(waitingRoomRef, (snap) => {
    if (!snap.exists()) {
      this.waitingRoomPublicData = { enabled: false, slides: [] };
      return;
    }
 
    const data = snap.data() || {};
    this.waitingRoomPublicData = {
      // La gracia vencida equivale a no estar publicada.
      enabled: (data.enabled ?? true) && isPublicationActive(data),
      slides: Array.isArray(data.slides) ? data.slides : [],
      publishPlan: data.publishPlan || null,
      publishGraceStartedAt: data.publishGraceStartedAt || null
    };
  });
},
 
colorConAlpha(color, alpha = 1) {
  if (!color) return `rgba(47, 42, 39, ${alpha})`;
  if (color.startsWith('rgb(')) {
    return color.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);
  }
  return color;
},
 
actualizarEstadoMomentoPublicado(canalId = this.canalId) {
  if (!canalId) {
    this.momentoPublicado = false;
    return;
  }
  this.momentoPublicado = localStorage.getItem(`moment_posted_${canalId}_${this.userId || 'anon'}`) === 'true';
},
 
async manejarSubidaMomento(event) {
  const file = event?.target?.files?.[0];
  if (!file) return;
 
  const reader = new FileReader();
  reader.onload = () => {
    const result = reader.result;
    this.momentPhotoPreview = result;
    const img = new Image();
    img.onload = () => {
      if (img.height > img.width * 1.1) {
        this.momentPhotoOrientation = 'portrait';
      } else if (img.width > img.height * 1.1) {
        this.momentPhotoOrientation = 'landscape';
      } else {
        this.momentPhotoOrientation = 'square';
      }
    };
    img.src = result;
  };
  reader.readAsDataURL(file);
},
 
async guardarMomento() {
  if (!this.puedeGuardarMomento || !this.canalId) return;
  this.subiendoMomento = true;
  this.momentoGuardado = false;
 
  try {
    const storage = getStorage();
    const momentId = `moment_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const storageRef = ref(storage, `moments/${this.canalId}/${momentId}.jpg`);
    const snapshot = await uploadString(storageRef, this.momentPhotoPreview, 'data_url');
    const imageUrl = await getDownloadURL(snapshot.ref);
 
    await addDoc(collection(db, "canales", this.canalId, "moments"), {
      imageUrl,
      caption: this.momentCaption.trim(),
      userId: this.userId,
      nombre: this.nombreUsuario || 'Invitado',
      foto: this.fotoUrl || null,
      createdAt: serverTimestamp()
    });
 
    this.momentPhotoPreview = '';
    this.momentPhotoOrientation = 'square';
    this.momentCaption = '';
    this.momentoGuardado = true;
    this.momentoPublicado = true;
    localStorage.setItem(`moment_posted_${this.canalId}_${this.userId || 'anon'}`, 'true');
    if (this.$refs.momentInput) {
      this.$refs.momentInput.value = '';
    }
  } catch (error) {
    console.error("Error al guardar momento:", error);
  } finally {
    this.subiendoMomento = false;
  }
},
 
limpiarConexionActiva() {
  if (this.proyectorListener) {
    this.proyectorListener();
    this.proyectorListener = null;
  }
 
  if (this.preguntaListener) {
    this.preguntaListener();
    this.preguntaListener = null;
  }
 
  if (this.unsubConsultasIA) {
    this.unsubConsultasIA();
    this.unsubConsultasIA = null;
  }
 
  if (this.userTimerInterval) {
    clearInterval(this.userTimerInterval);
    this.userTimerInterval = null;
  }
 
  if (this.intervaloReloj) {
    clearInterval(this.intervaloReloj);
    this.intervaloReloj = null;
  }

  if (this.exploreAutoSlideInterval) {
    clearInterval(this.exploreAutoSlideInterval);
    this.exploreAutoSlideInterval = null;
  }

  // These were only cleaned in beforeUnmount — also clean on room switch
  if (this.unsubProximaCita) {
    this.unsubProximaCita();
    this.unsubProximaCita = null;
  }
  if (this.rotatingAudienceInterval) {
    clearInterval(this.rotatingAudienceInterval);
    this.rotatingAudienceInterval = null;
  }
  // El carrusel del lienzo de reclamo NO es un recurso de la conexión: es la
  // animación de la portada. Apagarlo aquí lo dejaba estático justo al volver
  // a esa pantalla desde un canal. Se reinicia en vez de matarlo.
  this.startBrandSlideShow();

  this.currentProyectorEscuchado = null;
  this._lastPreguntaActivaId = null; // Reset so next room starts fresh
  this.preguntaCanalId = null;
  this.proyectorConfig = {};
  this.waitingRoomPublicData = { enabled: false, slides: [] };
  this.misConsultas = [];
  this.consultaPendienteLocal = null;
  this.selectedAiProfile = null;
  this._likesInitializedForCanal = '';
},
 
reiniciarEstadoTrasCambioDeCanal() {
  this._lastPreguntaActivaId = null; // Reset so new canal starts fresh
  this.preguntaCanalId = null;
  if (this.preguntaListener) {
    this.preguntaListener();
    this.preguntaListener = null;
  }
 
  if (this.userTimerInterval) {
    clearInterval(this.userTimerInterval);
    this.userTimerInterval = null;
  }
 
  if (this.intervaloReloj) {
    clearInterval(this.intervaloReloj);
    this.intervaloReloj = null;
  }

  if (this.exploreAutoSlideInterval) {
    clearInterval(this.exploreAutoSlideInterval);
    this.exploreAutoSlideInterval = null;
  }
 
  if (typeof this.resetPdfPhone === 'function') {
    this.resetPdfPhone();
  }
 
  if (typeof this.resetInteraccion === 'function') {
    this.resetInteraccion();
  }
 
  this.proyectorConfig = {};
  if (this.unsubWaitingRoomConfig) {
    this.unsubWaitingRoomConfig();
    this.unsubWaitingRoomConfig = null;
  }
 
  this.preguntaActiva = null;
  this.consultaPendienteLocal = null;
  this.loadingEnvio = false;
  this.votoRealizado = false;
  this.indiceSeleccionado = null;
  this.indicesSeleccionados = [];
  this.comentario = '';
  this.listaOrdenable = [];
  this.tiempoRestante = 0;
  this.tiempoQuiz = 0;
  this.ganadorLocal = false;
  this.confetiLanzado = false;
  this.respuestaCorrectaTexto = '';
  this.puntosGanados = 0;
  this.waitingRoomPublicData = { enabled: false, slides: [] };
  this.misConsultas = [];
  this.consultaPendienteLocal = null;
  this.selectedAiProfile = null;
},
 
async cargarPdfPhone(url) {
  this.pdfLoading = true;
  try {
    if (this.pdfDoc) {
      if (typeof this.pdfDoc.cleanup === 'function') this.pdfDoc.cleanup();
      if (typeof this.pdfDoc.destroy === 'function') this.pdfDoc.destroy();
    }
    const task = pdfjsLib.getDocument(url);
    const rawDoc = await task.promise;
    this.pdfDoc = markRaw(rawDoc);
    await this.$nextTick();
    await this.renderizarPdfPhone(this.pdfPaginaActual || 1);
    this.mostrarPdfUi();
  } catch (e) {
    console.error("Error cargando PDF en teléfono:", e);
  } finally {
    this.pdfLoading = false;
  }
},
 
async esperarPdfCanvas() {
  for (let i = 0; i < 10; i++) {
    const canvas = document.getElementById('pdf-user-canvas');
    if (canvas) return canvas;
    await new Promise(r => requestAnimationFrame(r));
  }
  return null;
},
 
async renderizarPdfPhone(numeroPagina) {
  if (!this.pdfDoc) return;
  const num = parseInt(numeroPagina);
  if (isNaN(num) || num < 1 || num > this.pdfDoc.numPages) return;
  try {
    const canvas = await this.esperarPdfCanvas();
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const page = await this.pdfDoc.getPage(num);
    const baseViewport = page.getViewport({ scale: 1 });
    this.pdfIsPortrait = baseViewport.height >= baseViewport.width;
 
    const rotation = this.pdfIsPortrait ? 0 : 90;
    const scale = 2.0;
    const viewport = page.getViewport({ scale, rotation });
 
    canvas.width = viewport.width;
    canvas.height = viewport.height;
 
    await page.render({ canvasContext: ctx, viewport }).promise;
  } catch (e) {
    console.error("Error render PDF teléfono:", e);
  }
},
 
guardarCapturaPdf() {
  const canvas = document.getElementById('pdf-user-canvas');
  if (!canvas) return;
  const dataUrl = canvas.toDataURL('image/png');
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = `pdf_pagina_${this.pdfPaginaActual || 1}.png`;
  link.click();
},
 
resetPdfPhone() {
  this.pdfLoading = false;
  this.pdfIsPortrait = true;
  this.pdfPaginaActual = 1;
  this.pdfUiVisible = true;
  if (this.pdfUiTimer) {
    clearTimeout(this.pdfUiTimer);
    this.pdfUiTimer = null;
  }
  if (this.pdfDoc) {
    if (typeof this.pdfDoc.cleanup === 'function') this.pdfDoc.cleanup();
    if (typeof this.pdfDoc.destroy === 'function') this.pdfDoc.destroy();
  }
  this.pdfDoc = null;
  const canvas = document.getElementById('pdf-user-canvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    ctx && ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
},
 
mostrarPdfUi() {
  this.pdfUiVisible = true;
  if (this.pdfUiTimer) clearTimeout(this.pdfUiTimer);
  this.pdfUiTimer = setTimeout(() => {
    this.pdfUiVisible = false;
  }, 2500);
},
 
iniciarCronometroQuiz() {
  // 1. Limpieza de seguridad: Detener cualquier intervalo previo
  if (this.intervaloReloj) {
    clearInterval(this.intervaloReloj);
    this.intervaloReloj = null;
  }

  if (this.exploreAutoSlideInterval) {
    clearInterval(this.exploreAutoSlideInterval);
    this.exploreAutoSlideInterval = null;
  }
 
  const actualizarReloj = () => {
    // 2. Si no hay pregunta, terminamos
    if (!this.preguntaActiva) {
      this.tiempoQuiz = 0;
      if (this.intervaloReloj) clearInterval(this.intervaloReloj);
      return;
    }
 
    // 3. MANEJO DE LATENCIA (serverTimestamp):
    // Si la pregunta existe pero fechaLanzamiento aún es null, el servidor 
    // de Firebase está procesando la hora. No ponemos 0, ponemos la duración total.
    if (!this.preguntaActiva.fechaLanzamiento) {
      this.tiempoQuiz = this.preguntaActiva.duracion || 0;
      return; // Salimos y esperamos al siguiente tic del intervalo
    }
 
    // 4. CÁLCULO DEL TIEMPO REAL
    try {
      const inicioMs = this.preguntaActiva.fechaLanzamiento.toMillis();
      const finMs = inicioMs + (this.preguntaActiva.duracion * 1000);
      const ahoraMs = Date.now();
      
      // Diferencia en segundos
      const diff = Math.ceil((finMs - ahoraMs) / 1000);
 
      // 5. ASIGNACIÓN Y CIERRE
      if (diff <= 0) {
        this.tiempoQuiz = 0;
        clearInterval(this.intervaloReloj);
        this.intervaloReloj = null;
      } else {
        this.tiempoQuiz = diff;
      }
    } catch (e) {
      console.error("Error calculando el tiempo del Quiz:", e);
      // En caso de error de formato de fecha, mostramos la duración por defecto
      this.tiempoQuiz = this.preguntaActiva.duracion || 0;
    }
  };
 
  // Ejecución inmediata para evitar el retraso del primer segundo
  actualizarReloj();
  
  // Guardar el intervalo en la instancia
  this.intervaloReloj = setInterval(actualizarReloj, 1000);
},
 
 
    //resetear los estados 
   resetInteraccion() {
    if (this.intervaloReloj) {
    clearInterval(this.intervaloReloj);
    this.intervaloReloj = null;
  }

  if (this.exploreAutoSlideInterval) {
    clearInterval(this.exploreAutoSlideInterval);
    this.exploreAutoSlideInterval = null;
  }
  // NO pongas this.votoRealizado = false aquí a menos que sea estrictamente necesario
  this.indiceSeleccionado = null;
  this.indicesSeleccionados = [];
  this.comentario = '';
  this.listaOrdenable = [];
  this.ganadorLocal = false;
  this.confetiLanzado = false;
  this.loadingEnvio = false;
  this.puntosGanados = 0;
  this.respuestaCorrectaTexto = '';
  this.tiempoRestante = 0;
  this.indiceSeleccionado = null;
  
  
},
 
 
    //funciones para verificar si el usaurio es un usuario respondio correctamente al Quiz 
 
   
 
verificarResultadoQuiz() {
  // 1. Validaciones iniciales
  if (!this.preguntaActiva || !this.preguntaTieneRespuestaCorrecta(this.preguntaActiva) || this.proyectorConfig.modo !== 'resultados') {
    return;
  }
 
  const preguntaId = this.preguntaActiva.id;
  const respuestaCorrectaIndice = Number(this.preguntaActiva.respuestaCorrecta);
 
  // 2. INTENTO DE RECUPERACIÓN: Si el estado en memoria es null, buscamos en el storage
  if (this.indiceSeleccionado === null) {
    const indexGuardado = localStorage.getItem(`voted_index_${preguntaId}`);
    if (indexGuardado !== null) {
      this.indiceSeleccionado = parseInt(indexGuardado);
      this.votoRealizado = true; // Sincronizamos también este estado
    } else {
      // Si llegamos aquí en modo resultados y no hay nada en storage, es que no participó
      this.ganadorLocal = false;
      this.respuestaCorrectaTexto = this.preguntaActiva.opciones[respuestaCorrectaIndice] || 'No definida';
      return;
    }
  }
 
  // 3. LÓGICA DE GANADOR / PERDEDOR
  if (Number(this.indiceSeleccionado) === respuestaCorrectaIndice) {
    this.ganadorLocal = true;
    this.respuestaCorrectaTexto = this.preguntaActiva.opciones[respuestaCorrectaIndice];
    this.puntosGanados = this.preguntaActiva.puntos || 100;
    
    // Lanzar confeti solo una vez
    if (!this.confetiLanzado) {
       const jsConfetti = new JSConfetti();
       jsConfetti.addConfetti();
       this.confetiLanzado = true;
        setTimeout(() => {
        jsConfetti.addConfetti();
       }, 1500);
    }
  } else {
    this.ganadorLocal = false;
    this.respuestaCorrectaTexto = this.preguntaActiva.opciones[respuestaCorrectaIndice] || 'No definida';
  }
},
 
preguntaTieneRespuestaCorrecta(pregunta) {
  return !!pregunta && Array.isArray(pregunta.opciones) && pregunta.respuestaCorrecta !== null && pregunta.respuestaCorrecta !== undefined;
},
 
  lanzarConfettiVictoria() {
    const jsConfetti = new JSConfetti();
    jsConfetti.addConfetti({
      confettiRadius: 6,
      confettiNumber: 500,
      // Puedes mezclar colores corporativos aquí
      confettiColors: [this.proyectorConfig.color, '#ffffff', '#ff9800', '#46D68E'],
    });
  },
 
  getPuntosStorageKey() {
    return `uvoto_pts_${this.canalId || 'global'}`;
  },
 
  async guardarPuntosLocalmente(pts) {
    if (!this.runtimeConfig.gamificationEnabled) return;
    try {
      const userRef = doc(db, `canales/${this.canalId}/puntuaciones`, this.userId);
      await setDoc(userRef, {
        usuarioId: this.userId,
        nombre: this.nombreUsuario || 'Anónimo',
        foto: this.fotoUrl || this.computedAvatar || '',
        puntos: increment(pts),
        participaciones: increment(1),
        ultimaActividad: serverTimestamp()
      }, { merge: true });
      
      // También lo guardamos en localStorage por si acaso
      const storageKey = this.getPuntosStorageKey();
      const puntosActuales = parseInt(localStorage.getItem(storageKey) || 0);
      const totalPuntos = puntosActuales + pts;
      localStorage.setItem(storageKey, totalPuntos);
      this.puntosUsuario = totalPuntos;
    } catch (e) {
      console.error("Error guardando puntos:", e);
    }
  },
 
     esImagenBack(valor) {
    if (!valor) return false;
    // Verifica si es una URL (empieza con http, https o data:image)
    return /^(http|https|data:image)/.test(valor);
  },
 
 
  toggleSeleccionMultiple(index) {
    const max = this.preguntaActiva.config?.maxSeleccion || 0;
    const posicion = this.indicesSeleccionados.indexOf(index);
 
    if (posicion > -1) {
      // Si ya está, lo quitamos
      this.indicesSeleccionados.splice(posicion, 1);
    } else {
      // Si no está, verificamos el límite
      if (max === 0 || this.indicesSeleccionados.length < max) {
        this.indicesSeleccionados.push(index);
        if (navigator.vibrate) navigator.vibrate(10);
      } else {
        alert(`Solo puedes seleccionar hasta ${max} opciones`);
      }
    }
  },
 
 
  iniciarRelojUsuario() {
      if (this.userTimerInterval) clearInterval(this.userTimerInterval);
 
      this.userTimerInterval = setInterval(() => {
        // Leemos el estado directamente de la config del proyector capturada
        const estadoG = this.proyectorConfig?.ultimoConteo?.estado;
        
        if (this.tiempoRestante > 0 && estadoG === 'play') {
          this.tiempoRestante--;
        } else {
          clearInterval(this.userTimerInterval);
          this.userTimerInterval = null;
        }
      }, 1000);
    },
 
  formatTimer(segundos) {
    const min = Math.floor(segundos / 60);
    const seg = segundos % 60;
    return `${min}:${seg < 10 ? '0' : ''}${seg}`;
  },
 
  getContextoIAActivoId() {
    // Algunos proyectores solo tienen activeContextId anidado en contexto_ia
    // (nunca se espejó también a la raíz) — sin este fallback, el mensaje se
    // guardaba con contextoId vacío mientras el listener de la conversación
    // sí filtraba por el id real, y nunca coincidían: la respuesta llegaba
    // al servidor pero jamás aparecía en el chat ("está escribiendo" para
    // siempre).
    return String(
      this.proyectorConfig?.activeContextId || this.proyectorConfig?.contexto_ia?.activeContextId || ''
    ).trim();
  },

  getContextoIAActivoNombre() {
    return String(
      this.proyectorConfig?.activeContextName || this.proyectorConfig?.contexto_ia?.activeContextName || ''
    ).trim();
  },

  getContextoIAActivoTipo() {
  // Devuelve el kind real: event | brand | personal | product
  return this.activeContextKind;
},
 
  reiniciarChatIAPorContexto() {
    if (this.unsubConsultasIA) {
      this.unsubConsultasIA();
      this.unsubConsultasIA = null;
    }
    this.misConsultas = [];
    this.consultaPendienteLocal = null;
    this.selectedAiProfile = null;
    this.selectedAiImage = null;
    this.$nextTick(() => this.scrollChatToBottom());
  },

  async loginConGoogle() {
    this.loginLoading = 'google';
    this.loginError = null;
    try {
      const provider = new GoogleAuthProvider();
      let authResult;
      
      // Si el usuario es anónimo, vinculamos su cuenta para no perder sus datos
      if (auth.currentUser && auth.currentUser.isAnonymous) {
        try {
          authResult = await linkWithPopup(auth.currentUser, provider);
        } catch (linkError) {
          // Si el correo ya existe en Firebase, linkWithPopup falla.
          // En ese caso, iniciamos sesión normal (perderá lo anónimo, pero podrá entrar)
          if (linkError.code === 'auth/credential-already-in-use') {
            authResult = await signInWithPopup(auth, provider);
          } else {
            throw linkError;
          }
        }
      } else {
        authResult = await signInWithPopup(auth, provider);
      }
      
      const user = authResult.user;
      this.userId = user.uid;
      localStorage.setItem(this.sessionUserIdKey(this.canalId), user.uid);
      
      if (user.displayName) {
        this.nombreUsuario = user.displayName;
        localStorage.setItem('user_name', user.displayName);
      }
      if (user.photoURL) {
        this.fotoUrl = user.photoURL;
        localStorage.setItem('user_photo', user.photoURL);
      }

      this.mostrarModalLogin = false;
      this.loginLoading = false;
      
      if (this.brandSlugStatus === 'current') {
        await this.handleBrandClaimAfterLogin(user.uid);
      } else if (this.nuevaPregunta.trim()) {
        // Estaba en medio de una charla, enviamos su pregunta
        this.enviarPreguntaIA();
      }
    } catch (e) {
      console.error('Error Google Login:', e);
      this.loginError = 'No pudimos conectarnos con Google. Intenta de nuevo.';
      this.loginLoading = false;
    }
  },

  async loginConApple() {
    this.loginLoading = 'apple';
    this.loginError = null;
    try {
      const provider = new OAuthProvider('apple.com');
      let authResult;
      
      if (auth.currentUser && auth.currentUser.isAnonymous) {
        try {
          authResult = await linkWithPopup(auth.currentUser, provider);
        } catch (linkError) {
          if (linkError.code === 'auth/credential-already-in-use') {
            authResult = await signInWithPopup(auth, provider);
          } else {
            throw linkError;
          }
        }
      } else {
        authResult = await signInWithPopup(auth, provider);
      }
      
      const user = authResult.user;
      this.userId = user.uid;
      localStorage.setItem(this.sessionUserIdKey(this.canalId), user.uid);
      
      if (user.displayName) {
        this.nombreUsuario = user.displayName;
        localStorage.setItem('user_name', user.displayName);
      }
      
      this.mostrarModalLogin = false;
      this.loginLoading = false;
      
      if (this.brandSlugStatus === 'current') {
        await this.handleBrandClaimAfterLogin(user.uid);
      } else if (this.nuevaPregunta.trim()) {
        // Estaba en medio de una charla, enviamos su pregunta
        this.enviarPreguntaIA();
      }
    } catch (e) {
      console.error('Error Apple Login:', e);
      this.loginError = 'No pudimos conectarnos con Apple. Intenta de nuevo.';
      this.loginLoading = false;
    }
  },

  cerrarPanelConsultas() {
    this.mostrarModalPreguntas = false;
    this.stopVoiceRecording(true);
    this.activeVoicePlaybackId = null;
  },

  abrirPanelConsultas() {
    this.mostrarModalPreguntas = true;
    this.escucharMisConsultas();
    this.$nextTick(() => {
      this.scrollChatToBottom();
      this.autoResizeChatTextarea();
    });
  },

  getSpeechRecognitionConstructor() {
    if (typeof window === 'undefined') return null;
    return window.SpeechRecognition || window.webkitSpeechRecognition || null;
  },

  normalizarIdiomaNavegador() {
    const selected = String(this.selectedLanguage || '').trim().toLowerCase();
    if (selected === 'es') return 'es-CO';
    if (selected === 'pt') return 'pt-BR';
    if (selected === 'en') return 'en-US';

    const lang = String(navigator?.language || 'es-CO').trim();
    if (/^es/i.test(lang)) return 'es-CO';
    if (/^pt/i.test(lang)) return 'pt-BR';
    if (/^en/i.test(lang)) return 'en-US';
    return lang;
  },

  async toggleVoiceRecording() {
    if (this.isRecordingVoice) {
      this.stopVoiceRecording();
      return;
    }
    await this.startVoiceRecording();
  },

  async startVoiceRecording() {
    if (!this.runtimeConfig.qnaEnabled || this.loadingEnvio || this.voiceUploading) return;

    if (!navigator.mediaDevices?.getUserMedia) {
      alert('Tu navegador no soporta grabación de audio.');
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const preferredMimeType = typeof MediaRecorder !== 'undefined' && MediaRecorder.isTypeSupported('audio/webm;codecs=opus')
        ? 'audio/webm;codecs=opus'
        : '';
      const recorder = preferredMimeType
        ? new MediaRecorder(stream, { mimeType: preferredMimeType })
        : new MediaRecorder(stream);

      this.voiceRecorderStream = stream;
      this.voiceRecorder = recorder;
      this.voiceRecorderChunks = [];
      // Preservar texto ya escrito en el textarea como punto de partida
      const textoExistente = String(this.nuevaPregunta || '').trim();
      this.voiceTranscriptDraft = textoExistente;
      this._voiceAccumulatedTranscript = textoExistente;
      this.voiceRecordingStartedAt = Date.now();
      this.isRecordingVoice = true;

      // Iniciar contador visual
      this._recordingInterval = setInterval(() => {
        const ms = Date.now() - this.voiceRecordingStartedAt;
        const totalSec = Math.floor(ms / 1000);
        const min = Math.floor(totalSec / 60);
        const sec = totalSec % 60;
        this.recordingDurationFormatted = `${min}:${sec.toString().padStart(2, '0')}`;
      }, 500);

      recorder.ondataavailable = (event) => {
        if (event?.data?.size) {
          this.voiceRecorderChunks.push(event.data);
        }
      };

      recorder.onstop = () => {
        this.finalizeVoiceRecording();
      };

      // SpeechRecognition is optional — audio recording works without it
      const SpeechRecognition = this.getSpeechRecognitionConstructor();
      if (SpeechRecognition) {
        const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
        const recognition = new SpeechRecognition();
        
        // 🔥 FORZAR ESPAÑOL como prioridad para evitar detección errónea de portugués
        const langBase = this.normalizarIdiomaNavegador();
        recognition.lang = langBase.startsWith('es') ? langBase : 'es-CO';
        
        recognition.continuous = !isMobile;
        recognition.interimResults = true;
        this.voiceRecognitionShouldRestart = true;

        recognition.onresult = (event) => {
          let sessionTranscript = '';
          for (let i = 0; i < event.results.length; i += 1) {
            sessionTranscript += `${event.results[i][0]?.transcript || ''} `;
          }
          // Combine previously confirmed words + current session interim results
          this.voiceTranscriptDraft = ((this._voiceAccumulatedTranscript || '') + ' ' + sessionTranscript).trim();
          // ✅ Mostrar en tiempo real en el textarea mientras el usuario habla
          this.nuevaPregunta = this.voiceTranscriptDraft;
        };

        recognition.onend = () => {
          // Si ya se solicitó detener, NO reiniciar — finalizeVoiceRecording se llamará desde stopVoiceRecording
          if (!this.voiceRecognitionShouldRestart) return;
          // Guardar transcript confirmado antes de reiniciar
          if (this.voiceTranscriptDraft) {
            this._voiceAccumulatedTranscript = this.voiceTranscriptDraft;
          }
          // Solo reiniciar si todavía estamos grabando
          if (this.isRecordingVoice) {
            try {
              recognition.start();
            } catch (error) {
              console.warn('No pudimos reiniciar el reconocimiento de voz:', error);
            }
          }
        };

        recognition.onerror = (event) => {
          // 'no-speech' is expected during pauses — not a real error
          if (event.error !== 'no-speech') {
            console.warn('SpeechRecognition error:', event.error);
          }
        };

        this.voiceRecognition = recognition;
        try {
          recognition.start();
        } catch (e) {
          console.warn('SpeechRecognition no disponible en este navegador:', e);
          this.voiceRecognition = null;
        }
      }

      recorder.start();
      this.$nextTick(() => this.scrollChatToBottom());
    } catch (error) {
      console.error('Error iniciando nota de voz:', error);
      this.stopVoiceRecording(true);
      alert('No pudimos iniciar la nota de voz en este momento.');
    }
  },

  stopVoiceRecording(silent = false) {
    this.voiceRecognitionShouldRestart = false;

    // ✅ Guardar transcripción AHORA de forma síncrona — no esperar a recognition.onend.
    // En iOS/mobile onend es poco confiable y puede dispararse vacío o no dispararse.
    if (this.voiceTranscriptDraft) {
      this._voiceAccumulatedTranscript = this.voiceTranscriptDraft;
    }

    // Detener el reconocimiento de voz (fire-and-forget — ya guardamos el transcript)
    if (this.voiceRecognition) {
      // Limpiar handlers para evitar que eventos tardíos sobreescriban el transcript
      this.voiceRecognition.onend = null;
      this.voiceRecognition.onresult = null;
      this.voiceRecognition.onerror = null;
      try { this.voiceRecognition.stop(); } catch (_) {}
      this.voiceRecognition = null;
    }

    if (this._recordingInterval) {
      clearInterval(this._recordingInterval);
      this._recordingInterval = null;
    }

    this.isRecordingVoice = false;

    // Detener la grabación → onstop → finalizeVoiceRecording (que pone el transcript en el textarea)
    if (this.voiceRecorder && this.voiceRecorder.state !== 'inactive') {
      try {
        this.voiceRecorder.stop();
      } catch (error) {
        if (!silent) console.warn('No pudimos detener la grabación de voz:', error);
        this.finalizeVoiceRecording();
      }
    } else {
      this.finalizeVoiceRecording();
    }
  },

  finalizeVoiceRecording() {
    if (this._isFinalizingVoice) return;
    this._isFinalizingVoice = true;

    if (this.voiceRecorderStream) {
      this.voiceRecorderStream.getTracks().forEach((track) => track.stop());
      this.voiceRecorderStream = null;
    }

    this.voiceRecorder = null;
    this.voiceRecorderChunks = [];
    this.voiceRecognition = null;

    const finalTranscript = String(
      this._voiceAccumulatedTranscript || this.voiceTranscriptDraft || ''
    ).trim();

    // Colocar la transcripción en el textarea y dar foco
    if (finalTranscript) {
      this.nuevaPregunta = finalTranscript;
      this.$nextTick(() => {
        const el = this.$refs.chatTextarea;
        if (el) {
          el.style.height = 'auto';
          el.style.height = `${Math.min(el.scrollHeight, 160)}px`;
          el.focus();
        }
      });
    }

    this.voiceTranscriptDraft = '';
    this._voiceAccumulatedTranscript = '';
    this.voiceRecordingStartedAt = 0;
    this.recordingDurationFormatted = '0:00';
    this.isTranscribingVoice = false;
    this._isFinalizingVoice = false;
    this.$nextTick(() => this.scrollChatToBottom());
  },


  escucharMisConsultas() {
    if (this.unsubConsultasIA) {
      this.unsubConsultasIA();
      this.unsubConsultasIA = null;
    }
 
    if (!this.canalId || !this.userId) {
      this.misConsultas = [];
      return;
    }

    this.misConsultas = [];
 
    const contextoId = this.getContextoIAActivoId();
    const consultasRef = collection(db, `canales/${this.canalId}/consultas_ia`);
    const q = contextoId
      ? query(
          consultasRef,
          where("usuarioId", "==", this.userId),
          where("contextoId", "==", contextoId),
          orderBy("fecha", "asc")
        )
      : query(
          consultasRef,
          where("usuarioId", "==", this.userId),
          orderBy("fecha", "asc")
        );
 
    // Track which item IDs already had a response so we can detect newly answered ones
    const yaRespondidos = new Set();
    let esApertura = true;

    this.unsubConsultasIA = onSnapshot(q, (snap) => {
      const nuevas = snap.docs.map((docSnap) => this.normalizarConsultaIA(docSnap));

      if (this.consultaPendienteLocal) {
        const encontrada = nuevas.some((item) => item.clientTempId === this.consultaPendienteLocal.clientTempId);
        if (encontrada) {
          if (this.consultaPendienteLocal.audioUrl && /^blob:/.test(this.consultaPendienteLocal.audioUrl)) {
            URL.revokeObjectURL(this.consultaPendienteLocal.audioUrl);
          }
          this.consultaPendienteLocal = null;
        }
      }

      // Detect items that just received a response (not in initial load)
      if (!esApertura) {
        for (const item of nuevas) {
          // Si el item ya tiene respuesta y no lo hemos procesado aún ni está en revealState
          if (this.consultaTieneRespuesta(item) && !yaRespondidos.has(item.id) && !this.revealState[item.id]) {
            this.iniciarRevealMensaje(item);
          }
        }
      }

      this.misConsultas = nuevas;

      // Si algún mensaje tiene bloque booking, recargar slots tomados
      const hayBooking = nuevas.some(item =>
        Array.isArray(item.respuestaUI?.blocks) && item.respuestaUI.blocks.some(b => b?.type === 'booking')
      );
      if (hayBooking) this.cargarSlotsTomados();

      // Mark all currently answered items as known
      for (const item of nuevas) {
        if (this.consultaTieneRespuesta(item)) yaRespondidos.add(item.id);
      }

      this.$nextTick(() => {
        // Only auto-scroll to bottom when not in the middle of a reveal sequence
        const hayReveal = Object.values(this.revealState).some(
          (s) => s.phase === 'sent' || s.phase === 'typing' || s.phase === 'typing-between' || s.phase === 'revealing'
        );
        if (!hayReveal) this.scrollChatToBottom();
      });
      
      esApertura = false;
    });
  },
 
async enviarPreguntaIA() {
  if (!this.runtimeConfig.qnaEnabled) return;
  if (this.loadingEnvio || this.voiceUploading) return;

  const promptUsuario = String(this.nuevaPregunta || '').trim();
  if (!promptUsuario) return;

  // 1. Validar Canal ID (Crítico para la ruta de Firestore)
  if (!this.canalId) {
    console.warn('[Uvoto] CanalId no detectado, intentando recuperar...');
    if (this.isChatOnlyMode) {
      const slug = String(this.$route?.params?.slug || '').trim();
      if (slug) {
        try {
          const destino = await resolverShortLinkCompartido(slug);
          if (destino?.canalId) this.canalId = destino.canalId;
        } catch (e) { console.error("[Uvoto] Error recuperando canalId:", e); }
      }
    }
  }

  if (!this.canalId) {
    console.error('[Uvoto] Error: No hay un canalId activo. No se puede enviar el mensaje.');
    return;
  }

  // 2. Garantizar que hay un usuario Firebase autenticado antes de escribir en Firestore.
  if (!auth.currentUser) {
    console.log('[Uvoto] Sin sesión, iniciando sesión anónima...');
    await this.getOrCreateSessionUserId(this.canalId);
  }

  if (!auth.currentUser) {
    console.error('[Uvoto] Error: No hay sesión Firebase activa — el navegador podría estar bloqueando cookies de terceros.');
    return;
  }

  const clientTempId = `local_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const contextoId = this.getContextoIAActivoId();
  const contextoNombre = this.getContextoIAActivoNombre();
  const contextoKind = this.getContextoIAActivoTipo();
  this.nuevaPregunta = '';
  this.loadingEnvio = true;
  this.consultaPendienteLocal = {
    id: clientTempId,
    clientTempId,
    texto: promptUsuario,
    audioUrl: '',
    audioDurationMs: 0,
    fecha: new Date()
  };
  this.$nextTick(() => this.scrollChatToBottom());
 
  try {
    const ahora = new Date();
    const ultimaConsulta = (this.misConsultas || []).slice(-1)[0] || null;
    const ultimoPayload = ultimaConsulta ? this.getAiPayload(ultimaConsulta) : null;
    const ultimoFollowUp = String(ultimoPayload?.followUp || '').trim();
    const ultimoAnswer = String(ultimoPayload?.answer || ultimaConsulta?.respuesta || '').trim();
    const ultimoFollowUpFuePregunta = /[?¿]/.test(ultimoFollowUp);
    const preguntaIA = ultimoFollowUpFuePregunta ? ultimoFollowUp : '';
    const respuestaBreve = [
      'si', 'sí', 'si por favor', 'sí por favor', 'dale', 'ok', 'okay', 'claro',
      'por favor', 'me gusta', 'me encantó', 'me encanto', 'me encanta',
      'qué buena idea', 'que buena idea', 'qué chévere', 'que chevere',
      'qué brutal', 'que brutal', 'qué locura', 'que locura', 'suena bien',
      'suena brutal', 'está buenísimo', 'esta buenisimo', 'está brutal',
      'esta brutal', 'genial', 'de una'
    ].includes(promptUsuario.toLowerCase());
    
    const historialSemantico = (this.misConsultas || [])
      .slice(-4)
      .flatMap((m) => {
        const payload = this.getAiPayload(m);
        const fechaBase = m.fecha || ahora;
        const turns = [];
        if (m.texto) {
          turns.push({ rol: 'usuario', contenido: m.texto, timestamp: fechaBase });
        }
        const respuestaAsistente = payload?.answer || m.respuesta || '';
        if (respuestaAsistente) {
          turns.push({ rol: 'asistente', contenido: respuestaAsistente, timestamp: fechaBase });
        }
        return turns;
      });

    // 3. Determinar la API Key — solo si llegó desde el frame padre (embed real).
    // NO usar proyectorConfig.embedApiKey: si el projector tiene una key configurada pero
    // el canal tiene una diferente, Firestore rechaza la escritura (permission-denied).
    const resolvedApiKey = this.embedApiKey ? String(this.embedApiKey).trim() : '';
    const hasPageContext = !!this.embedPageContext;

    // usuarioId debe coincidir EXACTO con el UID que usa escucharMisConsultas
    // para su query (this.userId) — si acá se usa auth.currentUser.uid en su
    // lugar y en el medio hubo una re-autenticación silenciosa (nueva sesión
    // anónima), ambos IDs divergen: el mensaje se guarda con un UID distinto
    // al que el listener está escuchando y la respuesta nunca llega al
    // cliente aunque el servidor sí la haya generado — se queda pegado en
    // "está escribiendo" para siempre.
    const usuarioIdEnvio = this.userId || auth.currentUser.uid;

    console.log(`[Uvoto] Enviando a Firestore: canales/${this.canalId}/consultas_ia`, {
      uid: usuarioIdEnvio,
      key: resolvedApiKey ? 'PRESENT' : 'MISSING',
      hasPageContext
    });

    if (hasPageContext) {
      console.log('[Uvoto] Contexto de página detectado:', this.embedPageContext.title);
    }

    await addDoc(collection(db, `canales/${this.canalId}/consultas_ia`), {
      usuarioId: usuarioIdEnvio,
      nombre: this.nombreUsuario || 'Invitado',
      texto: promptUsuario,
      audioUrl: '',
      audioDurationMs: 0,
      inputMode: 'text',
      respuesta: null,
      clientTempId,
      contextoId,
      contextoNombre,
      fecha: serverTimestamp(),
      estado: 'pendiente',
      ...(resolvedApiKey ? { embedApiKey: resolvedApiKey } : {}),
      metadata: {
        timestamp: ahora.getTime(),
        reloj: ahora.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
        modoActual: this.proyectorConfig?.modo || 'standard',
        idPreguntaVisible: this.proyectorConfig?.preguntaActivaId || 'ninguna',
        nombreSesion: this.tituloVisibleSesionUsuario || 'Sesión sin nombre',
        contextoId,
        contextoNombre,
        contextoKind,
        historial: historialSemantico,
        preguntaIA,
        ultimoAnswer,
        respuestaBreve,
        haySeguimientoPendiente: !!preguntaIA,
        ultimoFollowUp,
        ultimoFollowUpFuePregunta,
        inputMode: 'text',
        ...(this.embedPageContext
          ? (() => {
              const ctx = this.embedPageContext;
              const pageCtx = {
                url: ctx.url || '',
                title: ctx.title || '',
                productName: ctx.productName || '',
                description: ctx.description || '',
                mainText: ctx.mainText || '',
                price: ctx.price || '',
                brand: ctx.brand || '',
                type: ctx.type || '',
              };
              if (ctx.image) pageCtx.image = ctx.image;
              return { pageContext: pageCtx };
            })()
          : {}
        )
      }
    });

    // Track engagement counters — fire-and-forget (Admin SDK bypasses these rules on CF side)
    try {
      const canalRef = doc(db, 'canales', this.canalId);
      const statsUpdate = { messagesCount: increment(1) };
      if (!this.conversationTracked) {
        this.conversationTracked = true;
        statsUpdate.conversationsCount = increment(1);
      }
      await updateDoc(canalRef, statsUpdate);
    } catch (_) {}

    this.$nextTick(() => this.scrollChatToBottom());
 
  } catch (e) {
    this.consultaPendienteLocal = null;
    console.error("[Uvoto] ERROR CRÍTICO AL ENVIAR:", {
      error: e.message,
      code: e.code,
      canalId: this.canalId,
      apiKey: this.embedApiKey,
      uid: auth.currentUser?.uid
    });
    alert("No se pudo enviar el mensaje. Error: " + (e.code || e.message));
  } finally {
    this.loadingEnvio = false;
    this.voiceUploading = false;
  }
},
 
  extractJsonStringField(raw = '', fieldName = 'answer') {
    const source = String(raw || '');
    if (!source) return '';
    const fieldToken = `"${fieldName}"`;
    const fieldIndex = source.indexOf(fieldToken);
    if (fieldIndex === -1) return '';
    const nextFieldCandidates = {
      answer: ['followUp', 'conversationIntent', 'isOffTopic', 'adminNeedsContext', 'blocks'],
      followUp: ['conversationIntent', 'isOffTopic', 'adminNeedsContext', 'blocks'],
      conversationIntent: ['isOffTopic', 'adminNeedsContext', 'blocks']
    }[fieldName] || [];

    let cursor = fieldIndex + fieldToken.length;
    while (cursor < source.length && /\s/.test(source[cursor])) cursor += 1;
    if (source[cursor] !== ':') return '';
    cursor += 1;
    while (cursor < source.length && /\s/.test(source[cursor])) cursor += 1;
    if (source[cursor] !== '"') return '';
    cursor += 1;

    if (nextFieldCandidates.length) {
      const nextIndexes = nextFieldCandidates
        .map((nextField) => source.indexOf(`"${nextField}"`, cursor))
        .filter((index) => index > cursor)
        .sort((a, b) => a - b);
      if (nextIndexes.length) {
        return source
          .slice(cursor, nextIndexes[0])
          .replace(/",?\s*$/, '')
          .replace(/\\"/g, '"')
          .replace(/\\n/g, '\n')
          .replace(/\\\\/g, '\\')
          .trim();
      }
    }

    let result = '';
    let escaped = false;
    for (; cursor < source.length; cursor += 1) {
      const char = source[cursor];
      if (escaped) {
        result += char;
        escaped = false;
        continue;
      }
      if (char === '\\') {
        escaped = true;
        result += char;
        continue;
      }
      if (char === '"') break;
      result += char;
    }

    return result
      .replace(/\\"/g, '"')
      .replace(/\\n/g, '\n')
      .replace(/\\\\/g, '\\')
      .trim();
  },

  parseAiPayload(value) {
    if (!value) return null;
    if (typeof value === 'object') return value;
    if (typeof value !== 'string') return null;
 
    const raw = value.trim();
    if (!raw) return null;
 
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
      const start = raw.indexOf('{');
      const end = raw.lastIndexOf('}');
      if (start !== -1 && end > start) {
        const candidate = raw.slice(start, end + 1);
        try {
          const parsed = JSON.parse(candidate);
          return parsed && typeof parsed === 'object' ? parsed : null;
        } catch (nestedError) {
          const answer = this.extractJsonStringField(candidate, 'answer');
          const followUp = this.extractJsonStringField(candidate, 'followUp');
          if (answer) {
            return {
              answer,
              followUp,
              blocks: []
            };
          }
          return null;
        }
      }
      return null;
    }
  },
 
  normalizarConsultaIA(docSnap) {
    const data = docSnap.data ? docSnap.data() : (docSnap || {});
    const payload = this.parseAiPayload(data?.respuestaUI)
      || this.parseAiPayload(data?.respuestaEstructurada)
      || this.parseAiPayload(data?.respuesta)
      || null;
    const respuestaTexto = this.cleanAiText(payload?.answer || data?.respuesta || '');
 
    return {
      id: docSnap.id || data?.id || `consulta_${Date.now()}`,
      ...data,
      respuesta: respuestaTexto || '',
      respuestaUI: payload || data?.respuestaUI || data?.respuestaEstructurada || null,
      audioUrl: String(data?.audioUrl || '').trim(),
      audioDurationMs: Number(data?.audioDurationMs || 0) || 0,
      inputMode: String(data?.inputMode || data?.metadata?.inputMode || 'text').trim()
    };
  },
 
  getAiPayload(item) {
    return this.parseAiPayload(item?.respuestaUI)
      || this.parseAiPayload(item?.respuestaEstructurada)
      || this.parseAiPayload(item?.respuesta)
      || null;
  },
 
  cleanAiText(texto) {
    const cleaned = String(texto || '')
      .replace(/^\s*\{[\s\S]*?"answer"\s*:\s*"/i, '')
      .replace(/",\s*"followUp"[\s\S]*$/i, '')
      .replace(/\\"/g, '"')
      .replace(/\\n/g, '\n')
      .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '$1')
      .replace(/https?:\/\/[^\s]+/g, '')
      .replace(/\*\*(.*?)\*\*/g, '$1')
      .replace(/^\s*[-*]\s+/gm, '')
      .replace(/\n{3,}/g, '\n\n')
      .replace(/^(¡?\s*hola!?[\s,.:-]*)+/i, '')
      .replace(/^(claro que sí|claro|sí, claro)[!,.:\s-]*/i, 'Sí. ')
      .replace(/^(entiendo que te interesa[^.]*\.\s*)/i, '')
      .replace(/^(seg[uú]n (el texto|la informaci[oó]n proporcionada|lo que compartiste|lo que explicas)[^.,:]*[.,:\s-]*)/i, '')
      .replace(/^(based on (the text|the information provided|what you shared)[^.,:]*[.,:\s-]*)/i, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
    if (!cleaned) return '';
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  },
 
  getAiAnswer(item) {
    const payload = this.getAiPayload(item);
    if (payload?.answer) {
      return this.cleanAiText(payload.answer);
    }
    const raw = String(item?.respuesta || '').trim();
    if (raw.startsWith('{') || raw.startsWith('[')) {
      return '';
    }
    return this.cleanAiText(raw);
  },
 
  getAiFollowUp(item) {
    const payload = this.getAiPayload(item);
    return this.cleanAiText(payload?.followUp || '');
  },

  getFollowUpSlot(item) {
    const answer = this.getAiAnswer(item);
    const blocks = this.getAiBlocks(item);
    return (answer ? 1 : 0) + blocks.length + 1;
  },

  enviarStarter(texto) {
    if (!texto || this.loadingEnvio) return;
    this.nuevaPregunta = texto;
    this.$nextTick(() => this.enviarPreguntaIA());
  },

  consultaTieneRespuesta(item) {
    const payload = this.getAiPayload(item);
    const answer = this.getAiAnswer(item);
    const followUp = this.getAiFollowUp(item);
    const blocks = this.getAiBlocks(item);
    const estado = String(item?.estado || '').trim().toLowerCase();
    return !!(
      answer
      || followUp
      || (Array.isArray(blocks) && blocks.length)
      || ['respondida', 'respondido', 'resuelta', 'resuelto', 'no_requerida'].includes(estado)
    );
  },
 
  getUserBubbleStyle() {
    const branding = String(this.proyectorConfig?.Branding || this.proyectorConfig?.BrandingActual || '').trim();
    const fallback = '#6366f1';
    const colorFallback = String(this.proyectorConfig?.color || '').trim();
    const source = branding || colorFallback || fallback;
    const normalized = source.toLowerCase();
    const isImage = /^https?:\/\//i.test(source) || /\.(png|jpe?g|webp|gif|svg)(\?|$)/i.test(source);
    const isWhiteLike = /(^|\s)(#fff|#ffffff|white)(\s|$)|255\s*,\s*255\s*,\s*255/i.test(normalized);
    const background = !isImage && !isWhiteLike ? source : (colorFallback && !/(^|\s)(#fff|#ffffff|white)(\s|$)|255\s*,\s*255\s*,\s*255/i.test(colorFallback.toLowerCase()) ? colorFallback : fallback);
 
    return {
      background,
      color: '#ffffff',
      boxShadow: 'none'
    };
  },
 
  getAiBlocks(item) {
    const payload = this.getAiPayload(item);
    const blocks = Array.isArray(payload?.blocks)
      ? payload.blocks
          .filter((block) => block?.type !== 'note')
          .filter((block) => !/notas? estratégicas?/i.test(block?.title || ''))
          .filter((block) => block?.type === 'booking' || (Array.isArray(block?.items) ? block.items.length : true))
          .map((block) => this.normalizeAiPresentationBlock(this.sanitizeAiBlock(block)))
      : [];
    return blocks;
  },

  // Returns normalized image URL array for a product block item
  toggleDesc(key) {
    this.expandedDescriptions = { ...this.expandedDescriptions, [key]: !this.expandedDescriptions[key] };
  },
  formatAiPrice(raw = '') {
    const str = String(raw || '').trim();
    if (!str) return '';
    // Extract currency symbol or code (leading or trailing)
    const currencyMatch = str.match(/^([€$£¥₩₹])|([A-Z]{2,4})$/);
    const leading = currencyMatch?.[1] || '';
    const trailing = currencyMatch?.[2] || '';
    // Remove trailing .00 or ,00 (zero cents)
    const cleaned = str.replace(/[.,]00\b/, '').trim();
    return cleaned;
  },
  aiProductImages(product = {}) {
    if (Array.isArray(product.imageUrls) && product.imageUrls.length) {
      return product.imageUrls.map((u) => String(u || '').trim()).filter(Boolean);
    }
    const single = String(product.imageUrl || '').trim();
    return single ? [single] : [];
  },

  // Returns normalized image URL array for a service block item
  aiServiceImages(service = {}) {
    if (Array.isArray(service.imageUrls) && service.imageUrls.length) {
      return service.imageUrls.map((u) => String(u || '').trim()).filter(Boolean);
    }
    const single = String(service.imageUrl || '').trim();
    return single ? [single] : [];
  },

  // Returns CSS modifier class for service card based on image count
  aiServiceCardClass(service = {}) {
    const count = this.aiServiceImages(service).length;
    if (count === 0) return 'ai-service-card--no-img';
    if (count === 1) return 'ai-service-card--single';
    return 'ai-service-card--gallery';
  },
 
  normalizeBlockItems(block) {
    if (Array.isArray(block?.items) && block.items.length) return block.items;
    if (block?.text) return [{ title: block.text }];
    return [];
  },
 
  sanitizeAiBlock(block) {
    return {
      ...block,
      title: this.cleanAiText(block?.title || ''),
      items: (block?.items || []).map((entry) => ({
        ...entry,
        linkUrl: String(entry?.linkUrl || entry?.url || entry?.fileUrl || entry?.downloadUrl || '').trim(),
        title: this.cleanAiText(entry?.title || ''),
        subtitle: this.cleanAiText(entry?.subtitle || ''),
        meta: this.cleanAiText(entry?.meta || '')
      }))
    };
  },

  normalizeAiPresentationBlock(block) {
    if (block?.type !== 'people') return block;
    const items = Array.isArray(block?.items) ? block.items.filter((item) => String(item?.imageUrl || '').trim()) : [];
    if (items.length !== 1) return block;
    const image = items[0];
    return {
      type: 'gallery',
      title: block?.title || '',
      items: [
        {
          ...image,
          title: image.title || block?.title || '',
          subtitle: image.subtitle || '',
          meta: image.meta || 'Imagen relacionada'
        }
      ]
    };
  },
 
  inferAiBlocksFromAnswer(item) {
    return [];
  },
 
  openAiPersonProfile(person) {
    this.selectedAiProfile = person || null;
  },
 
  closeAiPersonProfile() {
    this.selectedAiProfile = null;
  },

  openAiContextImage(image) {
    this.chatAbiertoAntesDeGaleria = this.mostrarModalPreguntas;
    this.mostrarModalPreguntas = false;
    this.selectedAiImage = image?.imageUrl ? image : null;
    this.selectedAiGallery = [];
  },

  openAiContextGallery(images, startImage) {
    this.galleryLoadedMap = {};
    if (!images || !images.length) return;
    const filtered = images.filter(img => img.imageUrl);
    // Usamos la URL para encontrar el índice, ya que la referencia directa puede fallar con Proxies
    const index = filtered.findIndex(img => img.imageUrl === startImage?.imageUrl || img === startImage);

    this.chatAbiertoAntesDeGaleria = this.mostrarModalPreguntas;
    this.mostrarModalPreguntas = false;
    this.selectedAiGallery = filtered;
    this.selectedAiGalleryIndex = index >= 0 ? index : 0;
    // Fallback para componentes que aún busquen selectedAiImage
    this.selectedAiImage = filtered[this.selectedAiGalleryIndex];
  },

  selectBookingSlot(blockKey, slot) {
    this.bookingState = {
      ...this.bookingState,
      [blockKey]: { ...this.bookingState[blockKey], selectedSlot: slot, nombre: this.nombreUsuario || '', telefono: '' }
    };
  },
  changeBookingSlot(blockKey) {
    const current = this.bookingState[blockKey] || {};
    this.bookingState = { ...this.bookingState, [blockKey]: { ...current, selectedSlot: null } };
  },
  // Por defecto, apenas el usuario elige un horario le mostramos un botón de
  // WhatsApp con un mensaje ya armado para que pueda confirmar directo con el
  // dueño — además del registro interno (confirmarAgendamiento) que ya
  // notifica al admin. No reemplaza el formulario, es una ruta adicional.
  getBookingWhatsAppLink(blockKey) {
    const slot = this.bookingState[blockKey]?.selectedSlot;
    if (!slot) return '';
    const rawWhatsapp = String(this.activeContextBusinessBasics?.channels?.whatsapp || '').trim();
    if (!rawWhatsapp) return '';
    const waBase = /^https?:\/\//i.test(rawWhatsapp)
      ? rawWhatsapp.split('?')[0]
      : `https://wa.me/${rawWhatsapp.replace(/\D/g, '')}`;
    const nombreMarca = this.tituloVisibleSesionUsuario || this.proyectorConfig?.nombreSesion || '';
    const lang = this.selectedLanguage || 'es';
    const mensaje = lang === 'en'
      ? `Hi! I'd like to confirm my appointment for ${slot.label}${nombreMarca ? ` with ${nombreMarca}` : ''}.`
      : lang === 'pt'
        ? `Oi! Gostaria de confirmar meu horário para ${slot.label}${nombreMarca ? ` com ${nombreMarca}` : ''}.`
        : `¡Hola! Quiero confirmar mi cita para ${slot.label}${nombreMarca ? ` con ${nombreMarca}` : ''}.`;
    return `${waBase}?text=${encodeURIComponent(mensaje)}`;
  },
  async confirmarAgendamiento(blockKey, consultaId, servicioNombre) {
    const state = this.bookingState[blockKey] || {};
    if (!state.selectedSlot || !String(state.nombre || '').trim()) return;
    this.bookingState = { ...this.bookingState, [blockKey]: { ...state, loading: true } };
    try {
      const functions = getFunctions();
      const fn = httpsCallable(functions, 'confirmarAgendamiento');
      const result = await fn({
        canalId: this.canalId,
        fecha: state.selectedSlot.fecha,
        hora: state.selectedSlot.hora,
        nombre: String(state.nombre || '').trim(),
        telefono: String(state.telefono || '').trim(),
        servicioNombre: String(servicioNombre || '').trim(),
        consultaId: String(consultaId || ''),
        blockKey: String(blockKey || ''),
        esAnonimo: !this.userId
      });
      const confirmed = { confirmed: true, agendamientoId: result.data?.agendamientoId, selectedSlot: state.selectedSlot };
      this.bookingState = { ...this.bookingState, [blockKey]: { ...state, loading: false, ...confirmed } };
      this.saveBookingLocal(blockKey, confirmed);
    } catch (e) {
      console.error('Error confirmando agendamiento:', e);
      const code = String(e?.code || e?.details?.code || '');
      const slotOcupado = code.includes('already-exists') || String(e?.message || '').includes('ya no está disponible');
      this.bookingState = {
        ...this.bookingState,
        [blockKey]: { ...state, loading: false, selectedSlot: slotOcupado ? null : state.selectedSlot, error: slotOcupado ? 'Este horario ya no está disponible. Por favor elige otro.' : 'Error al confirmar. Intenta de nuevo.' }
      };
    }
  },
  async cargarSlotsTomados() {
    if (!this.canalId) return;
    try {
      const hoy = new Date().toISOString().split('T')[0];
      const en15 = new Date(); en15.setDate(en15.getDate() + 15);
      const en15Str = en15.toISOString().split('T')[0];
      // Lee de /disponibilidad — colección pública sin PII (solo fecha/hora)
      const snap = await getDocs(query(
        collection(db, `canales/${this.canalId}/disponibilidad`),
        where('fecha', '>=', hoy),
        where('fecha', '<=', en15Str),
        limit(200)
      ));
      const tomados = new Set();
      snap.forEach(d => {
        const s = d.data();
        if (s.fecha && s.hora) tomados.add(`${s.fecha}|${s.hora}`);
      });
      this.slotsTomados = tomados;
    } catch (e) { console.warn('cargarSlotsTomados error:', e); }
  },
  saveBookingLocal(blockKey, data) {
    try {
      const stored = JSON.parse(localStorage.getItem(`uvoto_bookings_${this.canalId}`) || '{}');
      stored[blockKey] = data;
      localStorage.setItem(`uvoto_bookings_${this.canalId}`, JSON.stringify(stored));
    } catch (_) {}
  },
  loadPersistedBookings() {
    if (!this.canalId) return;
    // localStorage (rápido, funciona sin auth)
    try {
      const stored = JSON.parse(localStorage.getItem(`uvoto_bookings_${this.canalId}`) || '{}');
      if (Object.keys(stored).length) this.bookingState = { ...this.bookingState, ...stored };
    } catch (_) {}
    // Firestore (persiste entre dispositivos para usuarios con auth)
    this.loadBookingsFirestore();
    // Escucha próxima cita en tiempo real
    this.subscribeProximaCita();
  },
  async loadBookingsFirestore() {
    if (!this.canalId || !this.userId) return;
    try {
      // Sin operadores != ni orderBy para evitar índices compuestos — filtramos cliente
      const snap = await getDocs(query(
        collection(db, `canales/${this.canalId}/agendamientos`),
        where('usuarioId', '==', this.userId),
        limit(30)
      ));
      const merged = {};
      snap.forEach((d) => {
        const ag = d.data();
        if (ag.estado === 'cancelado') return;
        const bk = ag.blockKey || `${ag.consultaId}_0`;
        if (bk) merged[bk] = { confirmed: true, agendamientoId: d.id, selectedSlot: { fecha: ag.fecha, hora: ag.hora, label: `${ag.fecha} ${ag.hora}` } };
      });
      if (Object.keys(merged).length) this.bookingState = { ...this.bookingState, ...merged };
    } catch (e) { console.warn('loadBookingsFirestore error:', e); }
  },
  subscribeProximaCita() {
    if (this.unsubProximaCita) { this.unsubProximaCita(); this.unsubProximaCita = null; }
    if (!this.canalId || !this.userId) return;
    try {
      // Query simple por usuarioId — sin orderBy ni >= para no requerir índice compuesto
      const q = query(
        collection(db, `canales/${this.canalId}/agendamientos`),
        where('usuarioId', '==', this.userId),
        limit(20)
      );
      this.unsubProximaCita = onSnapshot(q, (snap) => {
        const hoy = new Date().toISOString().split('T')[0];
        const upcoming = snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .filter(a => a.estado !== 'cancelado' && String(a.fecha || '') >= hoy)
          .sort((a, b) => a.fecha < b.fecha ? -1 : a.fecha > b.fecha ? 1 : a.hora < b.hora ? -1 : 1);
        this.proximaCita = upcoming[0] || null;
      }, (err) => { console.warn('subscribeProximaCita error:', err); });
    } catch (e) { console.warn('subscribeProximaCita setup error:', e); }
  },
  async abrirGestionar(cita) {
    this.gestionarModal = { open: true, agendamientoId: cita.id, accion: null, motivo: '', slots: [], selectedSlot: null, loading: true };
    const slots = await this.computarSlotsDisponiblesCliente();
    this.gestionarModal = { ...this.gestionarModal, slots, loading: false };
  },
  async computarSlotsDisponiblesCliente() {
    const avail = this.activeContextBusinessBasics?.availabilitySlots || this.proyectorConfig?.businessBasics?.availabilitySlots || {};
    if (!avail?.enabled) return [];
    // Obtener slots ya ocupados de Firestore
    let tomadosSet = new Set();
    try {
      const hoy = new Date().toISOString().split('T')[0];
      const en15 = new Date(); en15.setDate(en15.getDate() + 15);
      const en15Str = en15.toISOString().split('T')[0];
      const snap = await getDocs(query(
        collection(db, `canales/${this.canalId}/disponibilidad`),
        where('fecha', '>=', hoy),
        where('fecha', '<=', en15Str),
        limit(100)
      ));
      snap.forEach(d => {
        const s = d.data();
        if (s.fecha && s.hora) tomadosSet.add(`${s.fecha}|${s.hora}`);
      });
    } catch (_) {}
    const dayKeys = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
    const days = avail.days || {};
    const slots = [];
    const now = new Date();
    for (let i = 1; i <= 14 && slots.length < 6; i++) {
      const d = new Date(now);
      d.setDate(now.getDate() + i);
      const cfg = days[dayKeys[d.getDay()]];
      if (!cfg?.enabled || !cfg.times?.length) continue;
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const fecha = `${yyyy}-${mm}-${dd}`;
      for (const hora of cfg.times) {
        if (slots.length >= 6) break;
        if (tomadosSet.has(`${fecha}|${hora}`)) continue;
        slots.push({ fecha, hora, label: `${fecha} ${hora}` });
      }
    }
    return slots;
  },
  async ejecutarGestionar() {
    const { agendamientoId, accion, motivo, selectedSlot } = this.gestionarModal;
    if (!agendamientoId || !accion) return;
    this.gestionarModal.loading = true;
    try {
      const functions = getFunctions();
      const fn = httpsCallable(functions, 'gestionarAgendamiento');
      await fn({
        canalId: this.canalId,
        agendamientoId,
        accion,
        motivo: String(motivo || '').trim(),
        nuevaFecha: selectedSlot?.fecha || null,
        nuevaHora: selectedSlot?.hora || null
      });
      this.gestionarModal.open = false;
      if (accion === 'cancelar') {
        // limpiar de localStorage los bookings relacionados
        try {
          const stored = JSON.parse(localStorage.getItem(`uvoto_bookings_${this.canalId}`) || '{}');
          Object.keys(stored).forEach(k => { if (stored[k]?.agendamientoId === agendamientoId) delete stored[k]; });
          localStorage.setItem(`uvoto_bookings_${this.canalId}`, JSON.stringify(stored));
          // actualizar bookingState
          const newState = { ...this.bookingState };
          Object.keys(newState).forEach(k => { if (newState[k]?.agendamientoId === agendamientoId) delete newState[k]; });
          this.bookingState = newState;
        } catch (_) {}
      }
    } catch (e) {
      console.error('Error gestionando agendamiento:', e);
    } finally {
      this.gestionarModal.loading = false;
    }
  },

  wrPlatformIcon(platform = 'url') {
    const p = String(platform).toLowerCase();
    if (p === 'whatsapp') return '<path d="M17.5 14.4c-.3-.1-1.7-.8-2-1-.3-.1-.5-.1-.7.2s-.8 1-1 1.2c-.2.2-.4.2-.7.1-1.9-.9-3.2-2.6-3.4-3-.2-.4 0-.6.2-.7l.5-.6c.1-.2.2-.4.3-.6 0-.2 0-.4-.1-.6L9.5 8c-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.1 1.1-1.1 2.7s1.2 3.1 1.3 3.3c.2.2 2.3 3.6 5.7 4.9.8.3 1.4.5 1.9.6.8.2 1.5.2 2.1.1.6-.1 1.8-.7 2.1-1.4.3-.6.3-1.2.2-1.3-.1-.2-.3-.3-.6-.4z"/><path d="M12 2a10 10 0 0 1 8.7 14.9L22 22l-5.2-1.3A10 10 0 1 1 12 2z"/>';
    if (p === 'youtube') return '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-1.94C18.88 4 12 4 12 4s-6.88 0-8.6.48a2.78 2.78 0 0 0-1.94 1.94A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.94 1.94c1.72.48 8.6.48 8.6.48s6.88 0 8.6-.48a2.78 2.78 0 0 0 1.94-1.94A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"></path><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"></polygon>';
    if (p === 'instagram') return '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>';
    if (p === 'facebook') return '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>';
    if (p === 'twitter' || p === 'x') return '<path d="M4 4l11.733 16h4.267l-11.733 -16z"></path><path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"></path>';
    if (p === 'linkedin') return '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>';
    if (p === 'maps') return '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>';
    return '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>';
  },

  wrPlatformLabel(platform) {
    const p = String(platform).toLowerCase();
    if (p === 'whatsapp') return 'WhatsApp';
    if (p === 'youtube') return 'YouTube';
    if (p === 'instagram') return 'Instagram';
    if (p === 'facebook') return 'Facebook';
    if (p === 'twitter' || p === 'x') return 'X';
    if (p === 'linkedin') return 'LinkedIn';
    if (p === 'maps') return 'Google Maps';
    return '';
  },

  getWrLinkClass(link) {
    const p = String(link?.platform || '').toLowerCase();
    const url = String(link?.value || '').toLowerCase();
    const label = String(link?.label || '').toLowerCase();

    if (p === 'whatsapp' || url.includes('wa.me') || label.includes('whatsapp')) return 'is-whatsapp';
    if (p === 'youtube' || url.includes('youtube.com') || url.includes('youtu.be') || label.includes('youtube')) return 'is-youtube';
    if (p === 'instagram' || url.includes('instagram.com') || label.includes('instagram')) return 'is-instagram';
    if (p === 'facebook' || url.includes('facebook.com') || label.includes('facebook')) return 'is-facebook';
    if (p === 'twitter' || p === 'x' || url.includes('twitter.com') || url.includes('x.com')) return 'is-twitter';
    if (p === 'linkedin' || url.includes('linkedin.com') || label.includes('linkedin')) return 'is-linkedin';
    if (p === 'maps' || url.includes('google.com/maps') || url.includes('maps.app.goo.gl') || url.includes('goo.gl/maps') || url.includes('maps.google.') || label.includes('maps') || label.includes('ubicacion') || label.includes('ubicación')) return 'is-maps';
    return 'is-web';
  },

  closeAiContextImage() {
    this.selectedAiImage = null;
    this.selectedAiGallery = [];
    if (this.chatAbiertoAntesDeGaleria) {
      this.mostrarModalPreguntas = true;
      this.chatAbiertoAntesDeGaleria = false;
    }
  },

  getPersonPrimaryLink(person) {
    return person?.linkUrl || person?.url || person?.linkedin || '';
  },
 
  getPersonPrimaryLinkLabel(person) {
    const link = this.getPersonPrimaryLink(person);
    if (!link) return '';
    return /linkedin\.com/i.test(link) ? 'LinkedIn' : 'Ver perfil';
  },

  resolveAiExternalLink(entry = {}) {
    return String(
      entry?.linkUrl ||
      entry?.url ||
      entry?.fileUrl ||
      entry?.downloadUrl ||
      entry?.href ||
      ''
    ).trim();
  },

  getAiActionIcon(action) {
    const link = this.resolveAiExternalLink(action).toLowerCase();
    const label = String(action?.linkLabel || action?.title || '').toLowerCase();
    
    // WhatsApp
    if (link.includes('wa.me') || link.includes('whatsapp') || label.includes('whatsapp')) {
      return '<path d="M17.5 14.4c-.3-.1-1.7-.8-2-1-.3-.1-.5-.1-.7.2s-.8 1-1 1.2c-.2.2-.4.2-.7.1-1.9-.9-3.2-2.6-3.4-3-.2-.4 0-.6.2-.7l.5-.6c.1-.2.2-.4.3-.6 0-.2 0-.4-.1-.6L9.5 8c-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.1 1.1-1.1 2.7s1.2 3.1 1.3 3.3c.2.2 2.3 3.6 5.7 4.9.8.3 1.4.5 1.9.6.8.2 1.5.2 2.1.1.6-.1 1.8-.7 2.1-1.4.3-.6.3-1.2.2-1.3-.1-.2-.3-.3-.6-.4z"/><path d="M12 2a10 10 0 0 1 8.7 14.9L22 22l-5.2-1.3A10 10 0 1 1 12 2z"/>';
    }
    // YouTube
    if (link.includes('youtube.com') || link.includes('youtu.be') || label.includes('youtube') || label.includes('video')) {
      return '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-1.94C18.88 4 12 4 12 4s-6.88 0-8.6.48a2.78 2.78 0 0 0-1.94 1.94A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.94 1.94c1.72.48 8.6.48 8.6.48s6.88 0 8.6-.48a2.78 2.78 0 0 0 1.94-1.94A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"></path><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"></polygon>';
    }
    // Instagram
    if (link.includes('instagram.com') || label.includes('instagram') || label.includes('insta')) {
      return '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>';
    }
    // Facebook
    if (link.includes('facebook.com') || label.includes('facebook')) {
      return '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>';
    }
    // Email
    if (link.includes('mailto:') || label.includes('correo') || label.includes('email')) {
      return '<path d="M4 6h16v12H4z"></path><path d="m4 8 8 6 8-6"></path>';
    }
    // Calendar
    if (link.includes('calend') || label.includes('agenda') || label.includes('demo')) {
      return '<rect x="3" y="5" width="18" height="16" rx="3"></rect><path d="M8 3v4M16 3v4M3 10h18"></path>';
    }
    // Google Maps / ubicación
    if (link.includes('google.com/maps') || link.includes('maps.app.goo.gl') || link.includes('goo.gl/maps') || link.includes('maps.google.') || label.includes('maps') || label.includes('ubicacion') || label.includes('ubicación') || label.includes('direccion') || label.includes('dirección') || label.includes('como llegar') || label.includes('cómo llegar')) {
      return '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>';
    }
    return '<path d="M10 14 21 3"></path><path d="M15 3h6v6"></path><path d="M11 5H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-3"></path>';
  },

  detectFileKind(fileName = '') {
    const ext = String(fileName || '').split('.').pop().toLowerCase();
    if (ext === 'pdf') return 'pdf';
    if (['png', 'jpg', 'jpeg', 'webp', 'gif'].includes(ext)) return 'image';
    if (['doc', 'docx', 'txt', 'md', 'rtf'].includes(ext)) return 'doc';
    return 'other';
  },

  fileVisualLabel(fileName = '') {
    const ext = String(fileName || '').split('.').pop().toUpperCase();
    return ext || 'DOC';
  },

  getAiActionClass(action) {
    const link = this.resolveAiExternalLink(action).toLowerCase();
    const label = String(action?.linkLabel || action?.title || '').toLowerCase();
    if (link.includes('wa.me') || link.includes('whatsapp') || label.includes('whatsapp')) return 'is-whatsapp';
    if (link.includes('youtube.com') || link.includes('youtu.be') || label.includes('youtube')) return 'is-youtube';
    if (link.includes('instagram.com') || label.includes('instagram')) return 'is-instagram';
    if (link.includes('facebook.com') || label.includes('facebook')) return 'is-facebook';
    if (link.includes('twitter.com') || link.includes('x.com') || label.includes('twitter') || label.includes(' x ')) return 'is-twitter';
    if (link.includes('linkedin.com') || label.includes('linkedin')) return 'is-linkedin';
    if (link.includes('tiktok.com') || label.includes('tiktok')) return 'is-tiktok';
    if (link.includes('mailto:') || label.includes('correo') || label.includes('email')) return 'is-email';
    if (link.includes('calend') || label.includes('agenda') || label.includes('demo')) return 'is-calendar';
    if (link.includes('google.com/maps') || link.includes('maps.app.goo.gl') || link.includes('goo.gl/maps') || link.includes('maps.google.') || label.includes('maps') || label.includes('ubicacion') || label.includes('ubicación')) return 'is-maps';
    return 'is-web';
  },

  getAiActionBrandSvg(action) {
    const link = this.resolveAiExternalLink(action).toLowerCase();
    const label = String(action?.linkLabel || action?.title || '').toLowerCase();
    if (link.includes('wa.me') || link.includes('whatsapp') || label.includes('whatsapp')) {
      return '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>';
    }
    if (link.includes('youtube.com') || link.includes('youtu.be') || label.includes('youtube') || label.includes('video')) {
      return '<path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>';
    }
    if (link.includes('instagram.com') || label.includes('instagram') || label.includes('insta')) {
      return '<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>';
    }
    if (link.includes('linkedin.com') || label.includes('linkedin')) {
      return '<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>';
    }
    if (link.includes('tiktok.com') || label.includes('tiktok')) {
      return '<path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 2.78-1.15 5.54-3.33 7.39-2.26 1.94-5.46 2.5-8.3 1.83-2.66-.61-5-2.5-6.08-5.02-1.01-2.4-.87-5.26.43-7.53 1.4-2.5 4.09-4.28 6.94-4.52 1.14-.11 2.29-.04 3.42.12v4.02c-1.02-.38-2.18-.32-3.15.15-1.07.51-1.89 1.52-2.1 2.7-.22 1.25.1 2.56 1 3.48 1.01 1.05 2.65 1.34 4.01.7 1.3-.61 2.15-1.92 2.22-3.36.14-3.56.09-7.14.09-10.71.01-2.02.01-4.03.01-6.05z"/>';
    }
    if (link.includes('facebook.com') || label.includes('facebook')) {
      return '<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>';
    }
    if (link.includes('mailto:') || label.includes('correo') || label.includes('email')) {
      return '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M4 6h16v12H4z"/><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="m4 8 8 6 8-6"/>';
    }
    if (link.includes('calend') || label.includes('agenda') || label.includes('demo')) {
      return '<rect fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" x="3" y="5" width="18" height="16" rx="3"/><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M8 3v4M16 3v4M3 10h18"/>';
    }
    if (link.includes('google.com/maps') || link.includes('maps.app.goo.gl') || link.includes('goo.gl/maps') || link.includes('maps.google.') || label.includes('maps') || label.includes('ubicacion') || label.includes('ubicación')) {
      return '<path d="M12 0C7.802 0 4 3.403 4 7.602 4 13.4 12 24 12 24s8-10.6 8-16.398C20 3.403 16.199 0 12 0zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>';
    }
    return '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>';
  },

  abrirLinkExterno(url) {
    if (!url) return;
    const raw = String(url).trim();
    const finalUrl = /^(mailto|tel|whatsapp|sms|tg|tgbot):/i.test(raw) ? raw : (raw.startsWith('http') ? raw : `https://${raw}`);
    this._trackOutboundLink(finalUrl);
    // WhatsApp primero, incluso si viene como esquema whatsapp://: abrirWhatsapp
    // decide según la plataforma y normaliza el número (los "+57..." escritos a
    // mano rompen wa.me). Si esto fuera después del bloque de esquemas, en la
    // web Safari intentaría abrir el whatsapp:// crudo y mostraría su error de
    // "dirección no válida".
    const wa = parsearEnlaceWhatsapp(finalUrl);
    if (wa) {
      abrirWhatsapp(wa.numero, wa.texto, (webUrl) => window.open(webUrl, '_blank', 'noopener'));
      return;
    }
    if (/^(mailto|tel|sms|tg|tgbot):/i.test(raw)) {
      window.location.href = raw;
      return;
    }
    window.open(finalUrl, '_blank', 'noopener');
  },

  openProductLink(product) {
    const url = this.resolveAiExternalLink(product) || product?.linkUrl || '';
    if (!url) return;
    if (this.canalId && product?.title) {
      const safe = String(product.title).slice(0, 60).replace(/[.#$[\]/]/g, '_');
      updateDoc(doc(db, 'canales', this.canalId), {
        [`productClicks.${safe}`]: increment(1)
      }).catch(() => {});
    }
    this.abrirLinkExterno(url);
  },

  _trackOutboundLink(url) {
    if (!this.canalId || !url) return;
    const u = url.toLowerCase();
    const canalRef = doc(db, 'canales', this.canalId);
    if (u.includes('wa.me') || u.includes('whatsapp.com') || u.startsWith('whatsapp:')) {
      updateDoc(canalRef, { whatsappClicks: increment(1) }).catch(() => {});
    } else if (u.includes('instagram.com')) {
      updateDoc(canalRef, { instagramClicks: increment(1) }).catch(() => {});
    } else if (u.includes('facebook.com') || u.includes('fb.com')) {
      updateDoc(canalRef, { facebookClicks: increment(1) }).catch(() => {});
    } else if (u.includes('youtube.com') || u.includes('youtu.be')) {
      updateDoc(canalRef, { youtubeClicks: increment(1) }).catch(() => {});
    } else if (u.includes('linkedin.com')) {
      updateDoc(canalRef, { linkedinClicks: increment(1) }).catch(() => {});
    } else if (u.includes('tiktok.com')) {
      updateDoc(canalRef, { tiktokClicks: increment(1) }).catch(() => {});
    } else if (u.includes('twitter.com') || u.includes('x.com')) {
      updateDoc(canalRef, { twitterClicks: increment(1) }).catch(() => {});
    } else if (!u.startsWith('mailto:') && !u.startsWith('tel:')) {
      updateDoc(canalRef, { websiteClicks: increment(1) }).catch(() => {});
    }
  },

  abrirLinkInApp(url) { this.abrirLinkExterno(url); },
  openAiExternalLink(url) { this.abrirLinkExterno(url); },

  async abrirQuickApp() {
    const config = this.quickAppConfig;
    if (!config?.url) return;
    this.abrirLinkExterno(config.url);
  },

  toggleVoicePlayback(id) {
    const audio = document.getElementById(`voice-note-${id}`);
    if (!audio) return;

    if (this.activeVoicePlaybackId && this.activeVoicePlaybackId !== id) {
      const previous = document.getElementById(`voice-note-${this.activeVoicePlaybackId}`);
      if (previous) previous.pause();
    }

    if (audio.paused) {
      audio.play();
      this.activeVoicePlaybackId = id;
    } else {
      audio.pause();
      this.activeVoicePlaybackId = null;
    }
  },

  isVoicePlaying(id) {
    return this.activeVoicePlaybackId === id;
  },

  handleVoicePlaybackEnded(id) {
    if (this.activeVoicePlaybackId === id) {
      this.activeVoicePlaybackId = null;
    }
  },

  formatVoiceDuration(durationMs = 0) {
    const totalSeconds = Math.max(1, Math.round((Number(durationMs || 0) || 0) / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  },

  actualizarViewportChat() {
    const vv = window.visualViewport;
    if (!vv) {
      this.chatViewportHeight = window.innerHeight || 0;
      this.chatKeyboardInset = 0;
      return;
    }

    const viewportHeight = Math.round(vv.height || window.innerHeight || 0);
    const offsetTop = Math.round(vv.offsetTop || 0);
    const inset = Math.max(0, Math.round((window.innerHeight || viewportHeight) - (viewportHeight + offsetTop)));

    this.chatViewportHeight = viewportHeight;
    this.chatKeyboardInset = inset > 80 ? inset : 0;
  },

  handleEditableFocus(event) {
    const target = event?.target || event;
    if (!target || !['INPUT', 'TEXTAREA'].includes(target.tagName)) return;

    this.actualizarViewportChat();

    window.setTimeout(() => {
      try {
        target.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
      } catch (error) {
        target.scrollIntoView();
      }

      if (this.$refs.chatBody && this.mostrarModalPreguntas) {
        this.$refs.chatBody.scrollTop = this.$refs.chatBody.scrollHeight;
      }
    }, 220);
  },
 
  onChatEnterKey() {
    // En móvil (pantalla táctil) Enter añade salto de línea normalmente.
    // En desktop/PC, Enter envía el mensaje (Shift+Enter para nueva línea).
    const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    if (isMobile) {
      // Insertar salto de línea manualmente
      const ta = this.$refs.chatTextarea;
      if (!ta) return;
      const start = ta.selectionStart;
      const end = ta.selectionEnd;
      this.nuevaPregunta = this.nuevaPregunta.slice(0, start) + '\n' + this.nuevaPregunta.slice(end);
      this.$nextTick(() => {
        ta.selectionStart = ta.selectionEnd = start + 1;
        this.autoResizeChatTextarea();
      });
      return;
    }
    // Desktop: enviar si hay texto
    if (this.nuevaPregunta.trim() && !this.isRecordingVoice) {
      this.enviarPreguntaIA();
    }
  },

  autoResizeChatTextarea() {
    const textarea = this.$refs.chatTextarea;
    if (!textarea) return;
    
    // Reset para medir altura real
    textarea.style.height = 'auto';
    
    // Altura base slim de 40px
    const baseHeight = 40;
    const scrollH = textarea.scrollHeight;
    
    // Aplicamos el cálculo: mínimo 40px, máximo 160px
    const finalHeight = Math.max(baseHeight, Math.min(scrollH, 160));
    textarea.style.height = `${finalHeight}px`;
  },

  // ── Progressive reveal ────────────────────────────────────────────

  iniciarRevealMensaje(item) {
    const id = item.id;

    // Phase 1 — 'typing': the waiting dots are already visible (v-else), now
    // we keep them via revealState while the transition happens (~1.4s)
    this.revealState = { ...this.revealState, [id]: { phase: 'typing', visibleCount: 0 } };
    this.$nextTick(() => this.scrollChatToBottom());

    setTimeout(() => {
      if (!this.revealState[id]) return;

      // Phase 2 — 'revealing': start showing content piece by piece
      this.revealState = { ...this.revealState, [id]: { phase: 'revealing', visibleCount: 0 } };
      this.$nextTick(() => this.scrollChatToMessage(id));
      this.revelarSiguienteBloque(item);
    }, 1200);
  },

  revelarSiguienteBloque(item) {
    const id = item.id;
    const state = this.revealState[id];
    if (!state || state.phase !== 'revealing') return;

    const answer = this.getAiAnswer(item);
    const blocks = this.getAiBlocks(item);
    const followUp = this.getAiFollowUp(item);
    const total = (answer ? 1 : 0) + blocks.length + (followUp ? 1 : 0);
    const nextCount = state.visibleCount + 1;

    if (nextCount > total) {
      // Done — remove state so message renders fully with no animation classes
      const updated = { ...this.revealState };
      delete updated[id];
      this.revealState = updated;
      return;
    }

    // Determine what's about to be revealed (text or a block)
    const isText = answer && nextCount === 1;
    const revealingBlock = !isText ? (answer ? blocks[nextCount - 2] : blocks[nextCount - 1]) : null;
    const isHeavyBlock = revealingBlock && ['gallery', 'people', 'products', 'actions'].includes(revealingBlock.type);

    // Show micro typing dots between blocks (not before the first text)
    const showMicroTyping = nextCount > 1;
    const microTypingDuration = isHeavyBlock ? 900 : 600;

    if (showMicroTyping) {
      // Brief 'typing-between' phase before each subsequent piece
      this.revealState = { ...this.revealState, [id]: { phase: 'typing-between', visibleCount: state.visibleCount } };
      this.$nextTick(() => this.scrollChatToBottom());

      setTimeout(() => {
        if (!this.revealState[id]) return;
        // Back to revealing — show the next piece
        this.revealState = { ...this.revealState, [id]: { phase: 'revealing', visibleCount: nextCount } };
        this.$nextTick(() => this.scrollChatToMessage(id));
        setTimeout(() => this.revelarSiguienteBloque(item), isHeavyBlock ? 480 : 320);
      }, microTypingDuration);

    } else {
      // First piece — reveal immediately (no micro typing before the first text)
      this.revealState = { ...this.revealState, [id]: { phase: 'revealing', visibleCount: nextCount } };
      this.$nextTick(() => this.scrollChatToMessage(id));
      setTimeout(() => this.revelarSiguienteBloque(item), 380);
    }
  },

  scrollChatToMessage(itemId) {
    const container = this.$refs.chatBody || document.querySelector('.chat-body-modern');
    if (!container) return;
    const el = container.querySelector(`[data-msg-id="${itemId}"]`);
    if (el) {
      const containerTop = container.getBoundingClientRect().top;
      const elTop = el.getBoundingClientRect().top;
      container.scrollTop += (elTop - containerTop) - 12; // 12px breathing room
    } else {
      container.scrollTop = container.scrollHeight;
    }
  },

  // ─────────────────────────────────────────────────────────────────

  scrollChatToBottom() {
    const container = this.$refs.chatBody || document.querySelector('.chat-body-modern');
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  },
 
  formatearHora(timestamp) {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  },
 
    //registrar l apresencia del usuario 
 
    async registrarPresencia() {
      const uid = await this.getOrCreateSessionUserId(this.canalId);
      if (!uid || !this.canalId) return;
      try {
        const presenciaRef = doc(db, `canales/${this.canalId}/presencia`, uid);
        await setDoc(presenciaRef, {
          nombre: this.nombreUsuario,
          ultimaConexion: new Date(),
          online: true
        });
        window.addEventListener('beforeunload', () => {
          updateDoc(presenciaRef, { online: false });
        });
      } catch (_) {}

      // Track visit once per session — visitsCount vive en el doc raíz del canal
      // (las reglas de Firestore solo permiten incrementar ese campo ahí, no en un sub-doc).
      if (!this.visitTracked && this.canalId) {
        this.visitTracked = true;
        try {
          await updateDoc(doc(db, 'canales', this.canalId), { visitsCount: increment(1) });
        } catch (_) {}
      }
    },
 
 
    // Función simple para generar hash MD5 (necesaria para Gravatar)
    hashEmail(email) {
      // Si no quieres meter librerías pesadas, podemos usar esta opción de UI Avatars 
      // o instalar 'md5' vía npm. Por ahora, asumamos que quieres algo rápido:
      return btoa(email).substring(0, 10); // Esto es un placeholder, lo ideal es MD5
    },
 
   async enviarPresentacionFlash() {
    if (!this.textoPresentacion.trim() || this.loadingEnvio) return;
    this.loadingEnvio = true;
 
    try {
      // Usamos el userId como ID del documento para sobreescribir (setDoc)
      const greetingRef = doc(db, `canales/${this.canalId}/greetings`, this.userId);
      
      await setDoc(greetingRef, {
        nombre: this.nombreUsuario,
        texto: this.textoPresentacion,
        foto: this.fotoUrl || this.computedAvatar,
        userId: this.userId,
        fecha: new Date(), // Esto dispara el orden en el proyector
        
      });
 
      this.yaSePresento = true;
      
      // Feedback táctil
      if (navigator.vibrate) navigator.vibrate(50);
      
      console.log("🚀 Saludo actualizado en el proyector");
 
      // Opcional: Cerrar después de unos segundos o dejar que él decida
      // setTimeout(() => { this.mostrarCajaLocal = false; }, 2000);
 
    } catch (e) {
      console.error("Error al enviar saludo:", e);
    } finally {
      this.loadingEnvio = false;
    }
  },
 
  async ejecutarReaccionCompleta(emoji) {
  const now = Date.now();
  if (this._lastReaccionTime && now - this._lastReaccionTime < 1500) return;
  this._lastReaccionTime = now;
  try {
    const greetingRef = doc(db, `canales/${this.canalId}/greetings`, this.userId);
    await setDoc(greetingRef, {
      reaccion: emoji,
      fecha: new Date(),
    }, { merge: true });
    if (navigator.vibrate) navigator.vibrate(20);
  } catch (e) {
    console.error(e);
  }
},
 
 
    async cargarSesionesRecientes() {
        const data = localStorage.getItem('uvoto_recent_sessions');
        if (!data) return;
        const sesionesLocales = JSON.parse(data);
        const promesasVerificacion = sesionesLocales.map(async (sesion) => {
            try {
            const docRef = doc(db, "canales", sesion.id);
            const docSnap = await getDoc(docRef);
            return docSnap.exists() ? sesion : null;
            } catch (error) {
            console.error(`Error verificando sesión ${sesion.id}:`, error);
            return sesion;
            }
        });
        const resultados = await Promise.all(promesasVerificacion);
        const sesionesValidas = resultados.filter(s => s !== null);
        if (sesionesValidas.length !== sesionesLocales.length) {
            localStorage.setItem('uvoto_recent_sessions', JSON.stringify(sesionesValidas));
        }
        this.sesionesRecientes = sesionesValidas;
    },
    guardarSesionReciente(id, nombre, pin, imageUrl = null, logoUrl = null) {
      let sesiones = [...this.sesionesRecientes].filter(s => s.id !== id);
      sesiones.unshift({ id, nombre, pin, imageUrl, logoUrl });
      sesiones = sesiones.slice(0, 3);
      this.sesionesRecientes = sesiones;
      localStorage.setItem('uvoto_recent_sessions', JSON.stringify(sesiones));
    },
 
 
    getRandomShard() {
    const NUM_SHARDS = 10;
    return Math.floor(Math.random() * NUM_SHARDS);
  },

  async buscarProyectorPorPin(pinStr = '', proyectorEsperado = null) {
    const pin = normalizarPinIngreso(pinStr);
    if (!pin) return null;

    const qPinCanal = query(
      collection(db, "proyectores"),
      where("pinCanal", "==", pin),
      where("estado", "==", "vinculado")
    );

    const qPinVirtual = query(
      collection(db, "proyectores"),
      where("proyectorVirtualPin", "==", pin),
      where("estado", "==", "vinculado")
    );

    const [snapPinCanal, snapPinVirtual] = await Promise.all([
      getDocs(qPinCanal),
      getDocs(qPinVirtual)
    ]);

    console.log('PIN LOOKUP', {
      pinBuscado: pin,
      porPinCanal: snapPinCanal.size,
      porPinVirtual: snapPinVirtual.size,
      proyectorEsperado: proyectorEsperado || null
    });

    const docsMap = new Map();
    [...snapPinCanal.docs, ...snapPinVirtual.docs].forEach((docSnap) => {
      docsMap.set(docSnap.id, docSnap);
    });

    const docs = [...docsMap.values()];
    if (!docs.length) return null;

    if (proyectorEsperado) {
      const esperado = docs.find((docSnap) => docSnap.id === proyectorEsperado);
      if (esperado) return esperado;
    }

    return elegirProyectorMasReciente(docs, pin);
  },
 
    
async conectarPorPin(pinManual = null, options = {}) {
 
  const pinStr = normalizarPinIngreso(pinManual || this.pinIngresado);
  if (pinStr.length < 4) return;

  console.log('PIN MANUAL FLOW', {
    pinManual,
    pinIngresado: this.pinIngresado,
    pinNormalizado: pinStr,
    autoFromUrl: !!options.autoFromUrl,
    proyectorEsperado: options.proyectorEsperado || null
  });
 
  this.loading = true;
  if (!this.enteringSessionPreview) {
    this.setEntryLoadingPreview({
      title: this.selectedLanguage === 'en' ? 'your experience' : this.selectedLanguage === 'pt' ? 'sua experiencia' : 'tu experiencia',
      imageUrl: this.fallbackExploreImage
    });
  }
  this.limpiarConexionActiva();
  this.proyectorConfig = {};
  this.preguntaActiva = null;
  this.waitingRoomPublicData = { enabled: false, slides: [] };
 
  // Limpiar ?pin= de la URL después de iniciar el flujo para evitar reintentos raros
  if (options.autoFromUrl && window.location.search.includes('pin=')) {
    const cleanUrl = window.location.pathname;
    window.history.replaceState({}, '', cleanUrl);
  }
 
  try {
 
    const docSnap = await this.buscarProyectorPorPin(pinStr, options.proyectorEsperado || null);
 
    if (docSnap) {
      const proyectorData = docSnap.data();
      const idProyector = docSnap.id;
      this.setEntryLoadingPreviewFromProjector(proyectorData);

      this.pinIngresado = pinStr;
      this.canalId = proyectorData.canalId;
      console.log('[Uvoto] Conexión establecida con canal:', this.canalId);
      
      await this.getOrCreateSessionUserId(this.canalId);
      if (this.userId) {
        console.log('[Uvoto] Iniciando escucha de consultas para UID:', this.userId);
        this.escucharMisConsultas();
      }
      this.escucharWaitingRoomConfig();
 
      this.verificarPerfil();
 
      this.guardarSesionReciente(
        proyectorData.canalId,
        proyectorData.tituloVisible || proyectorData.nombreSesion || proyectorData.nombreEvento || "Sesión Activa",
        pinStr,
        (this.esImagenBack(proyectorData.Branding) ? proyectorData.Branding : null) || proyectorData.imageUrl || null,
        proyectorData.logoEmpresa || proyectorData.logoUrl || null
      );
 
      // 🎯 Escuchamos el proyector
      this.escucharEstadoProyector(idProyector);
      this.registrarPresencia();
      this.actualizarEstadoMomentoPublicado(this.canalId);
 
    } else {
 
      alert("Código inválido");
 
    }
 
  } catch (e) {
 
    console.error(e);
 
  } finally {
 
    if (!this.canalId) {
      this.loading = false;
      this.clearEntryLoadingPreview();
    }
 
  }
},
 
 
 
async conectarProyector() {
  console.log('Iniciando conexión para el canal:', this.canalId);
  this.loading = true;
 
  try {
    // 1. Buscamos el proyector vinculado a este canalId
    const q = query(
      collection(db, "proyectores"),
      where("canalId", "==", this.canalId),
      where("estado", "==", "vinculado")
    );
 
    const snap = await getDocs(q);
 
        if (!snap.empty) {
      const docSnap = elegirProyectorMasReciente(snap.docs);
      if (!docSnap) {
        throw new Error('No matching projector for recent session pin');
      }
      const proyectorData = docSnap.data();
      const idProyector = docSnap.id;
      this.setEntryLoadingPreviewFromProjector(proyectorData);
 
      console.log("Proyector activo encontrado:", idProyector);
      this.escucharWaitingRoomConfig();
 
      // --- PERSISTENCIA DE SESIÓN ---
      // A) Guardamos en el historial de sesiones recientes (para la lista del Home)
      const nombreSesion = proyectorData.tituloVisible || proyectorData.nombreSesion || proyectorData.nombreEvento || "Sesión Activa";
      const pinRecuperado = proyectorData.pinCanal || "";
 
      this.guardarSesionReciente(this.canalId, nombreSesion, pinRecuperado, (this.esImagenBack(proyectorData.Branding) ? proyectorData.Branding : null) || proyectorData.imageUrl || null, proyectorData.logoEmpresa || proyectorData.logoUrl || null);
 
      // B) Guardamos en LocalStorage para recuperación inmediata al refrescar
      localStorage.setItem('ultimoCanalId', this.canalId);
      localStorage.setItem('ultimoProyectorId', idProyector);
 
      // 2. Escuchamos el proyector en tiempo real (Branding, Preguntas, etc.)
      this.escucharEstadoProyector(idProyector);
 
    } else {
      console.warn("⚠️ No se encontró ningún proyector activo para este canal.");
      // Opcional: Si no hay proyector activo, podrías limpiar la carga para mostrar un estado vacío
      this.loading = false;
    }
  } catch (e) {
    console.error("Error buscando proyector:", e);
  } finally {
    if (!this.canalId) {
      this.loading = false;
      this.clearEntryLoadingPreview();
    }
  }
},
    
 
 
 
 
escucharEstadoProyector(idProyector) {
  this.limpiarConexionActiva();
  this.currentProyectorEscuchado = idProyector;
 
  this.proyectorListener = onSnapshot(doc(db, "proyectores", idProyector), (snap) => {
    const data = snap.data();
    
    if (!data || data.estado === 'esperando') {
      if (this.canalId) {
        this.salirDeSalaForzado();
      }
      return;
    }
 
    if (data.canalId && data.canalId !== this.canalId) {
      this.reiniciarEstadoTrasCambioDeCanal();
      this.canalId = data.canalId;
      this.getOrCreateSessionUserId(this.canalId);
      this.escucharWaitingRoomConfig();
    }
 
    const normalizedConfig = {
      ...(data.config || {}),
      ...(('config.qnaEnabled' in data) ? { qnaEnabled: data['config.qnaEnabled'] } : {}),
      ...(('config.greetingsMode' in data) ? { greetingsMode: data['config.greetingsMode'] } : {}),
      ...(('config.momentsEnabled' in data) ? { momentsEnabled: data['config.momentsEnabled'] } : {}),
      ...(('config.waitingRoomEnabled' in data) ? { waitingRoomEnabled: data['config.waitingRoomEnabled'] } : {}),
      ...(('config.gamificationEnabled' in data) ? { gamificationEnabled: data['config.gamificationEnabled'] } : {})
    };
 
    const tituloVisibleNormalizado = typeof data.tituloVisible === 'string'
      ? data.tituloVisible.trim()
      : typeof data?.config?.tituloVisible === 'string'
        ? data.config.tituloVisible.trim()
        : '';
 
    // Strip chatTimeline from contexto_ia — private notes/data not needed in client
    const contextoIaSafe = data.contexto_ia
      ? { ...data.contexto_ia, contexts: undefined }
      : undefined;

    this.proyectorConfig = {
      ...data,
      ...(contextoIaSafe !== undefined ? { contexto_ia: contextoIaSafe } : {}),
      tituloVisible: tituloVisibleNormalizado,
      config: normalizedConfig
    };
    this.persistCurrentRoomPreview(this.proyectorConfig);
    this.loading = false;
    this.clearEntryLoadingPreview();

    // Respaldo: el proyector debería traer contexto_ia (se propaga al
    // guardar el entrenamiento), pero algunos quedaron sin él — el más
    // común es un canal cuyo proyector virtual se creó DESPUÉS del último
    // guardado de entrenamiento, así que nunca recibió la copia. Sin esto,
    // activeContextKind cae siempre a 'event' y el chat muestra el saludo y
    // las pills genéricas en vez de las que corresponden al tipo real
    // (personal/marca/producto).
    if (!data.contexto_ia?.activeContextKind && data.canalId && this._contextoIaRespaldoCanalId !== data.canalId) {
      this._contextoIaRespaldoCanalId = data.canalId;
      getDoc(doc(db, 'canales', data.canalId)).then((canalSnap) => {
        const canalContextoIa = canalSnap.exists() ? canalSnap.data()?.contexto_ia : null;
        if (canalContextoIa && this.canalId === data.canalId) {
          this.proyectorConfig = {
            ...this.proyectorConfig,
            contexto_ia: { ...canalContextoIa, contexts: undefined },
            activeContextKind: this.proyectorConfig.activeContextKind || canalContextoIa.activeContextKind
          };
        }
      }).catch(() => {});
    }

    // Init likes — only once per canal to avoid onSnapshot overwriting optimistic state
    if (this.canalId && this._likesInitializedForCanal !== this.canalId) {
      this._likesInitializedForCanal = this.canalId;
      this.roomLiked = !!localStorage.getItem(`uvoto_liked_${this.canalId}`);
      this.roomLikesCount = Number(data.likesCount || 0);
    }

    const tituloActualizado = (tituloVisibleNormalizado || data.nombreSesion || data.nombreEvento || '').trim();
    const pinSesionActual = data.pinCanal || this.sesionesRecientes.find((sesion) => sesion.id === this.canalId)?.pin || '';
    if (tituloActualizado && pinSesionActual) {
      this.guardarSesionReciente(this.canalId, tituloActualizado, pinSesionActual, (this.esImagenBack(data.Branding) ? data.Branding : null) || data.imageUrl || null, data.logoEmpresa || data.logoUrl || null);
    }

    // 1. Gestión de Pregunta Activa
    // CRITICAL: only reconnect when preguntaActivaId actually changes.
    // Calling conectarPregunta on every proyector snapshot (e.g. page change, branding)
    // was destroying+recreating the listener needlessly, which caused the preguntaActiva
    // watcher to fire, reset tiempoQuiz and restart the cronometer — leading to timer=0
    // or inconsistent states for multiple simultaneous users.
    const newPreguntaId = data.preguntaActivaId || null;
    const newPreguntaCanalId = data.preguntaCanalId || null;
    console.log('[proyector-doc] preguntaActivaId:', newPreguntaId, '| preguntaCanalId:', newPreguntaCanalId, '| _last:', this._lastPreguntaActivaId ?? null);
    if (newPreguntaId !== (this._lastPreguntaActivaId ?? null)) {
      this._lastPreguntaActivaId = newPreguntaId;
      this.preguntaCanalId = newPreguntaCanalId;
      if (newPreguntaId) {
        this.conectarPregunta(newPreguntaId);
      } else {
        if (this.preguntaListener) {
          this.preguntaListener();
          this.preguntaListener = null;
        }
        this.preguntaActiva = null;
        if (data.modo !== 'cards' && data.modo !== 'conteo') {
          this.votoRealizado = false;
        }
      }
    }

    // 2. Lógica para CARDS
    if (data.modo === 'cards') {
      // cardsLaunchId cambia en cada lanzamiento (incluso del mismo set)
      const newKey = String(data.cardsLaunchId || (data.cardsData || []).map(c => c.id || c.orden).join(','));
      const sessionCambio = this._cardsSessionKey && newKey !== this._cardsSessionKey;
      this._cardsSessionKey = newKey;

      if (sessionCambio) {
        this.cardVotada = null;
        this.votoRealizado = false;
        localStorage.removeItem(`voted_cards_${this.canalId}`);
        localStorage.removeItem(`voted_card_data_${this.canalId}`);
      }

      // Verificar voto por UID en Firestore (fuente de verdad, persiste entre recargas)
      this.verificarVotoCardPorUID();
    }
 
    // 3. Manejo del Conteo
    if (data.modo === 'conteo' && data.ultimoConteo) {
      const uc = data.ultimoConteo;
      this.tiempoRestante = uc.segundosActuales ?? uc.segundos;
 
      if (uc.estado === 'play') {
        this.iniciarRelojUsuario();
      } else {
        if (this.userTimerInterval) {
          clearInterval(this.userTimerInterval);
          this.userTimerInterval = null;
        }
      }
    }
  });
},
 
 
 
salirDeSalaForzado() {
  console.warn("🚫 Conexión con el proyector perdida o finalizada. Cerrando sesión...");
  this.clearEntryLoadingPreview();
  
  const idABorrar = this.canalId;
 
  // 1. LIMPIEZA DE SESIONES RECIENTES EN LOCALSTORAGE
  if (idABorrar) {
    const data = localStorage.getItem('uvoto_recent_sessions');
    if (data) {
      let sesiones = JSON.parse(data);
      // Filtramos para quitar la sesión actual de la lista de "Recientes"
      sesiones = sesiones.filter(s => s.id !== idABorrar);
      localStorage.setItem('uvoto_recent_sessions', JSON.stringify(sesiones));
      
      // Actualizamos el estado local de la lista (si lo usas en el componente)
      if (this.sesionesRecientes) {
        this.sesionesRecientes = sesiones;
      }
    }
    
    // Borramos los rastros específicos de esta sesión
    localStorage.removeItem(`proyector_link_${idABorrar}`);
    localStorage.removeItem(`presented_${idABorrar}`);
    localStorage.removeItem(`voted_cards_${idABorrar}`); // Limpiamos también rastro de votos cards
  }

  const url = new URL(window.location.href);
  url.searchParams.delete('canal');
  url.searchParams.delete('pin');
  url.searchParams.delete('proyector');
  window.history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : ''));
 
  // 2. Limpiamos el listener del proyector para evitar fugas de memoria
  this.limpiarConexionActiva();
 
  // 3. Reset de variables de interfaz para volver al estado inicial (Pantalla de PIN)
  this.canalId = null;
  this.preguntaActiva = null;
  this.proyectorConfig = {};
  this.waitingRoomPublicData = { enabled: false, slides: [] };

  // 4. La URL ya quedó limpia arriba
  this.pinIngresado = '';
 
  // 5. Notificar al usuario
  alert("La sesión ha finalizado y ha sido eliminada de tus recientes.");
},
 
 
 
 
 
conectarPregunta(id) {
  const canal = this.preguntaCanalId || this.canalId;
  console.log('[conectarPregunta] id:', id, '| canal:', canal, '(preguntaCanalId:', this.preguntaCanalId, ', canalId:', this.canalId, ')');

  if (this.preguntaListener) this.preguntaListener();

  const refPregunta = doc(db, `canales/${canal}/preguntas/${id}`);
 
  this.preguntaListener = onSnapshot(refPregunta, (snap) => {
    // 1. Si el documento no existe, limpiamos y salimos
    if (!snap.exists()) {
      this.resetInteraccion();
      return;
    }

    const data = snap.data();
    console.log('[conectarPregunta-snap] id:', snap.id, '| estado:', data.estado, '| tipoContenido:', data.tipoContenido, '| activo:', data.activo);

    // 2. 🔥 FILTRO CRÍTICO: Si el estado es 'finalizado', no la tratamos como activa
    if (data.estado === 'finalizado') {
      this.resetInteraccion(); // Esto pondrá preguntaActiva en null y limpiará relojes
      return;
    }

    // 3. 🔥 FILTRO QUIZ EXPIRADO: Si el quiz ya terminó su tiempo pero el admin no lo
    //    cerró formalmente, un usuario nuevo no debe verlo con timer=0.
    //    Usuarios que ya estaban conectados (this.preguntaActiva.id === snap.id)
    //    siguen viendo la pantalla de resultado.
    if (
      data.tipoContenido === 'quiz' &&
      data.duracion > 0 &&
      data.fechaLanzamiento &&
      this.preguntaActiva?.id !== snap.id  // solo afecta conexiones nuevas
    ) {
      try {
        const finMs = data.fechaLanzamiento.toMillis() + (data.duracion * 1000);
        if (Date.now() >= finMs) {
          // Quiz ya caducó — no lo mostramos a quien se conecta ahora
          this.resetInteraccion();
          return;
        }
      } catch (e) { /* fecha inválida — dejamos pasar y el timer mostrará 0 */ }
    }

    // 4. Si llegamos aquí, la pregunta existe y NO está finalizada
    this.preguntaActiva = { id: snap.id, ...data };
    console.log(this.preguntaActiva);
    
 
    // 4. VALIDACIÓN DE BLOQUEO (Persistencia)
    // Solo comprobamos si ya votó si la pregunta es nueva o cambió
    if (data.tipoContenido === 'cards') {
      this.votoRealizado = localStorage.getItem(`voted_cards_${this.canalId}`) === 'true';
    } else {
      this.votoRealizado = localStorage.getItem(`voted_${snap.id}`) === 'true';
    }
  });
},
 
 
async enviarVotoMultiple() {
  if (this.indicesSeleccionados.length === 0 || this.loadingEnvio) return;
  this.loadingEnvio = true;
 
  try {
    this.getOrCreateSessionUserId(this.canalId);
    const path = `canales/${this.preguntaCanalId || this.canalId}/preguntas/${this.preguntaActiva.id}`;
    const shard = this.getRandomShard();
    const counterRef = doc(db, `${path}/counters/shard_${shard}`);

    // 1. Asegurar estructura del shard (merge: true para no borrar otros datos)
    await setDoc(counterRef, {
      participantes: increment(1), // Una persona más participó
      votos: {}
    }, { merge: true });
 
    // 2. Crear el objeto de actualizaciones para los múltiples votos
    const updates = {};
    this.indicesSeleccionados.forEach(index => {
      // Incrementamos cada opción que el usuario marcó
      updates[`votos.${index}`] = increment(1);
    });
 
    // 3. Ejecutar la actualización en el shard
    await updateDoc(counterRef, updates);
 
    // 4. (Opcional) Guardar registro individual para auditoría o comentarios
    await addDoc(collection(db, `${path}/comentarios`), {
      nombre: this.nombreUsuario || 'Anónimo',
      foto: this.fotoUrl || this.computedAvatar,
      tipo: 'multichoice',
      indicesVotados: this.indicesSeleccionados,
      fecha: new Date()
    });
 
    // Marcar como votado localmente
    localStorage.setItem(`voted_${this.preguntaActiva.id}`, 'true');
    this.votoRealizado = true;
    await this.guardarPuntosLocalmente(15);
 
    if (navigator.vibrate) navigator.vibrate([50, 30, 50]);
 
  } catch (e) {
    console.error("Error al enviar multichoice a counters:", e);
  } finally {
    this.loadingEnvio = false;
  }
},
 
 
async enviarVotoQuiz(indexSeleccionado) {
  // SEGURIDAD: Si el tiempo es 0, no permitimos ejecutar la función
  if (this.tiempoQuiz <= 0) {
     alert("¡Lo sentimos! El tiempo de esta pregunta ha finalizado.");
     return;
  }
 
 
  if (this.loadingEnvio || this.votoRealizado) return;
  this.loadingEnvio = true;
 
  try {
    this.getOrCreateSessionUserId(this.canalId);
    const pregunta = this.preguntaActiva;
    const esCorrecta = Number(indexSeleccionado) === Number(pregunta.respuestaCorrecta);
    
    // Calculamos puntos por velocidad (opcional)
    // Si tienes un timer, a menos tiempo consumido, más puntos.
    const puntos = esCorrecta ? (pregunta.puntos || 100) : 10;
 
    const path = `canales/${this.preguntaCanalId || this.canalId}/preguntas/${pregunta.id}`;
    const shard = this.getRandomShard();
    const counterRef = doc(db, `${path}/counters/shard_${shard}`);

    // 1. Incrementamos contadores globales para la gráfica
    await setDoc(counterRef, {
      participantes: increment(1),
      votos: {}
    }, { merge: true });
 
    await updateDoc(counterRef, {
      [`votos.${indexSeleccionado}`]: increment(1)
    });
 
    // 2. Guardamos la respuesta individual detallada para el Ranking
    // Esta es la que el proyector usará para sacar la lista de ganadores
    await addDoc(collection(db, `${path}/respuestas_quiz`), {
      usuarioId: this.userId,
      nombre: this.nombreUsuario || 'Anónimo',
      foto: this.fotoUrl || this.computedAvatar,
      opcion: indexSeleccionado,
      esCorrecta: esCorrecta,
      puntos: puntos,
      fecha: new Date()
    });
 
    await this.guardarPuntosLocalmente(puntos);
 
    this.indiceSeleccionado = indexSeleccionado;
    this.votoRealizado = true;
    localStorage.setItem(`voted_${pregunta.id}`, 'true');
    localStorage.setItem(`voted_index_${pregunta.id}`, indexSeleccionado);
    if (pregunta.relaunchVersion != null) {
      localStorage.setItem(`relaunch_version_${pregunta.id}`, String(pregunta.relaunchVersion));
    }
 
    // Feedback visual/táctil
    if (navigator.vibrate) {
      esCorrecta ? navigator.vibrate([30, 100]) : navigator.vibrate(100);
    }
 
  } catch (e) {
    console.error("Error en Quiz:", e);
  } finally {
    this.loadingEnvio = false;
  }
},
 
 
recuperarVotoLocal() {
  if (!this.preguntaActiva) return;
  
  const id = this.preguntaActiva.id;
  const votado = localStorage.getItem(`voted_${id}`);
  
  if (votado === 'true') {
    this.votoRealizado = true;
    // Recuperamos el índice y lo convertimos a número
    const indexGuardado = localStorage.getItem(`voted_index_${id}`);
    this.indiceSeleccionado = indexGuardado !== null ? parseInt(indexGuardado) : null;
    
    // Si ya estamos en modo resultados al recargar, verificamos de inmediato
    if (this.proyectorConfig.modo === 'resultados') {
      this.verificarResultadoQuiz();
    }
  } else {
    // Si es una pregunta nueva o no ha votado, limpiamos
    this.votoRealizado = false;
    this.indiceSeleccionado = null;
  }
},
 
async verificarVotoCardPorUID() {
  if (!this.canalId || !this._cardsSessionKey || this.votoRealizado) return;
  try {
    const uid = this.userId || await this.getOrCreateSessionUserId(this.canalId);
    if (!uid) return;
    const voteRef = doc(db, `canales/${this.canalId}/cards_votos_usuarios`, uid);
    const snap = await getDoc(voteRef);
    if (snap.exists() && snap.data().cardsSessionKey === this._cardsSessionKey) {
      this.votoRealizado = true;
      // Intentar restaurar la card votada (para mostrar el success state)
      let savedCard = snap.data().cardData || null;
      if (!savedCard && snap.data().cardId) {
        // Fallback: buscar por cardId en las cards actuales
        const cardId = snap.data().cardId;
        savedCard = (this.proyectorConfig.cardsData || []).find(c =>
          (c.id || c.title || `card_${c.orden}`) === cardId
        ) || null;
      }
      if (savedCard) this.cardVotada = savedCard;
    }
  } catch (e) {
    console.warn('verificarVotoCardPorUID:', e);
  }
},

async enviarVotoCard(cardSeleccionada) {
  if (this.loadingEnvio || this.votoRealizado) return;
 
  // 1. Selección por defecto si no hay interacción (Carta 1)
  if (!cardSeleccionada && this.proyectorConfig.cardsData?.length > 0) {
    cardSeleccionada = this.proyectorConfig.cardsData[0];
  }
 
  if (!cardSeleccionada) return;
 
  this.loadingEnvio = true;
 
  try {
    this.getOrCreateSessionUserId(this.canalId);
    // Definimos un ID seguro (si no hay .id, usamos el .title)
    const cardIdSeguro = cardSeleccionada.id || cardSeleccionada.title || `card_${cardSeleccionada.orden}`;
    
    const path = `canales/${this.canalId}/cards/global`;
    const shard = this.getRandomShard();
    const counterRef = doc(db, `${path}/counters/shard_${shard}`);

    // 1. Incrementamos contadores globales (shards para alta concurrencia)
    try {
      await updateDoc(counterRef, {
        participantes: increment(1),
        [`votos.${cardIdSeguro}`]: increment(1)
      });
    } catch {
      await setDoc(counterRef, {
        participantes: 1,
        votos: { [cardIdSeguro]: 1 }
      });
    }

    // 2. Actualizar doc global para que el proyector lo lea en tiempo real
    const globalRef = doc(db, path);
    try {
      await updateDoc(globalRef, { [`votos.${cardIdSeguro}`]: increment(1) });
    } catch {
      await setDoc(globalRef, { votos: { [cardIdSeguro]: 1 } });
    }
 
    // 2. Guardamos la respuesta individual
    // Usamos || null o || "" para evitar que valores inexistentes sean "undefined"
    await addDoc(collection(db, `canales/${this.canalId}/interacciones_cards`), {
      usuarioId: this.userId || 'anonimo',
      nombre: this.nombreUsuario || 'Anónimo',
      foto: this.fotoUrl || this.computedAvatar || null,
      cardId: cardIdSeguro,
      titulo: cardSeleccionada.title || 'Sin título',
      fecha: new Date()
    });
 
    // 3. Registrar voto bajo UID (persiste entre recargas)
    const uid = this.userId || await this.getOrCreateSessionUserId(this.canalId);
    if (uid) {
      const voteRef = doc(db, `canales/${this.canalId}/cards_votos_usuarios`, uid);
      await setDoc(voteRef, {
        cardId: cardIdSeguro,
        cardData: cardSeleccionada,
        cardsSessionKey: this._cardsSessionKey || '',
        fecha: new Date()
      });
    }

    // 4. Bloqueo y persistencia local (fallback)
    localStorage.setItem(`voted_cards_${this.canalId}`, 'true');
    localStorage.setItem(`voted_card_data_${this.canalId}`, JSON.stringify(cardSeleccionada));
    this.cardVotada = cardSeleccionada;
    this.votoRealizado = true;
    await this.guardarPuntosLocalmente(15);
 
    if (navigator.vibrate) navigator.vibrate(50);
 
  } catch (e) {
    console.error("Error al votar card:", e);
  } finally {
    this.loadingEnvio = false;
  }
},
 
 
    verificarPerfil() {
      console.log('se mando a llamar');
      
      const nombre = localStorage.getItem('user_name');
      const edad = localStorage.getItem('user_age');
      
      if (!nombre || !edad) {
        this.mostrarModalPerfil = true;
      }
    },
 
    
 
 
async enviarOrden() {
 
  this.loadingEnvio = true;
 
  try {
    const userId = this.getOrCreateSessionUserId(this.canalId);
 
    const path = `canales/${this.preguntaCanalId || this.canalId}/preguntas/${this.preguntaActiva.id}`;
    const preguntaRef = doc(db, path);

    await setDoc(preguntaRef, {
      votosOrden: {
        [userId]: this.listaOrdenable
      }
    }, { merge: true });
 
    const shard = this.getRandomShard();
    const counterRef = doc(db, `${path}/counters/shard_${shard}`);
 
    await setDoc(counterRef, {
      participantes: 0
    }, { merge: true });
 
    await updateDoc(counterRef, {
      participantes: increment(1)
    });
 
    await addDoc(collection(db, `${path}/comentarios`), {
      texto: "Ha organizado la lista",
      nombre: this.nombreUsuario || 'Anónimo',
      edad: this.edadUsuario || '--',
      foto: this.fotoUrl || this.computedAvatar,
      tipo: 'ordenamiento',
      ordenFinal: this.listaOrdenable,
      fecha: new Date()
    });
 
    await setDoc(preguntaRef, {
      totalComentarios: increment(1)
    }, { merge: true });
 
    localStorage.setItem(`voted_${this.preguntaActiva.id}`, 'true');
    if (this.indiceSeleccionado !== null) {
      localStorage.setItem(`voted_index_${this.preguntaActiva.id}`, this.indiceSeleccionado);
    }
    if (this.preguntaActiva.relaunchVersion != null) {
      localStorage.setItem(`relaunch_version_${this.preguntaActiva.id}`, String(this.preguntaActiva.relaunchVersion));
    }
 
    this.votoRealizado = true;
    await this.guardarPuntosLocalmente(25);
 
    if (navigator.vibrate) navigator.vibrate(50);
 
  } catch (e) {
 
    console.error("Error al enviar orden:", e);
 
  } finally {
 
    this.loadingEnvio = false;
 
  }
 
},
 
    guardarPerfil() {
      if (!this.nombreUsuario.trim() || !this.edadUsuario) {
        alert("Por favor completa tu nombre y edad");
        return;
      }
 
      localStorage.setItem('user_name', this.nombreUsuario);
      localStorage.setItem('user_age', this.edadUsuario);
      localStorage.setItem('user_email', this.emailUsuario);
      localStorage.setItem('user_photo', this.fotoUrl || this.computedAvatar);
      
      this.fotoUsuario = this.fotoUrl || this.computedAvatar;
      this.mostrarModalPerfil = false;
    },
 
    // Actualiza tu función de enviar participación para incluir la foto
async enviarParticipacionCompleta() {
 
  this.loadingEnvio = true;
 
  try {
    this.getOrCreateSessionUserId(this.canalId);
 
    const path = `canales/${this.preguntaCanalId || this.canalId}/preguntas/${this.preguntaActiva.id}`;
    const preguntaRef = doc(db, path);

    const shard = this.getRandomShard();
    const counterRef = doc(db, `${path}/counters/shard_${shard}`);
 
    // asegurar estructura
    await setDoc(counterRef, {
      participantes: 0,
      votos: {}
    }, { merge: true });
 
    if (this.indiceSeleccionado !== null) {
 
      await updateDoc(counterRef, {
        [`votos.${this.indiceSeleccionado}`]: increment(1),
        participantes: increment(1)
      });
 
    }
 
    if (this.comentario.trim()) {
 
      await addDoc(collection(db, `${path}/comentarios`), {
        texto: this.comentario,
        nombre: this.nombreUsuario || 'Anónimo',
        edad: this.edadUsuario || '--',
        foto: this.fotoUrl || this.computedAvatar,
        opcionVotada: this.indiceSeleccionado !== null
          ? this.getLabel(this.indiceSeleccionado)
          : 'Abierta',
        fecha: new Date()
      });
 
      await setDoc(preguntaRef, {
        totalComentarios: increment(1)
      }, { merge: true });
 
    }
 
    localStorage.setItem(`voted_${this.preguntaActiva.id}`, 'true');

    // Save voted index so verificarResultadoQuiz can recover it from localStorage
    if (this.indiceSeleccionado !== null) {
      localStorage.setItem(`voted_index_${this.preguntaActiva.id}`, this.indiceSeleccionado);
    }

    this.votoRealizado = true;
    await this.guardarPuntosLocalmente(20);

    // If mode is already 'resultados' (auto-launch for pregunta type), re-check result now that we have the answer
    if (this.preguntaTieneRespuestaCorrecta(this.preguntaActiva)) {
      this.verificarResultadoQuiz();
    }

  } catch (e) {

    console.error("Error al enviar participación:", e);

  } finally {

    this.loadingEnvio = false;

  }

},



// ─── Buscador de salas ───────────────────────────────────────
cerrarBuscador() {
  this.showSearchModal = false;
  this.searchQuery = '';
  this.searchResults = [];
},

onSearchInput() {
  clearTimeout(this.searchDebounceTimer);
  if (this.searchQuery.trim().length < 2) { this.searchResults = []; return; }
  this.searchLoading = true;
  this.searchDebounceTimer = setTimeout(() => this.buscarSalas(this.searchQuery), 400);
},

async buscarSalas(termino) {
  const term = String(termino || '').trim();
  if (term.length < 2) { this.searchResults = []; this.searchLoading = false; return; }

  const resultMap = new Map(); // canalId → result

  const addCanal = (canalId, data, pin = '', activa = false) => {
    if (resultMap.has(canalId)) return;
    resultMap.set(canalId, {
      canalId,
      nombre: String(data.tituloVisible || data.nombreSesion || data.nombreEvento || 'Sala').trim(),
      logo: String(data.logoEmpresa || data.shareImageUrl || '').trim(),
      shareSlug: String(data.shareSlug || '').trim(),
      pin,
      activa,
    });
  };

  try {
    const termLow = term.toLowerCase();

    // 1. short_link exacto
    const shortSnap = await getDoc(doc(db, 'short_links', termLow));
    if (shortSnap.exists() && shortSnap.data()?.active !== false) {
      const cid = shortSnap.data().canalId;
      if (cid) {
        const cs = await getDoc(doc(db, 'canales', cid));
        if (cs.exists()) addCanal(cid, cs.data());
      }
    }

    // 2. shareSlug exacto en canales
    const slugSnap = await getDocs(query(collection(db, 'canales'), where('shareSlug', '==', termLow)));
    slugSnap.docs.forEach(d => addCanal(d.id, d.data()));

    // 3. Por pin / código
    const pinNorm = normalizarPinIngreso(term);
    if (pinNorm.length >= 4) {
      const proySnap = await this.buscarProyectorPorPin(pinNorm);
      if (proySnap) {
        const pd = proySnap.data();
        const cid = pd.canalId;
        if (cid) {
          const cs = await getDoc(doc(db, 'canales', cid));
          if (cs.exists()) addCanal(cid, cs.data(), pinNorm, true);
          else if (!resultMap.has(cid)) resultMap.set(cid, {
            canalId: cid, nombre: pd.canalNombre || 'Sala', logo: pd.logoEmpresa || '',
            shareSlug: '', pin: pinNorm, activa: true,
          });
        }
      }
    }

    // 4. Búsqueda por nombre (prefix)
    const nameSnap = await getDocs(query(
      collection(db, 'canales'),
      where('nombreSesion', '>=', term),
      where('nombreSesion', '<=', term + ''),
      limit(5)
    ));
    nameSnap.docs.forEach(d => addCanal(d.id, d.data()));

    // 5. Verificar cuáles están activas (proyector vinculado)
    const ids = [...resultMap.keys()];
    await Promise.all(ids.map(async cid => {
      const r = resultMap.get(cid);
      if (r.activa) return; // ya sabemos
      const ps = await getDocs(query(
        collection(db, 'proyectores'),
        where('canalId', '==', cid),
        where('estado', '==', 'vinculado'),
        limit(1)
      ));
      if (!ps.empty) {
        const pd = ps.docs[0].data();
        r.activa = true;
        if (!r.pin) r.pin = pd.pinCanal || pd.proyectorVirtualPin || '';
      }
    }));

  } catch (e) { console.error('[buscarSalas]', e); }

  this.searchResults = [...resultMap.values()];
  this.searchLoading = false;
},

async entrarDesdeBuscador(sala) {
  this.cerrarBuscador();
  if (sala.pin) {
    await this.conectarPorPin(sala.pin);
  } else if (sala.shareSlug) {
    window.location.href = `/u/${sala.shareSlug}`;
  } else if (sala.canalId) {
    window.location.href = `/user/?canal=${sala.canalId}`;
  }
},
// ─────────────────────────────────────────────────────────────

async reconectarSesion(s) {
  this.loading = true;
  this.showJoinHomePanel = false;
  this.showExploreOverlay = false;
  this.showExploreModal = false;
  if (!this.enteringSessionPreview) {
    this.setEntryLoadingPreview({
      title: s?.nombre || '',
      imageUrl: this.fallbackExploreImage
    });
  }
 
  try {
    console.log('PIN RECENT FLOW', {
      sesionId: s?.id || null,
      sesionNombre: s?.nombre || null,
      sesionPin: s?.pin || null,
      pinNormalizado: normalizarPinIngreso(s?.pin || '')
    });
    const docSnap = await this.buscarProyectorPorPin(s.pin);

    if (docSnap) {
      const proyectorData = docSnap.data();
      const idProyector = docSnap.id;
      this.setEntryLoadingPreviewFromProjector(proyectorData, {
        title: s?.nombre || '',
        brandName: s?.nombre || ''
      });
      
      console.log("Reconectando a proyector:", idProyector);
 
      // Sincronizamos el canalId local con el del proyector
      this.pinIngresado = s.pin;
      this.canalId = proyectorData.canalId;
      this.getOrCreateSessionUserId(this.canalId);
      this.escucharWaitingRoomConfig();
 
      this.verificarPerfil();
 
      // 🔥 Iniciamos la escucha activa
      this.escucharEstadoProyector(idProyector);
      this.registrarPresencia();
      this.actualizarEstadoMomentoPublicado(this.canalId);
 
    } else {
      // 🚨 CASO: El PIN ya no existe o el admin cerró la sesión
      console.warn("⚠️ La sesión ya no está activa o el PIN cambió.");
      
      // Usamos el ID que viene en el objeto 's' de la lista de recientes
      // para limpiar el rastro de esa sesión muerta
      this.canalId = s.id; // Seteamos temporalmente para que la limpieza sepa qué borrar
      this.salirDeSalaForzado();
      
      alert("Esta sesión ya no está disponible y ha sido eliminada.");
    }
 
  } catch (e) {
    console.error("Error en reconexión:", e);
  } finally {
    if (!this.canalId) {
      this.loading = false;
      this.clearEntryLoadingPreview();
    }
  }
},
 
    salirDeSala(fromBrowserBack = false) {
      const canalActual = this.canalId;
      this.clearEntryLoadingPreview();
      this.limpiarConexionActiva();
      this.preguntaActiva = null;
 
      localStorage.removeItem('ultimoCanalId');
      localStorage.removeItem('ultimoProyectorId');
      
      // Reset de variables locales
      this.canalId = null;
      this.pinIngresado = '';
      this.proyectorConfig = {};
      this.waitingRoomPublicData = { enabled: false, slides: [] };
      this.showJoinHomePanel = false;
      this.showExploreOverlay = false;
      this.showExploreModal = false;

      // En desktop showcase, al salir volvemos al explore modal
      if (this.shouldUseDesktopShowcase) {
        this.$nextTick(() => {
          if (this.filteredExploreProfiles && this.filteredExploreProfiles.length) {
            this.showExploreModal = true;
          }
        });
        const url = new URL(window.location.href);
        url.searchParams.delete('canal');
        url.searchParams.delete('pin');
        url.searchParams.delete('proyector');
        window.history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : ''));
        return;
      }

      if (!fromBrowserBack && window.history.length > 1) {
        window.history.go(-1);
        return;
      }

      const url = new URL(window.location.href);
      url.searchParams.delete('canal');
      url.searchParams.delete('pin');
      url.searchParams.delete('proyector');
      window.history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : ''));
      
      // Redirigir a la home (si usas router) o simplemente dejar que el v-if actúe
      console.log("🚪 Sesión cerrada correctamente");
    },
 
 
 
    getLabel(i) {
      return this.preguntaActiva?.formato === '123' ? i + 1 : String.fromCharCode(65 + i);
    },
    adjustTextarea(e) {
      e.target.style.height = 'auto';
      e.target.style.height = e.target.scrollHeight + 'px';
    },
 
 
   async subirFotoPerfil(base64Original) {
  this.subiendoFoto = true;
  try {
    // 1. Redimensionar y recortar la imagen localmente antes de subir
    const base64Procesado = await this.redimensionarImagen(base64Original, 200, 200);
 
    const storage = getStorage();
    const path = `perfiles/${this.userId}/avatar.jpg`;
    const storageRef = ref(storage, path);
    
    // 2. Subir el Base64 ya optimizado
    const snapshot = await uploadString(storageRef, base64Procesado, 'data_url');
    const url = await getDownloadURL(snapshot.ref);
    
    this.fotoUrl = url;
    localStorage.setItem('user_photo', url);
    return url;
  } catch (error) {
    console.error("Error al procesar/subir foto:", error);
  } finally {
    this.subiendoFoto = false;
  }
},
 
// Nueva función auxiliar para recortar y comprimir
redimensionarImagen(base64, ancho, alto) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = ancho;
      canvas.height = alto;
 
      // Calcular proporciones para un recorte cuadrado central (aspect fill)
      let sourceX = 0;
      let sourceY = 0;
      let sourceWidth = img.width;
      let sourceHeight = img.height;
 
      if (img.width > img.height) {
        sourceWidth = img.height;
        sourceX = (img.width - img.height) / 2;
      } else {
        sourceHeight = img.width;
        sourceY = (img.height - img.width) / 2;
      }
 
      // Dibujar en el canvas redimensionando
      ctx.drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, ancho, alto);
      
      // Exportar como JPEG con calidad 0.7 (70%) para que pese muy poco
      resolve(canvas.toDataURL('image/jpeg', 0.7));
    };
  });
},
 
// Antes se pedía el nombre en un popup al entrar por primera vez. Ahora se
// asigna un nombre de invitado y un avatar automáticamente, sin interrumpir
// al usuario — reutiliza el mismo guardado (presencia) que el flujo manual.
async asignarNombreYAvatarAutomatico() {
  if (this.nombreUsuario) return;
  await this.cargarAvataresTomados();

  const sufijo = Math.floor(100 + Math.random() * 900);
  this.nombreUsuario = `Invitado ${sufijo}`;

  const disponibles = AVATARES_FIJOS.filter(a => !this.avataresTomados.includes(a.id));
  const pool = disponibles.length ? disponibles : AVATARES_FIJOS;
  this.avatarSeleccionado = pool[Math.floor(Math.random() * pool.length)].id;

  await this.guardarNombreYAvatar();
},

async cargarAvataresTomados() {
  if (!this.canalId) return;
  try {
    const presenciaSnap = await getDocs(collection(db, `canales/${this.canalId}/presencia`));
    this.avataresTomados = presenciaSnap.docs
      .filter(d => d.id !== this.userId)
      .map(d => d.data().avatarId)
      .filter(Boolean);
  } catch (_) {
    this.avataresTomados = [];
  }
},

async guardarNombreYAvatar() {
  if (!this.puedeGuardarNombreSetup) return;
  const nombre = this.nombreUsuario.trim();
  localStorage.setItem('user_name', nombre);
  this.nombreUsuario = nombre;

  if (this.avatarSeleccionado) {
    localStorage.setItem('user_avatar_id', this.avatarSeleccionado);
    const avatarObj = AVATARES_FIJOS.find(a => a.id === this.avatarSeleccionado);
    if (avatarObj && !this.fotoUrl) {
      this.fotoUrl = avatarObj.url;
      localStorage.setItem('user_photo', avatarObj.url);
    }
  }

  // Write avatarId to presencia
  try {
    const uid = await this.getOrCreateSessionUserId(this.canalId);
    if (uid && this.canalId) {
      const presenciaRef = doc(db, `canales/${this.canalId}/presencia`, uid);
      await setDoc(presenciaRef, {
        avatarId: this.avatarSeleccionado || null,
        nombre: nombre,
        ultimaConexion: new Date(),
        online: true
      }, { merge: true });
    }
  } catch (_) {}

  this.mostrarModalNombreSetup = false;
  this.registrarPresencia();
},

async manejarSubidaFoto(e) {
  const file = e.target.files[0];
  if (!file) return;
 
  const reader = new FileReader();
  reader.onload = async (event) => {
    const base64 = event.target.result;
    // Subimos inmediatamente al Storage
    await this.subirFotoPerfil(base64);
  };
  reader.readAsDataURL(file);
}
  }
}
 
</script>

<style scoped>




/* ── iOS / Safari global fixes ──────────────────────────────────────────────
   • -webkit-text-size-adjust: prevents iOS from bumping font sizes on rotate
   • touch-action: manipulation on interactive elements removes the 300ms tap
     delay and prevents accidental double-tap zoom
   • All text inputs / textareas font-size ≥ 16px to stop Safari from
     auto-zooming the viewport on focus
   ────────────────────────────────────────────────────────────────────────── */
* {
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
button, a, [role="button"] {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}
input, select {
  font-size: 16px; /* prevents iOS zoom on focus */
}

/* --- THEME BASE --- */
.uvoto-dark-theme {
  width: 100%;
  background-color: #262626;
  min-height: 100dvh;
  color: white;
  font-family: 'Plus Jakarta Sans', sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.user-app--desktop-showcase {
  min-height: 100dvh;
}

.desktop-entry-gate {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background:
    radial-gradient(circle at 14% 18%, rgba(216,255,52,0.12), transparent 22%),
    radial-gradient(circle at 88% 82%, rgba(255,255,255,0.08), transparent 24%),
    linear-gradient(180deg, rgba(38,38,38,0.98) 0%, rgba(22,22,22,1) 100%);
}

.desktop-entry-gate-card {
  width: min(560px, 100%);
  padding: 40px;
  border-radius: 36px;
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.04);
  box-shadow: 0 24px 90px rgba(0,0,0,0.34);
  display: grid;
  gap: 18px;
  text-align: left;
}

.desktop-entry-gate-kicker {
  display: inline-flex;
  width: fit-content;
  min-height: 32px;
  align-items: center;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.72);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.desktop-entry-gate-title {
  margin: 0;
  font-size: clamp(40px, 5vw, 58px);
  line-height: 0.96;
  letter-spacing: -0.06em;
  color: #f8f8f3;
}

.desktop-entry-gate-body {
  margin: 0;
  max-width: 40ch;
  font-size: 18px;
  line-height: 1.55;
  color: rgba(255,255,255,0.72);
}

.desktop-entry-gate-purpose {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255,255,255,0.45);
  border-top: 1px solid rgba(255,255,255,0.08);
  padding-top: 14px;
}

.desktop-entry-gate-btn {
  width: fit-content;
  min-height: 56px;
  padding: 0 26px;
  border: none;
  border-radius: 18px;
  background: linear-gradient(135deg, #d8ff34 0%, #b9f31c 100%);
  color: #141810;
  font-size: 16px;
  font-weight: 800;
  box-shadow: 0 18px 34px rgba(126,154,20,0.25);
  cursor: pointer;
}

.desktop-entry-gate-legal {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 4px;
}

.desktop-entry-gate-legal-link {
  font-size: 12px;
  color: rgba(255,255,255,0.35);
  text-decoration: none;
  transition: color 0.15s;
}

.desktop-entry-gate-legal-link:hover {
  color: rgba(255,255,255,0.7);
}

.desktop-entry-gate-legal-sep {
  font-size: 12px;
  color: rgba(255,255,255,0.2);
}

/* ════════════════════════════════════════════════════
   ULTRAWIDE LIMIT — centra el layout en pantallas grandes
   ════════════════════════════════════════════════════ */

.desktop-user-layout {
  min-height: 100dvh;
  display: grid;
  grid-template-columns: 1fr 1fr;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
}

/* Wrapper para centrar el layout y dar fondo al resto */
.user-app--desktop-showcase {
  background: #1a1a1a;
}

/* ════════════════════════════════════════════════════
   DESKTOP SIDEBAR INFO — startup landing
   ════════════════════════════════════════════════════ */

.desktop-user-info {
  min-height: 100dvh;
  background: #1a1a1a;
  position: relative;
  display: flex;
  flex-direction: column;
}

/* Logo pegado al top */
.dsi-logo-top {
  position: absolute;
  top: 36px;
  left: 44px;
  z-index: 2;
}

.desktop-user-info-logo {
  width: 130px;
  height: auto;
  display: block;
}

/* Scroll container — centrado verticalmente, empieza debajo del logo */
.desktop-user-info-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 120px 44px 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  box-sizing: border-box;
  scrollbar-width: none;
}
.desktop-user-info-scroll::-webkit-scrollbar { display: none; }

/* Lang switcher — esquina inferior izquierda */
.dsi-lang-bottom {
  position: absolute;
  bottom: 28px;
  left: 44px;
  z-index: 10;
}

.lang-switcher-bottom {
  position: relative;
}

.lang-dropdown-up {
  position: absolute;
  bottom: calc(100% + 8px);
  top: auto !important;
  left: 0;
  transform: none !important;
  min-width: 152px;
  padding: 8px;
  border-radius: 18px;
  background: rgba(18,18,18,0.96);
  border: 1px solid rgba(255,255,255,0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 10;
  box-shadow: 0 -8px 24px rgba(0,0,0,0.32);
}

/* Animación lang menu hacia arriba */
.lang-menu-up-enter-active {
  transition: opacity 0.2s ease, transform 0.22s cubic-bezier(0.34, 1.3, 0.64, 1);
}
.lang-menu-up-leave-active {
  transition: opacity 0.14s ease, transform 0.14s ease;
}
.lang-menu-up-enter-from {
  opacity: 0;
  transform: translateY(8px);
}
.lang-menu-up-leave-to {
  opacity: 0;
  transform: translateY(4px);
}

/* HERO */
.dsi-hero {
  display: flex;
  flex-direction: column;
  gap: 18px;
  text-align: left;
}

.dsi-title {
  margin: 0;
  font-size: clamp(42px, 4.8vw, 70px);
  line-height: 0.94;
  letter-spacing: -0.065em;
  color: #f8f8f4;
}

.dsi-title-line {
  display: block;
}

.dsi-title-accent {
  color: #d8ff34;
  display: inline-block;
}

.dsi-subtitle {
  margin: 0;
  max-width: 36ch;
  font-size: 16px;
  line-height: 1.65;
  color: rgba(255,255,255,0.62);
}

/* JOIN */
.dsi-join {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.desktop-user-label {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.42);
}

.desktop-capsule-input-container {
  max-width: 100%;
}

.desktop-join-helper {
  /* Mismo ancho visual que el input — evita salto de línea innecesario */
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
}

/* ════════════════════════════════════════════════════
   ANIMACIONES DE ENTRADA
   ════════════════════════════════════════════════════ */

/* Hero: fade + slide desde abajo */
.dsi-anim-hero {
  animation: dsiHeroIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}

/* Join: misma animación con delay */
.dsi-anim-join {
  animation: dsiHeroIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.12s both;
}

/* Teléfono: fade + slide desde la derecha */
.dsi-anim-phone {
  animation: dsiPhoneIn 0.85s cubic-bezier(0.22, 1, 0.36, 1) 0.18s both;
}

@keyframes dsiHeroIn {
  from {
    opacity: 0;
    transform: translateY(28px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes dsiPhoneIn {
  from {
    opacity: 0;
    transform: translateX(48px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

/* DIVIDER */
.dsi-divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.04) 60%, transparent 100%);
}

/* SECTION HEAD */
.dsi-section-head {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dsi-section-title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.04em;
  color: #f0f0ec;
  line-height: 1.05;
}

.dsi-section-body {
  margin: 0;
  font-size: 15px;
  line-height: 1.65;
  color: rgba(255,255,255,0.56);
  max-width: 40ch;
}

/* BENEFITS */
.dsi-benefits {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dsi-benefit-card {
  display: grid;
  grid-template-columns: 48px 1fr;
  gap: 16px;
  align-items: flex-start;
  padding: 18px 20px;
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.07);
  background: rgba(255,255,255,0.03);
  transition: border-color 0.2s ease, background 0.2s ease;
}

.dsi-benefit-card:hover {
  border-color: rgba(216,255,52,0.18);
  background: rgba(216,255,52,0.03);
}

.dsi-benefit-icon {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background: rgba(216,255,52,0.08);
  border: 1px solid rgba(216,255,52,0.14);
  color: #d8ff34;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dsi-benefit-icon svg {
  width: 20px;
  height: 20px;
}

.dsi-benefit-copy strong {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.02em;
  margin-bottom: 4px;
  line-height: 1.15;
}

.dsi-benefit-copy p {
  margin: 0;
  font-size: 13px;
  line-height: 1.58;
  color: rgba(255,255,255,0.54);
}

/* FOOTER BLOCK */
.dsi-footer-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 24px;
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.07);
  background: linear-gradient(135deg, rgba(216,255,52,0.04) 0%, rgba(255,255,255,0.02) 100%);
}

.dsi-footer-title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.04em;
  color: #f0f0ec;
}

.dsi-footer-body {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: rgba(255,255,255,0.52);
}

/* ════════════════════════════════════════════════════
   PILL FLOTANTE — salir de sala (desktop showcase)
   ════════════════════════════════════════════════════ */

.dsi-exit-pill {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px 9px 12px;
  border-radius: 999px;
  border: 1px solid rgba(255,80,80,0.28);
  background: rgba(20,10,10,0.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  color: rgba(255,120,120,0.95);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(0,0,0,0.44), 0 0 0 1px rgba(255,80,80,0.08) inset;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.18s ease;
}

.dsi-exit-pill:hover {
  background: rgba(40,12,12,0.96);
  border-color: rgba(255,80,80,0.5);
  transform: translateX(-50%) translateY(-1px);
}

.dsi-exit-pill:active {
  transform: translateX(-50%) translateY(1px);
}

.dsi-exit-pill-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ff5050;
  box-shadow: 0 0 6px rgba(255,80,80,0.8);
  animation: exitPillPulse 1.6s ease-in-out infinite;
  flex-shrink: 0;
}

@keyframes exitPillPulse {
  0%, 100% { opacity: 1; box-shadow: 0 0 6px rgba(255,80,80,0.8); }
  50% { opacity: 0.6; box-shadow: 0 0 12px rgba(255,80,80,0.4); }
}

.dsi-exit-pill-label {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 11px;
}

.dsi-exit-pill-icon {
  width: 14px;
  height: 14px;
  opacity: 0.8;
}

/* Transición de entrada/salida de la pill */
.dsi-pill-pop-enter-active {
  transition: opacity 0.28s ease, transform 0.32s cubic-bezier(0.34, 1.4, 0.64, 1);
}
.dsi-pill-pop-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.dsi-pill-pop-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(-10px) scale(0.85);
}
.dsi-pill-pop-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-6px) scale(0.9);
}

/* device-stage necesita position relative para la pill */
.desktop-user-device-stage {
  position: relative;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 34px 28px;
  background: #1a1a1a;
}

.desktop-user-device-shell {
  position: sticky;
  top: 32px;
  /* Mantener proporción de teléfono 9:19.5 — nunca achatarlo */
  width: min(390px, calc((100dvh - 68px) * 9 / 19.5), 100%);
  aspect-ratio: 9 / 19.5;
  max-height: calc(100dvh - 68px);
  border-radius: 42px;
  padding: 14px;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  box-shadow: 0 42px 120px rgba(0,0,0,0.42);
  border: 1px solid rgba(255,255,255,0.08);
}

.desktop-user-device-shell::before {

}

.desktop-user-device-screen {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 30px;
  overflow: hidden;
  background: #262626;
  box-shadow: inset 0 0 0 1px rgba(255,255,255,0.04);
}

.pdf-phone-overlay {
  position: fixed;
  inset: 0;
  background: #0b0b0b;
  z-index: 999999;
  display: flex;
  flex-direction: column;
}

.pdf-phone-controls {
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 1000000;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.pdf-phone-controls.hidden {
  opacity: 0;
  transform: translateY(6px);
  pointer-events: none;
}

.pdf-phone-controls.portrait {
  right: 20px;
  bottom: 22px;
}

.pdf-phone-controls.landscape {
  left: 24px;
  right: auto;
  bottom: 25%;
  transform: rotate(90deg) translateY(-20px);
  transform-origin: bottom left;
}

.pdf-save-btn {
  background: rgba(255, 255, 255, 0.96);
  color: #111;
  border: none;
  padding: 6px 14px 6px 6px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
}

.download-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #111;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.download-icon svg {
  width: 18px;
  height: 18px;
}

.download-text {
  white-space: nowrap;
}

.pdf-phone-canvas-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-sizing: border-box;
}

.pdf-phone-canvas {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  background: #fff;
}

.pdf-phone-canvas-wrap.portrait {
  background: #eef2f5;
  padding: 12px;
}

.pdf-phone-canvas-wrap.portrait .pdf-phone-canvas {
  width: 99%;
  height: auto;
  max-height: 100%;
  border-radius: 10px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.pdf-phone-canvas-wrap.landscape .pdf-phone-canvas {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  background: #000;
}

.pdf-phone-canvas-wrap.landscape {
  background: #000;
}

.pdf-phone-loader {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  background: rgba(0, 0, 0, 0.4);
}

/* --- HEADER --- */
.app-header {
  padding: 30px;
  display: flex;
  align-items: center;
  
  justify-content: space-between;
  position: relative;
  
}
.room-back-btn {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.14);
  background: rgba(255,255,255,0.08);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  backdrop-filter: blur(12px);
}
.room-back-btn svg {
  width: 16px;
  height: 16px;
}
.app-brand-logo { height: 45px; }
.live-status {
  font-size: 10px; font-weight: 800; color: #ff4757;
  display: flex; align-items: center; gap: 5px;
}
.dot { width: 6px; height: 6px; background: #ff4757; border-radius: 50%; animation: blink 1s infinite; }

/* --- CONTENT CONTAINER --- */
.content-container {
  flex: 1;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

/* --- CARDS SECTION --- */
.cards-user-section {
  position: fixed;
  top: 2.5vh;
  left: 2.5vw;
  right: 2.5vw;
  bottom: 2.5vh;
  border-radius: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  z-index: 20;
  overflow: hidden;
}

/* --- HERO LOGIN --- */
.login-screen {
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
  padding: 12px 16px 36px;
  box-sizing: border-box;
  overflow-x: visible;
}

.login-shell {
  display: grid;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  overflow-x: visible;
}

.login-content-wrap {
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
  display: grid;
  gap: 16px;
  box-sizing: border-box;
}

.login-topbar {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 12px;
  min-height: 48px;
  position: relative;
  box-sizing: border-box;
  padding-right: 128px;
}

.login-topbar-brand {
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: calc(100% - 128px);
  padding-left: 8px;
}

.login-topbar-logo {
  width: 110px;
  height: auto;
  display: block;
}

.hero-section {
  display: grid;
  gap: 12px;
  text-align: left;
  padding-top: clamp(4px, 2vh, 16px);
  flex-direction: column;
}

.hero-eyebrow {
  display: inline-flex;
  width: fit-content;
  min-height: 28px;
  align-items: center;
  padding: 0 12px;
  border-radius: 999px;
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.74);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.main-title {
  font-size: clamp(30px, 8vw, 44px);
  margin: 0;
  letter-spacing: -0.06em;
  line-height: 0.94;
  color: #f7f7f2;
  text-wrap: normal;
  max-width: 11.5ch;
  overflow-wrap: normal;
}

.main-title-line {
  display: block;
}

.main-title-line-accent {
  white-space: nowrap;
}

.main-title-line-space {
  display: inline;
}

.main-title-accent {
  color: #d8ff34;
}

.main-title-accent-animated {
  display: inline-block;
  min-width: 7.2ch;
}

.main-title-accent-animated.is-motion-slide {
  animation: audienceFadeLeft 0.42s ease;
}

@keyframes audienceFadeLeft {
  from {
    opacity: 0;
    transform: translateX(-18px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.main-subtitle {
  font-size: 15px;
  line-height: 1.48;
  color: rgba(255,255,255,0.72);
  margin: 0;
  max-width: 32ch;
}

.join-panel {
  display: grid;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 5%;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
  overflow: visible;
}

.join-panel-head {
  display: grid;
  gap: 3px;
  text-align: left;
}

.join-panel-head strong {
  font-size: 15px;
  font-weight: 700;
  color: rgba(255,255,255,0.94);
  letter-spacing: -0.02em;
}

.join-panel-head span {
  font-size: 13px;
  line-height: 1.45;
  color: rgba(255,255,255,0.56);
}

.capsule-input-container {
  width: 100%;
  box-sizing: border-box;
  background: rgba(255,255,255,0.02);
  border-radius: 20px;
  margin: 0;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255,255,255,0.14);
  box-shadow: none;
  overflow: hidden;
}
.capsule-field {
  flex: 1;
  background: transparent;
  border: none;
  padding: 0 14px;
  font-size: 17px;
  color: #f6f7f3;
  outline: none;
  font-weight: 700;
  min-width: 0;
  min-height: 52px;
  letter-spacing: -0.02em;
}

.capsule-field::placeholder{
  font-size: 16px;
  color: rgba(255,255,255,0.34);
}

.btn-create-circle {
  background: linear-gradient(135deg, #d8ff34 0%, #b9f31c 100%);
  color: #161a12;
  border: none;
  min-height: 52px;
  padding: 0 18px;
  border-radius: 16px;
  font-weight: 800;
  font-size: 14px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  box-shadow: 0 12px 26px rgba(126,154,20,0.22);
  flex-shrink: 0;
  max-width: 42%;
}

.btn-create-circle:not(:disabled):active {
  transform: translateY(1px) scale(0.985);
}

.btn-create-circle:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.capsule-input-container:focus-within {
  border-color: rgba(216,255,52,0.95);
  box-shadow:
    0 0 0 4px rgba(216,255,52,0.16),
    inset 0 1px 0 rgba(255,255,255,0.72);
}

.join-helper {
  margin: 1% 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: rgba(255,255,255,0.54);
}

/* --- RECENT FAB (botón flotante en el bottom) --- */
.recent-fab {
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 20px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 90;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px 12px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(30,30,30,0.92);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 8px 32px rgba(0,0,0,0.38), 0 1px 0 rgba(255,255,255,0.06) inset;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  min-width: 220px;
  max-width: calc(100vw - 32px);
}

.recent-fab-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(216,255,52,0.14);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #d8ff34;
}

.recent-fab-icon svg {
  width: 16px;
  height: 16px;
}

.recent-fab-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
  flex: 1;
  min-width: 0;
}

.recent-fab-label {
  font-size: 13px;
  font-weight: 700;
  color: rgba(255,255,255,0.94);
  letter-spacing: -0.02em;
}

.recent-fab-sub {
  font-size: 11px;
  color: rgba(255,255,255,0.45);
  font-weight: 400;
  text-align: left;
}

.recent-fab-arrow {
  color: rgba(255,255,255,0.38);
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.recent-fab-arrow svg {
  width: 14px;
  height: 14px;
}

@media (min-width: 1100px) {
  .user-app--desktop-showcase {
    overflow: hidden;
  }

  .desktop-user-device-screen .app-header {
    padding-top: 46px;
  }

  .desktop-user-device-screen .content-container {
    height: 100%;
    padding: 0;
    overflow-y: auto;
    align-items: stretch;
  }

  .desktop-user-device-screen .login-screen {
    max-width: none;
    padding: 46px 16px 28px;
    min-height: 100%;
    box-sizing: border-box;
  }

  /* Ocultar elementos duplicados dentro del teléfono */
  .desktop-user-device-screen .login-topbar,
  .desktop-user-device-screen .hero-section,
  .desktop-user-device-screen .join-panel {
    display: none !important;
  }

  .desktop-user-device-screen .login-shell {
    gap: 0;
    min-height: 100%;
    padding-bottom: 96px;
  }

  .desktop-user-device-screen .explore-section {
    padding-top: 16px;
  }

  .desktop-user-device-screen .explore-head-bleed {
    margin-top: 0;
  }

  /* Ocultar botón salir interno del teléfono en desktop — usamos la pill flotante */
  .desktop-user-device-screen .btn-exit-text {
    display: none !important;
  }

  /* Ocultar botón de cierre del explore-modal en el teléfono */
  .desktop-user-device-screen .explore-modal-close {
    display: none !important;
  }

  .desktop-user-device-screen .login-content-wrap {
    max-width: none;
  }

  .desktop-user-device-screen .recent-fab,
  .desktop-user-device-screen .footer-text,
  .desktop-user-device-screen .emoji-dock-container-right,
  .desktop-user-device-screen .btn-flotante-pregunta,
  .desktop-user-device-screen .recent-modal-overlay,
  .desktop-user-device-screen .explore-modal-overlay,
  .desktop-user-device-screen .modal-consultas-overlay,
  .desktop-user-device-screen .uvoto-overlay,
  .desktop-user-device-screen .bottom-sheet-overlay,
  .desktop-user-device-screen .pdf-phone-overlay {
    position: absolute;
  }

  .desktop-user-device-screen .recent-modal-overlay,
  .desktop-user-device-screen .explore-modal-overlay,
  .desktop-user-device-screen .modal-consultas-overlay,
  .desktop-user-device-screen .uvoto-overlay,
  .desktop-user-device-screen .bottom-sheet-overlay,
  .desktop-user-device-screen .pdf-phone-overlay {
    inset: 0;
  }

  .desktop-user-device-screen .recent-fab {
    bottom: 16px;
  }

  .desktop-user-device-screen .footer-text {
    bottom: 12px;
    padding-bottom: 18px;
  }

  .desktop-user-device-screen .emoji-dock-container-right {
    right: 14px;
    bottom: 20%;
  }

  .desktop-user-device-screen .btn-flotante-pregunta {
    right: 14px;
    bottom: 14%;
  }

  .desktop-user-device-screen .modal-consultas-modern {
    height: 100%;
    border-radius: 0;
  }

  .desktop-user-device-screen .explore-modal,
  .desktop-user-device-screen .recent-modal {
    width: 100%;
    max-width: none;
    height: 100%;
    border-radius: 0;
  }
}

/* explore entry hint */
.explore-entry-hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255,255,255,0.42);
  text-align: left;
  padding: 0 16px;
  margin-top: 2px;
}

.recent-modal-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: min(56vh, 420px);
  overflow-y: auto;
  padding-right: 2px;
  box-sizing: border-box;
}

.recent-glass-card {
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(12px);
  border-radius: 22px;
  padding: 16px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border: 1px solid rgba(255,255,255,0.08);
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
  width: 100%;
  box-sizing: border-box;
}

.recent-glass-card:active {
  transform: scale(0.985);
}

.recent-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 120;
  background: rgba(5, 7, 8, 0.72);
  backdrop-filter: blur(14px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0 0 0 0;
  box-sizing: border-box;
}

.recent-modal {
  width: 100%;
  max-width: 460px;
  max-height: min(72vh, 560px);
  border-radius: 28px 28px 0 0;
  background: #161616;
  border: 1px solid rgba(255,255,255,0.08);
  border-bottom: 0;
  box-shadow: 0 -8px 40px rgba(0,0,0,0.44);
  padding: 8px 18px calc(env(safe-area-inset-bottom, 0px) + 24px);
  display: grid;
  gap: 16px;
  box-sizing: border-box;
}

.recent-modal-handle {
  width: 36px;
  height: 4px;
  border-radius: 999px;
  background: rgba(255,255,255,0.18);
  margin: 0 auto 4px;
}

.recent-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  text-align: left;
}

.recent-modal-head strong {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.03em;
}

.recent-modal-head p {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.45;
  color: rgba(255,255,255,0.56);
  text-align: left;
}

.recent-modal-close {
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 999px;
  background: rgba(255,255,255,0.08);
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
}

.recent-modal-item {
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(12px);
  border-radius: 22px;
  padding: 10px 16px 10px 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  border: 1px solid rgba(255,255,255,0.08);
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
}

/* thumb estilo rail */
.recent-modal-thumb {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background-color: rgba(255,255,255,0.08);
  background-size: cover;
  background-position: center;
  box-shadow: 0 4px 14px rgba(0,0,0,0.28);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.recent-modal-thumb-fallback {
  font-size: 22px;
  font-weight: 800;
  color: rgba(255,255,255,0.4);
  line-height: 1;
  user-select: none;
}

.recent-modal-item-copy {
  display: grid;
  gap: 5px;
  min-width: 0;
  flex: 1;
}

.recent-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.24;
  max-width: 220px;
  color: #fff;
}

.recent-pin {
  font-size: 11px;
  opacity: 0.55;
  font-weight: 700;
  color: rgba(255,255,255,0.82);
}

.recent-info {
  display: grid;
  gap: 5px;
}

.recent-action-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(216,255,52,0.12);
  color: #d8ff34;
  font-weight: 900;
  flex-shrink: 0;
}

.onboarding-brand-cta {
  width: 100%;
  min-height: 48px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.14);
  background: rgba(255,255,255,0.06);
  color: #f3f5ef;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.02em;
  box-sizing: border-box;
}

.explore-section {
  width: 100vw;
  max-width: 100vw;
  display: grid;
  gap: 12px;
  padding-top: 2px;
  box-sizing: border-box;
  overflow: visible;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
}

.explore-head-bleed {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  text-align: left;
  padding-left: 16px;
  box-sizing: border-box;
  scrollbar-width: none;
  margin-top: 5%;
}

.explore-head-bleed::-webkit-scrollbar {
  display: none;
}

.explore-head {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  text-align: left;
  width: auto;
  min-width: max-content;
  padding-right: 16px;
}

.explore-categories-head {
  padding-top: 4px;
  flex: none;
  min-width: max-content;
  max-width: none;
  overflow: visible;
  scrollbar-width: none;
}

.explore-all-trigger {
  min-height: 36px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.14);
  background: rgba(255,255,255,0.06);
  color: rgba(255,255,255,0.9);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
}

.explore-all-trigger svg {
  width: 14px;
  height: 14px;
}

.explore-slider-bleed {
  width: 100vw;
  padding: 0 0 0 16px;
  box-sizing: border-box;
  overflow: hidden;
  touch-action: pan-y;
}

.explore-slider {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  margin-top: 0;
  touch-action: pan-y;
}

.explore-slide {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.explore-slide--cta {
  width: 100%;
  max-width: 100%;
}

.explore-tile {
  display: grid;
  gap: 10px;
  width: 100%;
}

.explore-tile--cta {
  height: 100%;
}

.explore-card {
  position: relative;
  display: block;
  width: 100%;
  max-width: 100%;
  aspect-ratio: 1 / 1;
  min-height: 0;
  border: 0;
  padding: 0;
  border-radius: 22px;
  overflow: hidden;
  text-align: left;
  background: #101010;
  box-shadow: 0 20px 52px rgba(0,0,0,0.24);
  box-sizing: border-box;
}

/* Reclamo de link en la portada: compacto, sin card ni titulares */
.explore-claim-compact {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  /* Aire respecto al titular de arriba, para que no queden pegados */
  margin-top: 14px;
}

.explore-claim-line {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #f7f7f2;
}

.explore-claim-status {
  min-height: 14px;
  font-size: 11.5px;
  line-height: 1.35;
  color: rgba(255,255,255,0.62);
}
.explore-claim-status.is-available,
.explore-claim-status.is-current { color: #d8ff34; }
.explore-claim-status.is-taken,
.explore-claim-status.is-invalid,
.explore-claim-status.is-error { color: #ff8b8b; }

.explore-brand-claim-card {
  min-height: 198px;
  border-radius: 22px;
  border: 1px solid rgba(216,255,52,0.18);
  background:
    radial-gradient(circle at top left, rgba(216,255,52,0.16), transparent 36%),
    linear-gradient(180deg, rgba(255,255,255,0.1), rgba(255,255,255,0.04));
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
  color: #fff;
}

.explore-brand-claim-kicker {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: rgba(216,255,52,0.9);
}

.explore-brand-claim-card strong {
  font-size: 18px;
  line-height: 1.15;
  letter-spacing: -0.03em;
}

.explore-brand-claim-card p {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
  color: rgba(255,255,255,0.68);
}

.explore-brand-claim-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(10,10,10,0.18);
  padding: 0 12px;
}

.explore-brand-claim-prefix {
  font-size: 11px;
  color: rgba(255,255,255,0.44);
  white-space: nowrap;
}

.explore-brand-claim-input {
  flex: 1;
  background: transparent;
  border: 0;
  color: #fff;
  font-size: 13px;
  outline: none;
}

.explore-brand-claim-status {
  min-height: 15px;
  font-size: 11px;
  line-height: 1.35;
  color: rgba(255,255,255,0.62);
}

.explore-brand-claim-status.is-available,
.explore-brand-claim-status.is-current {
  color: #d8ff34;
}

.explore-brand-claim-status.is-taken,
.explore-brand-claim-status.is-invalid,
.explore-brand-claim-status.is-error {
  color: #ff8b8b;
}

.explore-brand-claim-btn {
  min-height: 40px;
  border-radius: 999px;
  border: 0;
  background: #d8ff34;
  color: #151b10;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.explore-brand-claim-btn:disabled {
  opacity: 0.5;
}

.explore-card-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transform: scale(1.02);
}

.explore-card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(5,8,7,0.04) 0%, rgba(8,11,9,0.06) 42%, rgba(8,11,9,0.84) 100%);
}

.explore-card-mini-meta {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 10px;
}

.explore-brand-logo {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  overflow: hidden;
  border: 2px solid rgba(255,255,255,0.82);
  background: rgba(255,255,255,0.12);
  box-shadow: 0 10px 24px rgba(0,0,0,0.24);
  flex-shrink: 0;
}

.explore-brand-logo img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.explore-tile-label {
  display: block;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.15;
  color: rgba(255,255,255,0.9);
  letter-spacing: -0.02em;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  padding: 0 2px;
}


.explore-brand-copy {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.explore-brand-copy strong {
  font-size: 15px;
  color: #fff;
  letter-spacing: -0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.explore-brand-copy span {
  font-size: 11px;
  color: rgba(255,255,255,0.72);
  font-weight: 700;
  letter-spacing: 0.08em;
}

.explore-visit-chip {
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(255,255,255,0.14);
  border: 1px solid rgba(255,255,255,0.18);
  color: #fff;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  backdrop-filter: blur(10px);
  font-size: 13px;
  font-weight: 700;
}

.explore-visit-chip svg {
  width: 14px;
  height: 14px;
}

.explore-card-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 18px 14px 14px;
  display: grid;
  gap: 6px;
}

.explore-card-bottom h3 {
  margin: 0;
  font-size: clamp(22px, 6.5vw, 32px);
  line-height: 0.95;
  letter-spacing: -0.06em;
  color: #fff;
  text-wrap: balance;
}

.explore-card-bottom p {
  margin: 0;
  max-width: 30ch;
  font-size: 12px;
  line-height: 1.45;
  color: rgba(255,255,255,0.78);
}

.explore-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.explore-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255,255,255,0.16);
}

.explore-dot.active {
  width: 20px;
  border-radius: 999px;
  background: #d8ff34;
}

.explore-card-mini-copy {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.explore-card-mini-copy strong {
  font-size: 12px;
  color: #fff;
  letter-spacing: -0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.explore-card-mini-copy span {
  font-size: 10px;
  color: rgba(255,255,255,0.7);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.explore-categories {
  display: flex;
  gap: 10px;
  max-width: 100%;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: none;
  box-sizing: border-box;
}

.explore-categories::-webkit-scrollbar {
  display: none;
}

.explore-category-chip {
  min-height: 36px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.06);
  color: rgba(255,255,255,0.84);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
}

.explore-category-chip.active {
  background: #d8ff34;
  color: #131910;
  border-color: transparent;
}

.explore-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 140;
  background: rgba(6, 6, 7, 0.97);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px);
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  padding: 0;
  box-sizing: border-box;
}

.explore-modal {
  width: 100%;
  height: 100%;
  border-radius: 0;
  border: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.explore-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: calc(env(safe-area-inset-top, 0px) + 18px) 18px 14px;
  flex-shrink: 0;
}

.explore-modal-copy strong {
  display: block;
  color: #fff;
  font-size: 19px;
  font-weight: 800;
  letter-spacing: -0.04em;
  text-align: left;
}

.explore-modal-copy p {
  margin: 6px 0 0;
  color: rgba(255,255,255,0.62);
  font-size: 12px;
  line-height: 1.45;
  text-align: left;
}

.explore-modal-close {
  width: 32px;
  height: 32px;
  border-radius: 0;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 24px;
  line-height: 1;
  flex-shrink: 0;
}

.explore-modal-body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: pan-y;
  padding: 0 0 12px;
  display: grid;
  gap: 26px;
  align-content: start;
}

.explore-modal-body::-webkit-scrollbar {
  display: none;
}

.explore-modal-categories {
  flex-shrink: 0;
  min-height: 50px;
  padding-top: 0;
  padding-bottom: 14px;
  padding-left: 18px;
  padding-right: 18px;
  overflow-x: auto;
  scrollbar-width: none;
}
.explore-modal-categories::-webkit-scrollbar {
  display: none;
}

.explore-modal-rail {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: visible;
  padding-bottom: 4px;
  padding-left: 18px;
  padding-right: 18px;
  min-height: 118px;
  align-items: start;
  /* bleed full width — no clip */
  width: 100%;
  box-sizing: border-box;
}

.explore-modal-rail::-webkit-scrollbar {
  display: none;
}

.explore-modal-rail-item {
  width: 88px;
  flex-shrink: 0;
  display: grid;
  gap: 8px;
  border: 0;
  background: transparent;
  color: #fff;
  text-align: left;
  padding: 0;
}

.explore-modal-rail-thumb {
  width: 88px;
  height: 88px;
  border-radius: 24px;
  background-size: cover;
  background-position: center;
  box-shadow: 0 18px 42px rgba(0,0,0,0.28);
}

.explore-modal-rail-item span {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: rgba(255,255,255,0.94);
  word-break: break-word;
}

.explore-modal-featured {
  width: 100%;
  justify-self: start;
  align-self: start;
  display: grid;
  gap: 10px;
  margin-top: 4px;
}

.explore-modal-featured-kicker {
  display: block;
  width: 100%;
  justify-self: start;
  text-align: left;
  color: rgba(255,255,255,0.88);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding-left: 18px;
}

.explore-category-rows {
  display: grid;
  gap: 26px;
}

.explore-category-row {
  display: grid;
  gap: 10px;
}

.explore-category-row-kicker {
  display: block;
  width: 100%;
  text-align: left;
  color: rgba(255,255,255,0.88);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding-left: 18px;
}

.explore-category-row-rail {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: visible;
  padding-bottom: 4px;
  padding-left: 18px;
  padding-right: 18px;
  min-height: 118px;
  align-items: start;
  width: 100%;
  box-sizing: border-box;
}
.explore-category-row-rail::-webkit-scrollbar {
  display: none;
}

.explore-modal-slider {
  width: 100%;
  display: flex;
  gap: 14px;
  overflow-x: auto;
  overflow-y: visible;
  padding: 0 18px 4px;
  box-sizing: border-box;
  justify-self: start;
  align-self: start;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
}

.explore-modal-slide {
  height: auto;
  width: min(82vw, 320px) !important;
  box-sizing: border-box;
  flex-shrink: 0;
  scroll-snap-align: start;
}

.explore-modal-slider::-webkit-scrollbar {
  display: none;
}

.explore-modal-featured-card {
  position: relative;
  width: 100%;
  height: calc((100vw - 18px) / 1.08);
  max-height: 280px;
  border: 0;
  border-radius: 22px;
  overflow: hidden;
  padding: 0;
  background: #0d0d0d;
  text-align: left;
  display: block;
}

.explore-modal-featured-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
}

.explore-modal-featured-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(8,8,8,0.0) 0%, rgba(8,8,8,0.15) 40%, rgba(8,8,8,0.78) 100%);
}

.explore-modal-featured-meta {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 1;
  display: grid;
  gap: 12px;
}

.explore-modal-brand-badge {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  overflow: hidden;
  border: 2px solid rgba(255,255,255,0.88);
  background: rgba(255,255,255,0.1);
}

.explore-modal-brand-badge img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.explore-modal-featured-copy {
  display: grid;
  gap: 6px;
}

.explore-modal-featured-copy strong {
  color: #fff;
  font-size: clamp(28px, 7vw, 40px);
  font-weight: 900;
  line-height: 0.88;
  letter-spacing: -0.06em;
  text-wrap: balance;
}

.explore-modal-featured-copy span {
  color: rgba(255,255,255,0.8);
  font-size: 13px;
  line-height: 1.45;
  max-width: 32ch;
}

.explore-search-results {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding-bottom: 8px;
  padding-left: 18px;
  padding-right: 18px;
}

.explore-search-card {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.06);
  border-radius: 18px;
  padding: 10px;
  color: #fff;
  text-align: left;
}

.explore-search-card-media {
  width: 54px;
  height: 54px;
  border-radius: 14px;
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
}

.explore-search-card-copy {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.explore-search-card-copy strong {
  font-size: 13px;
  font-weight: 800;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.explore-search-card-copy span {
  font-size: 11px;
  color: rgba(255,255,255,0.62);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.explore-modal-searchbar {
  padding: 14px 18px calc(env(safe-area-inset-bottom, 0px) + 18px);
  border-top: 1px solid rgba(255,255,255,0.06);
  background: linear-gradient(180deg, rgba(12,12,12,0) 0%, rgba(12,12,12,0.76) 30%, rgba(12,12,12,0.94) 100%);
}

.explore-modal-search-input {
  width: 100%;
  min-height: 50px;
  border-radius: 18px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.08);
  color: #fff;
  padding: 0 16px;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
}

.explore-modal-search-input::placeholder {
  color: rgba(255,255,255,0.45);
}

/* --- FOOTER TEXT --- */
.footer-text {
  position: fixed;
  /* Sin z-index el swiper (z-index:2) quedaba encima y se comía los clics
     de los enlaces legales: se veían pero no llevaban a ningún lado. */
  z-index: 12;
  padding: 40px 0;
  font-size: 11px;
  line-height: 1.6;
  opacity: 0.4;
  text-align: center;
  left: 0;
  right: 0;
  bottom: 10px;
  pointer-events: none;
}

.footer-legal-sep { pointer-events: none; }

.footer-legal-link {
  pointer-events: auto;
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid currentColor;
  padding-bottom: 1px;
}

/* --- VOTE CARD --- */
/* ── Voting overlay (~95% viewport, floating) ── */
.vote-screen-overlay {
  position: fixed;
  /* dvh accounts for the iOS Safari dynamic toolbar (URL bar) so the card
     never overflows or gets cropped behind it */
  top: max(2.5dvh, env(safe-area-inset-top, 10px));
  left: max(2.5vw, env(safe-area-inset-left, 8px));
  right: max(2.5vw, env(safe-area-inset-right, 8px));
  bottom: max(2.5dvh, env(safe-area-inset-bottom, 10px));
  border-radius: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #0d0d14;
  z-index: 20;
  overflow-y: auto;
  /* padding-bottom compensates for the iPhone home indicator bar */
  padding: 24px 16px max(24px, env(safe-area-inset-bottom, 24px));
  box-sizing: border-box;
  box-shadow: 0 0 0 1px rgba(255,255,255,0.06),
              0 30px 80px rgba(0,0,0,0.7);
  /* Smooth momentum scrolling on iOS */
  -webkit-overflow-scrolling: touch;
}

/* ── The card itself ── */
.vote-card {
  background: transparent;
  color: #ffffff;
  width: 100%;
  max-width: 450px;
  border-radius: 28px;
  padding: 28px;
  box-shadow: none;
}
.live-tag {
  font-size: 9px; color: white; padding: 4px 8px;
  border-radius: 6px; font-weight: 900; margin-bottom: 10px; display: inline-block;
}

.question-title { font-size: 24px; font-weight: 800; line-height: 1.2; margin-bottom: 25px; color: #ffffff; }

.opt-btn {
  width: 100%; display: flex; align-items: center; background: rgba(255,255,255,0.07);
  border: 2px solid rgba(255,255,255,0.12); border-radius: 18px; margin-bottom: 10px;
  padding: 8px; cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, border-color 0.15s ease;
  touch-action: manipulation; /* prevents 300ms iOS tap delay and accidental double-tap zoom */
  -webkit-tap-highlight-color: transparent;
}
.opt-btn.is-selected {
  border-width: 2.5px !important;
  transform: translateY(-3px) scale(1.025);
  box-shadow: 0 8px 28px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.08);
}
.opt-label {
  width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;
  background: rgba(255,255,255,0.15); color: #ffffff; border-radius: 12px; font-weight: 800;
  flex-shrink: 0;
  transition: background 0.15s ease;
}
.opt-text { padding-left: 15px; font-weight: 700; font-size: 15px; color: rgba(255,255,255,0.9); flex: 1; text-align: left; }

/* Checkmark badge that appears on the right when an option is selected */
.opt-selected-check {
  margin-left: auto;
  margin-right: 4px;
  width: 26px; height: 26px;
  background: rgba(255,255,255,0.95);
  color: #111;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; font-weight: 900;
  flex-shrink: 0;
  animation: checkPop 0.18s cubic-bezier(0.34,1.56,0.64,1) both;
}
@keyframes checkPop {
  from { transform: scale(0); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

.minimal-textarea {
  width: 100%; background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.15);
  padding: 15px; border-radius: 15px;
  /* 16px minimum prevents iOS Safari from auto-zooming the viewport on focus */
  font-size: 16px;
  outline: none; resize: none;
  min-height: 80px; box-sizing: border-box; color: #ffffff;
  touch-action: manipulation;
}
.minimal-textarea::placeholder { color: rgba(255,255,255,0.4); }

.btn-submit-full {
  width: 100%; margin-top: 20px; padding: 20px; border-radius: 20px;
  background: black;
  border: none; color: white; font-weight: 800; font-size: 16px;
}

.lang-switcher {
  width: fit-content;
  margin: 0;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 4;
  flex-shrink: 0;
}

.lang-toggle-btn {
  border: 1px solid rgba(255,255,255,0.15);
  background: rgba(255,255,255,0.08);
  color: #fff;
  border-radius: 999px;
  padding: 8px 12px;
  min-height: 38px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 116px;
  justify-content: space-between;
  backdrop-filter: blur(10px);
}

.lang-toggle-caret {
  transition: transform 0.2s ease;
}

.lang-toggle-caret.open {
  transform: rotate(180deg);
}

.lang-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 152px;
  padding: 8px;
  border-radius: 18px;
  background: rgba(18,18,18,0.96);
  border: 1px solid rgba(255,255,255,0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 10;
}

.lang-dropdown-item {
  border: none;
  background: transparent;
  color: rgba(255,255,255,0.82);
  border-radius: 12px;
  padding: 9px 10px;
  font-size: 12px;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
  text-align: center;
}

.lang-dropdown-item.active {
  background: #fff;
  color: #111;
}

.moments-mobile-card {
  background: #ffffff;
  color: #121212;
  width: 95%;
  max-width: 480px;
  border-radius: 30px;
  padding: 22px 20px 20px;
  box-shadow: 0 18px 40px rgba(0,0,0,0.12);
  border: 1px solid rgba(255,255,255,0.8);
  font-family: 'Poppins', sans-serif;
  margin: 0 auto auto;
  align-self: center;
  max-height: calc(98vh - 110px);
  box-sizing: border-box;
  position: relative;
  z-index: 5;
  transform: translateY(-12px);
}

.moments-mobile-header .question-title {
  margin-bottom: 8px;
  color: #111;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.3px;
}

.moments-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 12px;
  border-radius: 999px;
  background: #f3f3f3;
  color: #555;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 12px;
}

.moments-instruction {
  margin: 0;
  color: #5f5f5f;
  font-size: 13px;
  line-height: 1.55;
  font-weight: 400;
}

.moments-upload-stage {
  margin: 14px 0 10px;
  display: flex;
  justify-content: center;
}

.moments-photo-frame {
  width: 100%;
  display: flex;
  justify-content: center;
}

.moments-photo-frame.portrait .moments-photo-picker {
  width: min(80%, 250px);
  min-height: 300px;
}

.moments-photo-frame.landscape .moments-photo-picker {
  width: 100%;
  min-height: 180px;
}

.moments-photo-frame.square .moments-photo-picker {
  width: min(88%, 280px);
  min-height: 220px;
}

.moments-photo-picker {
  width: 100%;
  border-radius: 24px;
  border: 1px solid rgba(17,17,17,0.08);
  background: #f9f9f9;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  transition: transform 0.2s ease;
}

.moments-photo-picker:active {
  transform: scale(0.985);
}

.moments-photo-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.moments-photo-empty {
  min-height: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #585858;
  font-weight: 500;
  padding: 24px;
  font-size: 13px;
}

.moments-upload-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b3b3b;
  border: 1px solid rgba(0,0,0,0.08);
}

.moments-photo-empty svg {
  width: 28px;
  height: 28px;
}

.moments-upload-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.moments-textarea {
  background: #fff;
  border: none;
  border-bottom: 1px solid rgba(0,0,0,0.12);
  border-radius: 0;
  padding: 14px 2px 12px;
  color: #111;
  min-height: 64px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px; /* ≥16px prevents iOS Safari auto-zoom on focus */
  line-height: 1.55;
  font-weight: 400;
  box-shadow: none;
}

.moments-textarea::placeholder {
  color: #9b9b9b;
  font-weight: 400;
}

.moments-counter {
  margin-top: 6px;
  text-align: right;
  color: #8d8d8d;
  font-size: 11px;
  font-weight: 500;
}

.moments-submit-btn {
  margin-top: 18px;
  border-radius: 18px;
  padding: 16px;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 600;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.moments-submit-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.moments-submit-btn:not(:disabled):active {
  transform: scale(0.985);
}

.moments-success-text {
  margin-top: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #2f7d44;
  text-align: center;
}

.moments-waiting-state {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
  padding: 24px 12px 8px;
}

.moments-waiting-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #111;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
}

.moments-waiting-copy {
  margin: 0;
  max-width: 290px;
  color: #626262;
  font-size: 13px;
  line-height: 1.5;
}

/* UTILS */
.animate-in { animation: fadeInUp 0.5s ease-out; }
.animate-inLeft { animation: fadeInLeft 0.5s ease-out; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
@keyframes blink { 50% { opacity: 0.2; } }
.poppins-bold { font-weight: 800; }

.btn-exit-text {
  width: 20%;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  padding: 10px;
  text-transform: uppercase;
}

.success-screen {
  position: fixed;
  top: 2.5vh;
  left: 2.5vw;
  right: 2.5vw;
  bottom: 2.5vh;
  border-radius: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #0d0d14;
  z-index: 20;
  padding: 32px 20px;
  box-sizing: border-box;
  box-shadow: 0 0 0 1px rgba(255,255,255,0.06),
              0 30px 80px rgba(0,0,0,0.7);
}

/* ── Standard success (pregunta / multichoice / ordenar) ── */
.standard-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

.check-circle {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 38px;
  color: white;
  background: var(--brand, #6c63ff);
  border: 4px solid rgba(255,255,255,0.25);
  box-shadow: 0 0 0 10px rgba(255,255,255,0.07),
              0 20px 50px rgba(0,0,0,0.5);
  margin-bottom: 24px;
  animation: popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.standard-success h2 {
  font-size: 26px;
  font-weight: 800;
  color: white;
  margin: 0 0 10px;
  animation: fadeUp 0.4s 0.15s ease both;
}

.standard-success p {
  font-size: 15px;
  color: rgba(255,255,255,0.55);
  margin: 0 0 20px;
  animation: fadeUp 0.4s 0.25s ease both;
}

.standard-success-confetti {
  display: flex;
  gap: 12px;
  font-size: 22px;
  justify-content: center;
  animation: fadeUp 0.4s 0.35s ease both;
}


@keyframes popIn {
  0% { transform: scale(0); opacity: 0; }
  80% { transform: scale(1.1); }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes fadeUp {
  0%   { transform: translateY(16px); opacity: 0; }
  100% { transform: translateY(0);    opacity: 1; }
}

.spinner-simple {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(255,255,255,0.1);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 20px auto;
}
@keyframes spin { to { transform: rotate(360deg); } }

.empty-state{
      display: flex;
    flex-direction: column;
    align-items: center;
}

.glass-info-card {
 
  padding: 30px; 
    
  text-align: center;
  width: 90%;
}
.connected-badge {
  font-size: 10px;
  padding: 4px 10px;
  border-radius: 20px;
  display: inline-block;
  margin-bottom: 10px;
 
}

.room-name{
  font-size: clamp(22px, 5vw, 30px);
  text-align: center;
  line-height: 1.05;
  max-width: min(88vw, 420px);
  margin: 0 auto;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-wrap: balance;
}

/* El contenedor que cubre toda la pantalla */
.bottom-sheet-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85); /* Fondo oscuro */
  backdrop-filter: blur(8px);    /* Desenfoque de fondo */
  z-index: 9999;                 /* Por encima de TODO */
  display: flex;
  align-items: flex-end;         /* Alinea el contenido abajo */
}

/* La tarjeta que sube */
.bottom-sheet.profile-setup {
  width: 100%;
  background: #1a1a1a;
  border-radius: 30px 30px 0 0;
  padding: 20px 25px 50px 25px;
  box-shadow: 0 -10px 40px rgba(0,0,0,0.5);
  border-top: 1px solid rgba(255,255,255,0.1);
}

.handle {
  width: 40px;
  height: 4px;
  background: rgba(255,255,255,0.2);
  border-radius: 2px;
  margin: 0 auto 20px auto;
}

.avatar-preview-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.avatar-setup-img {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  border: 3px solid var(--brand-color);
  object-fit: cover;
  padding: 5px;
  background: #252525;
}

.profile-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.minimal-input {
  width: 100%;
  background: #252525;
  border: 1px solid #333;
  padding: 15px;
  border-radius: 15px;
  color: white;
  font-size: 16px;
  outline: none;
  box-sizing: border-box;
}

.minimal-input:focus {
  border-color: var(--brand-color);
}

.profile-setup {
  padding: 30px;
  background: #1a1a1a;
  border-top: 1px solid #333;
}

.avatar-preview-container {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}

.avatar-setup-img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 4px solid var(--brand-color);
  object-fit: cover;
  background: #333;
}

.profile-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
}

.input-group label {
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
  opacity: 0.6;
}

.input-row {
  display: flex;
  gap: 15px;
}

.minimal-input {
  background: #2c2c2c;
  border: 1px solid #444;
  padding: 12px 15px;
  border-radius: 12px;
  color: white;
  outline: none;
}

.minimal-input:focus {
  border-color: var(--brand-color);
}

.btn-save-profile {
  margin-top: 10px;
  padding: 18px;
  border-radius: 15px;
  border: none;
  color: white;
  font-weight: 800;
  font-size: 16px;
  cursor: pointer;
}

.mini-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.avatar-setup-img {
  transition: opacity 0.3s ease;
}

/* Instrucción secundaria */
.instruction-text {
  font-size: 14px;
  color: rgba(255,255,255,0.55);
  margin-top: -15px;
  margin-bottom: 20px;
}

.order-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.sortable-item {
  display: flex;
  align-items: center;
  background: rgba(255,255,255,0.07);
  padding: 15px;
  border-radius: 16px;
  cursor: grab;
  border: 1px solid rgba(255,255,255,0.1);
  transition: all 0.2s;
}

.sortable-item:active {
  cursor: grabbing;
  transform: scale(1.02);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.sort-badge {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  margin-right: 15px;
}

.sort-text {
  flex: 1;
  font-weight: 700;
  color: rgba(255,255,255,0.9);
  font-size: 15px;
}

/* Las 3 rayitas de la derecha */
.sort-handle span {
  display: block;
  width: 15px;
  height: 2px;
  background: rgba(255,255,255,0.3);
  margin: 2px 0;
  border-radius: 2px;
}

/* Efecto visual al arrastrar */
.sortable-ghost {
  opacity: 0.2;
  border: 2px dashed var(--brand-color) !important;
  background: white;
}

.sortable-drag {
  opacity: 1;
  background: white !important;
  border-color: var(--brand-color);
}



.quiz-timer-container-circular {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 25px;
  background: rgba(255, 255, 255, 0.05);
  padding: 15px;
  border-radius: 20px;
}

.circular-timer {
  position: relative;
  width: 70px;
  height: 70px;
}

.circular-chart {
  display: block;
  width: 100%;
  height: 100%;
}

.circle-bg {
  fill: none;
  stroke: rgba(23, 23, 23, 0.1);
  stroke-width: 2.8;
}

.circle {
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
  transition: stroke-dasharray 1s linear, stroke 0.3s;
}

.timer-percentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 22px;
  color: #ffffff;
}

.timer-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.instruction-text-mini {
  font-size: 12px;
  color: #aaa;
  margin: 5px 0 0 0;
}

.timer-low {
  color: #ff5252 !important;
  animation: pulse-red 0.5s infinite alternate;
}

/* Pantalla de Tiempo Agotado */
.time-expired-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  padding: 20px;
}

.big-timer-zero {
  position: relative;
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
}

.circle-bg-expired {
  fill: none;
  stroke: #ff5252;
  stroke-width: 3;
  stroke-dasharray: 100, 100; /* Círculo completo pero estático */
  opacity: 0.3;
}

.zero-num {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 50px;
  color: #ff5252;
}

.time-expired-overlay h2 {
  color: #ff5252;
  letter-spacing: 1px;
  font-size: 24px;
  margin-bottom: 10px;
}

.expired-subtitle {
  color: #888;
  font-size: 16px;
  max-width: 250px;
  margin: 0 auto 30px;
}

.attention-box {
  background: rgba(0, 0, 0, 0.05);
  border: 1px dashed rgba(197, 197, 197, 0.2);
  padding: 15px;
  border-radius: 15px;
  color: #ccc;
  font-size: 14px;
}

/* Re-utilizamos tus animaciones */
.animate__animated {
  animation-duration: 0.5s;
}

.expired-content{
      display: flex;
    flex-direction: column;
    align-items: center;
}




/* --- OVERLAY PARA PODER CERRAR CON CLIC AFUERA --- */
.uvoto-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  z-index: 5000;
  display: flex;
  align-items: flex-end;
}




/* --- OVERLAY PARA PODER CERRAR CON CLIC AFUERA --- */
/* --- OVERLAY PARA PODER CERRAR CON CLIC AFUERA --- */
.uvoto-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 5000;
  display: flex;
  align-items: flex-end;
}

/* --- PANEL PRINCIPAL --- */
.uvoto-premium-panel {
  width: 100%;
  background: #ffffff;
  border-radius: 32px 32px 0 0;
  overflow: hidden;
  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.2);
  position: relative;
  animation: slideUp 0.35s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.drag-handle {
  width: 40px;
  height: 5px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  cursor: pointer;
}

/* --- BANNER COMPACTO --- */
.panel-banner {
  position: relative;
  height: 120px; /* Un poco más ajustado para dar foco al input */
  width: 100%;
}
.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(transparent, rgba(0,0,0,0.8));
  display: flex;
  align-items: flex-end;
  padding: 15px 20px;
}
.event-name-overlay {
  color: white;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  max-width: calc(100% - 48px);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.btn-close-modern {
  position: absolute;
  top: 15px;
  right: 20px;
  background: rgba(0, 0, 0, 0.4);
  border: none;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
  cursor: pointer;
}

.panel-body {
  padding: 20px;
  background: #ffffff;
}

/* =========================================
   NUEVO COMPOSITOR ESTILO PROMPT AI
   ========================================= */

.prompt-composer-box {
  background: #f4f4f4; /* Fondo gris claro unificado */
  border-radius: 24px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #eaeaea;
}

/* Fila Superior: Textarea + Botón Enviar */
.prompt-top-row {
  display: flex;
  align-items: flex-end; /* Alinea el botón abajo si el texto crece */
  gap: 10px;
}

.prompt-textarea {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  resize: none;
  font-size: 16px;
  font-family: inherit;
  color: #333;
  min-height: 40px;
  max-height: 100px; /* Evita que crezca infinitamente */
  line-height: 1.4;
  padding-top: 8px;
}

.prompt-textarea::placeholder {
  color: #999;
}

/* Botón Enviar (Flecha hacia arriba) */
.btn-send-up {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.btn-send-up:disabled {
  color: #a0a0a0;
  cursor: not-allowed;
}

/* Fila Inferior: Texto + Emojis */
.prompt-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e5e5e5; /* Ligera línea separadora opcional */
  padding-top: 8px;
}

.prompt-helper-text {
  font-size: 0.85rem;
  color: #666;
  font-weight: 500;
}

/* Emojis alineados horizontalmente */
.prompt-emoji-row {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.emoji-inline-btn {
  background: transparent;
  border: none;
  font-size: 1.6rem; /* Tamaño ideal para tocar en horizontal */
  padding: 0;
  cursor: pointer;
  transition: transform 0.1s ease;
  -webkit-tap-highlight-color: transparent;
  position: relative;
}

.emoji-inline-btn:active {
  transform: scale(0.8);
}

/* Animación de panel */
@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

/* Animación fantasma para emojis (mantener la tuya) */
.ghost-emoji {
  position: absolute;
  top: 0;
  pointer-events: none;
  user-select: none;
  z-index: 10;
  animation: ghostFlyUp 0.6s ease-out forwards;
  font-size: 2rem;
  opacity: 0.8;
}

@keyframes ghostFlyUp {
  0% { transform: translateY(0) scale(1); opacity: 0.8; }
  100% { transform: translateY(-80px) scale(1.5); opacity: 0; filter: blur(2px); }
}

/* =========================================
   NUEVO COMPOSITOR ESTILO PROMPT AI
   ========================================= */

.prompt-composer-box {
  background: #f4f4f4; /* Fondo gris claro unificado */
  border-radius: 24px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #eaeaea;
}

/* Fila Superior: Textarea + Botón Enviar */
.prompt-top-row {
  display: flex;
  align-items: flex-end; /* Alinea el botón abajo si el texto crece */
  gap: 10px;
  background: #f1f1f1;
  padding: 8px 12px;
  border-radius: 50px;
  margin-top: 10px;
}

.chat-avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  object-fit: cover;
}

.chat-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  resize: none;
  font-size: 13px;
  font-family: inherit;
  color: #333;
  min-height: 40px;
  max-height: 100px; /* Evita que crezca infinitamente */
  line-height: 1.4;
  padding-top: 8px;
}

.prompt-textarea::placeholder{
  font-size: 13px;
}

.prompt-textarea::placeholder {
  color: #999;
}

/* Botón Enviar (Flecha hacia arriba) */
.btn-send-up {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.btn-send-up:disabled {
  color: #a0a0a0;
  cursor: not-allowed;
}

/* Fila Inferior: Texto + Emojis */
.prompt-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e5e5e5; /* Ligera línea separadora opcional */
  padding-top: 8px;
}

.prompt-helper-text {
  font-size: 11px;
  color: #666;
  font-weight: 500;
  text-align: left;
}

/* Emojis alineados horizontalmente */
.prompt-emoji-row {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.emoji-inline-btn {
  background: transparent;
  border: none;
  font-size: 1.6rem; /* Tamaño ideal para tocar en horizontal */
  padding: 0;
  cursor: pointer;
  transition: transform 0.1s ease;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  background: white;
  height: 40px;
  width: 40px;
  border-radius: 14px;
}

.emoji-inline-btn:active {
  transform: scale(0.8);
}

/* Animación de panel */
@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

/* Animación fantasma para emojis (mantener la tuya) */
.ghost-emoji {
  position: absolute;
  top: 0;
  pointer-events: none;
  user-select: none;
  z-index: 10;
  animation: ghostFlyUp 0.6s ease-out forwards;
  font-size: 2rem;
  opacity: 0.8;
}

@keyframes ghostFlyUp {
  0% { transform: translateY(0) scale(1); opacity: 0.8; }
  100% { transform: translateY(-80px) scale(1.5); opacity: 0; filter: blur(2px); }
}




.btn-flotante-pregunta {
   position: fixed;
     bottom: 12%;
    right: 20px;
    padding: 8px 20px;
    border-radius: 30px;
    background: #ffffff;
    color: #0c0c0c;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    z-index: 999;
    font-weight: bold;
  
}

.pulse-mini {
  animation: pulse-animation 2s infinite;
}

@keyframes pulse-animation {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0,0,0,0.4); }
  70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(0,0,0,0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0,0,0,0); }
}


/* Modal y Burbujas */
.modal-consultas {
  position: fixed;
  bottom: 0; left: 0; right: 0;
  height: 80vh;
  background: #f8f9fa;
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
}

.aviso-respeto {
  background: #e3f2fd;
  padding: 10px;
  border-radius: 10px;
  font-size: 0.85rem;
  margin-bottom: 15px;
  color: #1976d2;
  display: flex;
  gap: 10px;
}

.burbuja-consulta {
  margin-bottom: 20px;
}

.mi-pregunta {
  background: white;
  padding: 12px;
  border-radius: 15px 15px 0 15px;
  margin-left: 20%;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.respuesta-ia {
  background: #f0f0f0;
  padding: 12px;
  border-radius: 15px 15px 15px 0;
  margin-right: 20%;
  margin-top: 10px;
  border-left: 4px solid var(--brand-color);
}




.chat-empty-state {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 0 8px 0;
}

.chat-welcome-bubble {
  align-self: flex-start;
  background: #f0f0f0;
  border-radius: 18px 18px 18px 4px;
  padding: 11px 14px;
  max-width: 80%;
  margin-bottom: 12px;
}

.chat-welcome-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: #111;
}

.chat-starters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chat-starter-chip {
  background: transparent;
  border: 1.5px solid rgba(17, 17, 17, 0.18);
  border-radius: 20px;
  padding: 7px 14px;
  font-size: 13px;
  color: #111;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  text-align: left;
  line-height: 1.3;
}

.chat-starter-chip:hover {
  background: rgba(17, 17, 17, 0.06);
  border-color: rgba(17, 17, 17, 0.32);
}

.msg-ai-followup-chip {
  display: inline-block;
  background: transparent;
  border: 1.5px solid rgba(17, 17, 17, 0.18);
  border-radius: 20px;
  padding: 7px 14px;
  font-size: 13px;
  color: rgba(17, 17, 17, 0.75);
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.15s, border-color 0.15s;
  text-align: left;
  line-height: 1.3;
}

.msg-ai-followup-chip:hover {
  background: rgba(17, 17, 17, 0.06);
  border-color: rgba(17, 17, 17, 0.32);
  color: #111;
}

.apple-icon-circle {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #f5f5f7 0%, #e8e8ed 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  margin-bottom: 20px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.05);
}

.apple-title {
  font-size: 22px;
  font-weight: 600;
  color: #1d1d1f;
  margin-bottom: 8px;
  letter-spacing: -0.02em;
}

.apple-subtitle {
  font-size: 14px;
  color: #86868b;
  max-width: 300px;
  line-height: 1.4;
  margin-bottom: 30px;
}

/* Grilla de sugerencias */
.apple-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 100%;
  max-width: 320px;
  margin-bottom: 40px;
}

.apple-card-hint {
  background: #f5f5f7;
  padding: 15px 10px;
  border-radius: 18px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.apple-card-hint:active {
  transform: scale(0.95);
  background: #e8e8ed;
}

.hint-icon {
  font-size: 20px;
  display: block;
  margin-bottom: 5px;
}

.apple-card-hint p {
  font-size: 11px;
  font-weight: 500;
  color: #1d1d1f;
  margin: 0;
}

.apple-instruction-footer {
  font-size: 12px;
  color: #86868b;
  background: rgba(0,0,0,0.03);
  padding: 8px 15px;
  border-radius: 20px;
}


/* ÍCONOS SVG GENÉRICOS */
.svg-premium-icon {
  width: 24px;
  height: 24px;
  color: #353535; /* Hereda el color del contenedor */
  transition: transform 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}

/* ÍCONO PRINCIPAL (Magia/IA) */
.main-ai-icon {
  width: 36px;
  height: 36px;
  color: #fff; /* O el color principal de tu branding */
}

.apple-icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%); /* Gradiente Apple-like */
  margin: 0 auto 20px auto;
  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.3);
}

/* CONTENEDOR DE LOS ÍCONOS DE LAS TARJETAS */
.hint-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05); /* Fondo sutil para dar volumen */
  color: #a1a1aa; /* Color base del icono */
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

/* ANIMACIÓN HOVER DE LAS TARJETAS */
.apple-card-hint:hover .hint-icon-wrapper {
  background: rgba(99, 102, 241, 0.1);
  color: #818cf8; /* El SVG se colorea al heredar esto */
}

.apple-card-hint:hover .svg-premium-icon {
  transform: scale(1.1); /* Ligero zoom premium */
}

/* ÍCONO DEL FOOTER (BOMBILLA) */
.apple-instruction-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #a1a1aa;
}

.svg-tip-icon {
  width: 18px;
  height: 18px;
  color: #fbbf24; /* Tono ámbar/dorado para la bombilla */
}

/* --- MODAL OVERLAY OSCURO --- */
.modal-consultas-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.75);
  backdrop-filter: blur(12px);
  z-index: 5000;
  display: flex;
  align-items: flex-end;
}

/* --- MODO CHAT STANDALONE (ruta /chat/:slug) --- */

/* Lock page scroll when in chat-only mode */
html.chat-only-page,
html.chat-only-page body {
  overflow: hidden;
  height: 100%;
  width: 100%;
}

/* Loading cover that hides all UserView content while connecting */
.chat-only-loading-cover {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #111;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.chat-only-preview-bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
}
.chat-only-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(12px);
  transform: scale(1.06);
}
.chat-only-preview-dim {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.55);
}

.chat-only-brand-center {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 40px;
}
.chat-only-brand-logo {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  object-fit: cover;
  background: rgba(255,255,255,0.1);
}
.chat-only-brand-name {
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.01em;
  text-align: center;
  margin: 0;
}

.chat-only-spinner {
  position: relative;
  z-index: 1;
}
.chat-only-spinner-ring {
  width: 32px;
  height: 32px;
  border: 2.5px solid rgba(255,255,255,0.2);
  border-top-color: #fff;
  border-radius: 50%;
  animation: chatOnlySpin 0.75s linear infinite;
}
@keyframes chatOnlySpin {
  to { transform: rotate(360deg); }
}

.modal-consultas-overlay.is-chat-only {
  background: none;
  backdrop-filter: none;
  align-items: stretch;
  z-index: 10;
}
.modal-consultas-overlay.is-chat-only .modal-consultas-modern {
  height: 100% !important;
  max-width: 100% !important;
  border-radius: 0 !important;
  animation: none !important;
  transform: none !important;
}

/* --- CONTENEDOR PRINCIPAL --- */
.modal-consultas-modern {
  width: 100%;
  height: 85vh;
  position: relative; /* Added for absolute positioning of children */
  background: #ffffff;
  border-radius: 28px 28px 0 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.35s ease;
  will-change: transform, height;
  transition: transform 0.22s ease, height 0.22s ease;
}

/* El límite de 400px solo tiene sentido en pantallas de tablet/desktop —
   en teléfonos (incluyendo los iPhone más anchos, 428-430px) el chat debe
   cubrir el ancho completo. */
@media (min-width: 600px) {
  .modal-consultas-modern {
    max-width: 400px;
  }
}

/* HEADER */
.chat-header-modern {
  padding: 16px 18px 14px;
  color: rgb(0, 0, 0);
  position: relative;
  border-bottom: 1px solid rgba(17,17,17,0.06);
  background: #ffffff;
}

.chat-header-identity {
  display: flex;
  align-items: center;
  gap: 12px;
}

.chat-header-avatar {
  width: 52px;
  height: 52px;
  border-radius: 18px;
  overflow: hidden;
  background: #111;
  flex-shrink: 0;
}

.chat-header-avatar img,
.chat-header-avatar-fallback {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.chat-header-avatar-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 800;
}

.chat-header-copy {
  min-width: 0;
  flex: 1;
  text-align: left;
}

.chat-header-kicker {
  display: block;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: rgba(17,17,17,0.42);
  margin-bottom: 3px;
}

.chat-header-copy h3 {
  margin: 0;
  font-size: 18px;
  line-height: 1.05;
  color: #111;
}

.chat-header-copy p {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: rgba(17,17,17,0.62);
}

.drag-line {
  width: 40px;
  height: 4px;
  background: rgba(255,255,255,0.3);
  border-radius: 10px;
  margin: 0 auto 10px auto;
}

/* ── Quick App Bar (Bottom CTA) ────────────────── */
.chat-quick-app-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 92% !important;
  max-width: 500px;
  margin: 0 auto 16px auto !important;
  padding: 12px 16px;
  border-radius: 14px;
  cursor: pointer;
  color: #fff;
  transition: transform 0.15s ease, filter 0.2s ease;
  user-select: none;
  z-index: 10;
  box-shadow: 0 4px 14px rgba(0,0,0,0.18);
  box-sizing: border-box;
  text-align: left;
}
.chat-quick-app-bar:active {
  transform: scale(0.97);
  filter: brightness(0.9);
}
.quick-app-bar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
  width: 100%;
}
.quick-app-bar-icon-box {
  width: 42px;
  height: 42px;
  background: rgba(255,255,255,0.25);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}
.quick-app-bar-logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.quick-app-bar-copy {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.quick-app-bar-title {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.quick-app-bar-subtitle {
  font-size: 11px;
  opacity: 0.8;
  font-weight: 500;
}
.quick-app-bar-right {
  opacity: 0.8;
}
.chat-quick-app-pill-inner:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0,0,0,0.22);
}
.chat-quick-app-pill-inner:active {
  transform: scale(0.96);
}


/* BODY */
.chat-body-modern {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* MENSAJES */
.chat-message {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 8px;
}

/* BURBUJA USUARIO */
.msg-user {
  align-self: flex-end;
  background: #ececec;
  color: #121212;
  padding: 13px 18px;
  border-radius: 20px 20px 6px 20px;
  max-width: 75%;
  font-size: 14px;
  line-height: 1.45;
  margin-top: 6px;
  margin-bottom: 4px;
  box-shadow: none;
  text-align: left;
}

.msg-user-voice {
  align-self: flex-end;
  min-width: 210px;
  max-width: 82%;
  padding: 12px 14px;
  border-radius: 22px 22px 8px 22px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.voice-note-play {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.16);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.voice-note-play svg {
  width: 18px;
  height: 18px;
}

.voice-note-play.is-dark {
  background: #111;
  color: #fff;
}

.voice-note-wave {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 3px;
  min-width: 0;
}

.voice-note-wave span {
  width: 3px;
  border-radius: 999px;
  background: rgba(255,255,255,0.52);
}

.voice-note-wave span:nth-child(1),
.voice-note-wave span:nth-child(7) { height: 8px; }
.voice-note-wave span:nth-child(2),
.voice-note-wave span:nth-child(10) { height: 16px; }
.voice-note-wave span:nth-child(3),
.voice-note-wave span:nth-child(11) { height: 12px; }
.voice-note-wave span:nth-child(4),
.voice-note-wave span:nth-child(8) { height: 20px; }
.voice-note-wave span:nth-child(5),
.voice-note-wave span:nth-child(9) { height: 14px; }
.voice-note-wave span:nth-child(6),
.voice-note-wave span:nth-child(12) { height: 10px; }

.voice-note-wave.is-dark span {
  background: rgba(17,17,17,0.22);
}

.voice-note-wave.is-recording span:nth-child(odd) {
  animation: voiceWavePulse 1s ease-in-out infinite;
}

.voice-note-wave.is-recording span:nth-child(even) {
  animation: voiceWavePulse 1s ease-in-out infinite 0.18s;
}

.voice-note-duration {
  font-size: 11px;
  font-weight: 700;
  color: rgba(255,255,255,0.82);
  white-space: nowrap;
}

.chat-voice-draft .voice-note-duration {
  color: rgba(17,17,17,0.58);
}

/* BURBUJA IA */
.msg-ai {
  align-self: stretch;
  background: transparent;
  color: #171717;
  padding: 0;
  border-radius: 0;
  max-width: 92%;
  font-size: 14px;
  line-height: 1.55;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 10px;
}

.msg-ai-text {
  white-space: pre-line;
  color: #161616;
  font-size: 14px;
  line-height: 1.6;
}

.msg-ai-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.msg-ai-block-title {
  margin: 0;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(17, 17, 17, 0.42);
}

.ai-people-list,
.ai-facts-list,
.ai-timeline {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ai-person-card,
.ai-fact-pill,
.ai-note-card {
  background: #ffffff;
  border: 1px solid rgba(17, 17, 17, 0.06);
  border-radius: 16px;
  padding: 10px 12px;
  box-shadow: none;
}

.ai-person-card {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 1px solid rgba(17, 17, 17, 0.06);
  text-align: left;
  cursor: pointer;
  justify-content: space-between;
}

.ai-person-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.ai-link-chip {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: #ffffff;
  color: #111111;
  border-radius: 999px;
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 600;
  box-shadow: inset 0 0 0 1px rgba(17, 17, 17, 0.08);
  flex-shrink: 0;
}

.ai-link-chip svg {
  width: 14px;
  height: 14px;
}

.ai-person-avatar {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  object-fit: cover;
  flex-shrink: 0;
}

.ai-person-avatar-fallback {
  background: #e4e4e4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111111;
  font-weight: 700;
}

.ai-person-copy,
.ai-timeline-copy,
.ai-fact-pill {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ai-person-copy strong,
.ai-timeline-copy strong,
.ai-fact-pill strong {
  font-size: 13px;
  color: #111111;
}

.ai-person-copy span,
.ai-timeline-copy span,
.ai-fact-pill span,
.ai-person-copy small,
.ai-timeline-copy small,
.ai-fact-pill small,
.ai-note-card p {
  color: rgba(17, 17, 17, 0.66);
  font-size: 12px;
  line-height: 1.4;
  margin: 0;
}

.ai-timeline-step {
  display: grid;
  grid-template-columns: 14px 1fr;
  gap: 10px;
  align-items: flex-start;
}

.ai-timeline-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  margin-top: 4px;
  background: rgba(17, 17, 17, 0.22);
  box-shadow: 0 0 0 3px rgba(17, 17, 17, 0.06);
}

.ai-timeline-dot.is-current {
  background: #111111;
}

.ai-timeline-dot.is-upcoming {
  background: rgba(17, 17, 17, 0.52);
}

.ai-timeline-dot.is-past {
  background: rgba(17, 17, 17, 0.18);
}

.msg-ai-followup {
  margin: 0;
  font-size: 12px;
  color: rgba(17, 17, 17, 0.56);
}
/* ── Progressive reveal animations ──────────────────────────── */

/* Read receipt ticks after user sends */
.msg-sent-receipt {
  align-self: flex-end;
  display: flex;
  justify-content: flex-end;
  margin-top: -6px;
  margin-bottom: 4px;
  padding-right: 4px;
  animation: receipt-fade-in 0.25s ease both;
}
.msg-sent-receipt svg {
  width: 18px;
  height: 10px;
  color: rgba(0, 0, 0, 0.35);
}
.msg-sent-receipt--pending svg {
  width: 10px;
  height: 10px;
}
@keyframes receipt-fade-in {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* "Nombre está escribiendo..." indicator */
.msg-ai-writing {
  align-self: flex-start;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 6px;
  display: flex;
  align-items: baseline;
  gap: 3px;
  animation: typing-wrap-in 0.22s ease both;
}
@keyframes typing-wrap-in {
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
}
.msg-ai-writing.is-delayed {
  animation-delay: 2s;
}
.msg-ai-writing-name {
  color: rgba(0, 0, 0, 0.7);
  font-weight: 600;
}
.msg-ai-writing-dots {
  display: inline-flex;
  align-items: baseline;
  gap: 1px;
}
.msg-ai-writing-dots span {
  display: inline-block;
  animation: dot-wave 1.3s infinite ease-in-out;
  font-size: 15px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.45);
}
.msg-ai-writing-dots span:nth-child(1) { animation-delay: 0s; }
.msg-ai-writing-dots span:nth-child(2) { animation-delay: 0.18s; }
.msg-ai-writing-dots span:nth-child(3) { animation-delay: 0.36s; }
@keyframes dot-wave {
  0%, 60%, 100% { transform: translateY(0);    opacity: 0.4; }
  30%            { transform: translateY(-4px); opacity: 1;   }
}

@keyframes msg-fade-up {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}
.msg-reveal-in {
  animation: msg-fade-up 0.28s ease both;
}
/* ─────────────────────────────────────────────────────────── */

.msg-ai-loading {
  align-self: flex-start;
  width: min(78%, 260px);
}

.msg-ai-loading-card {
  width: 100%;
  padding: 6px 0;
  border-radius: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  backdrop-filter: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
  position: relative;
}

.msg-ai-loading-line {
  height: 9px;
  border-radius: 999px;
  background: rgba(17, 17, 17, 0.08);
}

.msg-ai-loading-line.short {
  width: 36%;
}

.msg-ai-loading-line.medium {
  width: 62%;
}

.shimmer {
  background: linear-gradient(90deg, rgba(17, 17, 17, 0.019) 0%, rgba(255, 255, 255, 0.046) 48%, rgba(17,17,17,0.05) 100%);
  background-size: 200% 100%;
  border: none;
  animation: aiShimmer 1.35s linear infinite;
}

.ai-profile-overlay {
  position: absolute;
  inset: 0;
  background: rgba(17, 17, 17, 0.18);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 30;
}

.ai-profile-sheet {
  width: min(100%, 320px);
  background: #ffffff;
  border-radius: 28px;
  padding: 18px;
  box-shadow: 0 24px 60px rgba(17, 17, 17, 0.18);
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ai-profile-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: none;
  background: #f0f0f0;
  color: #111111;
}

.ai-profile-photo {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 22px;
  object-fit: cover;
  background: #efefef;
}

.ai-profile-photo-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 42px;
  font-weight: 700;
  color: #111111;
}

.ai-profile-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ai-profile-kicker {
  margin: 0;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(17, 17, 17, 0.45);
}

.ai-profile-content h4 {
  margin: 0;
  font-size: 22px;
  line-height: 1.1;
  color: #111111;
}

.ai-profile-subtitle,
.ai-profile-meta {
  margin: 0;
  color: rgba(17, 17, 17, 0.68);
  line-height: 1.5;
}

.ai-profile-link {
  margin-top: 6px;
  align-self: flex-start;
  border: none;
  background: #111111;
  color: #ffffff;
  border-radius: 999px;
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 600;
}

.ai-gallery-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 8px;
}

.ai-gallery-grid {
  display: grid !important;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.ai-gallery-grid .ai-gallery-card {
  margin: 0;
}

.ai-gallery-grid .ai-gallery-image {
  height: 120px;
}

.ai-products-list,
.ai-actions-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* FILE card — premium rendering */
.ai-files-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}
.ai-file-card {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border: 1.5px solid rgba(0,0,0,0.06);
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;
}
.ai-file-card:active {
  transform: scale(0.98);
  background: #fafafa;
}
.ai-file-card-icon {
  flex-shrink: 0;
  width: 40px;
  height: 48px;
  border-radius: 10px;
  border: 1px solid rgba(0,0,0,0.05);
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-file-card-icon.is-pdf {
  background: #fff5f5;
  border-color: rgba(255,59,48,0.15);
  color: #ff3b30;
}
.ai-file-card-icon.is-image {
  background: #f5f7ff;
  border-color: rgba(99,102,241,0.15);
  color: #6366f1;
}
.ai-file-card-icon.is-doc {
  background: #f4f8ff;
  border-color: rgba(43,87,154,0.15);
  color: #2b579a;
}
.ai-file-card-extension {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.05em;
}
.ai-file-card-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.ai-file-card-name {
  font-size: 13px;
  font-weight: 600;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ai-file-card-desc {
  font-size: 11px;
  color: #666;
}
.ai-file-card-download {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  color: #999;
}

.ai-gallery-card {
  border: none;
  background: transparent;
  border-radius: 24px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
  cursor: pointer;
  overflow: hidden;
}

.ai-gallery-image {
  width: 100%;
  max-height: 320px;
  object-fit: cover;
  border-radius: 24px;
  display: block;
  box-shadow: 0 18px 38px rgba(0, 0, 0, 0.12);
}

.ai-gallery-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 6px 4px;
  color: #111827;
  text-align: left;
}

.ai-gallery-copy strong,
.ai-gallery-copy span,
.ai-gallery-copy small {
  text-align: left;
}

.ai-gallery-copy strong {
  font-size: 14px;
  font-weight: 700;
}

.ai-gallery-copy span {
  font-size: 13px;
  color: #4b5563;
  line-height: 1.45;
}

.ai-gallery-copy small {
  font-size: 11.5px;
  color: #8c8c8c;
}

.ai-product-card {
  background: #ffffff;
  border: 1px solid rgba(17, 17, 17, 0.06);
  border-radius: 22px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.ai-product-card--no-media {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.ai-product-media {
  border: none;
  background: transparent;
  padding: 0;
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;
}

.ai-product-media--placeholder {
  min-height: 108px;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4b5563;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: default;
}

.ai-product-image {
  width: 100%;
  max-height: 240px;
  object-fit: cover;
  display: block;
  border-radius: 18px;
}

.ai-product-copy {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0 2px;
}

.ai-product-copy strong {
  font-size: 14px;
  font-weight: 700;
  color: #111111;
  line-height: 1.3;
}

.ai-product-desc-wrap {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.ai-product-desc {
  font-size: 13px;
  line-height: 1.5;
  color: #4b5563;
  display: block;
}

.ai-product-desc--collapsed {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ai-product-desc-toggle {
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  align-self: flex-start;
  line-height: 1;
}

.ai-product-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 2px 2px;
  border-top: 1px solid rgba(17, 17, 17, 0.07);
  margin-top: 2px;
}

.ai-product-footer-spacer {
  flex: 1;
}

.ai-product-price {
  flex: 1;
  font-size: 18px;
  font-weight: 800;
  color: #111111;
  letter-spacing: -0.03em;
  line-height: 1;
}

.ai-product-cta {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 15px;
  height: 36px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.01em;
  border-radius: 10px;
  border: none;
  background: #111111;
  color: #fff;
  padding: 0 15px;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: opacity 0.15s, transform 0.1s;
}

.ai-product-cta::after {
  content: '';
  display: inline-block;
  width: 12px;
  height: 12px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M5 12h14M12 5l7 7-7 7'/%3E%3C/svg%3E") no-repeat center/contain;
  flex-shrink: 0;
}

.ai-product-cta:active {
  opacity: 0.82;
  transform: scale(0.98);
}

/* ===== AI ACTION CARDS (TrainingCenter-style) ===== */
.ai-actions-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.ai-action-card {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 14px;
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: opacity 0.15s ease;
}
.ai-action-card:active {
  opacity: 0.85;
}
.ai-action-card:disabled {
  opacity: 0.6;
  cursor: default;
}

.ai-action-brand {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.ai-action-brand-svg {
  width: 22px;
  height: 22px;
}

.ai-action-card-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.ai-action-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ai-action-card-meta {
  font-size: 11px;
  color: rgba(0,0,0,0.4);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ai-action-chevron {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  color: rgba(0,0,0,0.25);
}

/* Platform-branded borders & icon colors */
.ai-action-card.is-whatsapp  { border-color: #dcfce7; background: #f0fdf4; }
.ai-action-card.is-whatsapp  .ai-action-brand { color: #25D366; }

.ai-action-card.is-youtube   { border-color: #fee2e2; background: #fff5f5; }
.ai-action-card.is-youtube   .ai-action-brand { color: #FF0000; }

.ai-action-card.is-instagram { border-color: #fce7f3; background: #fdf4ff; }
.ai-action-card.is-instagram .ai-action-brand { color: #E1306C; }

.ai-action-card.is-linkedin  { border-color: #dbeafe; background: #eff6ff; }
.ai-action-card.is-linkedin  .ai-action-brand { color: #0077b5; }

.ai-action-card.is-facebook  { border-color: #dbeafe; background: #eff6ff; }
.ai-action-card.is-facebook  .ai-action-brand { color: #1877F2; }

.ai-action-card.is-tiktok    { border-color: #e2e8f0; background: #f8fafc; }
.ai-action-card.is-tiktok    .ai-action-brand { color: #111111; }

.ai-action-card.is-twitter   { border-color: #e2e8f0; background: #f8fafc; }
.ai-action-card.is-twitter   .ai-action-brand { color: #111111; }

.ai-action-card.is-email     { border-color: #e0e7ff; background: #f5f3ff; }
.ai-action-card.is-email     .ai-action-brand { color: #4f46e5; }

.ai-action-card.is-calendar  { border-color: #fef08a; background: #fefce8; }
.ai-action-card.is-calendar  .ai-action-brand { color: #ca8a04; }

.ai-action-card.is-maps      { border-color: #d2e3fc; background: #f4f8ff; }
.ai-action-card.is-maps      .ai-action-brand { color: #1a73e8; }

.ai-action-card.is-web       { border-color: rgba(0,0,0,0.06); background: #ffffff; }
.ai-action-card.is-web       .ai-action-brand { color: rgba(0,0,0,0.4); }

/* =========================================================
   🖤 FINAL WHATSAPP B&W LOGIC
========================================================= */

.chat-footer-final {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  padding-bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
  width: 100%;
  box-sizing: border-box;
  min-height: 64px; /* Altura total de la barra para que respire */
}

.footer-left-action {
  width: 24px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}

.btn-trash-bw {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}
.btn-trash-bw:hover { color: #ef4444; }
.btn-trash-bw svg { width: 22px; height: 22px; }

.footer-input-main {
  flex: 1;
  background: #f1f3f4;
  border-radius: 20px;
  padding: 0 16px;
  min-height: 40px; /* Regresamos a la estética ultra-slim */
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.footer-input-main textarea {
  width: 100%;
  background: transparent;
  border: none;
  padding: 10px 0; /* Ajuste para centrado perfecto en 40px */
  margin: 0;
  max-height: 160px;
  resize: none;
  font-size: 13px;
  line-height: 1.4;
  color: #111111;
  outline: none;
  font-family: inherit;
  overflow-y: auto;
}

/* UI Grabando */
.recording-ui-bw {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.record-dot-pulse {
  width: 8px;
  height: 8px;
  background: #ef4444;
  border-radius: 50%;
  animation: blink 1s infinite;
}

.record-timer-bw {
  font-size: 14px;
  font-weight: 700;
  color: #111111;
  min-width: 40px;
}

.record-waves-bw {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  height: 20px;
}
.record-waves-bw span {
  width: 2px;
  background: #111111;
  border-radius: 1px;
  animation: waveGrow 0.8s ease-in-out infinite alternate;
}

/* UI Audio Listo */
.audio-ready-bw {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.play-mini-btn {
  background: none;
  border: none;
  color: #111111;
  display: flex;
}
.play-mini-btn svg { width: 16px; height: 16px; }

.ready-waves-static {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 2px;
  height: 16px;
}
.ready-waves-static span {
  width: 2px;
  background: #d1d5db;
  border-radius: 1px;
}

.ready-time-bw {
  font-size: 12px;
  font-weight: 600;
  color: #666;
}

/* Acción Derecha */
.footer-right-action {
  flex-shrink: 0;
}

.btn-main-bw {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #111111;
  color: #ffffff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.btn-main-bw.is-stop {
  background: #ef4444;
}

.btn-main-bw svg {
  width: 22px;
  height: 22px;
}

.spinner-bw {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.2; }
}

@keyframes waveGrow {
  from { height: 4px; }
  to { height: 20px; }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}


.chat-voice-timer {
  color: #ef4444;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  font-size: 14px;
}

.btn-send-modern.has-draft {
  background: #111111 !important;
  color: #ffffff !important;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.spinner-mini {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}


.ai-action-icon {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  background: #f3f4f6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ai-action-icon svg {
  width: 15px;
  height: 15px;
}

.ai-action-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.ai-action-copy strong,
.ai-action-copy small {
  text-align: left;
}

.ai-action-copy strong {
  font-size: 12.5px;
  color: #111111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ai-action-copy small {
  font-size: 11px;
  color: rgba(17, 17, 17, 0.6);
}

.ai-image-overlay {
  position: fixed !important;
  inset: 0 !important;
  z-index: 999990 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 100vw !important;
  height: 100vh !important;
  padding: 0;
  background: rgb(0 0 0 / 58%);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.ai-image-close {
  position: absolute;
  top: calc(20px + 5%);
  right: 20px;
  width: 46px;
  height: 46px;
  border: 1.5px solid rgba(255, 255, 255, 0.25);
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.45);
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10100 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}
.ai-image-overlay-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}
.ai-gallery-swiper-wrap {
  width: 100%;
  height: 100%;
  display: contents;
}
.ai-gallery-swiper {
  width: 100%;
  height: 100%;
}
.ai-gallery-slide-inner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 70px 20px 56px;
  box-sizing: border-box;
  position: relative;
}
.ai-gallery-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 28px 24px 72px;
  background: linear-gradient(to top, rgba(0,0,0,0.65) 0%, transparent 100%);
  pointer-events: none;
}
.ai-gallery-caption-text {
  color: #fff;
  font-size: 14px;
  line-height: 1.55;
  text-align: center;
  margin: 0;
  text-shadow: 0 1px 6px rgba(0,0,0,0.5);
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.ai-gallery-swiper :deep(.swiper-pagination-bullet) {
  background: #ffffff !important;
  opacity: 0.5 !important;
  width: 8px !important;
  height: 8px !important;
  margin: 0 4px !important;
}
.ai-gallery-swiper :deep(.swiper-pagination-bullet-active) {
  background: #ffffff !important;
  opacity: 1 !important;
  transform: scale(1.2);
}
.ai-gallery-swiper :deep(.swiper-pagination) {
  bottom: 30px !important;
  z-index: 10005 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.ai-image-viewer {
  max-width: 90vw;
  max-height: 60vh;
  width: auto;
  height: auto;
  border-radius: 16px;
  display: block;
  box-shadow: 0 15px 40px rgba(0,0,0,0.4);
  object-fit: contain;
  background: #000;
  user-select: none;
  -webkit-user-drag: none;
  position: relative;
  z-index: 1;
}

.ai-image-overlay-global {
  position: fixed;
  z-index: 999990;
}

/* INPUT AREA */
.chat-status-disabled {
  margin: 12px 15px 0;
  padding: 12px 14px;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.06);
  color: #4b5563;
  font-size: 13px;
  line-height: 1.45;
  text-align: center;
}

.chat-input-modern {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  background: #ffffff;
  border-top: 1px solid rgba(255,255,255,0.05);
  position: relative;
  z-index: 2;
}

.chat-input-modern textarea {
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  height: 46px;
  min-height: 46px;
  resize: none;
  border: 1px solid rgba(17,17,17,0.08);
  background: #f2f2f2;
  color: #000000;
  padding: 12px 18px;
  border-radius: 999px;
  outline: none;
  font-size: 16px; /* ≥16px prevents iOS Safari auto-zoom on focus */
  line-height: 1.25;
  font-family: Arial, Helvetica, sans-serif;
  overflow-y: hidden;
}

.chat-recording-field {
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  height: 46px;
  min-height: 46px;
  border: 1px solid rgba(17,17,17,0.08);
  background: #f2f2f2;
  border-radius: 999px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  overflow: hidden;
}

.chat-recording-field-text {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: rgba(17,17,17,0.62);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-input-modern textarea.is-recording {
  border-color: rgba(220, 38, 38, 0.35);
  background: rgba(254, 226, 226, 0.45);
  color: rgba(17,17,17,0.75);
  cursor: default;
}

::-webkit-scrollbar{
  display: none;
}

/* BOTÓN ENVIAR */
.btn-send-modern {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: none;
  background: #111111;
  color: #ffffff;
  cursor: pointer;
  transition: 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-voice-modern {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 1px solid rgba(17,17,17,0.08);
  background: #f2f2f2;
  color: #111;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.btn-voice-modern svg {
  width: 19px;
  height: 19px;
}

.btn-voice-modern.recording {
  background: #111;
  color: #fff;
  border-color: #111;
}

.btn-voice-modern:disabled {
  opacity: 0.5;
}

.btn-send-modern svg {
  width: 18px;
  height: 18px;
}

.btn-send-modern:active {
  transform: scale(0.9);
}

.btn-send-modern:disabled {
  opacity: 1;
  background: #d5d5d5;
  color: #8a8a8a;
  cursor: not-allowed;
}

/* ANIMACIÓN */
@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

.btn-x-cerrar {
  position: static;
  background: rgba(0,0,0,0.05);
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #888;
  cursor: pointer;
  flex-shrink: 0;
}

.chat-voice-draft {
  padding: 12px 15px 0;
  background: #fff;
}

.chat-voice-draft-card {
  border: 1px solid rgba(17,17,17,0.08);
  background: #f6f6f6;
  border-radius: 20px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.chat-voice-draft-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.chat-voice-draft-copy strong {
  font-size: 13px;
  color: #111;
}

.chat-voice-draft-copy span {
  font-size: 11px;
  color: rgba(17,17,17,0.58);
  line-height: 1.4;
}

.voice-note-discard {
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 12px;
  font-weight: 700;
}

.chat-voice-recording {
  background: #fff;
  padding: 12px 15px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.chat-voice-recording span {
  font-size: 13px;
  font-weight: 700;
  color: #111;
  margin-bottom: 5px;
}

.chat-voice-recording small {
  font-size: 11.5px;
  color: rgba(17,17,17,0.58);
  line-height: 1.45;
}

.chat-voice-recording-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ef4444;
  box-shadow: 0 0 0 6px rgba(239,68,68,0.14);
  animation: pulse-record 1.2s ease-in-out infinite;
}

@keyframes pulse-record {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.7; }
}

@keyframes voiceWavePulse {
  0%, 100% { transform: scaleY(0.75); opacity: 0.55; }
  50% { transform: scaleY(1.18); opacity: 1; }
}

.chat-starter-pills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px 15px 0;
  background: #fff;
}

.chat-starter-pill {
  border: none;
  background: #f2f2f2;
  color: #222;
  border-radius: 999px;
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 600;
}





.emoji-dock-container-right {
  position: fixed;
  right: 20px; /* Anclado a la derecha */
  bottom: 18%;
  z-index: 4000;
  display: flex;
  justify-content: flex-end;
}

/* BOTÓN CERRADO */
.btn-dock-trigger-right {
  width: 55px;
  height: 55px;
  border-radius: 20px;
  background: white;
  border: none;
  font-size: 1.5rem;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
      position: fixed;
    bottom: 18%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: floatingPulse 3s infinite ease-in-out;
}

/* DOCK EXPANDIDO HACIA LA IZQUIERDA (RTL) */
.emoji-dock-expanded-rtl {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  padding: 8px 12px;
  border-radius: 25px; /* Radio de 25px solicitado */
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  border: 1px solid rgba(255,255,255,0.4);
  gap: 15px;
  transform-origin: right center; /* La expansión nace desde la derecha */
}

.dock-emojis-row {
  display: flex;
  flex-direction: row;
  gap: 15px;
  padding-left: 5px;
}

.emoji-item {
  background: transparent;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation: bounceInRight 0.5s both;
  -webkit-tap-highlight-color: transparent;
 
}



.emoji-item:active {
  transform: scale(0.7) translateY(5px);
  filter: brightness(1.2); /* Brilla un poco al tocarlo */
}

/* BOTÓN X DE CRISTAL */
.btn-dock-close-glass {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #000;
  font-weight: 900;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

/* --- ANIMACIONES CORREGIDAS --- */

/* Transición de entrada del Dock (Desliza desde la derecha hacia la izquierda) */
.dock-slide-rtl-enter-active, .dock-slide-rtl-leave-active {
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
.dock-slide-rtl-enter-from, .dock-slide-rtl-leave-to {
  opacity: 0;
  transform: translateX(50px) scaleX(0.5); /* Viene de la derecha */
}

/* Rebote de emojis */
@keyframes bounceInRight {
  0% { opacity: 0; transform: translateX(20px) scale(0); }
  70% { transform: translateX(-5px) scale(1.1); }
  100% { opacity: 1; transform: translateX(0) scale(1); }
}

@keyframes floatingPulse {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}







.user-countdown-screen {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;
  overflow: hidden;
}

.brand-bg-overlay {
  position: absolute;
  inset: 0;
  opacity: 0.15; /* Sutil color de marca de fondo */
  filter: blur(100px);
  z-index: -1;
}

.timer-user-container {
  text-align: center;
  margin-bottom: 50px;
}

.timer-user-label {
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.9rem;
}

.timer-user-display {
  font-size: 8rem;
  margin: 10px 0;
 
}

.blink-red {
  color: #ff4444;
  animation: blink 0.5s infinite alternate;
}

@keyframes blink {
  from { opacity: 1; }
  to { opacity: 0.5; }
}

.pause-tag {
  background: #ffcc00;
  color: black;
  padding: 5px 15px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 0.8rem;
}

/* Barra de Reacciones */
.user-reaction-bar {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 30px;
  width: 90%;
  max-width: 400px;
}

.reaction-title {
  text-align: center;
  font-size: 0.8rem;
  margin-bottom: 15px;
  color: #aaa;
}

.emoji-reaction-grid {
  display: flex;
  justify-content: space-around;
}

.reaction-btn {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.reaction-btn:active {
  transform: scale(1.5);
}


.tv-background-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.tv-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tv-bg-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, transparent 0%, rgba(0, 0, 0, 0.47) 100%),
              linear-gradient(90deg, rgba(0, 0, 0, 0.462) 10%, rgba(0, 0, 0, 0.457) 50%, rgba(0, 0, 0, 0.504) 100%);
}



/* Estilos multichoice */
.multi-btn {
  display: flex;
  align-items: center;
  gap: 15px;
  text-align: left;
  padding: 15px !important;
}

.check-icon{
  color: white;
}

.multi-check {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
  color: white;
  font-weight: bold;
}

.is-selected-multi {
  transform: scale(1.025) translateY(-2px);
  border-width: 2.5px !important;
  box-shadow: 0 8px 28px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.08);
}

.instruction-text {
  font-size: 0.85rem;
  opacity: 0.8;
  margin-bottom: 10px;
}


.quiz-btn {
  border: 2px solid rgba(255, 255, 255, 0.1);
  /* transition already on .opt-btn */
}

.quiz-btn.is-selected {
  transform: scale(1.025) translateY(-3px);
  border-width: 2.5px !important;
  box-shadow: 0 8px 28px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.08);
}

/* Animación de "latido" para el tag de Quiz */
.live-tag {
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 1px;
  margin-bottom: 10px;
  display: inline-block;
}



/* Estilso para mostrar al usuario que respondio bien el Quiz */
.results-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.text-correct {
  font-size: 2.8rem;
  color: #46D68E;
  line-height: 1;
  margin: 10px 0;
  letter-spacing: -1px;
}

.correct-info-box {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 25px;
  border-radius: 25px;
  width: 82%;
  margin: 20px 0;
}

.correct-val {
  font-size: 1.8rem;
  color: #fff;
  margin: 0;
  font-weight: 800;
}

.points-badge-premium {
  position: relative;
  background: linear-gradient(135deg, #FFD700 0%, #FF8C00 100%);
  color: #000;
  padding: 20px 40px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 15px 35px rgba(255, 140, 0, 0.4);
}

.pts-number {
  font-size: 3rem;
  font-weight: 900;
  line-height: 1;
}

.pts-sub {
  font-size: 0.7rem;
  font-weight: 800;
  opacity: 0.8;
}

/* Animación de pulso para el badge */
@keyframes pulse-gold {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.loser-card { text-align: center; color: #ccc; }
.error-icon { 
  font-size: 40px; background: #ff5252; width: 80px; height: 80px; 
  display: flex; align-items: center; justify-content: center; 
  border-radius: 50%; margin: 0 auto 20px; color: white;
}



/* 🌊 ANIMACIÓN PRINCIPAL (default elegante) */
.anim-float-slow {
  animation: floatBokeh 12s ease-in-out infinite;
}

@keyframes floatBokeh {
  0% {
    background-position: 
      0% 50%,
      100% 50%,
      50% 100%;
  }

  50% {
    background-position: 
      100% 0%,
      0% 100%,
      50% 0%;
  }

  100% {
    background-position: 
      0% 50%,
      100% 50%,
      50% 100%;
  }
}


/* 🔥 MOVIMIENTO MÁS DINÁMICO */
.anim-move {
  animation: moveBokeh 20s ease-in-out infinite;
}

@keyframes moveBokeh {
  0% {
    background-position: 
      0% 50%,
      100% 50%,
      50% 100%;
  }

  50% {
    background-position: 
      100% 50%,
      0% 50%,
      50% 0%;
  }

  100% {
    background-position: 
      0% 50%,
      100% 50%,
      50% 100%;
  }
}


/* ✨ EFECTO GLOW / RESPIRACIÓN */
.anim-pulse {
  animation: pulseGlow 10s ease-in-out infinite;
}

@keyframes pulseGlow {
  0%, 100% { 
    opacity: 0.5;
  }
  50% { 
    opacity: 0.85;
  }
}




/* =============================================
   WAITING ROOM — USER VIEW
   ============================================= */
 
.wr-screen {
  position: relative;
  width: 100%;
  /* dvh = Dynamic Viewport Height — excludes the iOS Safari address bar,
     preventing the screen from being taller than what's actually visible */
  height: 100dvh;
  padding: 0 0 40px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  transition: background 0.6s ease;
}

/* Blobs reactivos */
.wr-bg-blob {
  position: absolute;
  border-radius: 50%;
  /* -webkit-filter needed for iOS Safari — without it the blur is ignored */
  -webkit-filter: blur(60px);
  filter: blur(60px);
  opacity: 0.5;
  pointer-events: none;
  transition: background 0.8s ease;
  z-index: 0;
  /* GPU layer prevents iOS from deferring the paint */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.wr-bg-blob--top {
  width: 280px;
  height: 280px;
  top: -40px;
  right: -60px;
}
.wr-bg-blob--bottom {
  width: 320px;
  height: 320px;
  bottom: 60px;
  left: -100px;
  opacity: 0.28;
}

/* ── Header logo + título (igual al panel Admin) ── */
.wr-header {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 14px;

  padding: 18px 20px 14px;
}

.wr-header-logo {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  object-fit: cover;
  flex-shrink: 0;
}

.wr-header-logo-placeholder {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: #000;
  border: 1px solid rgba(255,255,255,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}
.wr-header-logo-placeholder svg { width: 22px; height: 22px; }

.wr-header-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.wr-chat-chip {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.1);
  color: #fff;
  border-radius: 999px;
  min-height: 40px;
  padding: 0 14px;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  white-space: nowrap;
}

.wr-header-title {
  color: #fff;
  font-size: 15px;
   text-align: left;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wr-header-live {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 700;
  color: rgba(255,255,255,0.5);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

/* /join: sin cabecera de sesión, el lienzo necesita su propio aire arriba */
.wr-screen.is-join-page {
  /* .wr-screen usa height:100dvh en content-box: sin esto los paddings se
     SUMAN al alto (812 -> 1000) y el contenido se iba contra el pie fijo. */
  box-sizing: border-box;
  /* Altura libre: con la card cuadrada el contenido puede pasar de una
     pantalla, así que la página scrollea en vez de recortar. */
  height: auto;
  min-height: 100dvh;
  overflow: visible;
  padding-top: calc(env(safe-area-inset-top, 0px) + 52px);
  /* Sin pie legal en /join: solo el respiro del safe-area */
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 32px);
}

/* Contenedor propio del lienzo de reclamo.
   Antes reutilizaba .wr-media-wrap, que es la caja CUADRADA para imágenes con
   tope de 360px. El mockup mide 340px y además lleva translateY(30px), o sea
   termina en 370: sobraba y la caja lo recortaba. Encima, con overflow:hidden
   el navegador todavía podía desplazarlo (iOS lo hacía al enfocar el input) y
   el recorte saltaba a la parte de arriba.
   Acá la altura se ajusta al contenido y se usa clip, que ni siquiera crea
   contenedor de scroll. */
.wr-brand-claim-stage {
  position: relative;
  z-index: 2;
  width: 100%;
  aspect-ratio: 1 / 1;   /* cuadrada de verdad: sin max-height que la achate */
  border-radius: 28px;
  /* clip y no hidden: hidden todavía se puede desplazar por código y iOS lo
     hacía al enfocar el input, recortando la card por arriba. */
  overflow: clip;
  overscroll-behavior: contain;
  background: #0f0d0c;
}

/* Carrusel de fotos de canal, a sangre completa */
.wr-claim-track {
  position: absolute;
  inset: 0;
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.wr-claim-shot {
  position: relative;
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.wr-claim-photo {
  position: absolute;
  inset: 0;
  background-color: #16130f;
  background-size: cover;
  background-position: center;
}

/* Degradado negro de abajo hacia arriba para que el texto se lea */
.wr-claim-fade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 62%;
  background: linear-gradient(to top,
    rgba(0,0,0,0.94) 0%,
    rgba(0,0,0,0.72) 34%,
    rgba(0,0,0,0.28) 66%,
    transparent 100%);
}

.wr-claim-meta {
  position: absolute;
  left: 22px;
  right: 22px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  /* #app hereda text-align:center de la plantilla de Vue */
  text-align: left;
}

.wr-claim-name {
  font-family: 'Plus Jakarta Sans', -apple-system, sans-serif;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #fff;
  line-height: 1.15;
}

.wr-claim-desc {
  font-size: 13px;
  line-height: 1.4;
  color: rgba(255,255,255,0.72);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.wr-brand-claim-bg {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 75% 25%, rgba(184, 150, 116, 0.15) 0%, transparent 60%),
              radial-gradient(circle at 25% 75%, rgba(216, 255, 52, 0.08) 0%, transparent 60%),
              #0f0d0c;
}

.wr-premium-scene {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 1000px;
}

.wr-phone-mockup {
  width: 180px;
  height: 340px;
  background: linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.01) 100%);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 28px;
  position: relative;
  box-shadow: 0 24px 48px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 14px;
  transform: translateY(30px);
}

.wr-phone-notch {
  width: 44px;
  height: 12px;
  background: rgba(0,0,0,0.8);
  border-radius: 6px;
  margin-bottom: 24px;
  box-shadow: inset 0 1px 1px rgba(255,255,255,0.1);
}

.wr-phone-screen {
  width: calc(100% - 12px);
  flex: 1;
  background: rgba(0,0,0,0.5);
  border-radius: 14px;
  margin-bottom: 6px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.wr-phone-slide-track {
  display: flex;
  height: 100%;
  width: max-content;
}

.wr-phone-mini-slide {
  width: 168px;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mini-img {
  height: 55%;
  background: rgba(255,255,255,0.05);
  border-radius: 10px 10px 0 0;
}
.mini-img.alt {
  background: rgba(216, 255, 52, 0.05);
}

.mini-content {
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  overflow: hidden;
  text-align: left;
  width: 100%;
  box-sizing: border-box;
}

.mini-title-text {
  font-size: 8px;
  font-weight: 700;
  color: rgba(255,255,255,0.85);
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mini-desc-text {
  font-size: 6px;
  font-weight: 400;
  color: rgba(255,255,255,0.4);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* slideAnim removed in favor of JS control */

.wr-floating-notif {
  position: absolute;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 16px 32px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.05) inset;
  width: 220px;
  animation: floatNotif 6s ease-in-out infinite alternate;
}

.notif-1 {
  --tx: -55%;
  --ty: -30%;
  top: 50%;
  left: 50%;
  transform: translate(var(--tx), var(--ty));
  animation-delay: 0s;
  z-index: 3;
}

.notif-2 {
  /* Arriba: abajo tapaba el nombre de la marca */
  --tx: -50%;
  --ty: 0%;
  top: 16px;
  left: 50%;
  transform: translate(var(--tx), var(--ty));
  animation-delay: -3s;
  z-index: 4;
  background: linear-gradient(135deg, rgba(184, 150, 116, 0.15), rgba(255, 255, 255, 0.03));
  border-color: rgba(184, 150, 116, 0.2);
}

.wr-float-icon {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 16px 32px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.05) inset;
  animation: floatIconFade 15s infinite;
  opacity: 0;
  z-index: 1;
  color: rgba(255,255,255,0.75);
}

.wr-float-icon svg {
  width: 60%;
  height: 60%;
  display: block;
}

.icon-1 { top: 12%; left: 2%;   animation-delay: 0s; }
.icon-2 { top: 8%;  right: 2%;  animation-delay: 3s; }
.icon-3 { top: 35%; left: 0%;   animation-delay: 6s; }
.icon-4 { top: 28%; right: 0%;  animation-delay: 9s; }
.icon-5 { top: 48%; left: 4%;   animation-delay: 12s; }
.icon-6 { top: 18%; right: 6%;  animation-delay: 4s; }
.icon-7 { top: 44%; right: 3%;  animation-delay: 7s; }
.icon-8 { top: 22%; left: 6%;   animation-delay: 10s; }

@keyframes floatIconFade {
  0%, 100% { opacity: 0; transform: translateY(10px) scale(0.9); }
  10%, 30% { opacity: 1; transform: translateY(0) scale(1); }
  40% { opacity: 0; transform: translateY(-10px) scale(0.9); }
}

.notif-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(255,255,255,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
}

.notif-icon.is-brand {
  background: #d8ff34;
  color: #000;
}

.notif-icon svg {
  width: 14px;
  height: 14px;
}

.notif-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}

.notif-content strong {
  font-size: 13px;
  color: #fff;
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: -0.01em;
}

.notif-content span {
  font-size: 11px;
  color: rgba(255,255,255,0.6);
  line-height: 1.3;
}

@keyframes floatNotif {
  0% { transform: translate(var(--tx), calc(var(--ty) - 6px)); }
  100% { transform: translate(var(--tx), calc(var(--ty) + 6px)); }
}

/* Botón que sustituye al input cuando la reserva ya existe */
.wr-continue-claim-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-height: 52px;
  padding: 0 14px 0 16px;
  border: 1px solid rgba(216, 255, 52, 0.45);
  border-radius: 12px;
  background: rgba(216, 255, 52, 0.10);
  color: #fff;
  font-family: inherit;
  cursor: pointer;
  box-sizing: border-box;
  text-align: left;
  transition: background 0.2s;
}
.wr-continue-claim-btn:hover { background: rgba(216, 255, 52, 0.16); }
.wr-continue-claim-copy { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.wr-continue-claim-label { font-size: 14px; font-weight: 700; color: #d8ff34; }
.wr-continue-claim-slug {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wr-continue-claim-btn svg { color: #d8ff34; flex-shrink: 0; }

.wr-startup-input-wrapper {
  display: flex;
  align-items: center;
  height: 52px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 0 6px 0 16px;
  transition: all 0.2s;
  width: 100%;
  box-sizing: border-box;
}

.wr-startup-input-wrapper:focus-within {
  border-color: #d8ff34;
  background: rgba(216, 255, 52, 0.02);
}

.wr-startup-input-prefix {
  color: rgba(255, 255, 255, 0.5);
  font-size: 15px;
  font-weight: 500;
  user-select: none;
}

.wr-startup-input-field {
  flex: 1;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 16px; /* ≥16px prevents iOS Safari auto-zoom on focus */
  font-weight: 600;
  outline: none;
  min-width: 0;
  padding-left: 2px;
}

.wr-startup-input-field::placeholder {
  color: rgba(255, 255, 255, 0.2);
  font-weight: 400;
}

.wr-startup-submit-btn {
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  border: 0;
  background: #ffffff;
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wr-startup-submit-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.wr-brand-claim-hint {
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255,255,255,0.4);
  margin-top: 8px;
  text-align: left;
}

.wr-brand-claim-status {
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  margin-top: 8px;
  display: block;
}

.wr-brand-claim-status.is-available,
.wr-brand-claim-status.is-current {
  color: #d8ff34;
}

.wr-brand-claim-status.is-taken,
.wr-brand-claim-status.is-invalid,
.wr-brand-claim-status.is-error {
  color: #ff6b6b;
}

.wr-slide-brand-claim {
  display: flex;
  flex-direction: column;
}

.wr-copy-brand-claim {
  padding-top: 24px;
}

.wr-brand-claim-hero-title {
  font-family: 'Plus Jakarta Sans', -apple-system, sans-serif;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.05;
  color: #ffffff;
  letter-spacing: -0.04em;
  margin: 0 0 12px 0;
  text-align: left;
}

.wr-brand-claim-hero-title .kicker {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: -0.01em;
  display: block;
  margin-bottom: 6px;
}

.wr-brand-claim-hero-title .text-lime {
  color: #d8ff34;
}

.wr-live-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2ecc71;
  animation: wr-blink 2s infinite;
}
@keyframes wr-blink {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.35; }
}

/* ── Swiper ── */
.wr-slider {
  background: transparent !important;
  position: relative;
  z-index: 2;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.wr-slide {
  background: transparent !important;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  /* 'contain: layout style' can prevent bg colors from painting on iOS — removed */
  /* 'will-change: contents' is invalid in Safari and triggers rendering bugs — fixed */
  will-change: transform;
}

.wr-slider :deep(.swiper),
.wr-slider :deep(.swiper-wrapper),
.wr-slider :deep(.swiper-slide) {
  background: transparent !important;
}

.wr-slider :deep(.swiper) {
  height: 100%;
}

.wr-slider :deep(.swiper-wrapper) {
  align-items: flex-start;
}

.wr-slide {
  width: 100%;
  max-height: calc(100vh - 116px);
  padding: 0 16px 56px;
  box-sizing: border-box;
  overflow-y: auto;
  touch-action: pan-y;
}

/* ── Imagen cuadrada (mismas proporciones que el Admin) ── */
.wr-media-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;          /* cuadrado igual que el Admin */
  /* Fallback for iOS < 15 that doesn't support aspect-ratio */
  min-height: min(100vw, 360px);
  max-height: 360px;             /* tope para pantallas grandes */
  border-radius: 28px;
  overflow: hidden;
  background: rgba(255,255,255,0.05);
  margin-bottom: 0;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.wr-media-blur-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  /* Both prefixed and unprefixed needed for all iOS versions */
  -webkit-filter: blur(20px) brightness(0.52);
  filter: blur(20px) brightness(0.52);
  -webkit-transform: scale(1.12) translateZ(0);
  transform: scale(1.12) translateZ(0);
  z-index: 0;
  /* Force GPU compositing so iOS paints this layer immediately */
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.wr-media-img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;   /* cover como en el Admin — llena el cuadrado */
  display: block;
  /* Force immediate GPU paint on iOS — prevents blank frame until interaction */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  /* Ensure iOS doesn't defer decode of the image */
  content-visibility: auto;
}

/* Se agotaron los reintentos del vigía de imágenes — la imagen queda oculta
   y el fondo (si existe) pasa a un degradado neutro en vez de mostrar el
   hueco a medias que reportó el usuario. */
.img-load-failed {
  background: rgba(255,255,255,0.06);
}
.wr-media-blur-bg--fallback {
  background-image: none !important;
  background: linear-gradient(135deg, rgba(255,255,255,0.08), rgba(255,255,255,0.02));
}

.wr-media-empty {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: rgba(255,255,255,0.28);
}
.wr-media-empty svg  { width: 40px; height: 40px; }
.wr-media-empty span { font-size: 13px; font-weight: 500; }

/* ── Video ── */
.wr-media-wrap--video {
  background: #000;
  aspect-ratio: 1 / 1;
  max-height: 360px;
  contain: content;
  isolation: isolate;
}
.wr-media-wrap--video.is-9x16 {
  aspect-ratio: 9 / 16;
  /* El tope de ALTO rompía la proporción: con width:100% el alto natural pasa
     de 560px en casi cualquier teléfono, así que la caja dejaba de ser 9:16
     —quedaba más achatada— y el video no llenaba el recuadro. El lienzo
     desborda hacia abajo y se hace scroll, que es lo correcto para un 9:16.

     El ancho es exactamente la banda del header: desde donde empieza el logo
     de la marca hasta donde termina el botón "Pregúntame". El header lleva
     20px de padding lateral y el lienzo 16px, así que se descuentan los 4px
     de diferencia a cada lado. Igual en iOS y en Android. */
  max-height: none;
  width: calc(100% - 8px);
  max-width: calc(100% - 8px);
  margin-left: auto;
  margin-right: auto;
}
.wr-video-embed {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  will-change: transform;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  opacity: 0;
  transition: opacity 0.45s ease;
}
.wr-video-embed.is-loaded {
  opacity: 1;
}
.wr-video-loader {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  pointer-events: none;
}
.wr-video-spinner {
  width: 46px;
  height: 46px;
  animation: wr-spin 1s linear infinite;
  filter: drop-shadow(0 0 6px rgba(255,255,255,0.2));
}
@keyframes wr-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.wr-video-mute-fab {
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 5;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(0,0,0,0.55);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  transition: background 0.18s;
}
.wr-video-mute-fab:active { background: rgba(0,0,0,0.8); }

/* Dots de navegación sobre la imagen */
.wr-dots {
  position: fixed;
  bottom: 14px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 4;
  display: flex;
  gap: 6px;
  align-items: center;
  pointer-events: none;
}

.wr-exit-floating {
  position: fixed;
  left: 50%;
  bottom: 44px;
  transform: translateX(-50%);
  z-index: 5;
  min-height: 34px;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(14,14,16,0.72);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
  box-shadow: 0 12px 28px rgba(0,0,0,0.24);
}
.wr-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255,255,255,0.4);
  transition: all 0.3s ease;
}
.wr-dot.active {
  width: 22px;
  border-radius: 3px;
  background: #fff;
}

.wr-guide-overlay {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60vh;
  z-index: 12;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 68px 24px 34px;
  overflow: hidden;
}

.wr-guide-overlay::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(8, 8, 8, 0), rgb(8 8 8 / 13%) 20%, rgb(8 8 8 / 91%) 40%, rgb(8 8 8));
  backdrop-filter: blur(305px);
  -webkit-backdrop-filter: blur(18px);
  -webkit-mask-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, .08) 18%, rgba(0, 0, 0, .58) 36%, #000);
  mask-image: linear-gradient(180deg, #00000000, rgba(0, 0, 0, .08) 18%, rgb(0 0 0 / 92%) 36%, #000);
}

.wr-guide-hand-wrap {
  position: relative;
  width: min(240px, 72vw);
  height: 92px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.wr-guide-trail {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
}

.wr-guide-trail path {
  stroke: rgba(255,255,255,0.58);
  stroke-width: 4;
  stroke-linecap: round;
  stroke-dasharray: 14 14;
  animation: wrTrailPulse 2.2s ease-in-out infinite;
}

.wr-guide-hand-float {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
}

.wr-guide-hand {
  width: 62px;
  height: 62px;
  object-fit: contain;
  filter: drop-shadow(0 12px 30px rgba(0,0,0,0.2));
}

.wr-guide-card {
  width: min(320px, 90vw);
  text-align: center;
  color: #fff;
  position: relative;
  z-index: 1;
}

.wr-guide-card strong {
  display: block;
  font-size: 20px;
  line-height: 1.05;
  margin-bottom: 8px;
}

.wr-guide-card p {
  margin: 0 0 22px;
  color: rgba(255,255,255,0.82);
  font-size: 13px;
  line-height: 1.45;
}

.wr-guide-btn {
  width: min(220px, 50vw);
  border: none;
  background: #fff;
  color: #111;
  border-radius: 999px;
  min-height: 50px;
  padding: 0 24px;
  font-size: 13px;
  font-weight: 800;
}

@keyframes wrTrailPulse {
  0%, 100% { opacity: 0.45; }
  50% { opacity: 1; }
}

/* ── Lienzo texto ── */
.wr-media-wrap-text {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  box-sizing: border-box;
}

.wr-primary-text-card {
  color: #fff;
  white-space: pre-wrap;
  word-break: break-word;
  width: 100%;
}

/* ── Copy: nuevo sistema wr-block ── */
.wr-copy {
  padding: 20px 4px 12px;
  text-align: left;
  overflow: visible;
}

/* base — por si llega un kind desconocido */
.wr-block {
  color: rgba(255,255,255,0.82);
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.wr-block--title {
  color: #fff;
  font-size: clamp(24px, 7vw, 36px);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.04em;
  margin-bottom: 10px;
}

.login-loading-screen {
  justify-content: center;
}

/* ── Entry screen glassmorphism ── */
.direct-slug-gate {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.slug-gate-bg {
  position: absolute;
  inset: -30px;
  background: #1a1a1a center / cover no-repeat;
  filter: blur(28px) brightness(0.55) saturate(1.2);
  transform: scale(1.06);
  transition: background-image 0.4s ease;
}

.slug-gate-glass {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
}

.slug-gate-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 40px 28px;
}

.slug-gate-avatar-wrap {
  position: relative;
  width: 112px;
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slug-gate-avatar {
  width: 112px;
  height: 112px;
  border-radius: 28px;
  background: #333 center / cover no-repeat;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.5);
  animation: exploreEntryFloat 1.15s ease-in-out infinite alternate;
  border: 2px solid rgba(255, 255, 255, 0.18);
}

.slug-gate-kicker {
  color: rgba(255, 255, 255, 0.62);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-top: 4px;
}

.slug-gate-title {
  color: #ffffff;
  font-size: clamp(22px, 6vw, 30px);
  font-weight: 700;
  letter-spacing: -0.03em;
  text-align: center;
  max-width: 14ch;
  line-height: 1.1;
  text-shadow: 0 2px 16px rgba(0, 0, 0, 0.5);
  margin: 0;
}

.slug-gate-spinner {
  margin-top: 4px;
  opacity: 0.6;
}

/* ── Product image grid ── */
.ai-product-grid {
  display: grid;
  gap: 4px;
  border-radius: 18px;
  overflow: hidden;
}

.ai-product-grid--2 {
  grid-template-columns: 1fr 1fr;
}

.ai-product-grid--3 {
  grid-template-columns: 1fr 1fr 1fr;
}

.ai-product-grid--4plus {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.ai-product-grid-cell {
  border: none;
  padding: 0;
  margin: 0;
  background: transparent;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  aspect-ratio: 1 / 1;
  display: block;
}

.ai-product-grid-cell img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.2s ease;
}

.ai-product-grid-cell:hover img {
  transform: scale(1.04);
}

.ai-product-grid-cell--more {
  position: relative;
}

.ai-product-grid-more-label {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.52);
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: -0.02em;
}

.explore-entry-loading {
  min-height: 72vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.explore-entry-loading-stack {
  position: relative;
  width: 116px;
  height: 116px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wr-link-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  color: #111111;
  padding: 9px 12px;
  border-radius: 14px;
  text-decoration: none;
  min-height: 46px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s ease, background 0.2s ease;
}

.wr-link-chip.is-whatsapp {
  background: #25d366;
  color: #ffffff;
}
.wr-link-chip.is-whatsapp .wr-link-chip-icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.wr-link-chip.is-whatsapp .wr-link-chip-platform,
.wr-link-chip.is-whatsapp .wr-link-chip-text,
.wr-link-chip.is-whatsapp .wr-link-chip-arrow {
  color: #ffffff;
}

.wr-link-chip.is-youtube {
  background: #ff0000;
  color: #ffffff;
}
.wr-link-chip.is-youtube .wr-link-chip-icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.wr-link-chip.is-youtube .wr-link-chip-platform,
.wr-link-chip.is-youtube .wr-link-chip-text,
.wr-link-chip.is-youtube .wr-link-chip-arrow {
  color: #ffffff;
}

.wr-link-chip.is-instagram {
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: #ffffff;
}
.wr-link-chip.is-instagram .wr-link-chip-icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.wr-link-chip.is-instagram .wr-link-chip-platform,
.wr-link-chip.is-instagram .wr-link-chip-text,
.wr-link-chip.is-instagram .wr-link-chip-arrow {
  color: #ffffff;
}

.wr-link-chip.is-maps {
  background: #1a73e8;
  color: #ffffff;
}
.wr-link-chip.is-maps .wr-link-chip-icon {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.wr-link-chip.is-maps .wr-link-chip-platform,
.wr-link-chip.is-maps .wr-link-chip-text,
.wr-link-chip.is-maps .wr-link-chip-arrow {
  color: #ffffff;
}

.explore-entry-loading-media {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 28px;
  background-size: cover;
  background-position: center;
  background-color: #111;
  box-shadow: 0 18px 38px rgba(0,0,0,0.28);
  animation: exploreEntryFloat 1.15s ease-in-out infinite alternate;
}

.explore-entry-loading-pulse {
  position: absolute;
  inset: -10px;
  border-radius: 34px;
  border: 1px solid rgba(255,255,255,0.14);
  animation: exploreEntryPulse 1.5s ease-out infinite;
}

.explore-entry-loading-kicker {
  margin: 10% 0 0;
  color: rgba(255,255,255,0.58);
  font-size: 14px;
  line-height: 1.2;
  font-weight: 600;
}

.explore-entry-loading-title {
  color: #fff;
  font-size: clamp(24px, 6vw, 32px);
  line-height: 1;
  letter-spacing: -0.04em;
  text-align: center;
  max-width: 12ch;
}

@keyframes exploreEntryFloat {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-6px);
  }
}

@keyframes exploreEntryPulse {
  0% {
    opacity: 0.75;
    transform: scale(0.94);
  }
  100% {
    opacity: 0;
    transform: scale(1.08);
  }
}

.wr-block--subtitle {
  color: white;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.45;
  margin-top: 10px;
  margin-bottom: 10px;
}

.wr-block--text {
  color: rgba(255,255,255,0.82);
  font-size: 15px;
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 10px;
}

.wr-block--small {
  color: rgba(255,255,255,0.65);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 8px;
}

/* ── Links ── */
.wr-links {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-top: 10px;
  margin-bottom: 14px;
}
.wr-links--block {
  margin-top: 20px;
  margin-bottom: 20px;
}

.wr-gallery-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-top: 16px;
  margin-bottom: 20px;
}

.wr-gallery-thumb {
  border: none;
  background: transparent;
  padding: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 6px;
  cursor: pointer;
}

.wr-gallery-thumb img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 14px;
  display: block;
  /* Force GPU layer — iOS defers painting images without explicit compositing */
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.wr-gallery-thumb-caption {
  font-size: 11px;
  line-height: 1.35;
  color: rgba(255,255,255,0.78);
}

.wr-link-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 14px 12px;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.09);
  background: rgba(255,255,255,0.06);
  color: #fff;
  text-decoration: none;
  transition: background 0.18s ease;
  box-sizing: border-box;
}

.wr-link-chip:active {
  background: rgba(255,255,255,0.13);
}

.wr-link-chip-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: rgba(255,255,255,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: rgba(255,255,255,0.8);
}

.wr-link-chip-icon svg {
  width: 14px;
  height: 14px;
}

.wr-link-chip-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.wr-link-chip-platform {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.4);
  line-height: 1;
  margin-bottom: 2px;
}

.wr-link-chip-text {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wr-link-chip-arrow {
  color: rgba(255,255,255,0.3);
  flex-shrink: 0;
}




@keyframes aiShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* recent-fab slide-up transition */
.tc-slide-up-enter-active {
  transition: opacity 0.28s ease, transform 0.28s cubic-bezier(0.34, 1.2, 0.64, 1);
}
.tc-slide-up-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.tc-slide-up-enter-from,
.tc-slide-up-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(16px);
}

/* ── AI Service Cards ────────────────────────────────────── */
.ai-services-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Base card */
.ai-service-card {
  background: #ffffff;
  border: 1px solid rgba(17, 17, 17, 0.07);
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: default;
  transition: box-shadow 0.15s ease;
}

.ai-service-card[onclick],
.ai-service-card.ai-service-card--gallery,
.ai-service-card.ai-service-card--single {
  cursor: pointer;
}

.ai-service-card:active {
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.08);
}

/* ── Variant: 0 images ── */
.ai-service-card--no-img .ai-service-copy {
  padding: 14px 16px;
}

/* ── Variant: 1 image — image on top, info below ── */
.ai-service-media {
  width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: block;
}

.ai-service-img {
  width: 100%;
  height: 190px;
  object-fit: cover;
  display: block;
}

/* ── Variant: 2+ images — gallery panel left, info right ── */
.ai-service-card--gallery {
  flex-direction: row;
  align-items: stretch;
}

.ai-service-gallery {
  display: grid;
  grid-template-rows: 1fr 1fr;
  flex-shrink: 0;
  width: 108px;
  gap: 2px;
  background: #f0f0f0;
}

.ai-service-gallery-cell {
  position: relative;
  overflow: hidden;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: block;
  width: 100%;
  height: 100%;
}

.ai-service-gallery-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ai-service-gallery-more {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.48);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

/* ── Info section (shared) ── */
.ai-service-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  text-align: left;
  flex: 1;
  min-width: 0;
}

.ai-service-copy strong {
  font-size: 14px;
  font-weight: 600;
  color: #111111;
  line-height: 1.35;
}

.ai-service-copy span {
  font-size: 12.5px;
  line-height: 1.45;
  color: #4b5563;
}

.ai-service-copy small {
  font-size: 11.5px;
  color: #8c8c8c;
}

.ai-service-cta-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #111111;
}

.ecosystem-join-panel {
  position: fixed;
  inset: 0;
  z-index: 80;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: -16px 0 40px rgba(0, 0, 0, 0.18);
}

/* Brand claim redirect panel */
.brand-claim-redirect-panel {
  background: #111111;
}

.bcr-header {
  padding: calc(env(safe-area-inset-top, 16px) + 16px) 20px 0;
}

.bcr-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(255,255,255,0.14);
  background: rgba(255,255,255,0.07);
  color: rgba(255,255,255,0.85);
  font-size: 13px;
  font-weight: 600;
  padding: 9px 16px;
  border-radius: 999px;
  cursor: pointer;
}

.bcr-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 28px calc(env(safe-area-inset-bottom, 24px) + 32px);
  text-align: center;
}

.bcr-check-icon {
  margin-bottom: 20px;
}

.bcr-title {
  font-size: 26px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.03em;
  margin-bottom: 10px;
}

.bcr-slug {
  font-size: 15px;
  color: rgba(255,255,255,0.5);
  margin-bottom: 8px;
}

.bcr-slug strong {
  color: #46D68E;
  font-weight: 700;
}

.bcr-subtitle {
  font-size: 14px;
  color: rgba(255,255,255,0.45);
  max-width: 280px;
  line-height: 1.55;
  margin-bottom: 32px;
}

.bcr-open-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  color: #111111;
  font-size: 15px;
  font-weight: 700;
  padding: 14px 28px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  width: 100%;
  max-width: 320px;
  justify-content: center;
  margin-bottom: 28px;
}

.bcr-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 320px;
  margin-bottom: 20px;
}

.bcr-divider::before,
.bcr-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: rgba(255,255,255,0.1);
}

.bcr-divider span {
  font-size: 12px;
  color: rgba(255,255,255,0.3);
  white-space: nowrap;
}

.bcr-store-btns {
  display: flex;
  gap: 12px;
  width: 100%;
  max-width: 320px;
}

.bcr-store-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  color: rgba(255,255,255,0.8);
  font-size: 13px;
  font-weight: 600;
  padding: 12px 16px;
  border-radius: 12px;
  text-decoration: none;
}

.bcr-cancel-btn {
  margin-top: 20px;
  background: none;
  border: none;
  color: rgba(255,255,255,0.25);
  font-size: 12px;
  cursor: pointer;
  padding: 8px 16px;
  -webkit-tap-highlight-color: transparent;
}

/* Pending claim banner on main screen */
.pending-claim-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 var(--app-side-pad, 20px) 16px;
  padding: 12px 14px;
  background: rgba(70, 214, 142, 0.07);
  border: 1px solid rgba(70, 214, 142, 0.2);
  border-radius: 14px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.pcb-icon { flex-shrink: 0; }

.pcb-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}

.pcb-label {
  font-size: 13px;
  color: rgba(255,255,255,0.85);
}

.pcb-label strong { color: #46D68E; }

.pcb-sub {
  font-size: 11px;
  color: rgba(255,255,255,0.35);
}

.pcb-arrow {
  flex-shrink: 0;
  color: rgba(255,255,255,0.25);
}

.ecosystem-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.06);
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.01em;
  padding: 10px 14px;
  border-radius: 999px;
  cursor: pointer;
  backdrop-filter: blur(14px);
}

.ecosystem-back-btn svg {
  width: 18px;
  height: 18px;
}

.ecosystem-swipe-zone {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: max(16px, calc(env(safe-area-inset-bottom, 0px) + 24px));
  z-index: 75;
  background: linear-gradient(to top, rgba(10, 10, 10, 0.08), rgba(10, 10, 10, 0));
  pointer-events: auto;
}

.explore-entry-screen {
  min-height: 100vh;
  padding-top: calc(env(safe-area-inset-top, 0px) + 24px);
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 44px);
  background:
    radial-gradient(circle at top center, rgba(255, 255, 255, 0.08), transparent 34%),
    linear-gradient(180deg, #161616 0%, #101010 55%, #0a0a0a 100%);
}

.explore-entry-screen.is-overlay-surface {
  position: fixed;
  inset: 0;
  z-index: 70;
  overflow-y: auto;
}

.explore-entry-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: min(1080px, calc(100vw - 32px));
  margin: 0 auto 18px;
  padding-inline: 6px;
}

.explore-entry-topbar .lang-switcher {
  position: static;
  top: auto;
  right: auto;
}

.explore-hero-section {
  width: min(1080px, calc(100vw - 32px));
  margin: 0 auto 18px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  /* Se sube el bloque y se compacta para dejarle aire al reclamo de link */
  padding-top: clamp(0px, 0.6vh, 6px);
}

.explore-hero-section .hero-eyebrow { min-height: 24px; font-size: 10px; }
.explore-hero-section .main-title { font-size: clamp(26px, 7vw, 38px); }
.explore-hero-section.hero-section { gap: 10px; }

.explore-join-pill {
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  min-height: 38px;
  min-width: 78px;
  padding: 8px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  letter-spacing: -0.01em;
  cursor: pointer;
  transition: transform 0.18s ease, background 0.18s ease, border-color 0.18s ease;
  backdrop-filter: blur(14px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.explore-join-pill:active {
  transform: scale(0.98);
}

.explore-join-pill:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.24);
}



.ecosystem-panel-slide-enter-active,
.ecosystem-panel-slide-leave-active {
  transition: transform 0.28s cubic-bezier(0.22, 0.9, 0.3, 1), opacity 0.28s ease;
}

.ecosystem-panel-slide-enter-from,
.ecosystem-panel-slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.ecosystem-explore-slide-enter-active,
.ecosystem-explore-slide-leave-active {
  transition: transform 0.26s cubic-bezier(0.22, 0.9, 0.3, 1), opacity 0.26s ease;
}

.ecosystem-explore-slide-enter-from,
.ecosystem-explore-slide-leave-to {
  transform: translateX(-12%);
  opacity: 0;
}

@media (min-width: 901px) {
  .ecosystem-swipe-zone {
    left: auto;
    right: 24px;
    bottom: 24px;
    width: 180px;
    height: 56px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.24);
    backdrop-filter: blur(18px);
  }
}

.shimmer {
  background: linear-gradient(90deg, rgba(17, 17, 17, 0.019) 0%, rgba(255, 255, 255, 0.046) 48%, rgba(17,17,17,0.05) 100%);
  background-size: 200% 100%;
  border: none;
  animation: aiShimmer 1.35s linear infinite;
}

@keyframes aiShimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

/* ==========================================================================
   LOGIN INVITE MODAL
   ========================================================================== */
.login-invite-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-invite-sheet {
  width: 100%;
  max-width: 400px;
  background: #0f0d0c;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 24px 48px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05);
  position: relative;
  overflow: hidden;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* Background animation */
.lib-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  border-radius: 28px;
  background: radial-gradient(circle at 75% 25%, rgba(184, 150, 116, 0.15) 0%, transparent 60%),
              radial-gradient(circle at 25% 75%, rgba(216, 255, 52, 0.08) 0%, transparent 60%);
}

.lib-blob {
  position: absolute;
  filter: blur(40px);
  opacity: 0.5;
  border-radius: 50%;
  animation: libFloat 8s infinite alternate ease-in-out;
}
.lib-blob-1 {
  width: 150px; height: 150px;
  background: rgba(216, 255, 52, 0.15);
  top: -50px; right: -50px;
}
.lib-blob-2 {
  width: 200px; height: 200px;
  background: rgba(184, 150, 116, 0.15);
  bottom: -80px; left: -80px;
  animation-delay: -4s;
}

@keyframes libFloat {
  0% { transform: translate(0, 0) scale(1); }
  100% { transform: translate(-20px, 20px) scale(1.1); }
}

/* Floating icons */
.lib-float-icon {
  position: absolute;
  width: 32px; height: 32px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex; align-items: center; justify-content: center;
  color: rgba(255,255,255,0.7);
  animation: floatIconFade 10s infinite;
  z-index: 1;
}
.lib-float-icon svg { width: 50%; height: 50%; }
.lib-fi-1 { top: 15%; left: 10%; animation-delay: 0s; }
.lib-fi-2 { top: 25%; right: 10%; animation-delay: 3s; }
.lib-fi-3 { bottom: 25%; left: 15%; animation-delay: 6s; }

.lib-close {
  position: absolute;
  top: 16px; right: 16px;
  width: 32px; height: 32px;
  border-radius: 50%;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  color: #fff;
  font-size: 14px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  z-index: 2;
  transition: all 0.2s;
}
.lib-close:hover { background: rgba(255,255,255,0.1); }

.lib-body {
  position: relative;
  z-index: 2;
  width: 100%;
}

.lib-kicker {
  font-size: 13px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 12px;
  display: block;
}

.lib-title {
  font-family: 'Plus Jakarta Sans', -apple-system, sans-serif;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.1;
  color: #fff;
  letter-spacing: -0.03em;
  margin: 0 0 16px 0;
}
.lib-lime { color: #d8ff34; }

.lib-desc {
  font-size: 15px;
  color: rgba(255,255,255,0.7);
  line-height: 1.5;
  margin-bottom: 32px;
}

.lib-error {
  color: #ff6b6b;
  font-size: 13px;
  margin-bottom: 20px;
  background: rgba(255, 107, 107, 0.1);
  padding: 10px;
  border-radius: 8px;
}

.lib-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-bottom: 24px;
}

.lib-btn {
  width: 100%;
  height: 52px;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.05);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s;
}
.lib-btn:hover:not(:disabled) {
  background: rgba(255,255,255,0.1);
  transform: translateY(-1px);
}
.lib-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.lib-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.lib-btn-google { background: #fff; color: #000; border-color: transparent; }
.lib-btn-google:hover:not(:disabled) { background: #f0f0f0; }

.lib-spinner {
  width: 20px; height: 20px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: libSpin 0.75s linear infinite;
}
@keyframes libSpin { 100% { transform: rotate(360deg); } }

.lib-skip {
  background: none;
  border: none;
  color: rgba(255,255,255,0.4);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px;
  transition: color 0.2s;
}
.lib-skip:hover { color: rgba(255,255,255,0.8); }

/* ── Booking block ── */
/* ── PRÓXIMA CITA BAR ── */
.proxima-cita-bar {
  position: sticky; top: 0; z-index: 50;
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
  padding: 9px 16px; background: #fff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 6px rgba(0,0,0,0.06);
}
.proxima-cita-info { display: flex; align-items: center; gap: 7px; flex: 1; min-width: 0; }
.proxima-cita-info svg { flex-shrink: 0; color: #64748b; }
.proxima-cita-text { font-size: 12px; color: #334155; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.proxima-cita-text strong { font-weight: 700; }
.proxima-cita-servicio { color: #64748b; }
.proxima-cita-estado { font-size: 11px; font-weight: 600; padding: 2px 7px; border-radius: 999px; flex-shrink: 0; background: #fef3c7; color: #92400e; }
.proxima-cita-estado.is-confirmado { background: #d1fae5; color: #065f46; }
.proxima-cita-estado.is-cancelado { background: #fee2e2; color: #991b1b; }
.proxima-cita-btn { flex-shrink: 0; font-size: 12px; font-weight: 700; padding: 6px 12px; border-radius: 8px; border: 1.5px solid #e2e8f0; background: #fff; color: #334155; cursor: pointer; transition: background 0.15s; }
.proxima-cita-btn:hover { background: #f1f5f9; }
/* ── GESTIONAR MODAL ── */
.gestionar-overlay { position: fixed; inset: 0; z-index: 200; background: rgba(0,0,0,0.35); display: flex; align-items: flex-end; justify-content: center; }
.gestionar-sheet { background: #fff; border-radius: 20px 20px 0 0; width: 100%; max-width: 480px; padding: 20px 20px 32px; display: flex; flex-direction: column; gap: 16px; }
.gestionar-header { display: flex; align-items: center; justify-content: space-between; }
.gestionar-header strong { font-size: 15px; font-weight: 700; color: #0f172a; }
.gestionar-close { border: none; background: none; padding: 4px; cursor: pointer; color: #94a3b8; }
.gestionar-actions { display: flex; flex-direction: column; gap: 10px; }
.gestionar-action-btn { display: flex; align-items: center; gap: 10px; width: 100%; padding: 13px 16px; border-radius: 12px; border: 1.5px solid #e2e8f0; background: #f8fafc; color: #1e293b; font-size: 14px; font-weight: 600; cursor: pointer; text-align: left; transition: background 0.15s; }
.gestionar-action-btn:hover { background: #f1f5f9; }
.gestionar-action-btn.is-danger { border-color: #fee2e2; background: #fff5f5; color: #dc2626; }
.gestionar-action-btn.is-danger:hover { background: #fee2e2; }
.gestionar-form { display: flex; flex-direction: column; gap: 12px; }
.gestionar-label { font-size: 14px; font-weight: 600; color: #0f172a; margin: 0; }
.gestionar-sub { font-size: 13px; color: #64748b; margin: -8px 0 0; }
.gestionar-slots { display: flex; flex-direction: column; gap: 7px; }
.gestionar-slot { width: 100%; padding: 10px 13px; border-radius: 9px; border: 1.5px solid #e2e8f0; background: #fff; color: #1e293b; font-size: 13px; font-weight: 500; text-align: left; cursor: pointer; transition: border-color 0.15s, background 0.15s; }
.gestionar-slot:hover { background: #f1f5f9; }
.gestionar-slot.selected { border-color: #6366f1; background: #eef2ff; color: #4338ca; font-weight: 700; }
.gestionar-empty { font-size: 13px; color: #94a3b8; }
.gestionar-motivo { width: 100%; padding: 10px 13px; border-radius: 9px; border: 1.5px solid #e2e8f0; font-size: 14px; color: #1e293b; resize: none; outline: none; box-sizing: border-box; font-family: inherit; }
.gestionar-motivo:focus { border-color: #94a3b8; }
.gestionar-footer { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-top: 4px; }
.gestionar-back { border: none; background: none; font-size: 13px; color: #64748b; cursor: pointer; padding: 0; }
.gestionar-confirm-btn { padding: 11px 20px; border-radius: 10px; border: none; font-size: 14px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 8px; transition: opacity 0.15s; }
.gestionar-confirm-btn.is-danger { background: #dc2626; color: #fff; }
.gestionar-confirm-btn:disabled { opacity: 0.4; cursor: not-allowed; }
/* ── BOOKING BLOCK ── */
.ai-booking-block { display: flex; flex-direction: column; gap: 8px; }
.ai-booking-slots { display: flex; flex-direction: column; gap: 6px; }
.ai-booking-slot {
  width: 100%; padding: 10px 13px;
  border-radius: 10px; border: 1.5px solid #e2e8f0;
  background: #fff; color: #1e293b;
  font-size: 13px; font-weight: 500;
  text-align: left; cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}
.ai-booking-slot:hover { background: #f1f5f9; border-color: #94a3b8; }
.ai-booking-form { display: flex; flex-direction: column; gap: 9px; text-align: left; }
.ai-booking-selected-slot {
  display: flex; align-items: center; gap: 6px;
  font-size: 13px; color: #475569;
  background: #f1f5f9; border-radius: 9px; padding: 9px 12px;
}
.ai-booking-selected-slot svg { flex-shrink: 0; color: #64748b; }
.ai-booking-selected-slot span { flex: 1; font-weight: 500; color: #1e293b; }
.ai-booking-change {
  margin-left: auto; border: none; background: none;
  color: #94a3b8; font-size: 12px; cursor: pointer;
  padding: 0; text-decoration: underline; flex-shrink: 0;
}
.ai-booking-input {
  width: 100%; padding: 10px 13px;
  border-radius: 9px; border: 1.5px solid #e2e8f0;
  background: #fff; color: #1e293b;
  font-size: 14px; outline: none;
  transition: border-color 0.18s; box-sizing: border-box;
}
.ai-booking-input::placeholder { color: #94a3b8; }
.ai-booking-input:focus { border-color: #94a3b8; }
.ai-booking-confirm-btn {
  width: 100%; padding: 11px;
  border-radius: 10px; border: none;
  background: #1e293b; color: #fff;
  font-size: 14px; font-weight: 700;
  cursor: pointer; transition: opacity 0.18s;
  display: flex; align-items: center; justify-content: center; gap: 8px;
}
.ai-booking-confirm-btn:hover { opacity: 0.85; }
.ai-booking-confirm-btn:disabled { opacity: 0.35; cursor: not-allowed; }
.ai-booking-spinner {
  width: 15px; height: 15px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: bookingSpin 0.7s linear infinite;
}
@keyframes bookingSpin { 100% { transform: rotate(360deg); } }
.ai-booking-whatsapp-btn {
  width: 100%; padding: 11px; box-sizing: border-box;
  border-radius: 10px; border: 1.5px solid #25D366;
  background: #f0fdf4; color: #128C4A;
  font-size: 14px; font-weight: 700;
  cursor: pointer; transition: opacity 0.18s;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  text-decoration: none;
}
.ai-booking-whatsapp-btn:hover { opacity: 0.85; }
.ai-booking-whatsapp-btn svg { flex-shrink: 0; color: #25D366; }
.ai-booking-error { font-size: 12px; color: #b91c1c; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 8px 10px; margin-bottom: 6px; }
.ai-booking-slot.is-taken { opacity: 0.45; cursor: not-allowed; text-decoration: line-through; }
.ai-slot-taken-label { font-size: 10px; color: #94a3b8; margin-left: 6px; font-weight: 500; }
.ai-booking-confirmed {
  display: flex; align-items: center; gap: 10px; text-align: left;
  background: #f0fdf4; border: 1.5px solid #bbf7d0;
  border-radius: 10px; padding: 12px 14px; color: #166534;
}
.ai-booking-confirmed > div { display: flex; flex-direction: column; gap: 2px; }
.ai-booking-confirmed strong { font-size: 13px; font-weight: 700; }
.ai-booking-confirmed span { font-size: 12px; color: #15803d; }

/* ── Gallery image loading ── */
.gallery-img-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(10, 10, 10, 0.55);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  z-index: 2;
  border-radius: inherit;
}
.gallery-img-spinner {
  width: 36px;
  height: 36px;
  border: 2.5px solid rgba(255,255,255,0.15);
  border-top-color: rgba(255,255,255,0.85);
  border-radius: 50%;
  animation: gallerySpinAnim 0.75s linear infinite;
}
@keyframes gallerySpinAnim {
  to { transform: rotate(360deg); }
}
.ai-image-viewer.is-visible {
  opacity: 1;
}
.ai-image-viewer:not(.is-visible) {
  opacity: 0;
}

/* ── Room action bar ── */
.room-action-bar {
  position: absolute;
  bottom: 52px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: inline-flex;
  align-items: center;
  gap: 0;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(10,10,10,0.88);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow: 0 8px 32px rgba(0,0,0,0.44), 0 0 0 1px rgba(255,255,255,0.04) inset;
  overflow: hidden;
}
.room-action-sep {
  width: 1px;
  height: 20px;
  background: rgba(255,255,255,0.1);
  flex-shrink: 0;
}
.room-action-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 9px 13px;
  border: none;
  background: transparent;
  color: rgba(255,255,255,0.55);
  cursor: pointer;
  transition: color 0.18s, background 0.18s, transform 0.15s;
  font-size: 12px;
  font-weight: 600;
}
.room-action-btn:hover {
  background: rgba(255,255,255,0.07);
  color: rgba(255,255,255,0.9);
}
.room-action-exit:hover {
  color: rgba(255,120,120,0.9);
  background: rgba(255,80,80,0.1);
}
.room-action-exit-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
}
.room-action-like.is-liked {
  color: #E1306C;
}
.room-action-like:active {
  transform: scale(1.35);
}
.room-action-like-count {
  font-size: 11px;
  font-weight: 700;
}

/* ── WR action bar ── */
.wr-action-bar {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(10,10,10,0.75);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.35);
  overflow: hidden;
}
.wr-exit-floating {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border: none;
  background: transparent;
  color: rgba(255,255,255,0.8);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.02em;
}
.wr-action-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 13px;
  border: none;
  border-left: 1px solid rgba(255,255,255,0.08);
  background: transparent;
  color: rgba(255,255,255,0.55);
  cursor: pointer;
  transition: color 0.18s, background 0.18s;
  font-size: 11px;
  font-weight: 700;
}
.wr-action-btn:hover { color: rgba(255,255,255,0.9); }
.wr-like-btn.is-liked { color: #ff4d6d; }


/* ── Share sheet — Instagram style ── */
/* ═══════════════════════════════════════
   SHARE SHEET — full-height profile layout
═══════════════════════════════════════ */
.share-sheet-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 9999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.share-sheet {
  width: 100%;
  max-width: 480px;
  max-height: 92dvh;
  background: #111;
  border-radius: 24px 24px 0 0;
  overflow: hidden;
  overflow-y: auto;
  box-shadow: 0 -20px 60px rgba(0,0,0,0.55);
  display: flex;
  flex-direction: column;
}

/* ─ Hero ─ */
.share-hero {
  position: relative;
  height: 300px;
  flex-shrink: 0;
  overflow: hidden;
}
/* Blurred bg reproduces dominant color */
.share-hero-bg {
  position: absolute;
  inset: -30px;
  background-size: cover;
  background-position: center top;
  filter: blur(28px) saturate(1.6) brightness(0.65);
  transform: scale(1.12);
  z-index: 0;
}
/* When Branding is a gradient (no real image), skip blur — just show the gradient */
.share-hero-bg--gradient {
  filter: none;
  transform: none;
  inset: 0;
}
/* Sharp image on top */
.share-hero-img {
  position: absolute;
  inset: 0;
  width: 100%; height: 100%;
  object-fit: cover;
  object-position: center top;
  z-index: 1;
}
/* Fallback initial letter */
.share-hero-initial {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex; align-items: center; justify-content: center;
  font-size: 72px; font-weight: 900; color: rgba(255,255,255,0.25);
}
/* Gradient at bottom fades hero into content card */
.share-hero-gradient {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 120px;
  background: linear-gradient(to bottom, transparent 0%, #111 100%);
  z-index: 2;
}
/* Back/close button */
.share-back-btn {
  position: absolute;
  top: 16px; left: 16px;
  z-index: 10;
  width: 36px; height: 36px;
  border-radius: 50%;
  background: rgba(0,0,0,0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,0.15);
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}
.share-back-btn:active { background: rgba(0,0,0,0.7); }

/* ─ Content card ─ */
.share-content-card {
  background: #111;
  padding: 0 0 max(20px, env(safe-area-inset-bottom));
  flex: 1;
}

/* Room header: name + likes badge */
.share-room-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px 14px;
}
.share-room-header-text { flex: 1; min-width: 0; }
.share-room-title {
  font-size: 22px; font-weight: 900; color: #fff;
  margin: 0 0 4px; line-height: 1.15;
  letter-spacing: -0.3px;
}
.share-room-desc {
  font-size: 13px; color: rgba(255,255,255,0.55);
  margin: 0 0 6px; line-height: 1.4;
  /* Una descripción larga estiraba el panel entero. La vista previa real
     recorta a 180 caracteres, así que dos líneas aquí ya dicen lo mismo. */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.share-room-url {
  font-size: 12px; color: rgba(255,255,255,0.3);
  margin: 0;
  /* Con el id del slide la URL se parte en dos líneas y afea el panel. Es
     informativa: una línea con puntos suspensivos basta. */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.share-like-badge {
  display: flex; align-items: center; gap: 5px;
  background: rgba(255,255,255,0.08);
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 13px; font-weight: 700; color: #ff6b8a;
  flex-shrink: 0;
  margin-top: 2px;
}

/* ─ Divider ─ */
.share-divider {
  height: 1px;
  background: rgba(255,255,255,0.07);
  margin: 0 20px 4px;
}

/* ─ Vertical action list ─ */
.share-actions-list {
  display: flex;
  flex-direction: column;
}
.share-list-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  background: none;
  border: none;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  cursor: pointer;
  text-align: left;
  transition: background 0.12s;
  width: 100%;
}
.share-list-item:active { background: rgba(255,255,255,0.06); }
.share-list-icon {
  width: 44px; height: 44px; border-radius: 13px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.share-list-icon--fb { background: #1877f2; color: #fff; }
.share-list-icon--ig {
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285aeb 90%);
  color: #fff;
}
.share-list-icon--wa { background: #25d366; color: #fff; }
.share-list-icon--copy { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.75); }
.share-list-icon--copied { background: rgba(52,211,153,0.15); color: #34d399; }
.share-list-label {
  flex: 1;
  font-size: 15px; font-weight: 600; color: #fff;
}
.share-list-chevron {
  color: rgba(255,255,255,0.22);
  flex-shrink: 0;
}
.share-list-chevron--check { color: #34d399; }

/* ─ Close/back button ─ */
.share-sheet-cancel {
  display: block;
  width: calc(100% - 32px);
  margin: 16px 16px 0;
  padding: 15px;
  border-radius: 14px;
  border: 1.5px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.05);
  color: rgba(255,255,255,0.8);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.12s;
}
.share-sheet-cancel:active { background: rgba(255,255,255,0.1); }

/* ─ Sheet animation ─ */
.sheet-up-enter-active { transition: opacity 0.22s ease; }
.sheet-up-enter-active .share-sheet { transition: transform 0.32s cubic-bezier(0.34,1.15,0.64,1); }
.sheet-up-leave-active { transition: opacity 0.18s ease; }
.sheet-up-leave-active .share-sheet { transition: transform 0.2s ease; }
.sheet-up-enter-from { opacity: 0; }
.sheet-up-enter-from .share-sheet { transform: translateY(100%); }
.sheet-up-leave-to { opacity: 0; }
.sheet-up-leave-to .share-sheet { transform: translateY(100%); }
.sheet-up-enter-to .share-sheet, .sheet-up-leave-from .share-sheet { transform: translateY(0); }

/* ── Name/Avatar Setup Modal ──────────────────────────────── */
/* ── Welcome card (replaces avatar modal) ──────────────────── */
.welcome-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.7);
  backdrop-filter: blur(10px);
  z-index: 8000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.welcome-card {
  background: rgba(18,18,24,0.95);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 28px;
  padding: 40px 28px 32px;
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  box-shadow: 0 32px 80px rgba(0,0,0,0.5);
}
.welcome-connected-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: rgba(255,255,255,0.4);
  text-transform: uppercase;
  margin: 0 0 8px;
}
.welcome-session-name {
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  text-align: center;
  margin: 0 0 28px;
  line-height: 1.2;
  letter-spacing: -0.3px;
}
.welcome-divider {
  width: 40px;
  height: 1px;
  background: rgba(255,255,255,0.12);
  margin-bottom: 28px;
}
.welcome-name-label {
  font-size: 14px;
  font-weight: 600;
  color: rgba(255,255,255,0.55);
  margin: 0 0 12px;
  align-self: flex-start;
}
.welcome-name-input {
  width: 100%;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.14);
  border-radius: 16px;
  padding: 15px 18px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  box-sizing: border-box;
  margin-bottom: 20px;
  transition: border-color 0.2s;
}
.welcome-name-input::placeholder { color: rgba(255,255,255,0.25); }
.welcome-name-input:focus { border-color: rgba(255,255,255,0.35); }
.welcome-btn-continuar {
  width: 100%;
  padding: 17px;
  border-radius: 50px;
  border: none;
  color: #fff;
  font-weight: 800;
  font-size: 15px;
  cursor: pointer;
  background: rgba(255,255,255,0.15);
  transition: opacity 0.2s, transform 0.15s;
  letter-spacing: 0.02em;
}
.welcome-btn-continuar:disabled { opacity: 0.3; cursor: not-allowed; }
.welcome-btn-continuar:not(:disabled):active { transform: scale(0.97); }

/* Transition */
.welcome-pop-enter-active { animation: welcomeIn 0.4s cubic-bezier(0.34, 1.4, 0.64, 1); }
.welcome-pop-leave-active { animation: welcomeIn 0.25s ease reverse; }
@keyframes welcomeIn {
  from { opacity: 0; transform: scale(0.88) translateY(20px); }
  to   { opacity: 1; transform: scale(1)   translateY(0); }
}

/* ── Mi Ganador Screen ──────────────────────────────────────── */
.mi-ganador-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #0a0a0f;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 32px 20px;
}
.mi-ganador-medal {
  font-size: 72px;
  margin-bottom: 8px;
  animation: medalBounce 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
}
@keyframes medalBounce {
  0%   { transform: scale(0) rotate(-20deg); opacity: 0; }
  100% { transform: scale(1) rotate(0deg);   opacity: 1; }
}
.mi-ganador-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 4px solid var(--brand, #6c63ff);
  box-shadow: 0 0 0 8px rgba(108,99,255,0.2), 0 20px 50px rgba(0,0,0,0.5);
  object-fit: cover;
  margin-bottom: 20px;
  animation: popIn 0.5s 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
}
.mi-ganador-puesto {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--brand, #6c63ff);
  margin: 0 0 6px;
  animation: fadeUp 0.4s 0.3s ease both;
}
.mi-ganador-felicidades {
  font-size: 32px;
  font-weight: 900;
  color: white;
  margin: 0 0 6px;
  animation: fadeUp 0.4s 0.35s ease both;
}
.mi-ganador-nombre {
  font-size: 18px;
  color: rgba(255,255,255,0.7);
  margin: 0 0 12px;
  animation: fadeUp 0.4s 0.4s ease both;
}
.mi-ganador-puntos {
  font-size: 15px;
  font-weight: 700;
  color: var(--brand, #6c63ff);
  background: rgba(108,99,255,0.12);
  border-radius: 50px;
  padding: 6px 20px;
  margin-bottom: 20px;
  animation: fadeUp 0.4s 0.45s ease both;
}
.mi-ganador-confetti {
  display: flex;
  gap: 16px;
  font-size: 28px;
  margin-bottom: 24px;
  animation: fadeUp 0.4s 0.5s ease both;
}
.mi-ganador-mensaje {
  font-size: 13px;
  color: rgba(255,255,255,0.4);
  animation: fadeUp 0.4s 0.55s ease both;
}
.mi-ganador-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255,255,255,0.1);
  border: none;
  color: rgba(255,255,255,0.6);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ══════════════════════════════════════
   EXPLORE TOPBAR — lupa + idioma
══════════════════════════════════════ */
.explore-topbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.explore-search-btn {
  width: 38px; height: 38px;
  border-radius: 50%;
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.14);
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
  flex-shrink: 0;
}
.explore-search-btn:active { background: rgba(255,255,255,0.2); }

/* ══════════════════════════════════════
   SEARCH MODAL (bottom sheet)
══════════════════════════════════════ */
.search-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  z-index: 9000;
  display: flex;
  align-items: flex-end;
  backdrop-filter: blur(4px);
}
.search-bottom-sheet {
  width: 100%;
  background: #141418;
  border-radius: 28px 28px 0 0;
  padding: 12px 20px 40px;
  max-height: 82vh;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.search-sheet-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.search-sheet-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}
.search-sheet-close {
  background: rgba(255,255,255,0.1);
  border: none;
  color: rgba(255,255,255,0.6);
  border-radius: 50%;
  width: 30px; height: 30px;
  cursor: pointer;
  font-size: 13px;
}
.search-input-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 16px;
  padding: 12px 14px;
  margin-bottom: 16px;
}
.search-input {
  flex: 1;
  background: none;
  border: none;
  outline: none;
  color: #fff;
  font-size: 16px; /* ≥16px prevents iOS Safari auto-zoom on focus */
  caret-color: #fff;
}
.search-input::placeholder { color: rgba(255,255,255,0.35); }
.search-clear {
  background: none;
  border: none;
  color: rgba(255,255,255,0.4);
  font-size: 14px;
  cursor: pointer;
  padding: 0 2px;
}
.search-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255,255,255,0.45);
  font-size: 13px;
  padding: 16px 0;
}
.search-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: rgba(255,255,255,0.3);
  font-size: 13px;
  padding: 32px 0;
  text-align: center;
}
.search-hint {
  color: rgba(255,255,255,0.3);
  font-size: 13px;
  text-align: center;
  padding: 28px 0;
}
.search-results {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  scrollbar-width: none;
}
.search-results::-webkit-scrollbar { display: none; }
.search-result-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 18px;
  cursor: pointer;
  transition: background 0.15s;
}
.search-result-item:active { background: rgba(255,255,255,0.1); }
.sri-logo {
  width: 46px; height: 46px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
  background: rgba(255,255,255,0.08);
  display: flex; align-items: center; justify-content: center;
}
.sri-logo img { width: 100%; height: 100%; object-fit: cover; }
.sri-logo-fallback {
  font-size: 20px;
  font-weight: 800;
  color: rgba(255,255,255,0.5);
}
.sri-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.sri-name {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sri-slug {
  font-size: 11px;
  color: rgba(255,255,255,0.4);
}
.sri-active-dot {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}
.sri-live-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: #34c759;
  box-shadow: 0 0 6px #34c759;
  animation: pulseLive 1.4s ease-in-out infinite;
}
@keyframes pulseLive {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
.sri-live-label {
  font-size: 9px;
  font-weight: 800;
  color: #34c759;
  letter-spacing: 0.8px;
}
.sri-arrow { flex-shrink: 0; }


/* Foto que todavía se está descargando: invisible hasta que termine, para
   que no se vea la mitad pintada. Debajo queda el fondo desenfocado. */
.img-cargando {
  opacity: 0;
}
img:not(.img-cargando) {
  transition: opacity 0.25s ease;
}


/* Selector de alcance: dos textos, sin la pastilla blanca que partía el
   panel en dos. Solo cambia el peso y la opacidad. */
.share-scope--sutil {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
  margin: 2px 0 10px;
}
.share-scope--sutil .share-scope-btn {
  border: none;
  background: transparent;
  color: rgba(255,255,255,0.38);
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 2px;
  cursor: pointer;
  position: relative;
  transition: color 0.18s ease;
}
.share-scope--sutil .share-scope-btn.active {
  color: #fff;
  font-weight: 700;
}
/* Subrayado fino solo en el activo */
.share-scope--sutil .share-scope-btn.active::after {
  content: '';
  position: absolute;
  left: 2px;
  right: 2px;
  bottom: -1px;
  height: 1.5px;
  border-radius: 2px;
  background: #fff;
}

/* Acciones en círculo, en una sola fila */
.share-circles {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  gap: 6px;
  padding: 4px 0 2px;
}
.share-circle-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  border: none;
  background: transparent;
  padding: 0;
  font-family: inherit;
  cursor: pointer;
  min-width: 0;
  flex: 1;
}
.share-circle {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.10);
  color: #fff;
  transition: transform 0.15s ease, background 0.2s ease;
}
.share-circle-item:active .share-circle { transform: scale(0.92); }
.share-circle.is-copied { background: #fff; color: #111; }
.share-circle--wa { background: #25D366; color: #fff; }
.share-circle--fb { background: #1877F2; color: #fff; }
.share-circle--ig {
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: #fff;
}
.share-circle-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(255,255,255,0.62);
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

</style>
